import { Component, ElementRef, EventEmitter, HostListener, Inject, Input, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import Konva from 'konva';
import { Comment, Post, PostField, Template, CanvasHistory, Link, Node, TaskData, rect, ResearchReport, CanvasPermissions, Chunk } from '../container';
import html2canvas from 'html2canvas';
import { MatDialog } from '@angular/material/dialog';
import { FirestoreService } from '../firestore-service.service';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { firstValueFrom, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { ConfirmingDialogComponent } from '../confirming-dialog/confirming-dialog.component';
import { doc, onSnapshot } from 'firebase/firestore';
import { SearchService } from '../search.service';
import { jsPDF } from 'jspdf';
import { OpportunityCard, OutcomeCard, AddCardPlaceholder } from '../treecards';
import { getDownloadURL, getStorage, ref as storageRef } from 'firebase/storage';
import '../../assets/fonts/Roboto-Regular-normal.js'; // Adjust path
import { Editor, Toolbar } from 'ngx-editor';
import { HttpClient, HttpClientModule } from '@angular/common/http';
//import { RobotoFontData } from '../../assets/fonts/Roboto-Regular-normal.js';

// import pdfFonts from 'pdfmake/build/vfs_fonts';

const WINDOW_WIDTH = 500;
const WINDOW_HEIGHT = 200; 
import * as d3 from "d3-force";
import { AddfiledialogComponent } from '../addfiledialog/addfiledialog.component';
import { RealtimeService } from '../realtime.service';
import { getDatabase, onValue, ref } from 'firebase/database';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { SharedServiceService } from '../shared-service.service';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { ContentlistComponent } from '../contentlist/contentlist.component';
import { SharedModule } from '../shared/shared.module';
import { Details2Component } from '../details2/details2.component';
import { GeminiService } from '../gemini.service';
import { Chapter, ResearchService } from '../research.service';
import { UploadpopupComponent } from '../uploadpopup/uploadpopup.component';
import { WaitingplaceholderComponent } from '../waitingplaceholder/waitingplaceholder.component';
import { RagchatComponent } from '../ragchat/ragchat.component';
import { PublicresearchService } from '../publicresearch.service';
import { PaymentpopupComponent } from '../paymentpopup/paymentpopup.component';
import { DetailsforpageComponent } from '../detailsforpage/detailsforpage.component';
import { CommentlistComponent } from '../commentlist/commentlist.component';
import { PostsearchpopupComponent } from '../postsearchpopup/postsearchpopup.component';
import { WorkpackagesearchpopupComponent } from '../workpackagesearchpopup/workpackagesearchpopup.component';
import { ProgressbarComponent } from '../progressbar/progressbar.component';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { ProgresshillComponent } from '../progresshill/progresshill.component';
import { InlinetutorialComponent } from '../inlinetutorial/inlinetutorial.component';
import { P } from '@angular/cdk/portal-directives.d-BoG39gYN';

// ng build --configuration productly
// ng serve --configuration productly
// firebase deploy --only hosting:productly

@Component({
    selector: 'app-canvas',
    templateUrl:  environment.site === 'wroolo' ? './canvas.component.wroolo.html' : './canvas.component.productly.html',
    styleUrl: './canvas.component.scss',
    standalone: true,
    imports: [
      CommonModule,
      FormsModule,
      SharedModule,
      ContentlistComponent,
      WaitingplaceholderComponent,
      RagchatComponent,
      DetailsforpageComponent,
      CommentlistComponent,
      PostsearchpopupComponent,
      WorkpackagesearchpopupComponent,
      DropdownComponent,
      ProgressbarComponent,
      ProgresshillComponent,
      InlinetutorialComponent,
      ConfirmingDialogComponent,
      RagchatComponent
    ]
})
export class CanvasComponent {
  solutionTypes: string[] = ["IT application", "Training", "Consulting", "Marketing Campaign", "New product", "Other"]

  @Input() workpackages: Post[] = []
  @Input() userId = ""
  @Input() userImageURL = ""
  @Input() projectKey = ""
  @Input() organizationKey = ""
  @Input() projectName = ""
  @Input() isViewChanged = false
  @Input() userEmail = ""
  @Input() userName = ""
  @Input() isLeftMenuExpanded = true
  @Input() canvasKey = ""
  @Input() canvasName = ""
  @Input() isAnonymous = false
  @Input() connectedPostKey = ""
  @Input() selectedTeamKey = ""
  @Input() teams:any[] = []
  @Input() selectedTeamName = ""
  @Input() fullScreen = false
  @Input() clickedOutsidePointerPosition: {x: number, y: number} = {x: 0, y: 0}
  @Output() sendIsRenderingCompleted = new EventEmitter<boolean>();
  stageWidth = 700; //window.innerWidth-10;
  stageHeight = window.innerHeight-90;
  
  layer = new Konva.Layer()
  backgroundGrid = new Konva.Layer({
    listening: false,
   // zIndex: 0
  })
  stage: any
  minimapStage: Konva.Stage | null = null
  minimapLayer: Konva.Layer | null = null
  targets: TaskData[] = [];
  isRenderingCompleted = false
  minimapWidth = 350
  minimapHeight = 200
  boxWidth = 200
  boxHeight = 80
  boxMargin = 50
  scale = 1
  previousDistance = 0
  //private activePointers: number = 0;
  doc = document.getElementById("container");
  addPostPopupVisible = false
  addWorkpackagePopupVisible = false
  lastCenter: any = null;
  lastDist = 0;
  dragStopped = false;
  x1 = 0
  y1 = 0
  x2 = 0
  y2 = 0
  selecting = false; // if true, user is selecting objects on canvas, selectionRectangle is visible
  selectionRectangle = new Konva.Rect(); // blue rectangle used to select objects on canvas
  tr = new Konva.Transformer({id: "transformer", padding: 5, anchorSize: 10, anchorStroke: '#459289', anchorFill: '#459289', borderStroke: "#459289", anchorStrokeWidth: 2, hitStrokeWidth: 10, keepRatio: false, enabledAnchors: ['top-left', 'top-right', 'bottom-right', 'bottom-left']});
  postObjects: {key: string, name: string, htmlName: string, x: number, y: number}[] = []
  selectedObjects: Konva.Node[] = [] // array of objects on canvas selected by user
  connectors: {id: string; from: string; to: string}[] = [] // array of connectors between tasks on canvas
  isReadOnly = false
  newPost: Post = {"authorKey": "", "authorName": "", "categoryKey": "", "commentCount": 0, "nameHTML": "", "contentRowsCount": 0, "dateOfCreation": new Date(), "dateOfUpdate": new Date(), "formattedDate": "", "imageURLs": [], "coverImageURL": "", "key": "", "lastCommentDate": new Date(), "organizationKey": "", "name": "", "projectKey": "", "title": "", "viewCount": 0, "isNewPost": true, "isDeleted": false, "loggedUserDisplayName": "", "loggedUserKey": "", "isDownloadAvailable": false, "projectName": "", "templateKey": "", "color": "", "fields": [], "tags": [], "contentType": "", "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": 0, "startDate": new Date(), "endDate": new Date(), "manHours": 0, "isSelected": false, "templateName": "", "isCompleted": false, "parentName": "", "areKidsColored": false, "description": "", "assignedUsers": [], "status": "", "sequence": 0, "parentKey": "", "isExpanded": false, "areKidsTagged": false, "milestoneKey": "", "isChecked": false, "isParent": false, "fileType": ""}
  templates: Template[] = []
  menuItems: {key: string, name: string, color: string}[] = []
  tags: {tag: string, isSelected: boolean}[] = []
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(Breakpoints.XSmall);
  fieldKeyWithLinks = -1
  embeddingModel =  "gemini-embedding-001"
  scrollPosition = 0
  isListening = true
  isLoadingLabelVisible = false
  isCanvasVisible = true // used during AI thinking process to hide canvas
  isCanvasVisibleForKnowledgeBase = true // used when showing knoewledge base popup
  standardLoadingMessage = "Please wait, generating content..."
  loadingMessage = "Please wait, generating content..."
  loadingTitle = "AI is thinking..."
  isDialogOpened = false
  isEraserEnabled = false
  canvasHistory: CanvasHistory[] = [] // history of canvas changes used for undo/redo and saving canvas
  undoedHistory: CanvasHistory[] = [] // history of canvas changes used for redo, structure is the same as canvasHistory, copied from canvasHistory when undo is called
  compressedHistory: CanvasHistory[] = [] // compressed history of canvas changes used for downloading and storing in firestore canvas history, it is compressed to make it smaller by removing unnecessary fields
  subscribe: any
  isDrawingStorymap = false
  startX: number = 0;
  endX: number = 0;
  startY: number = 0;
  endY: number = 0;
  gridOutsizePercentage = 0.1;
  fieldSize = 150;
  backgroundGridLine = new Konva.Line({
    points: [],
    stroke: "rgba(190,190,190,0.8)",
    dash: [ 1, 8 ],
    lineCap: "round",
    strokeWidth: 1,
    listening: false
});
  isPointerEnabled = false // if true, pointer is enabled and move button is shown, if false, pointer is disabled and move button is hidden. it is used to selectionRectangle or mobving the canvas. when I implented dragging with two fingers, I had to disable pointer and it is no longer used
  isLaserPointerEnabled = false
  isMinimapVisible = false
  isFreeHandDrawingEnabled = false
  isColorPalleteVisible = false
  isDrawingArrow = false
  isContentEditing = false // if true, content is being edited in textare of postit
  justPainting = false
  isContextMenuVisible = false
  isContextMenuFrameVisible = false
  cursorPositions: {userId: string, x: number, y: number, time: number}[] = []
  positionsToRemember = 1000
  durationToRemember = 5000 // duration of storing cursor positions in ms
  cursorPositionInterval: any = null
  positionsFrequenceStoring = 10
  laserLine = new Konva.Line({
    data: [],
    strokeWidth: 8,
    lineCap: 'round',
    lineJoin: 'round',
  });
  paintingMode = 'brush';
  lastPaintedLine: any;
  pickedColor = "#000000"
  boxContent: {key: string, content: string}[] = [] // html content of boxes
  selectedShapeKey: string = "" // key of the shape that is currently selected, potentially source for arrow
  fileName = ""
  /*userArrow = new Konva.Arrow({
    x: 0,
    y: 0,
    points: [],
    pointerLength: 20,
    pointerWidth: 20,
    fill: 'black',
    stroke: 'black',
    strokeWidth: 3,
    lineCap: 'round',
    lineJoin: 'round',
    tension: 0,
    id: "userArrow"
  })*/
 userArrow = new Konva.Path({
  data: "",
  strokeWidth: 4,
  stroke: 'black',
  lineCap: 'round',
  lineJoin: 'round',
  id: "userArrow"
 })
  mouseOverShapeKey = "" // key of the shape that is currently hovered while dragging arrow, potentially target for arrow
  isDeleteDialogVisible = false
  textPlaceholder = "<type your text here>"
  connectorCornerRadius = 10 // radius of the corners of the connector
  areCanvasEventsSuspended = false
  topDownTreenextPos: number = 0; // variable used to generate top down tree
  horizontalSpacingTopDownTree: number = 10; // Adjust as needed
  verticalSpacingTopDownTree: number = 100; // Adjust as needed
  private physicsNodesData: Node[] = [] // used for creating physical model o nodes to distribute them on canvas without overlapping
  private physicsLinksData: Link[] = [] // used in physics model to attract connected nodes together
  isShiftPressed = false
  nestedTasksKeys: {key: string, parentKey: string, kids: string[], xOffset: number, yOffset: number, width: number, height: number, color: string}[] = []
  pointerPosition: {x: number, y: number} = {x: 0, y: 0}
  usersCursorPositions: {"userId": string, "name": string, position: {x: number, y: number}, "object": Konva.Image, "isLaser": boolean, color: string, label: Konva.Text}[] = []
  faceIcons: string[] = ["face1", "face2", "face3", "face4", "face5", "face6", "face7", "face8", "face9", "face10", "face11"]
  colors: string[] = []
  randomFace = 0
  laserLines: {"userId": string, "laserLine": Konva.Line, "color": string}[] = []
  shareCanvasPopupVisible = false
  canvasLink = ""
  wheelTimeout: any = null
  stepsToUndo = 0
  isDragging = false; // used to detect if user is dragging canvas with two fingers
  touchMoveX = 0; // latest x position of touch move
  touchMoveY = 0; // latest y position of touch move
  startCenter = { x: 0, y: 0 }; // Initial center point between two touches
  prevCenter = { x: 0, y: 0 }; // Previous center point between two touches
  initialDistance = 0; // initial distance between two fingers
  initialScale = 1; // initial scale of the canvas
  orientation: string = ''; // orientation of user device
  isMobile = false;
  handleKeyDownBound: any
  isPromptPopupVisible = false
  isPromptPopupAddButtonVisible = false
  prompt = ""
  searchPosts = true
  searchTasks = false
  contentFoundByPrompt: {"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string, "contentType": string}[] = []
  promptFoundMessage: string = ""
  isLoadingCursor = false
  private panInterval: any = null;
  private panDirection = { x: 0, y: 0 };
  isMacBook = false
  statusReportContent = ""
  isStatusReportVisible = false
  progressPoints: { x: number, y: number, progress: number, label: string, color: string }[] = []
  isContextMenuCollapseExpandVisible = false
  isSelectedShapeExpanded = true
  isContextMenuCommentlistVisible = false
  friendlyNameObjectType = "" // field used to display friendly name of the object type in commentlist
  private changeQueue: (() => Promise<void>)[] = []; // queue of changes to be saved
  private isSaving: boolean = false; // flag to indicate if saving is in progress
  isSavingInstances: number = 0 // number of instances of saving is in progress
  isStoryMapAdded = false
  isCursorCurrrentlyMoving = false // flag to indicate if cursor is currently moving programmatically
  isProductlyMode = true // flag to indicate if productly mode is enabled
  draggedItem: any = null
  clickedPopupMenuShapeKey = ""
  showChatbotPopup = false // flag to indicate if chatbot popup is visible
  messageToChatbot = "Hello, how are you?"
  isDraggingDraggedItem = false
  placeholders: Konva.Group[] = []
  isContextMenuTreeVisible = false
  treeCardWidth = 300
  treeCardHeight = 180
  treeCardMargin = 70
  selectedTreeCardType = ""
  availableKidCardTypes: string[] = [] // list of kids card types that can be added to the selected card type
  selectedTreeCardKey = ""
  treeCards: {key: string, card: OpportunityCard | OutcomeCard, leftPlaceholder: AddCardPlaceholder, rightPlaceholder: AddCardPlaceholder, parentKey: string, kidCardKeys: string[], cardType: string, horizontalSpace: number, content: string, topBorderColor: string, status: string, rowSide: string, doAddButtons: boolean, tag: string, priority: number, contentKey: string, isKanbanTask: boolean, isKnowledgeBaseItem: boolean, treeLevel: number, order: number, kidCardTypes: string[], startDate: string, endDate: string, percentProgress: number, solutionType: string}[] = []
  loadedTreeCards: any[] = []
  selectedCards: {key: string, card: OpportunityCard | OutcomeCard, leftPlaceholder: AddCardPlaceholder, rightPlaceholder: AddCardPlaceholder, parentKey: string, kidCardKeys: string[], cardType: string, horizontalSpace: number, content: string, topBorderColor: string, status: string, rowSide: string, doAddButtons: boolean, tag: string, priority: number, contentKey: string, isKanbanTask: boolean, isKnowledgeBaseItem: boolean, treeLevel: number, order: number, kidCardTypes: string[], startDate: string, endDate: string, percentProgress: number, solutionType: string}[] = []
  isManualTreeComponentPopupVisible = false
  selectedParentKey = ""
  manualAddTitle = ""
  manualAddContent = ""
  treeCardPriority = 0
  isEditCardNamePopupVisible = false
  @ViewChild('treeCardNameAddInput') treeCardNameAddInput: ElementRef;
  @ViewChild('treeCardNameEditInput') treeCardNameEditInput: ElementRef;
  placeholderRowSide: string = "left"
  treeRootKey = "" // key of the root card of the ost tree
  site = environment.site
  personas: {"name": string, "key": string, "description": string, "isSelected": boolean}[] = []
  personasPrompt = ""
  isDataSourcesVisible = false
  selectedContent: Post[] = []
  skippedContentKeys: string[] = []
  contentListContextMessage = ""
  isPostPanelOpen = false
  selectedPostKey = ""
  post = {} as Post | null
  columnKey = ""
  color = ""
  areKidsColored = false
  areKidsTagged = false
  isCompleted = false
  imageURLs: string[] = []
  captureImage = false
  touchPointClicked = true
  touchPoints: {shape: Konva.Rect, isDragging: boolean}[] = []
  minContentLengthForOST = 1000 // min length of content to extract for OST
  maxContentLengthForOST = 30000 // max length of content to extract for OST
  useMOE = false // if true, mixture of experts is used to generate OST
  donotShowContentList = true // if true, content list is not shown in canvas, it is used to load content from contentlist component but without displaying it, it is when screen is initiated only
  promptLanguage = "English"
  modelKey = "gemini-3-pro-preview" //"gemini-2.5-pro" //"gemini-2.5-flash-lite" 
  researchReportKey = ""
  researchReport = {} as ResearchReport
  isResearchPopupVisible = false
  researchPopupContent: {title: string, content: string, sources: string} = {title: "", content: "", sources: ""}
  isDeepSearchPopupVisible = false
  isGenerateByAIPopupVisible = false
  researchTargetPrompt = ""
  isResearchReportUploaded = false
  isRagchatVisible = false
  dialogKey = ""
  chatComments: {"content": string, "isAI": boolean}[] = []
  progressStatus = ""
  progressLog: string[] = []
  private previousLogLength = 0;
  @ViewChild('progressLogWrapper') progressLogWrapper!: ElementRef;
  @ViewChild('reportContent') reportContent!: ElementRef;
  unsubisLoading: any // observer for loading status
  unsubProgressStatus: any // observer for progress status
  researchReportDocumentKey = "" // key of the document in the storage associated with the research report
  llmLimit = 0
  maxChapters = 30
  rtfEditor = new Editor()
  isRTFEditorClicked = false // if true, RTF editor is clicked and visible, if false, RTF editor is hidden and only beginning of content is displayed as static html
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    //['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];
  loadingCounter = 0 // counter of loading cards, used to display loading indicator
  setFocusKey = ""
  unsubFocus: any = null
  dropPlaceholders: any[] = []
  hoverDropPlaceholderKey: string = ""
  canvasPermissions: CanvasPermissions = {
    canAnonymousEditCards: false,
    canAnonymousAddCards: false,
    canAnonymousDeleteCards: false,
    canAnonymousLaunchAI: false,
    canAnonymousForceFocusCanvas: false,
    canAnonymousDownloadCanvas: false,
    canAnonymousChangeCardPriority: false,
    canAnonymousCommentCards: false,
    isFastAIUsed: true,
    canAnonymousLaunchKnowledgeBase: false,
    canAnonymousLaser: false,
  }
  showPermissionsPopup = false // if true, permissions popup is shown
  lastTouch: { x: number, y: number } = { x: 0, y: 0 }; // last user touch position
  isSuperUser = false // if true, user is super user and has all permissions
  showHelpPopup = false // if true, help popup is shown
  isRightClickMenuVisible = false // if true, right click menu is visible
  isRagPopupVisible = false // if true, rag popup is visible
  userQuery = ""
  responseChunks: Chunk[] = []
  selectedContentKeys: string[] = []
  useSearchGrounding = false
  additionalContent: string = ""
  chatTitle = "Chat with retrieved content"

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private breakpointObserver: BreakpointObserver, private dialog: MatDialog, private firestore: FirestoreService, private router: Router, private search: SearchService, private realtime: RealtimeService, private service: SharedServiceService, private gemini: GeminiService, private research: ResearchService, private publicresearch: PublicresearchService, private geminiService: GeminiService, private http: HttpClient) {
    this.randomFace = Math.floor(Math.random()*this.faceIcons.length-1) // random face icon for following user cursor
    this.colors = [...firestore.colors]
    this.laserLine.stroke(this.colors[this.randomFace])
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = this.checkIfMobile();
    }
    this.isMacBook = this.detectDevice();
    if (this.isProductlyMode == true) {
      this.tr = new Konva.Transformer({id: "transformer", padding: 5, anchorSize: 10, anchorStroke: '#459289', anchorFill: '#459289', borderStroke: "#459289", anchorStrokeWidth: 2, hitStrokeWidth: 10, keepRatio: false, enabledAnchors: []});
    }
    this.site = environment.site
    this.isProductlyMode = environment.site === 'productly' // detect which site is being built and deployed
  }

  ngOnInit() {
    this.detectOrientation();
    this.showHelpPopup = true
    setTimeout(() => {
      this.showHelpPopup = false
    }, 10000)
  }

  ngAfterViewInit() {
    this.initializeCanvas().then(() => {
      this.firestore.getUserLLMLimits(this.userId).then(llmLimit => {
        this.llmLimit = llmLimit
      })
    })
  }

  ngAfterViewChecked() {
    if (this.progressLog.length !== this.previousLogLength) { // scrolls to bottom of progress log when new message is added
      this.scrollToBottom();
      this.previousLogLength = this.progressLog.length;
      this.setFocus()
    }
  }

  @HostListener('window:resize')
  onResize() {  // Detect orientation on resize
    this.detectOrientation();
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Check if the pressed key is 'Escape'
    if (event.key === 'Escape') {
      this.hideContextMenus()
      this.hidePopupMenu()
      this.isEditCardNamePopupVisible = false
      this.isPostPanelOpen = false
      this.selectedShapeKey = ""
      this.selectedTreeCardKey = ""
      this.selectedContent = []
      this.selectedPostKey = ""    
    }
  }

  async initializeCanvas() {
    this.isCanvasVisible = false
    this.isLoadingCursor = true
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, while canvas is being prepared..."
    this.loadingTitle = "Loading canvas."
    if (this.isAnonymous == true) {
      this.isReadOnly = true
    }
    await this.getPermissions()
    history.pushState(null, '', location.href); // this removes browser back button by deleting history, so user can't go back to previous state
    window.onpopstate = () => {
      history.pushState(null, '', location.href);
    }
    // Determine the initial orientation
    this.detectOrientation();
    if (this.connectedPostKey) {
      await this.firestore.getPost(this.organizationKey, this.connectedPostKey).then(p => {
        const post: Post | null = this.preparePost(p, this.projectName)
        if (post != null) {
          this.fileName = post.name.slice(0, 40)
          this.getPersonas(post.tags)
        } 
      })
    }

    this.listenToResearchProgress()
    this.listenToFocus()
    this.doc = document.getElementById("container");
    this.listenToShiftKey()
    this.donotShowContentList = true // for productly mode display contnet list for the moment to get selected content
    this.isDataSourcesVisible = true // contentlist component will automatically be closed after getting selected content
    this.startListeningCursors()
    this.isLoadingLabelVisible = false
    this.isLoadingCursor = false
    this.isCanvasVisible = true
  }

  private detectOrientation() {
    if (window.innerWidth > window.innerHeight) {
      if (this.orientation != 'Landscape') {
        this.orientation = 'Landscape';
      }
    } else {
      if (this.orientation != 'Portrait') {
        this.orientation = 'Portrait';
      }
    }
    this.resizeStage()
  }

  redrawLayer() {
    this.layer.batchDraw()
  }

  listenToResearchProgress() { // when deep research is launched, we need to listen to loading and progress status
    this.unsubisLoading = this.research.isLoading.subscribe((loading: boolean) => {
     // this.isLoadingLabelVisible = loading // zakomentowałem bo popup pojawiał się i znikał
    })
    this.unsubProgressStatus = this.research.progressStatus.subscribe((progressStatus: string) => {
      this.progressStatus = progressStatus
      this.progressLog.push(progressStatus)
    })
  }

  async getPersonas(tags: string[]) {
    this.personasPrompt = "Take into account the designed product is for the following personas: "
    await this.firestore.getTags(this.organizationKey).then((result: any) => {
      let personas: {"name": string, "key": string, "description": string, "isSelected": boolean}[] = []
      result.docs.forEach((child: any) => {
        const teamKey = child.get("teamKey")
        if (teamKey == this.selectedTeamKey) {
          let isSelected = false
          if (tags.includes(child.get("name"))) {
            isSelected = true
            this.personasPrompt += child.get("name")+": "+child.get("description")+", "
          }
          personas.push({"name": child.get("name"), "key": child.id, "description": child.get("description"), "isSelected": isSelected})
        }
      })
      if (personas.length == 0) {
        this.personasPrompt = ""
      }
      this.personas = personas
    })
  }


  detectDevice() {
      const platform = navigator.platform.toLowerCase();
      const userAgent = navigator.userAgent.toLowerCase();
      return platform.includes('mac') || userAgent.includes('macintosh');
  }

  closeContentList(posts: Post[]) {
 //   this.selectedContent = posts
    this.showDataSources(false)
  }
  

  ngOnChanges(changes: SimpleChanges) {
    if (changes['organizationKey'] || changes['projectKey']) {
      this.service.changeOrganization(this.organizationKey)
      this.service.changeProject(this.projectKey)
      this.canvasLink = "https://wroolo.com/canvas/"+this.organizationKey+"/"+this.canvasKey
      if (this.site == "productly") {
        this.canvasLink = "https://app.prodely.com/canvas/"+this.organizationKey+"/"+this.canvasKey
      }
      this.initiateStage()
      if (this.organizationKey != "") {
        this.firestore.getTemplatesArray(this.organizationKey, ["post", "workpackage"]).then(templates => {
          this.templates = templates
        })
      }
      if (this.projectKey != "" && this.canvasKey == "") {
        this.canvasKey = this.projectKey
      }

    }
    if (changes['isLeftMenuExpanded']) {
      this.updateToolbarPosition()
      this.detectOrientation();
    }
    if (changes['clickedOutsidePointerPosition']) {
      this.hideContextMenus()
      this.hidePopupMenu()
      this.isEditCardNamePopupVisible = false
      this.isPostPanelOpen = false
    }
  }

  ngOnDestroy() {
    if (this.subscribe) {
      this.subscribe()
    }
    if (this.unsubFocus) {
      this.unsubFocus()
    }
    window.removeEventListener('resize', this.resizeStage);
    document.removeEventListener('keydown', this.handleKeyDownBound);
    document.removeEventListener('mouseleave', this.stopPanning);
    document.removeEventListener('paste', this.extractClipboardData);
    if (this.unsubisLoading) {
      this.unsubisLoading.unsubscribe()
    }
    if (this.unsubProgressStatus) {
      this.unsubProgressStatus.unsubscribe()
    }
  }

  onContextMenu(event: MouseEvent) {
    event.preventDefault()
    this.hideContextMenus()
    this.hidePopupMenu()
    this.isEditCardNamePopupVisible = false
    this.isPostPanelOpen = false
    this.showRightClickMenu(event.clientX, event.clientY)
  }

  showRightClickMenu(x: number = 0, y: number = 0) {
    if (x == 0 && y == 0) {

      x = window.innerWidth - 200
      y = 140
    }
    const contextMenu = document.getElementById('right-click-menu')
    if (contextMenu) {
      let left = x-20
      let top = y-20
      if (left < 0) {
        left = 0
      }
      if (top < 0) {
        top = 0
      }
      if (left + 220 > window.innerWidth) {
        left = window.innerWidth - 220
      }
      if (top + 190 > window.innerHeight) {
        top = window.innerHeight - 190
      }
      contextMenu.style.left = left + 'px'
      contextMenu.style.top = top + 'px'
      this.detectTreeCardWithinPosition()
      this.isRightClickMenuVisible = true
    }
  }

  detectTreeCardWithinPosition() {
    const stage = this.stage;
    const pos = this.stage.getPointerPosition();
    if (stage && pos) {
      const shape = stage.getIntersection({ x: pos.x, y: pos.y });
      if (shape) {
        const parentId = shape.parent.id()
        if (parentId != undefined && parentId != "") {
          const treeCard = this.treeCards.find(tc => tc.key === parentId)

          if (treeCard) {
            this.selectedTreeCardType = treeCard.cardType
            this.selectedTreeCardKey = treeCard.key
          } else {
            this.selectedTreeCardType = "";
            this.selectedTreeCardKey = "";
          }
        } else {
          this.selectedTreeCardType = "";
          this.selectedTreeCardKey = "";
        }
      } else {
        this.selectedTreeCardType = "";
        this.selectedTreeCardKey = "";
      }
    }
  }

  onRightClickMenuExit() {
    this.isRightClickMenuVisible = false
  }

  onCloseChatbotPopup() {
    this.showChatbotPopup = false
  }

  sendTestPopupMessage() {
    this.messageToChatbot = "Mam do zrobienia opportunity solution tree, który ma być w formie drzewa. Możesz mi pomóc?"
    this.showChatbotPopup = true
  }

  stopPanning() {
    if (this.panInterval) {
      clearInterval(this.panInterval);
      this.panInterval = null;
      this.panDirection = { x: 0, y: 0 };
    }
  }

  checkIfMobile() {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  startListeningCursors() {
    const cursorRef = ref(getDatabase(), "cursors/"+this.canvasKey+"/cursors/");
    onValue(cursorRef, (snapshot) => {
      snapshot.forEach(cursor => {
        let uId = cursor.key as string
        if (uId != this.userId) { // if cursor is not the current user, not to draw myself
          const lastMove: Date = new Date(cursor.child("dateOfUpdate").val())
          const timeDiff = (new Date().getTime()) - lastMove.getTime()
          const i = this.usersCursorPositions.findIndex(user => user.userId == uId)
          if (i > -1) {
            const isLaser = cursor.child("isLaser").val()
            if (isLaser == false && this.usersCursorPositions[i].isLaser == true) {
              this.laserLines[i].laserLine.remove()
            } else if (isLaser == true && this.usersCursorPositions[i].isLaser == false) {
              this.layer.add(this.laserLines[i].laserLine)
            }
            if (timeDiff > 10 && timeDiff < 20000) { // if user has moved cursor recently, then update its position
              const x = cursor.child("x").val()
              const y = cursor.child("y").val()
              this.usersCursorPositions[i].position = {x: x, y: y}
              this.usersCursorPositions[i].object.x(x)
              this.usersCursorPositions[i].object.y(y)
              this.usersCursorPositions[i].label.x(x+22)
              this.usersCursorPositions[i].label.y(y+6)
              this.usersCursorPositions[i].object.moveToTop()
              this.usersCursorPositions[i].label.moveToTop()
              this.usersCursorPositions[i].isLaser = isLaser
              if (isLaser == true) { // draw laser line
                this.laserLines[i].laserLine.zIndex(5000)
                this.laserLines[i].laserLine.points(cursor.child("laserPoints").val())
              }
            }
          } else if (timeDiff < 20000) { // if user has moved cursor recently 20 seconds ago, then load image and draw laser line
            this.loadImage("../../assets/"+this.faceIcons[this.randomFace]+".png").then(image => {
              if (image) {
            const shape = new Konva.Image({
              x: 0,
              y: 0,
              width: 20,
              height: 20,
              draggable: true,
              image: image,
              zIndex: 1000,
              listening: false
            });
            this.layer.add(shape);
            const name = cursor.child("name").val() || ""
            const label = new Konva.Text({
              x: 0,
              y: 0,
              text: name,
              fontSize: 10,
              fontFamily: 'Arial',
              zIndex: 1000,
            });
            this.layer.add(label);
            const isLaser = cursor.child("isLaser").val()
            const color = cursor.child("color").val() || "rgba(182,0,0,0.5)"
            const laserLine = new Konva.Line({
              data: [],
              stroke: color,
              strokeWidth: 8,
              lineCap: 'round',
              lineJoin: 'round',
              zIndex: 5000,
            });
            this.layer.add(laserLine)
            this.usersCursorPositions.push({"userId": uId, "name": name, "position": {x: 0, y: 0}, "object": shape, "isLaser": isLaser, "color": color, "label": label})
            this.laserLines.push({"userId": uId, "laserLine": laserLine, "color": color})
          }
          })

          }
        }

      })
    })
  }

  async loadImage(url: string) {
    const base64Image: string = await this.getBase64Image(url) as string; // Type assertion added here

    const img = document.createElement('img');
    if (base64Image != null) {
      img.src = base64Image; // Now this works correctly as TypeScript recognizes it as a string
    }
   // img.className = 'card-img-top img-fluid';
    img.style.height = '100%';
    img.style.objectFit = 'cover'; // This will maintain aspect ratio and cover the div
    //img.style.width = '100%';
 //   imageContainer.appendChild(img);

    return img
};

  listenToCanvasHistory(organizationKey: string, contentKey: string) {
    const db = this.firestore.getApps()
    const docRef = doc(db, "organizations", organizationKey, "content", contentKey)
    return onSnapshot(docRef, async (snapshot) => {
      if (this.isListening == true && this.isSaving == false) {
        this.stepsToUndo = 0
        const history = snapshot.get("history")
        const changes = this.getChangedRows(this.canvasHistory, history)
        this.canvasHistory.length = 0
        this.canvasHistory = history || []
        await this.loadTreeCards()
        if (this.treeCards.length == 0 && this.connectedPostKey != "" && this.connectedPostKey != null && this.connectedPostKey != undefined) { // if no cards are on the tree, then create an outcome card
          this.createOutcomeCard(this.connectedPostKey)
        }
        await this.drawCanvasFromHistory(changes).then(() => {
          this.sendIsRenderingCompleted.emit(true)
        })
      }
  //    this.updateBackgroundGrid(); // I put it here because it is called right after move is finished

    })
  }

  async saveTreeCards() { // to trzeba będzie zoptymalizować, bo zapisuje się za dużo danych
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
    const t = this.treeCards.map(c => {
      return {
        key: c.key,
        x: c.card.x,
        y: c.card.y,
        width: c.card.width,
        height: c.card.height,
        content: c.content,
        color: c.topBorderColor,
        topBorderColor: c.topBorderColor,
        status: c.status,
        parentKey: c.parentKey,
        cardType: c.cardType,
        horizontalSpace: c.horizontalSpace,
        kidCardKeys: c.kidCardKeys,
        rowSide: c.rowSide,
        doAddButtons: c.doAddButtons,
        tag: c.tag,
        order: c.order,
        priority: c.card.priority,
        contentKey: c.card.contentKey,
        isKanbanTask: c.isKanbanTask,
        isKnowledgeBaseItem: c.isKnowledgeBaseItem,
        emoticonsString: c.card.emoticonsString || "",
        commentsCount: c.card.commentsCount || 0,
        nameImageURL: c.card.nameImageURL || "",
        startDate: c.startDate || "",
        endDate: c.endDate || "",
        percentProgress: c.percentProgress || 0,
        solutionType: c.solutionType || ""
      }
    })
    await this.firestore.updateCanvasTreeCards(this.organizationKey, this.canvasKey, t)
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
  }

  async loadTreeCards() { // this must be launched after loading kanban tasks and other cards
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
    this.loadingCounter = 0

    const l = await this.firestore.getCanvasTreeCards(this.organizationKey, this.canvasKey) || []
    const cardCount = l.length
    const areEqual = this.arraysAreEqual(l, this.loadedTreeCards, [])
    if (areEqual.areEqual == false && (areEqual.differentFields != "nameImageURL" && areEqual.differentFields != "content")) { // if cover image is different, then reload it. to jest trochę zaślepka, bo występuję błąd taki, że najpierw zmieniany jest obrazek a dopiero potem jego adres w bazie, więc przy odświeżaniu pojawia się błąd 403 bo próbuje pokazać nieistniejący obrazek
      this.loadedTreeCards = [...l]
     // this.recountCardKids()
      this.removeTreeCards()
      const promiseArray: any[] = []
      if (this.loadedTreeCards) {
        let order = 0
        for (let i = 0; i < this.loadedTreeCards.length; i++) {
          const card = this.loadedTreeCards[i]
          this.sortKidsByOrder(card.kidCardKeys)
          if (card.order == undefined) {
            card.order = order
          }
          if (card.contentKey != undefined && card.contentKey != "" && card.contentKey != null) { // if card has contentKey, then load its content
            promiseArray.push(this.firestore.getContent(this.organizationKey, card.contentKey)) 
          }
          order++
        }
        const cardContents = await Promise.all(promiseArray)
          for (const card of this.loadedTreeCards) {
            setTimeout(() => {
                this.loadingCounter++
                this.loadingTitle = "Loading cards... " + this.loadingCounter + "/" + cardCount
            })
            const cardContent = cardContents.find((c: any) => c.key == card.contentKey)
            await this.loadOSTCard(cardContent, card.key, card.x, card.y, card.width, card.height, card.content, card.color, card.status, card.parentKey, card.rowSide, card.doAddButtons, card.tag, card.priority, card.cardType, card.contentKey, card.horizontalSpace, card.kidCardKeys, card.topBorderColor, card.isKanbanTask || false, card.isKnowledgeBaseItem || false, card.emoticonsString || "", card.commentsCount || 0, card.nameImageURL || "", card.order, card.startDate || "", card.endDate || "", card.percentProgress || 0, card.solutionType || "")
          }
        this.refreshOSTTree()
      }
    } else if (areEqual.areEqual == false && (areEqual.differentFields == "nameImageURL" || areEqual.differentFields == "content")) { // nameImageURL is different, reloading cover image
      for (const card of this.loadedTreeCards) {
        const newNameImageURL = await this.firestore.getCanvasTreeCardCoverImageUrl(this.organizationKey, this.canvasKey, card.key)
        card.nameImageURL = newNameImageURL
        const cardElement = this.treeCards.find(c => c.key == card.key)?.card
        if (cardElement && newNameImageURL != "") { // replace cover image
          const emoticonsString = card.emoticonsString || ""
          const commentsCount = card.commentsCount || 0
          const startDate = card.startDate || ""
          const endDate = card.endDate || ""
          const percentProgress = card.percentProgress || 0
          this.layer.add(await cardElement.createCard(false, commentsCount, emoticonsString, newNameImageURL))
        }
      }
    }
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
    if (this.treeCards.length <= 1) {
      setTimeout(async () => { // if canvas history is empty, move to the central position so user is not lost
        await this.moveToPosition(250, 500, 1)
        const outcomeCard = this.treeCards.find(card => card.cardType == "Outcome")
        if (outcomeCard) {
            const shapeRect = outcomeCard.card.getShapeRect(); // Gets dimensions
            const position = outcomeCard.card.card.getAbsolutePosition();
            this.showShapeUnderlining(shapeRect, outcomeCard.card.card); // Pass the Konva.Group
        }
      }, 2000)
    }
  }

  sortKidsByOrder(kidKeys: string[]) {
    for (let i = 0; i < kidKeys.length; i++) {
      const kidIndex = this.treeCards.findIndex(k => k.key == kidKeys[i])
      if (kidIndex != -1) {
        const order = this.treeCards[kidIndex].order
      }
    }
  }

  recountCardKids() {
    this.loadedTreeCards.forEach(card => {
      card.kidCardKeys = []
    })
  }

  arraysAreEqual(arr1: any[], arr2: any[], ignoredFields: string[] = []) {
    let result = {areEqual: true, differentFields: ""}
    if (arr1.length !== arr2.length) return {areEqual: false, differentFields: ""};
    arr1.sort((a, b) => a.order - b.order)
    arr2.sort((a, b) => a.order - b.order)
    for (let i = 0; i < arr1.length; i++) {
      const r = this.objectsAreEqual(arr1[i], arr2[i], ignoredFields)
      if (!r.areEqual) {
        result.areEqual = false
        result.differentFields = r.differentFields
        return result;
      }
    }
    return result;
  }

  
  objectsAreEqual(obj1: any, obj2: any, ignoredFields: string[] = []) {
    let result = {areEqual: true, differentFields: ""}
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
  
    if (keys1.length !== keys2.length) return {areEqual: false, differentFields: ""};
  
    for (const key of keys1) {
      if (ignoredFields.includes(key)) continue; // skip ignored fields

      const val1 = obj1[key];
      const val2 = obj2[key];
  
      if (typeof val1 === 'object' && val1 !== null &&
          typeof val2 === 'object' && val2 !== null) {
            result = this.objectsAreEqual(val1, val2, ignoredFields)
        if (result.areEqual) return result;
      } else if(val1 !== val2) {
        result.areEqual = false
        result.differentFields = key
        return result;
      }
    }
    return result;
  }

  /*getChangedRows2(oldArray: CanvasHistory[], newArray: CanvasHistory[]): CanvasHistory[] { // returns array of changed items from newArray compared to oldArray of canvas history
    const changed: CanvasHistory[] = [];
    const oldMap = new Map(oldArray.map(item => [item.key, item]));     // Create a map for quick access to the old items by key
    if (newArray != undefined) {
      for (const newItem of newArray) {     // Check new items against the old items
        const oldItem = oldMap.get(newItem.key);
        if (!oldItem || !this.areCanvasHistoryItemsEqual(oldItem, newItem)) {
          changed.push(newItem);
        }
      }
    }
    for (const oldItem of oldArray) {     // You may also want to check for items that were removed in the new history
      if (!newArray.some(newItem => newItem.key === oldItem.key)) {
        changed.push(oldItem);
      }
    }
    return changed;
  }*/

  getChangedRows(oldArray: CanvasHistory[], newArray: CanvasHistory[]): CanvasHistory[] {
    const changed: CanvasHistory[] = [];
    const oldMap = new Map(oldArray.map(item => [item.key, item])); // Create a map for quick access to the old items by key
    
    if (newArray !== undefined) {
      for (const newItem of newArray) { // Check new items against the old items
        const oldItem = oldMap.get(newItem.key);
        if (!oldItem || !this.areCanvasHistoryItemsEqual(oldItem, newItem)) {
          changed.push(newItem);
        }
      }
      // The second loop to check for removed items from oldArray is removed
      // since you want to avoid adding any old items that aren't in newArray
    }
    return changed;
  }

  areCanvasHistoryItemsEqual(oldItem: CanvasHistory, newItem: CanvasHistory) { // returns true if two canvas history items are equal
    return oldItem.sequence === newItem.sequence &&
           oldItem.contentKey === newItem.contentKey &&
           oldItem.content === newItem.content &&
           oldItem.command === newItem.command &&
           oldItem.shape === newItem.shape &&
           oldItem.x === newItem.x &&
           oldItem.y === newItem.y &&
           oldItem.width === newItem.width &&
           oldItem.height === newItem.height &&
           oldItem.color === newItem.color &&
           oldItem.strokeWidth === newItem.strokeWidth &&
           oldItem.rotation === newItem.rotation &&
           oldItem.fromKey === newItem.fromKey &&
           oldItem.toKey === newItem.toKey &&
           JSON.stringify(oldItem.points) === JSON.stringify(newItem.points) &&
           oldItem.coverImageURL === newItem.coverImageURL;
  };

showShapeUnderlining(shapeRect: any, targetNode: Konva.Node) { // draws yellow outline around the shape bouncing and disappearing after 5 seconds
  const bounceMargin = 4; // Extra space around the shape

  // 1. Get the absolute position of the card on the stage
  const absPos = targetNode.getAbsolutePosition();
  const underlining = new Konva.Rect({
    // 2. Use the absolute position of the node
    x: absPos.x + shapeRect.width / 2 - 250,
    y: absPos.y + shapeRect.height / 2 - 500,
    width: shapeRect.width + bounceMargin,
    height: shapeRect.height + bounceMargin + 30,
    stroke: "#e4ff5c",
    strokeWidth: 4,
    opacity: 0.8,
    cornerRadius: 8, // Matches your card's cornerRadius
    offsetX: (shapeRect.width + bounceMargin) / 2,
    offsetY: (shapeRect.height + bounceMargin) / 2,
    listening: false
  });

  this.layer.add(underlining);
  underlining.moveToTop();

  // Start the infinite bouncing animation
  const tween = new Konva.Tween({
    node: underlining,
    duration: 0.5, // Speed of one "pulse"
    scaleX: 1.15,
    scaleY: 1.15,
    opacity: 0.4,   // Fade slightly as it grows
    yoyo: true,
    repeat: -1,     // Loop indefinitely
    easing: Konva.Easings.EaseInOut,
  });

  tween.play();

  // Remove everything after exactly 5 seconds
  setTimeout(() => {
    tween.destroy();      // Stop the animation logic
    underlining.destroy(); // Remove the shape from the layer
    this.layer.draw();     // Refresh the canvas
  }, 5000);
}

  async initiateStage() { // load canvas from history
    this.isPromptPopupVisible = false
    this.promptFoundMessage = ""
    this.isPromptPopupAddButtonVisible = false
    this.contentFoundByPrompt.length = 0
    this.canvasHistory.length = 0
    Konva.hitOnDragEnabled = true;
    if (this.doc) {
      this.stageWidth = this.doc.offsetWidth-25;
    }
    if (this.stage) {
      this.stage.destroy()
      this.layer.destroyChildren()
      this.layer.destroy()
      this.backgroundGrid.destroyChildren()
      this.backgroundGrid.destroy()
    }
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, while canvas is being prepared..."
    this.loadingTitle = "Loading canvas."
    this.stage = new Konva.Stage({
      container: 'container',
      width: this.stageWidth,
      height: this.stageHeight,
      draggable: false,
      pixelRatio: window.devicePixelRatio,
    });
    this.backgroundGrid = new Konva.Layer({
      listening: false,
    })
    this.stage.add(this.backgroundGrid)
    if (this.subscribe) {
      this.subscribe()
    }
    this.subscribe = this.listenToCanvasHistory(this.organizationKey, this.canvasKey)
    this.researchReportKey = await this.firestore.getReportKeyForCanvas(this.organizationKey, this.canvasKey)
    if (this.researchReportKey != "") {
      this.researchReport = await this.getResearchReport(this.researchReportKey)
    }
    await this.stage.add(this.layer);
    setTimeout(() => {
      this.setupSelection()
    }, 1000)



    this.handleKeyDownBound = this.handleKeyDown.bind(this)
    document.addEventListener('keydown', this.handleKeyDownBound);

    this.stage.on('dragend', () => 
      {
        this.clearSelection()
    //    this.updateBackgroundGrid()
        //this.updateCursorPosition()
      });

      this.minimapStage = new Konva.Stage({ // set up minimap
        container: 'minimap',
        x: 0,
        y: 0,
        width: this.minimapWidth,
        height: this.minimapHeight,
        pixelRatio: window.devicePixelRatio,
      });
      this.minimapStage.on('click tap', (event) => {
        // Get the position of the click relative to the minimap
        if (this.minimapStage) {
          const pos = this.minimapStage.getPointerPosition();
          if (pos) {
                    // Get the bounding box of the main layer 
            // Get the bounding box of the main layer 
            const boundingBox = this.layer.getClientRect({ skipTransform: true });

            // Current scale of the main canvas
            const mainStage = this.layer.getStage();
            const mainScaleX = mainStage.scaleX();
            const mainScaleY = mainStage.scaleY();
            
            // Calculate the scale factors based on the bounding box dimensions and the minimap
            const scaleX = this.minimapWidth / boundingBox.width;
            const scaleY = this.minimapHeight / boundingBox.height;
            const scale = Math.min(scaleX, scaleY);

            // Calculate the corresponding position on the main stage, while accounting for main canvas zoom
            const targetX = ((pos.x / scale) + boundingBox.x) * mainScaleX; // Reverse scale, translate bounding box's x, then apply main scale
            const targetY = ((pos.y / scale) + boundingBox.y) * mainScaleY; // Reverse scale, translate bounding box's y, then apply main scale
            this.moveToPosition(-targetX, -targetY, 1)
            // If you want to ensure the main layer is visible after panning
            this.layer.getStage().batchDraw();
          }
        }
      });

      this.updateMinimap()
      const position = await this.getUserCursorPosition()
      await new Promise(resolve => setTimeout(resolve, 100))
      this.detectOrientation();
      if (position) {
        await this.moveToPosition(position.cursorX, position.cursorY, position.scale)
      }
      this.isLoadingLabelVisible = false
      this.loadingMessage = ""

  }

  listenToShiftKey() {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key == "Shift") {
        this.isShiftPressed = true
      }
    });
    document.addEventListener('keyup', (event: KeyboardEvent) => {
      if (event.key == "Shift") {
        this.isShiftPressed = false
      }
    });
  }

  async updateCursorPosition() { // TO POWINNO BYC ZAPISYWANE W INNYM MIEJSCU, BO TYLKO NIEPOTRZEBNIE WZBUDZA ONSNAPSHOT
   const position = {x: this.stage.x(), y: this.stage.y(),}
    if (position) {
      let switchListeningInFunction = true
      if (this.isListening == false) {
        switchListeningInFunction = false
      }
      this.isListening = false
      await this.firestore.updateCursorPosition(this.organizationKey, this.canvasKey, this.userId, position.x, position.y, this.stage.scaleX()) // to strasznie miesza w onsnapshot, bo zmienia się wiele razy. dopoki nie przerobie zeby zapisywalo gdzie indziej to nie odkomentowywac!!!
      if (switchListeningInFunction == true) {
        this.isListening = true
      }
    }
  }

  async getUserCursorPosition() {
    return await this.firestore.getCanvasUsers(this.organizationKey, this.canvasKey).then(users => {
      return users.find(user => user.userId == this.userId)
    })
  }

  updateToolbarPosition() {
    const toolbar = document.getElementById('toolbar');
    if (toolbar) {
      toolbar.style.left = this.isLeftMenuExpanded ? '200px' : '70px';
    }
  }

  handleSelectionRectanglePointer(isPointerEnabled: boolean) { // change mode between pointer and canvas move
    this.isPointerEnabled = isPointerEnabled
    this.stage.draggable(isPointerEnabled)
   //   this.layer.add(this.selectionRectangle)
    if (isPointerEnabled == true) {
      this.clearSelection()
    }
  }
    
  calculateBackgroundGridPoints(corner: {x: number, y: number}) { // calculate and save the current dimensions of the bord
    this.startX = Math.floor((corner.x - this.stage.width() * this.gridOutsizePercentage * Math.pow(this.stage.scaleX(), -1)) / this.fieldSize) * this.fieldSize;
    this.endX = Math.floor((corner.x + this.stage.width() * (1 + this.gridOutsizePercentage) * Math.pow(this.stage.scaleX(), -1)) / this.fieldSize) * this.fieldSize;

    this.startY = Math.floor((corner.y - this.stage.height() * this.gridOutsizePercentage * Math.pow(this.stage.scaleY(), -1)) / this.fieldSize) * this.fieldSize;
    this.endY = Math.floor((corner.y + this.stage.height() * (1 + this.gridOutsizePercentage) * Math.pow(this.stage.scaleY(), -1)) / this.fieldSize) * this.fieldSize;
}

// draw lines
/*createBackgroundGridLines(start: number, end: number, horizontalLines: boolean) {
    let clone;

    for (let n = start; n < end; n += this.fieldSize) {
        clone = this.backgroundGridLine.clone({
            points: horizontalLines ? [ n, this.startY, n, this.endY ] : [ this.startX, n, this.endX, n ]
        });
        clone.perfectDrawEnabled(false); // some config options to improve performance
        clone.shadowForStrokeEnabled(false);
        clone.transformsEnabled("position");

        this.backgroundGrid.add(clone);
    }
}*/

// remove all grid lines and redraw //TODO lock if this function is still necessary
updateBackgroundGrid() {
  if (this.backgroundGrid) {
    this.backgroundGrid.destroyChildren();
    this.updateBackgroundGridLines();
    this.backgroundGrid.batchDraw();
  }
}

getFieldSize(scaleX: number): number {
  if (scaleX >= 5) return 10;
  else if (scaleX >= 2) return 50;
  else if (scaleX >= 1) return 100;
  else if (scaleX >= 0.5) return 200;
  else if (scaleX >= 0.25) return 500;
  else return 1000;
}

updateBackgroundGridLines() {
  if (Math.pow(this.stage.scaleX(), -1) > 10) return; // Don't draw grid if zoomed out too much
  this.fieldSize = this.getFieldSize(this.stage.scaleX());
  let transform = this.stage.getAbsoluteTransform().copy().invert();
  let topLeftCorner = transform.point({
      x: 0,
      y: 0
  });
  this.calculateBackgroundGridPoints(topLeftCorner);
  this.createBackgroundGridLines(this.startX, this.endX, true);
  this.createBackgroundGridLines(this.startY, this.endY, false);
}

createBackgroundGridLines(start: number, end: number, horizontalLines: boolean) {
  let clone;
  for (let n = start; n < end; n += this.fieldSize) {
      clone = this.backgroundGridLine.clone({
          points: horizontalLines ? [ n, this.startY, n, this.endY ] : [ this.startX, n, this.endX, n ],
          strokeScaleEnabled: false // Keep line width constant regardless of zoom level
      });
      clone.perfectDrawEnabled(false);
      clone.shadowForStrokeEnabled(false);
      clone.transformsEnabled("position");

      this.backgroundGrid.add(clone);
  }
}

  resizeStage() {
    if (this.doc) {
      let menuWidth = 255
      let bottomCrop = 90
      if (this.isLeftMenuExpanded == false) {
        menuWidth = 64
      }
      if (this.isAnonymous == true || this.fullScreen == true) {
        menuWidth = 0
        bottomCrop = 50
      }
      this.stageWidth = window.innerWidth-menuWidth;
      this.stageHeight = window.innerHeight-bottomCrop
      this.stage.width(this.stageWidth);
      this.stage.height(this.stageHeight);
      this.isDrawingArrow = false
      this.userArrow.remove()
      this.updateBackgroundGrid()
      this.redrawLayer()
    }
  }

  destroyAllNodes() {
    const children = this.layer.getChildren()
    children.forEach((shape: any) => {
      if (shape.id() && (shape.id().startsWith("frame-") /*|| shape.id().startsWith("arrow-") */|| shape.id().startsWith("postit-") || shape.id().startsWith("content-") || shape.id().startsWith("workpackage-") || shape.id().startsWith("image-") || shape.id().startsWith("freeline-") || shape.id().startsWith("eraserline-") || shape.id().startsWith("label-"))) {
        setTimeout(() => { // wait for the end of the current event loop to destroy the shape, otherwise last shape is not destroyed
          shape.destroy()
          this.deleteConnectedArrows(this.findConnectedArrows(shape.id()))
        })
      }
    });
    this.isStoryMapAdded = false
  }

  async drawCanvasFromHistory(cH: CanvasHistory[] = []) { 
    if (cH.length == this.canvasHistory.length) { // if the same number of commands, then just update the shapes because it means that it is done for the first time
      this.destroyAllNodes()
     // this.connectors.length = 0

      if (this.canvasHistory) {
        for (const command of this.canvasHistory) {
          await this.createCanvasHistoryStep(command);
        }
      }
    } else { // if different number of commands, then it means that only some of shapes are changed, so I need to update only the changed shapes
      for (const command of cH) {
        const historyIndex = this.canvasHistory.findIndex(item => item.key == command.key)
        if (historyIndex != -1) {
          this.canvasHistory[historyIndex] = command
        } 
        const shape = this.layer.findOne('#' + command.key)
       // const ids: string[] = []
        if (shape) {
          const shapeExists = this.canvasHistory.find(item => item.key == command.key)
          if (shapeExists) {
            if (shape.x() !== command.x || shape.y() !== command.y) {
              shape.position({ x: command.x, y: command.y });
            }
            if (shape.width() !== command.width || shape.height() !== command.height) {
              const scaleX = command.width / shape.width()
              const scaleY = command.height / shape.height()
              shape.scale({ x: scaleX, y: scaleY });
            }
            if (shape.rotation() != command.rotation) {
              shape.rotation(command.rotation)
            }
            if (shape instanceof Konva.Group) {
              const rectNode = shape.findOne('Rect') as Konva.Rect || shape.findOne('Path') as Konva.Path
              if (command.color != undefined && rectNode && command.color != rectNode.fill()) {
                rectNode.fill(command.color)
              }
            }
            if (command.content && shape instanceof Konva.Group) {
              const textNode = shape.findOne('Text') as Konva.Text
              if (textNode) {
                textNode.text(command.content)
              }
            }
            if (command.key.startsWith("freeline")) {// do nothing for freeline, cause for now user can only add new freelines
            }
          } else {
            shape.destroy()
            await this.createCanvasHistoryStep(command);
          }
        } else { // if shape does not exist, then it means that it is a new shape
          await this.createCanvasHistoryStep(command);
        }
        this.updateConnectors(this.connectorCornerRadius)
      }

    }
   // this.updateConnectors(this.connectorCornerRadius)
   if (this.canvasHistory.length > 0) {
      this.updateMinimap()
      this.redrawLayer();
   }
  }

  getDistance2(p1: {x: number, y: number}, p2: {x: number, y: number}) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
  }

  distanceFromCenterToEdge(width: number, height: number, angleInDegrees: number): number {
    const angleInRadians = (Math.PI / 180) * angleInDegrees;
    const cosTheta = Math.cos(angleInRadians);
    const sinTheta = Math.sin(angleInRadians);
    const distanceToVerticalEdge = (width / 2) / Math.abs(cosTheta);
    const distanceToHorizontalEdge = (height / 2) / Math.abs(sinTheta);
    return Math.min(distanceToVerticalEdge, distanceToHorizontalEdge);
  }

  getConnectorPathWithRoundedCorners(fromRect: Konva.Rect, toRect: Konva.Rect, cornerRadius: number, onlyPointsFrom: {x: number, y: number}[] = [], onlyPointsTo: {x: number, y: number}[] = []) {
    const fromBox = {
      x: fromRect.x(),
      y: fromRect.y(),
      width: fromRect.width(),
      height: fromRect.height(),
    };
  
    const toBox = {
      x: toRect.x(),
      y: toRect.y(),
      width: toRect.width(),
      height: toRect.height(),
    };

  
    const fromCenter = {
      x: fromBox.x + fromBox.width / 2,
      y: fromBox.y + fromBox.height / 2,
    };
  
    const toCenter = {
      x: toBox.x + toBox.width / 2,
      y: toBox.y + toBox.height / 2,
    };
  
    let start = this.getEdgeIntersection(fromBox, toCenter);
    let end = this.getEdgeIntersection(toBox, fromCenter);
    if (onlyPointsFrom.length > 0) {
      start = onlyPointsFrom[0]
    }
    if (onlyPointsTo.length > 0) {
      end = onlyPointsTo[0]
    }
    const dx = toCenter.x - fromCenter.x;
    const dy = toCenter.y - fromCenter.y;
  
    let points;
  
    if (Math.abs(dx) > Math.abs(dy)) {
      // Predominantly horizontal arrangement
      const midX = (start.x + end.x) / 2;
      points = [
        { x: start.x, y: start.y },
        { x: midX, y: start.y },
        { x: midX, y: end.y },
        { x: end.x, y: end.y },
      ];
    } else {
      // Predominantly vertical arrangement
      const midY = (start.y + end.y) / 2;
      points = [
        { x: start.x, y: start.y },
        { x: start.x, y: midY },
        { x: end.x, y: midY },
        { x: end.x, y: end.y },
      ];
    }
  
    // Generate the path data string with rounded corners
    const pathData = this.generateRoundedPath(points, cornerRadius);

    return pathData;
  }

      // Function to get the intersection point with rectangle edges
  getEdgeIntersection(box: {x: number, y: number, width: number, height: number}, point: {x: number, y: number}) {

        const cx = box.x + box.width / 2;
        const cy = box.y + box.height / 2;
        const px = point.x;
        const py = point.y;
    
        const dx = px - cx;
        const dy = py - cy;
    
        const tValues = [];
    
        if (dx !== 0) {
          const tLeft = (box.x - cx) / dx;
          const tRight = (box.x + box.width - cx) / dx;
          tValues.push(tLeft, tRight);
        }
        if (dy !== 0) {
          const tTop = (box.y - cy) / dy;
          const tBottom = (box.y + box.height - cy) / dy;
          tValues.push(tTop, tBottom);
        }
    
        // Filter tValues to get valid t in (0, 1)
        const validT = tValues.filter((t) => t >= 0 && t <= 1);
    
        // If no valid t is found, return center
        if (validT.length === 0) {
          return { x: cx, y: cy };
        }
    
        // Get the smallest t
        const t = Math.min(...validT);
    
        // Compute intersection point
        const x = cx + t * dx;
        const y = cy + t * dy;
        return { x, y };
  }

  generateRoundedPath(points: {x: number, y: number}[], cornerRadius: number) {
    if (points.length < 2) return '';
  
    let path = '';
    const len = points.length;
  
    path += `M ${points[0].x} ${points[0].y}`; // Move to the first point
  
    for (let i = 1; i < len; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];
      let radius = cornerRadius;
  
      // If not the last point and not the first point, apply rounding
      if (i < len - 1) {
        const p2 = points[i + 1];
  
        // Calculate distances to prevent overshooting
        const prevDist = Math.hypot(p1.x - p0.x, p1.y - p0.y);
        const nextDist = Math.hypot(p2.x - p1.x, p2.y - p1.y);
        if (prevDist === 0 || nextDist === 0) {
          // Skip rounding if distances are zero
          path += ` L ${p1.x} ${p1.y}`;
          continue;
        }
        radius = Math.min(cornerRadius, prevDist / 2, nextDist / 2);
  
        // Points before and after the corner
        const pBefore = this.getPointAtDistance(p1, p0, radius);
        const pAfter = this.getPointAtDistance(p1, p2, radius);
  
        // Line to the point before the corner
        path += ` L ${pBefore.x} ${pBefore.y}`;
  
        // Quadratic curve to point after corner
        path += ` Q ${p1.x} ${p1.y} ${pAfter.x} ${pAfter.y}`;
      } else {
        // For the last point, just draw a line
        path += ` L ${p1.x} ${p1.y}`;
      }
    }
    return path;
  }
  

  // Helper function to get a point at a certain distance along a line
  getPointAtDistance(p1: {x: number, y: number}, p2: {x: number, y: number}, distance: number) {
    const dx = p2.x - p1.x;
    const dy = p2.y - p1.y;
    const len = Math.hypot(dx, dy);
    if (len === 0) {
      // Return the original point to avoid division by zero
      return { x: p1.x, y: p1.y };
    }
    const unitX = dx / len;
    const unitY = dy / len;
    return {
      x: p1.x + unitX * distance,
      y: p1.y + unitY * distance,
    };
  }

 /* calculateControlPoints(start: { x: number, y: number }, end: { x: number, y: number }, offset: number): { cp1: { x: number, y: number }, cp2: { x: number, y: number }} {
    const dx = end.x - start.x;
    const dy = end.y - start.y;
    const distance = Math.sqrt(dx * dx + dy * dy);
    const unitX = dx / distance;
    const unitY = dy / distance;
  
    // Perpendicular vector
    const perpX = -unitY;
    const perpY = unitX;
  
    // Offset control points
    const cp1 = {
      x: start.x + dx / 3 + perpX * offset,
      y: start.y + dy / 3 + perpY * offset
    };
  
    const cp2 = {
      x: start.x + (2 * dx) / 3 + perpX * offset,
      y: start.y + (2 * dy) / 3 + perpY * offset
    };
  
    return { cp1, cp2 };
  }*/



    getCubicBezierPath(points: number[], tension: number) {
      if (points.length < 4) {
          return '';
      }
  
      let path = 'M' + points[0] + ' ' + points[1];
      const cp = this.getCubicControlPoints(points, tension);
  
      for (let i = 0; i < cp.length; i += 6) {
          path += ' C' + cp[i] + ' ' + cp[i + 1] + ' ' + cp[i + 2] + ' ' + cp[i + 3] + ' ' + cp[i + 4] + ' ' + cp[i + 5];
      }
  
      // Now, add arrowhead at the end
      const n = points.length / 2;
      const xLast = points[(n - 1) * 2];
      const yLast = points[(n - 1) * 2 + 1];
      const xPenultimate = points[(n - 2) * 2];
      const yPenultimate = points[(n - 2) * 2 + 1];
      const dx = xLast - xPenultimate;
      const dy = yLast - yPenultimate;
      const len = Math.hypot(dx, dy);
  
      if (len > 0) {
          const ux = dx / len;
          const uy = dy / len;
          const arrowLength = 10;
          const arrowWidth = 7;
          const xBase = xLast - ux * arrowLength;
          const yBase = yLast - uy * arrowLength;
          const perpUx = -uy;
          const perpUy = ux;
          const xLeft = xBase + perpUx * (arrowWidth / 2);
          const yLeft = yBase + perpUy * (arrowWidth / 2);
          const xRight = xBase - perpUx * (arrowWidth / 2);
          const yRight = yBase - perpUy * (arrowWidth / 2);
          path += ' M' + xLeft + ' ' + yLeft;
          path += ' L' + xLast + ' ' + yLast;
          path += ' L' + xRight + ' ' + yRight;
          path += ' Z';
      }
      return path;
  }

  getCubicControlPoints(points: number[], tension = 0.5): number[] {
    const n = points.length / 2;
    const controlPoints: number[] = [];

    for (let i = 0; i < n - 1; i++) {
        const x0 = i === 0 ? points[0] : points[(i - 1) * 2];
        const y0 = i === 0 ? points[1] : points[(i - 1) * 2 + 1];
        const x1 = points[i * 2];
        const y1 = points[i * 2 + 1];
        const x2 = points[(i + 1) * 2];
        const y2 = points[(i + 1) * 2 + 1];
        const x3 = i + 2 < n ? points[(i + 2) * 2] : x2;
        const y3 = i + 2 < n ? points[(i + 2) * 2 + 1] : y2;

        // Calculate control points for smooth cubic Bézier curves
        const cp = this.calculateControlPoints(x0, y0, x1, y1, x2, y2, tension);
        const cp1x = cp[2];
        const cp1y = cp[3];

        const cpNext = this.calculateControlPoints(x1, y1, x2, y2, x3, y3, tension);
        const cp2x = cpNext[0];
        const cp2y = cpNext[1];

        controlPoints.push(cp1x, cp1y, cp2x, cp2y, x2, y2);
    }
    return controlPoints;
}

calculateControlPoints(x0: number, y0: number, x1: number, y1: number, x2: number, y2: number, tension: number): number[] {
  const d01 = Math.hypot(x1 - x0, y1 - y0);
  const d12 = Math.hypot(x2 - x1, y2 - y1);

  const fa = tension * d01 / (d01 + d12);
  const fb = tension - fa;

  const cp1x = x1 + fa * (x0 - x2);
  const cp1y = y1 + fa * (y0 - y2);
  const cp2x = x1 - fb * (x0 - x2);
  const cp2y = y1 - fb * (y0 - y2);

  return [cp1x, cp1y, cp2x, cp2y];
}

getTransformedBox(rect: Konva.Shape) {
  return {
      x: rect.x(),
      y: rect.y(),
      width: rect.width() * rect.scaleX(),
      height: rect.height() * rect.scaleY()
  };
}

getCenter(box: { x: number, y: number, width: number, height: number }) {
  return {
      x: box.x + box.width / 2,
      y: box.y + box.height / 2
  };
}

getEdgePoints(box: { x: number, y: number, width: number, height: number }) {
  return [
      { x: box.x + box.width / 2, y: box.y }, // Top center
      { x: box.x + box.width, y: box.y + box.height / 2 }, // Right center
      { x: box.x + box.width / 2, y: box.y + box.height }, // Bottom center
      { x: box.x, y: box.y + box.height / 2 }, // Left center
  ];
}


calculateBrokenLinePoints(
  start: { x: number; y: number },
  end: { x: number; y: number },
  offsetFromMiddle: number,
  style: string
) {
  let points: number[] = [];

  if (style === 'fromBottomToTop') {
    // always vertical-horizontal-vertical in this style
    const verticalMidY = (start.y + end.y) / 2;

    points = [
      start.x, start.y,          // Start: bottom center of fromRect
      start.x, verticalMidY,     // Vertical down to mid Y
      end.x, verticalMidY,       // Horizontal to align above toRect
      end.x, end.y               // Vertical down to top center of toRect
    ];

  } else { // use previous general logic otherwise
  
    const dx = end.x - start.x;
    const dy = end.y - start.y;

    if (Math.abs(dx) > Math.abs(dy)) {
      // Predominantly horizontal
      let midX1 = (start.x + end.x) * 0.5 * (1 - offsetFromMiddle);
      let midX2 = (start.x + end.x) * 0.5 * (1 + offsetFromMiddle);
      points = [
        start.x, start.y,
        midX1, start.y,
        midX2, end.y,
        end.x, end.y
      ];
    } else {
      // Predominantly vertical
      let midY1 = (start.y + end.y) * 0.5 * (1 - offsetFromMiddle);
      let midY2 = (start.y + end.y) * 0.5 * (1 + offsetFromMiddle);
      points = [
        start.x, start.y,
        start.x, midY1,
        end.x, midY2,
        end.x, end.y
      ];
    }
  }
  return points;
}


getConnectorPointsBrokenLine(fromRect: Konva.Shape, toRect: Konva.Shape, offsetFromMiddle: number = 0, style: string = "nearest") {
  if (!fromRect || !toRect) {
      return [];
  }

  const fromBox = this.getTransformedBox(fromRect);
  const toBox = this.getTransformedBox(toRect);

  const fromCenter = this.getCenter(fromBox);
  const toCenter = this.getCenter(toBox);

  let start: { x: number, y: number };
  let end: { x: number, y: number };
  
  // Get the edge points from the rectangles
  const onlyPointsFrom = this.getEdgePoints(fromBox);
  const onlyPointsTo = this.getEdgePoints(toBox);

  // Decide how to connect
  if (style === "fromBottomToTop") {
      // Connect from the bottom of the first rectangle to the top of the second
      start = { x: fromBox.x + fromBox.width / 2, y: fromBox.y + fromBox.height }; // Bottom middle point
      end = { x: toBox.x + toBox.width / 2, y: toBox.y }; // Top middle point
  } else {
      // Use previous logic for nearest points
      start = this.findClosestPoint(onlyPointsFrom, toCenter);
      end = this.findClosestPoint(onlyPointsTo, fromCenter);
  }
  const points = this.calculateBrokenLinePoints(start, end, offsetFromMiddle, style);
  return points;
}

  findClosestPoint(points: {x: number, y: number}[], point: {x: number, y: number}) {
    let minDistance = Infinity
    let closestPoint = {x: 0, y: 0}
    points.forEach(p => {
      const distance = Math.hypot(p.x - point.x, p.y - point.y)
      if (distance < minDistance) {
        minDistance = distance
        closestPoint = p
      }
    })
    return closestPoint
  }

  getRoundedPath(points: number[], cornerRadius: number) {
    let path = '';
    const numPoints = points.length / 2;
    if (numPoints == 0) {
        return path;
    }

    let x0 = points[0], y0 = points[1];

    path += 'M' + x0 + ' ' + y0;

    if (numPoints == 1) {
        return path;
    }

    if (numPoints == 2) {
        let x1 = points[2], y1 = points[3];
        path += ' L' + x1 + ' ' + y1;
    } else {
        for (let i = 1; i < numPoints - 1; i++) {
            let xPrev = points[(i - 1) * 2], yPrev = points[(i -1) * 2 +1];
            let xCurr = points[i * 2], yCurr = points[i * 2 + 1];
            let xNext = points[(i + 1) * 2], yNext = points[(i + 1) * 2 + 1];

            // Vector from previous to current
            let vx1 = xCurr - xPrev;
            let vy1 = yCurr - yPrev;
            let len1 = Math.hypot(vx1, vy1);

            // Vector from current to next
            let vx2 = xNext - xCurr;
            let vy2 = yNext - yCurr;
            let len2 = Math.hypot(vx2, vy2);

            if (len1 === 0 || len2 === 0) {
                path += ' L' + xCurr + ' ' + yCurr;
                continue;
            }

            // Shorten the segments by the corner radius
            let r = Math.min(cornerRadius, len1 / 2, len2 / 2);

            // Points for the straight segments
            let x1 = xCurr - (vx1 / len1) * r;
            let y1 = yCurr - (vy1 / len1) * r;
            let x2 = xCurr + (vx2 / len2) * r;
            let y2 = yCurr + (vy2 / len2) * r;

            // Line to first point
            path += ' L' + x1 + ' ' + y1;

            // Quadratic curve to second point
            path += ' Q' + xCurr + ' ' + yCurr + ' ' + x2 + ' ' + y2;
        }

        // Last segment to last point
        let xPenultimate = points[(numPoints - 2) * 2], yPenultimate = points[(numPoints - 2) * 2 + 1];
        let xLast = points[(numPoints - 1) * 2], yLast = points[(numPoints - 1) * 2 + 1];

        let vx = xLast - xPenultimate, vy = yLast - yPenultimate;
        let len = Math.hypot(vx, vy);

        if (len === 0) {
            // Last two points are the same
            path += ' L' + xLast + ' ' + yLast;
        } else {
            let r = Math.min(cornerRadius, len / 2);
            let x1 = xLast - (vx / len) * r;
            let y1 = yLast - (vy / len) * r;
            path += ' L' + x1 + ' ' + y1;
            path += ' L' + xLast + ' ' + yLast;
        }
    }

    // Now, add arrowhead at the end
    // Compute direction of last segment
    let xPenultimate = points[(numPoints - 2) * 2], yPenultimate = points[(numPoints - 2) * 2 + 1];
    let xLast = points[(numPoints - 1) * 2], yLast = points[(numPoints - 1) * 2 + 1];
    let dx = xLast - xPenultimate;
    let dy = yLast - yPenultimate;
    let len = Math.hypot(dx, dy);

    if (len > 0) {
        // Unit vector in direction of last segment
        let ux = dx / len;
        let uy = dy / len;

        // Size of the arrowhead
        let arrowLength = 10;
        let arrowWidth = 7;

        // Base point of the arrowhead
        let xBase = xLast - ux * arrowLength;
        let yBase = yLast - uy * arrowLength;

        // Perpendicular vector for arrowhead width
        let perpUx = -uy;
        let perpUy = ux;

        // Left and right points of the arrowhead
        let xLeft = xBase + perpUx * (arrowWidth / 2);
        let yLeft = yBase + perpUy * (arrowWidth / 2);

        let xRight = xBase - perpUx * (arrowWidth / 2);
        let yRight = yBase - perpUy * (arrowWidth / 2);

        // Define the arrowhead as a closed subpath
        path += ' M' + xLeft + ' ' + yLeft;
        path += ' L' + xLast + ' ' + yLast;
        path += ' L' + xRight + ' ' + yRight;
        path += ' Z'; // Close the arrowhead path
    }
    return path;
}

  getConnectorPointsToCursor(fromRect: Konva.Rect, toCursor: {x: number, y: number}) { // calculate the points of the connector line from center of the fromRect to the cursor
    const from = fromRect.getPosition()
    const dx = toCursor.x - from.x;
    const dy = toCursor.y - from.y;
    const angle = Math.atan2(-dy, dx);
    const distanceFrom = this.distanceFromCenterToEdge(fromRect.width(), fromRect.height(), angle * (180 / Math.PI)) + 10;     // Calculate distances to the edges
  //  const distanceTo = this.distanceFromCenterToEdge(toRect.width(), toRect.height(), angle * (180 / Math.PI)) + 10;
    return [
      from.x + -distanceFrom * Math.cos(angle + Math.PI) + fromRect.width()*0.5,
      from.y + distanceFrom * Math.sin(angle + Math.PI) + fromRect.height()*0.5,

      toCursor.x, //+ -distanceTo * Math.cos(angle) + toRect.width()*0.5,
      toCursor.y, //+ distanceTo * Math.sin(angle) + toRect.height()*0.5,
    ];
  }

  generateConnectors(targets: TaskData[]) {
    var result: {id: string, from: string, to: string}[] = [];
    targets.forEach(t => {
      if (t.parentKey != "" && this.getTargetByKey(t.id) > -1) {
        var from: string = t.parentKey;
        var to: string = t.id;
        result.push({
          id: 'connector-' + result.length,
          from: from,
          to: to,
        });
      }
    })
    return result;
  }

  updateObjects(connectors: {id: string; from: string; to: string;}[]) {
    this.targets.forEach((target) => {
      var node = this.layer.findOne('#' + target.id);
      if (node) {
        node.x(target.x);
        node.y(target.y);
      }
    });
    connectors.forEach((connect) => {
      const line = this.layer.findOne('#' + connect.id) as Konva.Line; // Type casting to Konva.Line
      const fromNode = this.layer.findOne('#' + connect.from) as Konva.Rect; // Type casting to Konva.Rect
      const toNode = this.layer.findOne('#' + connect.to) as Konva.Rect; // Type casting to Konva.Rect
      if (fromNode && toNode && line) {
        const points = this.getConnectorPointsBrokenLine(
          fromNode,
          toNode,
          
        );
        line.points(points);
      }
    });
  }

  getWorkpackageByKey(key: string) {
    for (let i = 0; i < this.workpackages.length; i++) {
      if (key == this.workpackages[i].key) {
        return i
      }
    }
    return -1
  } 

  getTargetByKey(key: string) {
    for (let i = 0; i < this.targets.length; i++) {
      if (key == this.targets[i].id) {
        return i
      }
    }
    return -1
  }

  countKidsByParent(parentKey: string) {
    let kids = 0
    this.targets.forEach(t => {
      if (t.parentKey == parentKey) {
        kids += 1
      }
    })
    return kids
  }

  countNestingLevel(w: TaskData, ns = 0) {
    let nestingLevel = ns
    if (w.parentKey == "") {
      return nestingLevel
    } else {
      const packageInd = this.getTargetByKey(w.parentKey)
      if (packageInd > -1) {
        nestingLevel = this.countNestingLevel(this.targets[packageInd], nestingLevel+1)
      }
      return nestingLevel
    }
  }

  generateBoxes() {
    this.targets.length = 0
    this.workpackages.forEach(w => {
      let name = w.nameHTML || w.name
      if (name.length > 0) {
        this.targets.push({
          id: w.key,
          x: 0,
          y: 0,
          name: name,
          color: w.color || "#ffffff",
          parentKey: w.parentKey,
          nestingLevel: 0,
          maxParallelKids: 0,
          sequence: w.sequence,
          verticalBand: 0,
          kidKeys: [],
          yPos: 0,
          coverImageURL: ""
        });
      }
    })
    this.targets.forEach(t => {
      t.maxParallelKids = this.countKidsByParent(t.parentKey)
      const nestingLevel = this.countNestingLevel(t)
      t.nestingLevel = nestingLevel
    })
    this.findKids()
    this.countVerticalSequence()
    let yOffset = 0
      this.targets.forEach(t => {
        if (t.nestingLevel == 0) {
          yOffset = this.locateBox(t, yOffset)
        }
      })
  }

  locateBox(task: TaskData, yOffset: number) {
    task.x = 50 + task.nestingLevel * (this.boxWidth+this.boxMargin)
    if (task.sequence == 0) {
      task.y =  yOffset
    } else {
      task.y = (this.boxHeight+this.boxMargin) + yOffset
    }
    yOffset = task.y
    task.y += 50
    let i = 0
    this.targets.forEach(t => {
      if (t.parentKey == task.id) {
        yOffset = this.locateBox(t, yOffset)
      }
      i += 1
    })
    return yOffset
  }

  getAboveBoxPosition(level: number, sequence: number) {
    let posY = 0
    this.targets.forEach(t => { 
      if (t.nestingLevel == level && t.sequence == sequence) {
        posY = t.y
      }
    })
    return posY
  }

  async drawBoxes() {
    this.connectors.forEach((connect) => {
      var line = new Konva.Arrow({
        stroke: 'black',
        id: connect.id,
        fill: 'black',
        points: [0, 0, 100, 100], // Example points, replace with actual logic
      });
      this.layer.add(line);
    });
    let promiseArray: Promise<any>[] = []
    this.targets.forEach((target) => {
      promiseArray.push( this.generateImagesFromDOM(target.name, target.id, target.color, this.boxWidth, this.boxHeight, target.coverImageURL, "left").then(result => {
        const shape = new Konva.Image({
          id: target.id,
          x: target.x,
          y: target.y,
          width: this.boxWidth,
          height: this.boxHeight,
          draggable: true,
          stroke: "#bfbfbf",
          fill: "#ffffff",
          cornerRadius: 4,
          image: result,
        //  zIndex: 1,
          name: 'selectable',
        });
        this.layer.add(shape);
        shape.on('dragstart', () => {
          this.hideContextMenus()
        })
        shape.on('dragmove', () => {
          if (this.selectedObjects.length == 0) {
            target.x = shape.x();  // mutate the state
            target.y = shape.y();
  
            // update nodes from the new state
            this.updateObjects(this.connectors);
            this.updateMinimap();
          }
        });
        shape.on('dragend', () => {
            target.x = shape.x();  // mutate the state
            target.y = shape.y();
      //    if (this.selectedObjects.length == 0) {
            this.updateObjects(this.connectors);
            this.updateBackgroundGrid()
       //   }
        })
      }))
    });
    await Promise.all(promiseArray).then(() => {
      this.isRenderingCompleted = true
      this.sendIsRenderingCompleted.emit(true)
    })
    return
  }

  async generateImagesFromDOM(name: string, key: string, color: string, width: number, height: number, coverImageURL: string, border: string = "none") {
    const index = this.boxContent.findIndex(b => b.key === key);
    
    if (index > -1) {
      this.boxContent[index].content = name;
    }
      // Create a container to hold the generated elements
      const container = document.createElement('div');
      document.body.appendChild(container);
      
      // Create the main div
      const div = document.createElement('div');
      div.id = key; // Create a unique ID
      if (border == "left") {
        div.style.paddingLeft = '4px';
      } else if (border == "right") {
        div.style.paddingRight = '4px';
      }
      div.style.position = 'relative'
      div.style.width = width + 'px';
      div.style.height = height + 'px';
      div.style.borderRadius = '4px'; // Optional rounded corners
      div.style.boxSizing = 'border-box'; // Include padding in width
      div.style.overflow = 'hidden'; // Ensure the image and text stay within bounds

      if (border == "right") {
        const borderElement = document.createElement('div');
        borderElement.style.position = 'absolute';
        borderElement.style.top = '0';
        borderElement.style.right = '0';
        borderElement.style.width = '8px'; // Thickness of the border
        borderElement.style.height = '100%';
        borderElement.style.backgroundColor = color;
        div.appendChild(borderElement);
      } else if (border == "left") {
        const borderElement = document.createElement('div');
        borderElement.style.position = 'absolute';
        borderElement.style.top = '0';
        borderElement.style.left = '0';
        borderElement.style.width = '8px'; // Thickness of the border
        borderElement.style.height = '100%';
        borderElement.style.backgroundColor = color;
        div.appendChild(borderElement);
      }

      // Set the background image if URL exists
      if (coverImageURL && coverImageURL != "") {
        const imageContainer = document.createElement('div');
        imageContainer.style.width = '100%';
        const imageHeight = name === "" ? '100%' : '50%';
        imageContainer.style.height = imageHeight; // Set height according to the presence of a name
        imageContainer.className = 'image-container';
        imageContainer.style.overflow = 'hidden'; // Optional: ensure there are no overflow issues
        const base64Image: string = await this.getBase64Image(coverImageURL) as string; // Type assertion added here
        const img = document.createElement('img');
        if (base64Image != null) {
          img.src = base64Image; // Now this works correctly as TypeScript recognizes it as a string
        }
        img.style.width = '100%';
        img.style.objectFit = 'cover'; // This will maintain aspect ratio and cover the div
        img.style.height = 'auto';   // Maintain aspect ratio
        img.style.overflow = 'hidden'; // Optional: ensure there are no overflow issues
        imageContainer.appendChild(img);
        div.appendChild(imageContainer);
      }
  
      if (name != "") {
        // Create the lower part for the text
        const textDiv = document.createElement('div');
        textDiv.style.height = '50%'; // Lower half
        textDiv.style.padding = '5px';
        textDiv.style.fontSize = '14px';
        textDiv.style.fontFamily = 'Poppins';
        textDiv.style.textAlign = 'left'; // Align the text
        textDiv.style.boxSizing = 'border-box'; // Include padding in width
        textDiv.innerHTML = name;
        textDiv.style.backgroundColor = 'white';
        // Append the image and text divs to the main div
        div.appendChild(textDiv);
      }
      container.appendChild(div);
      const canvas = await html2canvas(div);
      document.body.removeChild(container); // Remove the container from the DOM
      return canvas;
  }


async getBase64Image(url: string) {   // Helper function to convert image to Base64
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch image");
  }
  const blob = await response.blob();
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error fetching image:", error);
    return null;
  }
}

  async generateStorymap() {
    console.time("generateStorymap")
    this.isDrawingStorymap = true
    setTimeout(() => {
    this.generateBoxes()
    this.connectors = this.generateConnectors(this.targets)
    this.drawBoxes().then(() => {
      this.updateObjects(this.connectors);
      this.isDrawingStorymap = false
      })
    }, 100)
  }

  async createCanvasHistoryStep(command: any) {
    if (command.command == "add") {
      if (command.shape == "arrow") {
        this.drawConnector(command.fromKey, command.toKey, "broken")
      } else if (command.shape == "postit" || command.shape == "diamond" || command.shape == "circle") {
        await this.drawPostitContent(command)
      } else if (command.shape == "brush" || command.shape == "eraser") {
        this.drawFreeHandLine(command.key, command.points, command.color, command.strokeWidth, command.shape)
      } else if (command.shape == "box") {
        command.height = command.height ?? this.boxHeight
        command.width = command.width ?? this.boxWidth
        await this.drawBoxContent(command)
      } else if (command.shape == "frame") {
        await this.drawFrame(command)
      } else if (command.shape == "image") {
        command.height = command.height ?? this.boxHeight
        command.width = command.width ?? this.boxWidth
        await this.drawImageContent(command)
      } else if (command.shape == "label") {
        await this.drawLabel(command)
      }
    } else if (command.command == "update") {
      if (command.shape == "box") {
        command.height = command.height ?? this.boxHeight
        command.width = command.width ?? this.boxWidth
        await this.updateBoxContent(command)
      } else if (command.shape == "postit" || command.shape == "diamond" || command.shape == "circle") {
        await this.updatePostitContent(command)
      } else if (command.shape == "frame") {
        await this.updateFrame(command)
      } else if (command.shape == "image") {
        command.height = command.height ?? this.boxHeight
        command.width = command.width ?? this.boxWidth
        await this.updateImageContent(command)
      } else if (command.shape == "label") {
        await this.updateLabel(command)
      }
    } else if (command.command == "delete") {
      await this.deleteBoxContent(command)
    }
  }

  async deleteBoxContent(command: any) {
    const shape = this.layer.findOne('#' + command.key);
    if (shape) {
      shape.destroy()
    }
  }

  countVerticalSequence() {
    this.targets.sort((a, b) => {
      return a.sequence - b.sequence;
    });

    let sequence = 0
    this.targets.forEach(t => {
      if (t.nestingLevel == 0) {
        t.sequence = sequence
        this.assignVerticalSequnce(t.kidKeys)
        sequence += 1
      }
    })
  }

  assignVerticalSequnce(keys: string[]) {
    let sequence = 0
    keys.forEach(k => {
      const index = this.getTargetByKey(k)
      this.targets[index].sequence = sequence
      if (this.targets[index].kidKeys.length > 0) {
        this.assignVerticalSequnce(this.targets[index].kidKeys)
      }
      sequence += 1
    })
    return sequence
  }

  findKids() {
    this.targets.forEach(t => {
      t.kidKeys.length = 0
    })
    this.targets.forEach(t => {
      if (t.parentKey != "") {
        const p = this.getTargetByKey(t.parentKey)
        if (p > -1) {
          this.targets[p].kidKeys.push(t.id)
        }
      }
    })

    this.targets.forEach(t => {
      if (t.parentKey == "") {
        t.maxParallelKids = t.kidKeys.length
        this.countMaxKidsNumber(t, t.maxParallelKids)
      }
    })
  }

  countMaxKidsNumber(target: TaskData, currentMaxKids: number) {
    let maxKids = target.kidKeys.length
    if (maxKids < currentMaxKids) {
      maxKids = currentMaxKids
    }
    if (target.kidKeys.length > 0) {
      target.kidKeys.forEach(key => {
        const t = this.targets[this.getTargetByKey(key)]
        const m = this.countMaxKidsNumber(t, maxKids)
        if (m > maxKids) {
          maxKids = m
        }
      })
    }
    target.maxParallelKids = maxKids
    return maxKids
  }

  onAddNewPost() { // user clicked add new post on postsearchpopup
    this.addPostPopupVisible = false
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, while new post is being created..."
    this.loadingTitle = "Adding new content..."
    this.addNewPost(true, "", false)
  }

  async addNewPost(showDialog: boolean, initialContent: string = "", automaticAnalysis: boolean = false, type: string = "post", color: string = "", addNewCard: boolean = true, templateKey: string = "") { // adds new post
    let switchListeningInFunction = true  
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
    if (templateKey == "") {
      templateKey = this.templates.filter(t => t.type == type)[0].key
    }
    const templateIndex = this.templates.findIndex(t => t.key == templateKey)
    let placeholder = "tap to edit this piece of knowledge"
    let status = ""
    if (type == "workpackage") { // if it is workpackage, add kanban columns and initial content to be displayed on kanban
      const columns = await this.firestore.getKanbanColumns(this.organizationKey, this.projectKey)
      columns.sort((a, b) => a.sequence - b.sequence)
      if (columns.length > 0) {
        status = columns[0].key
      }
      placeholder = initialContent
    }

    const key = await this.firestore.addWorkpackage(this.organizationKey, this.projectKey, this.userId, true, -1, "", "", templateKey, true, type, status, placeholder, color).then(key => {
      return key
    })
    let fields: PostField[] = []
    if ((type == "post") && templateIndex > -1) {
      if (automaticAnalysis == true) {
        this.search.generateTags(this.organizationKey, key, this.tags.map(tag => tag.tag.toLowerCase()), fields, this.newPost.tags, initialContent, -1, true)
      }
      if (templateKey == 'diary') {
        fields = this.firestore.addDiaryFields(fields)
      } else if (templateKey == 'link') {
        fields = this.firestore.addLinkFields(fields)
      } else if (templateKey == 'image') {
        fields = this.firestore.addImageFields(fields)
      } else {
        fields = this.firestore.generateFields(this.templates[templateIndex].fields)
      }
      if (initialContent != "") {
        let isAdded = false
        for (let i = 0; i < fields.length; i++) {
          if (fields[i].type == "html") {
            fields[i].content = initialContent
            isAdded = true
            break;
          }
        }
        if (isAdded == false) { // if there is no html field in the template, add it
          const uid = this.firestore.generateUID()
          fields.unshift({"key": "htmlContent"+uid, "content": initialContent, "placeholder": "type description", "type": "html", "noteType": "html", "sequence": 1, "links": [], "uid": uid, "date": "", "isExpanded": true, "label": ""})
          fields.unshift({"key": "htmlContentlabel"+uid, "content": "Description", "placeholder": "type description", "type": "label", "noteType": "label", "sequence": 1, "links": [], "uid": uid, "date": "", "isExpanded": true, "label": "Description"})
        }
      }
    } else if (type == "workpackage" && templateIndex > -1) {
      fields = this.firestore.generateFields(this.templates[templateIndex].fields)
      if (initialContent != "") {
        let isAdded = false
        for (let i = 0; i < fields.length; i++) {
          if (fields[i].type == "html") {
            fields[i].content = initialContent
            isAdded = true
            break;
          }
        }
        if (isAdded == false) { // if there is no html field in the template, add it
          const uid = this.firestore.generateUID()
          fields.unshift({"key": "htmlContent"+uid, "content": initialContent, "placeholder": "type description", "type": "html", "noteType": "html", "sequence": 1, "links": [], "uid": uid, "date": "", "isExpanded": true, "label": ""})
          fields.unshift({"key": "htmlContentlabel"+uid, "content": "Description", "placeholder": "type description", "type": "label", "noteType": "label", "sequence": 1, "links": [], "uid": uid, "date": "", "isExpanded": true, "label": "Description"})
        }
      }
    }
    await this.firestore.updateWorkpackageFields(this.organizationKey, key, fields).then(() => {
        let captureImage = false
        if (templateKey == 'image') {
          captureImage = true
        }
        if (showDialog == true) {
          this.isLoadingLabelVisible = false
          this.launchPostDialog(key, "", "", true, templateKey, captureImage)
        }
      return
    }).catch(() => {
      this.isLoadingLabelVisible = false
    })
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
    return key
  }

  async onAddWorkpackageCentrally(type: string, workpackages: {"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string}[], xOffs: number = 0, yOffs: number = 0, maxXOffset: number = 5000, direction: string = "horizontal", saveCanvas: boolean = true) {
    const currentPosition = this.getCentralPosition()
    this.onAddWorkpackage(type, workpackages, xOffs, yOffs, {x: currentPosition.x, y: currentPosition.y, width: this.boxWidth, height: this.boxHeight*2}, maxXOffset, direction, saveCanvas)
  }

  async onAddWorkpackage(type: string, workpackages: {"key": string, "name": string, "htmlName": string, "color": string, "coverImageURL": string}[], xOffs: number = 0, yOffs: number = 0, position: {x: number, y: number, width: number, height: number} = {x: 0, y: 0, width: 0, height: 0}, maxXOffset: number = 5000, direction: string = "horizontal", saveCanvas: boolean = true, rotation: number = 0) {
    let contentKey = ""
    this.addWorkpackagePopupVisible = false
    this.addPostPopupVisible = false
    if (workpackages.length > 0) {
      let yOffset = yOffs
      let xOffset = xOffs
      if (position.x == 0 || position.y == 0) {
        position.x = this.boxWidth
        position.y = this.boxHeight*2
      }
      for (let i = 0; i < workpackages.length; i++) {
        const p = workpackages[i];
        if (p.coverImageURL == undefined) {
          p.coverImageURL = ""
        }
        this.stepsToUndo += 1
        if (p.htmlName == undefined || p.htmlName == "") {
          p.htmlName = p.name
        }
        contentKey = p.key
        this.canvasHistory.push({
          key: type+"-"+p.key,
          contentKey: contentKey,
          content: p.htmlName,
          command: "add",
          shape: "box",
          width: position.width,
          height: position.height,
          color: p.color,
          strokeWidth: 3,
          points: [],
          x: xOffset+position.x,
          y: yOffset+position.y,
          rotation: rotation,
          sequence: this.canvasHistory.length,
          fromKey: "",
          toKey: "",
          coverImageURL: p.coverImageURL,
          zIndex: 100,
          isExpanded: true,
          dateOfUpdate: new Date(),
          isFixed: false
        })
        await this.drawBoxContent(this.canvasHistory[this.canvasHistory.length-1])
        const stageX = (-position.x+xOffset) * this.scale + this.stageWidth / 2; // I need to recalculate the position of the stage taking into account the zoom
        const stageY = (-position.y+yOffset) * this.scale + this.stageHeight / 2;
        this.moveToPosition(stageX, stageY, 1)
        if (direction == "horizontal") {
          xOffset += this.boxWidth + this.boxMargin
          if (xOffset > maxXOffset) {
            xOffset = 20
            yOffset += this.boxHeight*2 + this.boxMargin
          }
        } else if (direction == "vertical") {
          yOffset += this.boxHeight*2 + this.boxMargin
        }
      }
    }
    if (saveCanvas) {
      this.saveCanvas()
    }
    return contentKey
  }

  findObjectByKey(key: string) {
    const foundObjects = this.layer.find((node: any) => node.getAttr('id') === key);
    return foundObjects;
  }

  getBoxAttributes(key: string) {
    console.time("getBoxAttributes")
    let command : CanvasHistory = {key: "", contentKey: "", content: "", command: "", shape: "", width: 0, height: 0, color: "", strokeWidth: 0, points: [], x: 0, y: 0, rotation: 0, sequence: 0, fromKey: "", toKey: "", coverImageURL: "", zIndex: 100, isExpanded: true, dateOfUpdate: new Date(), isFixed: false}
    const node = this.layer.findOne((node: any) => node.getAttr('id') === key)
    if (node && node instanceof Konva.Shape) {
      command.key = node.id()
      command.x = node.x()
      command.y = node.y()
      command.width = node.width()
      command.height = node.height()
      command.rotation = node.rotation()
      //command.color = typeof node.stroke() === 'string' ? node.stroke() : ''; 
      command.strokeWidth = node.strokeWidth()
      command.content = ""
      command.zIndex = node.zIndex()
    }
    return command
  }

  async updateBoxContent(command: any) {
    console.time("updateBoxContent")
    const shape = this.layer.findOne('#' + command.key);
    if (shape) {
      shape.position({
        x: command.x,
        y: command.y,
      });
      shape.size({
          width: command.width,
          height: command.height,
      });
      shape.rotation(command.rotation)
      const sx = command.width / this.boxWidth
      const sy = command.height / (this.boxHeight*2)
      if (shape instanceof Konva.Image ) {
        shape.stroke(command.color)
        let border = ""
        if (command.key.startsWith("workpackage-")) {
          border = "left"
        } else if (command.key.startsWith("content-")) {
          border = "right"
        }
        this.generateImagesFromDOM(command.content, command.key, command.color || "#ffffff", command.width, command.height, command.coverImageURL, border).then(im => {
          shape.image(im)
        })
      }
    }
    console.timeEnd("updateBoxContent")
  }

  async updateLabel(command: any) {
    const shape = this.layer.findOne('#' + command.key);
    if (shape && shape instanceof Konva.Text) {
      shape.position({
        x: command.x,
        y: command.y,
      });
      shape.size({
        width: command.width,
        height: command.height,
      });
      shape.rotation(command.rotation)
      shape.fill(command.color)
      shape.text(command.content);
    }
  }

  async updatePostitContent(command: any) {
    const shape = this.layer.findOne('#' + command.key);
    if (shape) {
      shape.position({
        x: command.x,
        y: command.y,
      });
      shape.size({
          width: command.width,
          height: command.height,
      });
     // const sx = command.width / this.boxWidth
     // const sy = command.height / (this.boxHeight*2)
      const textNode = this.stage.findOne('Text');     // Get the Text node within the shape
      textNode.text(command.content);
    }
  }

  async updateFrame(command: any) {
    const shape = this.layer.findOne('#' + command.key);
    if (shape) {
      shape.position({
        x: command.x,
        y: command.y,
      });
      shape.size({
        width: command.width,
        height: command.height,
      });
    }
  }

  addPostitCentrally(width: number, height: number, content: string = "", color: string = "", isProductlyMode: boolean = false) {
    const currentPosition = this.getCentralPosition()
    return this.addPostitContent(currentPosition.x, currentPosition.y, width, height, content, color, true, "postit", isProductlyMode)
  }

  addLabelCentrally(width: number, height: number, content: string = "", color: string = "") {
    const currentPosition = this.getCentralPosition()
    this.addLabel(currentPosition.x, currentPosition.y, width, height, content, color, true)
  }

  addLabel(x: number, y: number, width: number, height: number, content: string = "", color: string = "", saveCanvas: boolean = true, rotation: number = 0, fontSize: number = 18) {
    if (color == "") {
      color = this.pickedColor
    }
    if (!x || isNaN(x)) {
      x = 10
    }
    if (!y || isNaN(y)) {
      y = 10
    }
    const key = "label-"+this.firestore.generateUID()
    if (content == "") {
      content = this.textPlaceholder
    }
    const historyComnmand = {
      key: key,
      x: x,
      y: y,
      width: width,
      height: height,
      color: color,
      content: content,
      command: "add",
      shape: "label",
      sequence: this.canvasHistory.length,
      contentKey: key,
      strokeWidth: 1,
      points: [],
      rotation: rotation,
      fromKey: "",
      toKey: "",
      coverImageURL: "",
      zIndex: 100,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: false
    }
    this.drawLabel(historyComnmand, fontSize)
    this.stepsToUndo += 1
    this.canvasHistory.push(historyComnmand)
    if (saveCanvas) {
      this.saveCanvas()
    }
    return key
  }

  addPostitContent( x: number, y: number, width: number, height: number, content: string = "", color: string = "", saveCanvas = true, shapeType: string = "postit", isProductlyMode: boolean = false) {
    if (color == "") {
      color = this.pickedColor
    }
    if (!x || isNaN(x)) {
      x = 10
    }
    if (!y || isNaN(y)) {
      y = 10
    }
    const key = "postit-"+this.firestore.generateUID()
    this.boxContent.push({key: key, content: content})
    if (content == "") {
      content = this.textPlaceholder
    }
    let isFixed = false
    if (isProductlyMode) {
      isFixed = true
    }
    const historyComnmand = {
      key: key,
      x: x,
      y: y,
      width: width,
      height: height,
      color: color,
      content: content,
      command: "add",
      shape: shapeType,
      sequence: this.canvasHistory.length,
      contentKey: key,
      strokeWidth: 1,
      points: [],
      rotation: 0,
      fromKey: "",
      toKey: "",
      coverImageURL: "",
      zIndex: 100,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: isFixed
    }

    this.drawPostitContent(historyComnmand)
    this.stepsToUndo += 1
    this.canvasHistory.push(historyComnmand)
    if (saveCanvas) {
      this.saveCanvas()
    }
    return key
  }

  createRoundedDiamondPathData(width: number, height: number, radius: number) {
    const halfWidth = width / 2;     // Define the four corner points of the diamond
    const halfHeight = height / 2;
    const points = [
      { x: halfWidth, y: 0 },    // Top point
      { x: width, y: halfHeight },      // Right point
      { x: halfWidth, y: height },     // Bottom point
      { x: 0, y: halfHeight },     // Left point
    ];
    let pathData = "";
    const len = points.length;
    for (let i = 0; i < len; i++) {
      const current = points[i];
      const next = points[(i + 1) % len];
      const prev = points[(i - 1 + len) % len];
      const vectorA = {       // Calculate vectors
        x: current.x - prev.x,
        y: current.y - prev.y,
      };
      const vectorB = {
        x: next.x - current.x,
        y: next.y - current.y,
      };
      // Calculate the length of vectors
      const lengthA = Math.hypot(vectorA.x, vectorA.y);
      const lengthB = Math.hypot(vectorB.x, vectorB.y);
  
      // Calculate the proportion of the radius to the side length
      const ratioA = Math.min(radius / lengthA, 0.5);
      const ratioB = Math.min(radius / lengthB, 0.5);
  
      // Calculate the adjusted points for rounded corners
      const pointA = {
        x: current.x - vectorA.x * ratioA,
        y: current.y - vectorA.y * ratioA,
      };
  
      const pointB = {
        x: current.x + vectorB.x * ratioB,
        y: current.y + vectorB.y * ratioB,
      };
  
      if (i === 0) {
        pathData += `M ${pointA.x} ${pointA.y}`;
      } else {
        pathData += ` L ${pointA.x} ${pointA.y}`;
      }
  
      // Add the quadratic curve for rounded corner
      pathData += ` Q ${current.x} ${current.y} ${pointB.x} ${pointB.y}`;
    }
  
    pathData += " Z"; // Close the path
    return pathData;
  }

createCirclePathData(cx: number, cy: number, radius: number): string {
  return `M ${cx} ${cy - radius} A ${radius} ${radius} 0 1 0 ${cx} ${cy + radius} A ${radius} ${radius} 0 1 0 ${cx} ${cy - radius}`;
}

  async drawLabel(command: CanvasHistory, fontSize: number = 18) {
    const shape = new Konva.Text({
      id: command.key,
      x: command.x,
      y: command.y,
      width: command.width,
      height: command.height,
      draggable: true,
      fontSize: fontSize,
      fontFamily: 'Poppins',
      fill: command.color,
      padding: 5,
      align: 'center',
      verticalAlign: 'middle',
      cornerRadius: 4,
      rotation: command.rotation,
      name: 'selectable',
    });
    shape.text(command.content)

    shape.on('dragstart', (e: any) => {
      this.hideContextMenus()
    })
    
    let previousPosition = { x: shape.x(), y: shape.y() };
    shape.on('dragmove', (e: any) => {
      const currentPosition = e.target.position();
      const dx = currentPosition.x - previousPosition.x;
      const dy = currentPosition.y - previousPosition.y;
      previousPosition.x = currentPosition.x;
      previousPosition.y = currentPosition.y;

      if (this.isShiftPressed == true) {
        this.moveConnectedObjects(command.key, dx, dy)
      }
      this.updateConnectors(this.connectorCornerRadius)
    })

    shape.on('dragend', (result: any) => {
      let c = {...command}
      c.x = result.target.attrs.x
      c.y = result.target.attrs.y
      const sx = result.target.attrs.scaleX
      const sy = result.target.attrs.scaleY
      c.width = result.target.attrs.width * sx
      c.height = result.target.attrs.height * sy
      c.command = "update"
      //c.shape = "postit"
      c.sequence = this.canvasHistory.length
      c.rotation = result.target.attrs.rotation
      c.color = result.target.attrs.fill
      c.fromKey = ""
      c.toKey = ""
      this.hideContextMenus()
      this.stepsToUndo += 1
      this.canvasHistory.push(c)
      if (this.isShiftPressed == true) { // to powinno być odpalane tylko, gdy user zmieniał położenie wielu obiektów
        this.updateObjectPositionsOnCanvasHistory()
      }
      this.saveCanvas()
    })

    shape.on('transformstart', (e: any) => {
      this.hideContextMenus()
    })
    
    shape.on('transform', (result: any) => {
      let c = {...command}
          // Adjust the text width and positioning again
          const newWidth = result.target.width() * result.target.scaleX(); 
          result.target.width(newWidth);  // Set new width and reset scale
          result.target.scaleX(1);  // Reset scaleX to preserve text size
          c.width = newWidth;
      
          // Retaining height (or adjust if needed)
          const newHeight = result.target.height() * result.target.scaleY();
          result.target.height(newHeight);  // Same as width resetting
          result.target.scaleY(1);
          c.height = newHeight;
    })

    shape.on('transformend', (result: any) => {
      let c = {...command}
      c.x = result.target.attrs.x
      c.y = result.target.attrs.y
     // const sx = result.target.attrs.scaleX
     // const sy = result.target.attrs.scaleY
     // c.width = result.target.attrs.width * sx
    //  c.height = result.target.attrs.height * sy
      c.command = "update"
    //  c.shape = "postit"
      c.color = result.target.attrs.fill
      c.rotation = result.target.attrs.rotation
      c.sequence = this.canvasHistory.length
      c.fromKey = ""
      c.toKey = ""

          // Adjust the text width and positioning again
          const newWidth = result.target.width() * result.target.scaleX(); 
          result.target.width(newWidth);  // Set new width and reset scale
          result.target.scaleX(1);  // Reset scaleX to preserve text size
          c.width = newWidth;
      
          // Retaining height (or adjust if needed)
          const newHeight = result.target.height() * result.target.scaleY();
          result.target.height(newHeight);  // Same as width resetting
          result.target.scaleY(1);
          c.height = newHeight;
      
      this.hideContextMenus()
      this.stepsToUndo += 1
      this.canvasHistory.push(c)
      this.saveCanvas()
      this.updateConnectors(this.connectorCornerRadius)
    });

    shape.on('click tap', (e: any) => {
      this.drawTouchPoints(command.key, shape.x(), shape.y(), shape.width(), shape.height(), 20)
      
      if (this.isDrawingArrow == false) { // if arrow is not dragged prevent from accidentally creating arrow
        this.mouseOverShapeKey = ""
        this.selectedShapeKey = ""
        this.selectedParentKey = ""
      }
      if (this.mouseOverShapeKey != "" && this.selectedShapeKey != "" && this.isDrawingArrow == true) {
        if (this.findExistingArrow(this.selectedShapeKey, this.mouseOverShapeKey) == undefined) {
        this.stepsToUndo += 1
        this.canvasHistory.push({
          key: "arrow-"+this.selectedShapeKey+"-"+this.mouseOverShapeKey,
          fromKey: this.selectedShapeKey,
          toKey: this.mouseOverShapeKey,
          command: "add",
          shape: "arrow",
          contentKey: "", 
          content: "", 
          x: 0, 
          y: 0, 
          width: 0, 
          height: 0, 
          color: "", 
          sequence: this.canvasHistory.length,
          strokeWidth: 1, 
          rotation: 0,
          points: [],
          coverImageURL: "",
          zIndex: 100,
          isExpanded: true,
          dateOfUpdate: new Date(),
          isFixed: false
        })
          this.saveCanvas()
          this.drawConnector(this.selectedShapeKey, this.mouseOverShapeKey)
          return
        } else {
          this.firestore.showSnackBar("This arrow already exists.")
        }
      }

      this.showContextMenu(command.key, shape);
      this.showCommentList(command.key, shape, "label");
      if (this.isPointerEnabled == true) {
        this.layer.add(this.selectionRectangle)
      }
    })
    shape.on('dblclick dbltap', (e: any) => {
      this.launchLabelEdit(command.key)
    })

    shape.on('mouseenter', (e: any) => {
      e.cancelBubble = true;
      this.mouseOverShapeKey = shape.id()
      if ( this.isDrawingArrow == true) {
   //     const s = shape.findOne('Rect') as Konva.Rect
        shape.strokeWidth(4); // Change width on hover
        this.redrawLayer()
      }
    });

    shape.on('mouseleave', (e: any) => {
      if (this.mouseOverShapeKey == shape.id()) {
        this.mouseOverShapeKey = ""
      }
    //  const s = shape.findOne('Rect') as Konva.Rect || shape.findOne('Path') as Konva.Path
    //  if (s.id() != "rect-"+command.key) {
        shape.strokeWidth(1); // Reset color
        this.redrawLayer()
   //   }
    });
    
    this.layer.add(shape)
    this.redrawLayer()
  }


  drawTouchPoints(shapeKey: string, x: number, y: number, width: number, height: number, padding: number = 0, size: number = 15) { // draws 4 touch points for a rectangle to drag arrow
    let points: {id: string, x: number, y: number}[] = []
    points.push({id: shapeKey+"-touchpoint-0", x: x + width/2 - size/2, y: y - padding - size})
    points.push({id: shapeKey+"-touchpoint-1", x: x + width + padding, y: y + height/2 - size/2})
    points.push({id: shapeKey+"-touchpoint-2", x: x + width/2 - size/2, y: y + height + padding})
    points.push({id: shapeKey+"-touchpoint-3", x: x - padding - size, y: y + height/2 - size/2})
    this.touchPoints.length = 0
    for (let i = 0; i < 4; i++) {
      const shape = new Konva.Rect({
        id: shapeKey+"-touchpoint-"+i,
        x: points[i].x,
        y: points[i].y,
        width: size,
        height: size,
        fill: "rgba(69, 146, 137, 0.5)",
      })

      shape.on('mousedown touchstart', (e: any) => {
        const p = this.touchPoints.findIndex((p: any) => p.shape.id() == shape.id())
        if (p > -1) {
          this.touchPoints[p].isDragging = true
        }
      })

      shape.on('mouseup touchend', (e: any) => {
        const p = this.touchPoints.findIndex((p: any) => p.shape.id() == shape.id())
        if (p > -1) {
          this.touchPoints[p].isDragging = false
        }
      })

      shape.on('click tap', (e: any) => {

        let direction = "right"
        const p = this.touchPoints.findIndex((p: any) => p.shape.id() == shape.id())
        if (p > -1) {
          if (p == 0) {
            direction = "top"
          } else if (p == 1) {
            direction = "right"
          } else if (p == 2) {
            direction = "bottom"
          } else if (p == 3) {
            direction = "left"
          }
        }
        this.addBoxWithArrow(shapeKey, "postit", direction)
        this.removeTouchPoints(true)
      })

      shape.on('mouseenter', (e: any) => {
        shape.x(shape.x() - size/2)
        shape.y(shape.y() - size/2)
        shape.width(size*2)
        shape.height(size*2)
      })

      shape.on('mouseleave', (e: any) => {
        const p = this.touchPoints.findIndex((p: any) => p.shape.id() == shape.id())
        if (p > -1 && this.touchPoints[p].isDragging == true) { // if user pressed touchpoint and is dragging
          this.startDrawingArrow()
          this.removeTouchPoints(true)
        }
        shape.x(shape.x() + size/2)
        shape.y(shape.y() + size/2)
        shape.width(size)
        shape.height(size)
      })

      shape.on('dragstart', (e: any) => {
      })

      this.touchPoints.push({shape: shape, isDragging: false})
      this.layer.add(shape)
    }
  }

  removeTouchPoints(all: boolean = false) {
    this.touchPoints.forEach((p: {shape: Konva.Rect, isDragging: boolean}) => {
      if (all == true || p.isDragging == false) {
        p.shape.remove()
      }
    })
   // this.touchPoints.length = 0
  }
  
  showPlaceholders() {
    const placeholder = new Konva.Group({
      id: "placeholder-group",
      x: 1000,
      y: 1000,
      width: 200,
      height: 200,
      zIndex: 10,
    });
    
    const rect = new Konva.Rect({
      id: "placeholder-rect",
      x: 0,
      y: 0,
      width: 200,
      height: 200,
      fill: "rgba(69, 146, 137, 1)",
      zIndex: 10,
      opacity: 0.3,
      cornerRadius: 4,
      stroke: "#000",
      strokeWidth: 1,
    });
    
    // Add rectangle to group
    placeholder.add(rect);
    
    const text = new Konva.Text({
      id: "placeholder-text", // Changed ID to avoid duplication
      x: rect.width() / 2, // Position X to center
      y: rect.height() / 2, // Position Y to center
      text: "Drop it here",
      fontSize: 18,
      fontFamily: 'Poppins',
      fill: '#000',
      // Anchor the text to the center
      align: 'center',
    });
    text.offsetX(text.width() / 2);
    text.offsetY(text.height() / 2);
    placeholder.add(text)
    this.layer.add(placeholder)
    this.layer.batchDraw()
    this.placeholders.push(placeholder)

    placeholder.on('mouseenter', () => {
      rect.opacity(1); // Change rect opacity to 1
      rect.strokeWidth(2);
      this.layer.batchDraw(); // Redraw the layer to reflect changes
      if (this.draggedItem) {
        const rotationAnimation = new Konva.Tween({
          node: this.draggedItem,
          duration: 0.3, // duration in seconds
          rotation: 0, // target rotation in degrees
          easing: Konva.Easings.EaseInOut,
          onFinish: () => {

          }
        });
        rotationAnimation.play();
      }
    });

    placeholder.on('mouseleave', () => {
      rect.opacity(0.3); // Revert rect opacity if needed
      rect.strokeWidth(1);
      this.layer.batchDraw(); // Redraw the layer to reflect changes
      if (this.draggedItem) {
        const rotationAnimation = new Konva.Tween({
          node: this.draggedItem,
          duration: 0.3, // duration in seconds
          rotation: 10, // target rotation in degrees
          easing: Konva.Easings.EaseInOut,
          onFinish: () => {

          }
        });
        rotationAnimation.play();
      }
    });
  }

  removePlaceholders() {
    this.placeholders.forEach((p: Konva.Node) => {
      p.remove()
    })
    this.placeholders.length = 0
  }

  drawDraggedItem(node: Konva.Group) {
    if (this.draggedItem) {
      this.draggedItem.remove()
      this.draggedItem = null
    }
    const d = node.clone()
    const rect = d.findOne('Rect') as Konva.Rect
    d.draggable(true)
    d.zIndex(200)
   // d.rotation(15)
   this.layer.add(d)
   this.layer.batchDraw()
    const rotationAnimation = new Konva.Tween({
      node: d,
      duration: 0.3, // duration in seconds
      rotation: 10, // target rotation in degrees
      easing: Konva.Easings.EaseInOut,
      onFinish: () => {
          this.draggedItem = d
      }
    });
    rotationAnimation.play();
    if (rect) {
      rect.opacity(1)
      rect.shadowColor('grey')
      rect.shadowBlur(10)
      rect.shadowOffset({ x: 10, y: 10 })
      rect.shadowOpacity(0.7)
    }

    d.on('dragstart', (e: any) => {
      this.hidePopupMenu()
      this.showPlaceholders()
      d.moveToTop()
      this.isDraggingDraggedItem = true
    })

    d.on('dragmove', (e: any) => {
      e.cancelBubble = true;
    })

    d.on('dragend', (e: any) => {
      this.removePlaceholders()
      this.isDraggingDraggedItem = false
      d.remove()
      node.draggable(true);
      node.listening(true);
      const rect = node.findOne('Rect') as Konva.Rect
      if (rect) {
        rect.opacity(1)
      }
      const text = node.findOne('Text') as Konva.Text
      if (text) {
        text.opacity(1)
      }
      this.layer.batchDraw()
    })

    d.startDrag()
  }

  async drawPostitContent(command: CanvasHistory) {
    this.boxContent.push({key: command.key, content: command.content})
    if (command.color == undefined || command.color == "" || command.color == "#000000") {
      command.color = "#ffffff"
    }
    if (command.isFixed == true) {
      command.rotation = 0
    }
    const sx = command.width / this.boxWidth
    const sy = command.height / (this.boxHeight*2)
    const shape = new Konva.Group({
      id: command.key,
      x: command.x,
      y: command.y,
      width: this.boxWidth * sx,
      height: this.boxHeight*2 * sy,
      draggable: true,//!command.isFixed,
      stroke: "#bfbfbf",
      fill: command.color,
      cornerRadius: 4,
      name: 'selectable',
      rotation: command.rotation,
    }); 
    shape.on('dragstart', (e: any) => {
      if (command.isFixed == true) {
        shape.draggable(false)
        shape.listening(false)
        shape.stopDrag()
        if (this.isDraggingDraggedItem == false) {
          this.isDraggingDraggedItem = true
          this.drawDraggedItem(shape)
          const rect = shape.findOne('Rect') as Konva.Rect
          if (rect) {
            rect.opacity(0.5)
          }
          const text = shape.findOne('Text') as Konva.Text
          if (text) {
            text.opacity(0.5)
          }
        }
      }
      this.hideContextMenus()
    })

    let previousPosition = { x: shape.x(), y: shape.y() };
    shape.on('dragmove', (e: any) => {
        const currentPosition = e.target.position();
        const dx = currentPosition.x - previousPosition.x;
        const dy = currentPosition.y - previousPosition.y;
        previousPosition.x = currentPosition.x;
        previousPosition.y = currentPosition.y;
        if (this.isShiftPressed == true) {
          this.moveConnectedObjects(command.key, dx, dy)
        }
        this.updateConnectors(this.connectorCornerRadius)
        if (command.isFixed == true) {

        }
    })
    
    shape.on('dragend', (result: any) => {
      let c = {...command}
      c.x = result.target.attrs.x
      c.y = result.target.attrs.y
      const sx = result.target.attrs.scaleX
      const sy = result.target.attrs.scaleY
      c.width = result.target.attrs.width * sx
      c.height = result.target.attrs.height * sy
      c.command = "update"
      c.shape = "postit"
      c.sequence = this.canvasHistory.length
      c.rotation = result.target.attrs.rotation
      c.color = result.target.attrs.fill
      c.fromKey = ""
      c.toKey = ""
      if (command.isFixed == true) {

      } else {
        this.stepsToUndo += 1
        this.canvasHistory.push(c)
        if (this.isShiftPressed == true) { // to powinno być odpalane tylko, gdy user zmieniał położenie wielu obiektów
          this.updateObjectPositionsOnCanvasHistory()
        }
        this.saveCanvas()
      }
      this.hideContextMenus()
    })

    if (command.isFixed == true) {
      shape.on('transform', () => {
        this.tr.stopTransform();
      });
    }

    if (command.shape == "postit") {
      shape.add(new Konva.Rect({
        key: "postit-rect-"+command.key,
        width: this.boxWidth * sx,
        height: this.boxHeight*2 * sy,
        fill: command.color,
        stroke: "#bfbfbf",
        cornerRadius: 4,
        listening: false,
      }));
    } else if (command.shape == "diamond") {
      const path = this.createRoundedDiamondPathData(this.boxWidth * sx, this.boxHeight*2 * sy, 4)
      shape.add(new Konva.Path({
        key: "postit-path-"+command.key,
        data: path,
        fill: command.color,
        stroke: "#bfbfbf",
        strokeWidth: 1,
      }));
    } else if (command.shape == "circle") {
      const path = this.createCirclePathData(this.boxWidth * sx / 2, this.boxHeight*2 * sy / 2, this.boxWidth * sx / 2)
      shape.add(new Konva.Path({
        key: "postit-circle-"+command.key,
        data: path,
        fill: command.color,
        stroke: "#bfbfbf",
        strokeWidth: 1,
      }));
    }

    shape.add(new Konva.Text({
      key: "postit-text-"+command.key,
      text: command.content,
      fontSize: 18 * sx,
      fontFamily: 'Poppins',
      fill: '#000',
      width: this.boxWidth * sx,
      height: this.boxHeight*2 * sy,
      padding: 5,
      align: 'center',
      verticalAlign: 'middle',
      cornerRadius: 4,
    }));

    if (command.isFixed == true) {
      this.loadImage("../../assets/chat.png").then(image => {
        if (image) {
          const popupIcon = new Konva.Image({
            x: this.boxWidth * sx - 20,
            y: this.boxHeight*2 * sy - 20,
            width: 20,
            height: 20,
            draggable: false,
            image: image,
            zIndex: 200,
           //   listening: false
            });
            popupIcon.on('click tap', () => {
              if (this.clickedPopupMenuShapeKey != command.key) {
                this.clickedPopupMenuShapeKey = command.key
                this.showPopupMenu(command.key)
              } else {
                this.clickedPopupMenuShapeKey = ""
                this.hidePopupMenu()
              }
            })
          shape.add(popupIcon)
        }
      })
    }

    shape.on('transformend', (result: any) => {
      let c = {...command}
      c.x = result.target.attrs.x
      c.y = result.target.attrs.y
      const sx = result.target.attrs.scaleX
      const sy = result.target.attrs.scaleY
      c.width = result.target.attrs.width * sx
      c.height = result.target.attrs.height * sy
      c.command = "update"
      c.shape = "postit"
      c.color = result.target.attrs.fill
      c.rotation = result.target.attrs.rotation
      c.sequence = this.canvasHistory.length
      c.fromKey = ""
      c.toKey = ""
      this.hideContextMenus()
      this.stepsToUndo += 1
      this.canvasHistory.push(c)
      this.saveCanvas()
      this.updateConnectors(this.connectorCornerRadius)
    });

    shape.on('click tap', (e: any) => {
      this.drawTouchPoints(command.key, shape.x(), shape.y(), shape.width(), shape.height(), 20)
      
      if (this.isDrawingArrow == false) { // if arrow is not dragged prevent from accidentally creating arrow
        this.mouseOverShapeKey = ""
        this.selectedShapeKey = ""
        this.selectedParentKey = ""
      }
      if (this.mouseOverShapeKey != "" && this.selectedShapeKey != "" && this.isDrawingArrow == true) {
        if (this.findExistingArrow(this.selectedShapeKey, this.mouseOverShapeKey) == undefined) {
        this.stepsToUndo += 1
        this.canvasHistory.push({
          key: "arrow-"+this.selectedShapeKey+"-"+this.mouseOverShapeKey,
          fromKey: this.selectedShapeKey,
          toKey: this.mouseOverShapeKey,
          command: "add",
          shape: "arrow",
          contentKey: "", 
          content: "", 
          x: 0, 
          y: 0, 
          width: 0, 
          height: 0, 
          color: "", 
          sequence: this.canvasHistory.length,
          strokeWidth: 1, 
          rotation: 0,
          points: [],
          coverImageURL: "",
          zIndex: 100,
          isExpanded: true,
          dateOfUpdate: new Date(),
          isFixed: false
        })
        this.saveCanvas()
        this.drawConnector(this.selectedShapeKey, this.mouseOverShapeKey)
        return
        } else {
          this.firestore.showSnackBar("This arrow already exists.")
        }
      }
      this.showContextMenu(command.key, shape);
      this.showCommentList(command.key, shape, "note");
      if (this.isPointerEnabled == true) {
        this.layer.add(this.selectionRectangle)
      }
    })
    shape.on('dblclick dbltap', (e: any) => {
      this.launchPostitEdit(command.key, sx, sy)
    })

    shape.on('mouseenter', (e: any) => { // TU JEST BLAD BO W POSTIT MAM TRZY OBIEKTY: rect, text i group i ŻLE WYKRYWA MOUSEOVER
      e.cancelBubble = true;
      this.mouseOverShapeKey = shape.id()
      if ( this.isDrawingArrow == true) {
        const s = shape.findOne('Rect') as Konva.Rect
        s.strokeWidth(4); // Change width on hover
        this.redrawLayer();
      }
    });

    shape.on('mouseleave', (e: any) => {
      if (this.mouseOverShapeKey == shape.id()) {
        this.mouseOverShapeKey = ""
      }
      const s = shape.findOne('Rect') as Konva.Rect || shape.findOne('Path') as Konva.Path
      if (s.id() != "rect-"+command.key) {
        s.strokeWidth(1); // Reset color
        this.redrawLayer();
      }
    });
    this.layer.add(shape);
    this.redrawLayer();
  }

  popupMenu = new Konva.Group({
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    name: 'popupMenu'
  })

  showPopupMenu(key: string) {
    const shape = this.layer.findOne('#' + key)
    if (shape) {
       this.popupMenu = new Konva.Group({
        x: shape.x()+shape.width()-20,
        y: shape.y()+shape.height()+5,
        width: 100,
        height: 100,
        name: 'popupMenu'
      })
      this.popupMenu.add(new Konva.Rect({
        width: 100,
        height: 100,
        fill: 'white',
        stroke: 'black',
        strokeWidth: 1,
        cornerRadius: 4,
      }))
      const menuOptions = ["Option 1", "Option 2", "Option 3"]
      let y = 0
      menuOptions.forEach((option) => {
        const menuItem = new Konva.Text({
          x: 0,
          y: y,
          text: option,
          fontSize: 16,
          fill: 'black',
        })
        this.popupMenu.add(menuItem)
        menuItem.on('mouseenter', () => {
          const cursor = document.getElementById('container')
          if (cursor) {
            cursor.style.cursor = 'pointer'; // Set desired cursor
          }
          menuItem.fill('red')
        })
        menuItem.on('mouseleave', () => {
          const cursor = document.getElementById('container')
          if (cursor) {
            cursor.style.cursor = 'default'; // Set desired cursor
          }
          menuItem.fill('black')
        })
        menuItem.on('click tap', () => { // TODO: add menu item functionality
        })
        y += 20
      })
      this.layer.add(this.popupMenu)
      this.layer.batchDraw()
    }
  }

  hidePopupMenu() {
    this.clickedPopupMenuShapeKey = ""
    this.popupMenu.destroy()
    this.layer.batchDraw()
  }

  ensureShapeVisible(shape: Konva.Node) { // TO NIE DZIALA !!!! POWINNO PRZESUWAC STAGE DO POZIOMU WIDOCZNOSCI OBIEKTU, ALE TYLKO GDY NIE JEST W PELNIU WIDOCZNY
    const rect = shape.getClientRect();
    const scale = this.stage.scaleX(); // Assumes uniform scaling
  
    const stageX = this.stage.x();
    const stageY = this.stage.y();
    const stageWidth = this.stage.width();
    const stageHeight = this.stage.height();
  
    // Calculate the shape's bounding box edges in screen (viewport) coordinates
    const leftEdge = rect.x * scale + stageX;
    const rightEdge = (rect.x + rect.width) * scale + stageX;
    const topEdge = rect.y * scale + stageY;
    const bottomEdge = (rect.y + rect.height) * scale + stageY;
  
    // Find the minimum and maximum allowed stage positions to keep the shape fully visible
    const minStageX = stageWidth - (rect.x + rect.width) * scale; // When right edge aligns with viewport right edge
    const maxStageX = -rect.x * scale; // When left edge aligns with viewport left edge
    const minStageY = stageHeight - (rect.y + rect.height) * scale; // When bottom edge aligns with viewport bottom edge
    const maxStageY = -rect.y * scale; // When top edge aligns with viewport top edge
  
    // Clamp the stage position to keep the shape within the viewport
    let targetStageX = stageX;
    let targetStageY = stageY;
  
    // Adjust X position if necessary
    if (leftEdge < 0 || rightEdge > stageWidth) {
      targetStageX = Math.max(Math.min(stageX, maxStageX), minStageX);
    }
  
    // Adjust Y position if necessary
    if (topEdge < 0 || bottomEdge > stageHeight) {
      targetStageY = Math.max(Math.min(stageY, maxStageY), minStageY);
    }
  
    // Only proceed if adjustments are needed
    if (targetStageX !== stageX || targetStageY !== stageY) {
      this.stage.to({
        x: targetStageX,
        y: targetStageY,
        duration: 0.5,
        easing: Konva.Easings.EaseOut,
      });
    }
  }

  moveConnectedObjects(key: string, moveX: number, moveY: number) {
    let connectedObjectKeys = this.findConnectedObjects(key, [])
    if (key.startsWith("frame-")) { // for frames we also move all objects within the frame if user pressed shift
      connectedObjectKeys = connectedObjectKeys.concat(this.findShapesWithinShape(key))
    }
    connectedObjectKeys.forEach((c: any) => {
      const shape = this.layer.findOne('#' + c)
      if (shape) {
        shape.position({x: shape.x() + moveX, y: shape.y() + moveY})
      }
    })
    this.updateConnectors(this.connectorCornerRadius)
    this.redrawLayer()
  }

  findShapesWithinShape(key: string) {
    console.time("findShapesWithinShape")
    const shape = this.layer.findOne('#' + key)
    let shapesWithin: string[] = []
    if (shape) {
      const rect = shape.getClientRect(); // Get the bounding box of the shape
      const connectedObjects = this.canvasHistory.filter((c: any) => (c.command == "add" && c.key != key && c.shape != "arrow"))
      connectedObjects.forEach((c: any) => {
        const insideShape = this.layer.findOne('#' + c.key)
        if (insideShape) {
          const inside = insideShape.getClientRect()
          if (this.isRectInRect(rect, inside)) {           // Check if the child shape is fully within the bounding box of the given shape
            shapesWithin.push(c.key);
          }
        }
      })
    }
    console.timeEnd("findShapesWithinShape")
    return shapesWithin;
  }

  findConnectedObjects(key: string, connectedObjectKeys: string[]) { // recursively find all connected objects
    console.time("findConnectedObjects")
    const connectedArrows = this.canvasHistory.filter((c: any) => (c.fromKey == key || c.toKey == key) && c.command == "add" && c.shape == "arrow")
    let keysFromArrows: string[] = []
    connectedArrows.forEach((c: any) => {
      keysFromArrows.push(c.fromKey)
      keysFromArrows.push(c.toKey)
    })
    const connectedObjects = this.canvasHistory.filter((c: any) => (keysFromArrows.includes(c.key) && c.command == "add" && c.key != key))
    connectedObjects.forEach((c: any) => {
      if (!connectedObjectKeys.includes(c.key)) {
        connectedObjectKeys.push(c.key)
        connectedObjectKeys = this.findConnectedObjects(c.key, connectedObjectKeys)
      }
    })
    console.timeEnd("findConnectedObjects")
  return connectedObjectKeys
}

  async drawBoxContent(command: any) {
    this.boxContent.push({key: command.key, content: command.content})
    const sx = command.width / this.boxWidth
    const sy = command.height / (this.boxHeight*2)
    if (command.color == undefined || command.color == "" || command.color == "#000000") {
      command.color = "#bfbfbf"
    }
    let border = ""
    if (command.key.startsWith("workpackage-")) {
      this.friendlyNameObjectType = "task"
      border = "left"
    } else if (command.key.startsWith("content-")) {
      this.friendlyNameObjectType = "content"
      border = "right"
    }
    let draggable = true
    if (this.site == "productly") { // in productly we don't want to drag the postits cause shape of tree is created automatically
      draggable = false
    }
    await this.generateImagesFromDOM(command.content, command.key, command.color || "#ffffff", this.boxWidth * sx, this.boxHeight*2 * sy, command.coverImageURL, border).then(canvas => {
      const shape = new Konva.Image({
        id: command.key,
        x: command.x,
        y: command.y,
        width: this.boxWidth * sx,
        height: this.boxHeight*2 * sy,
        draggable: draggable,
        stroke: command.color,
        strokeWidth: 1,
        fill: "#ffffff",
        cornerRadius: 4,
        image: canvas,
       // zIndex: 1,
        name: 'selectable',
        rotation: command.rotation,
      });

      let previousPosition = { x: shape.x(), y: shape.y() };
      shape.on('dragstart', (e: any) => {
        if (this.isShiftPressed == true) {
          const currentPosition = e.target.position();
          const dx = currentPosition.x - previousPosition.x;
          const dy = currentPosition.y - previousPosition.y;
          previousPosition.x = currentPosition.x;
          previousPosition.y = currentPosition.y;
          this.moveConnectedObjects(command.key, dx, dy)
        }
        this.hideContextMenus()
      })

      shape.on('dragmove', (e: any) => {
        this.updateConnectors(this.connectorCornerRadius)
      })

        shape.on('dragend', (result: any) => {
          let c = {...command}
          c.x = result.target.attrs.x
          c.y = result.target.attrs.y
          const sx = result.target.attrs.scaleX
          const sy = result.target.attrs.scaleY
          c.width = result.target.attrs.width * sx
          c.height = result.target.attrs.height * sy
          c.rotation = result.target.attrs.rotation
          c.color = result.target.attrs.stroke
          c.command = "update"
          c.sequence = this.canvasHistory.length
          c.fromKey = ""
          c.toKey = ""
          this.hideContextMenus()
          this.stepsToUndo += 1
          this.canvasHistory.push(c)
          this.saveCanvas()
        })

        shape.on('transformstart', (e: any) => {
          this.hideContextMenus()
        })

        shape.on('transformend', (result: any) => {
            let c = {...command}
            c.x = result.target.attrs.x
            c.y = result.target.attrs.y
            const sx = result.target.attrs.scaleX
            const sy = result.target.attrs.scaleY
            c.width = result.target.attrs.width * sx
            c.height = result.target.attrs.height * sy
            c.command = "update"
            c.sequence = this.canvasHistory.length
            c.rotation = result.target.attrs.rotation
            c.color = result.target.attrs.stroke
            c.fromKey = ""
            c.toKey = ""
            this.hideContextMenus()
            this.stepsToUndo += 1
            this.canvasHistory.push(c)
            this.saveCanvas()
            let border = ""
            if (command.key.startsWith("workpackage-")) {
              border = "left"
            } else if (command.key.startsWith("content-")) {
              border = "right"
            }
            this.generateImagesFromDOM(command.content, command.key, command.color || "#ffffff", c.width, c.height, command.coverImageURL, border).then(im => {
              shape.image(im)
            })
            this.updateConnectors(this.connectorCornerRadius)
        });

        shape.on('dblclick dbltap', (e: any) => {
          e.cancelBubble = true
          const contentKey = command.key.replace("content-", "").replace("workpackage-", "")
          this.launchPostDialog(contentKey, "", "", false, "")
        })

        shape.on('click tap', (e: any) => {
          e.cancelBubble = true
          if (this.site == "wroolo") {
            this.drawTouchPoints(command.key, shape.x(), shape.y(), shape.width(), shape.height(), 20)
          }
          this.drawUserArrow()
         // const domPos = this.getShapePosition(shape);
          this.showContextMenu(command.key, shape);
          this.showCommentList(command.key, shape, this.friendlyNameObjectType);
        })

        shape.on('mouseover mouseenter', (e: any) => {
          if (this.selectedShapeKey != shape.id() && this.isDrawingArrow == true) {
            this.mouseOverShapeKey = shape.id()
            shape.strokeWidth(5); // Change width on hover
            this.redrawLayer();
          }
        });
    
        shape.on('mouseleave', (e: any) => {
          if (this.mouseOverShapeKey == shape.id()) {
            this.mouseOverShapeKey = ""
          }
          if (shape.id() != "rect-"+command.key) {
            shape.strokeWidth(1); // Reset color
            this.redrawLayer();
          }
        });
    
        this.layer.add(shape);
        this.selectionRectangle.moveToTop()
        this.redrawLayer();
      })
  }

  drawUserArrow() {
    if (this.isDrawingArrow == false) { // if arrow is not dragged prevent from accidentally creating arrow
      this.mouseOverShapeKey = ""
      this.selectedShapeKey = ""
      this.isEditCardNamePopupVisible = false
      this.isPostPanelOpen = false
    }
    if (this.mouseOverShapeKey != "" && this.selectedShapeKey != "" && this.isDrawingArrow == true && this.mouseOverShapeKey != this.selectedShapeKey) {
      if (this.findExistingArrow(this.selectedShapeKey, this.mouseOverShapeKey) == undefined) {
      this.stepsToUndo += 1
      this.canvasHistory.push({
        key: "arrow-"+this.selectedShapeKey+"-"+this.mouseOverShapeKey,
        fromKey: this.selectedShapeKey,
        toKey: this.mouseOverShapeKey,
        command: "add",
        shape: "arrow",
        contentKey: "", 
        content: "", 
        x: 0, 
        y: 0, 
        width: 0, 
        height: 0, 
        color: "", 
        sequence: this.canvasHistory.length,
        strokeWidth: 1, 
        rotation: 0,
        points: [],
        coverImageURL: "",
        zIndex: 100,
        isExpanded: true,
        dateOfUpdate: new Date(),
        isFixed: false
      })
      this.saveCanvas()
      this.drawConnector(this.selectedShapeKey, this.mouseOverShapeKey)
    } else {
      this.firestore.showSnackBar("This arrow already exists.")
    }
    }
  }

  drawFreeHandLine(key: string, points: number[], color: string, strokeWidth: number, paintingMode: string) {
    const line = new Konva.Line({
      id: key,
      stroke: color,
      strokeWidth: strokeWidth,
      points: points,
      globalCompositeOperation: paintingMode === 'brush' ? 'source-over' : 'destination-out',
   //   name: 'selectable',
    });
    this.layer.add(line);
    this.redrawLayer();
  }

  async launchLabelEdit(key: string) {
    this.isContentEditing = true
    const textNode = this.stage.findOne('#' + key); // Find the group (shape) by its key
    if (!textNode) {
      this.isContentEditing = false
      return;
    }

    this.createTextareaEditor(textNode, key, textNode.x(), textNode.y(), textNode.width(), textNode.height(), textNode.fill(), textNode.rotation(), textNode.getAbsoluteScale().x, textNode.getAbsoluteScale().y)

  }

  /*getTextHeight(text: string, fontSize: number, lineHeight: number) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    let height = this.boxHeight *0.5
    if (context) {
      context.font = `${fontSize}px Poppins`; // Use your specific font
      const metrics = context.measureText(text);
      const lines = Math.ceil(metrics.width / canvas.width);
      height = Math.max(height, lines * lineHeight);
    }
    return height;
}*/

  createTextareaEditor(textNode: any, key: string, x: number, y: number, width: number, height: number, color: string, rotation: number, sx: number, sy: number) {
    const stageBox = this.stage.container().getBoundingClientRect();     // Get the position of the Text node relative to the page
    const textPosition = textNode.absolutePosition();
    const areaPosition = {
      x: stageBox.left + textPosition.x,
      y: stageBox.top + textPosition.y,
    };
    const textarea = document.createElement('textarea'); // Create a textarea and style it
    document.body.appendChild(textarea);
    textarea.value = textNode.text();
    textarea.style.position = 'absolute';
    textarea.style.top = areaPosition.y + 'px';
    textarea.style.left = areaPosition.x + 'px';
    textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px';
    textarea.style.height = textNode.height() - textNode.padding() * 2 + 5 + 'px';
    textarea.style.fontSize = textNode.fontSize() + 'px';
    textarea.style.fontFamily = textNode.fontFamily();
    textarea.style.color = textNode.fill();
    textarea.style.background = 'none';
    textarea.style.border = '1px solid #ccc';
    textarea.style.padding = '0px';
    textarea.style.margin = '0px';
    textarea.style.overflow = 'hidden';
    textarea.style.outline = 'none';
    textarea.style.resize = 'none';
    textarea.style.lineHeight = textNode.lineHeight().toString();
    // Hide the text node and transformer while editing
    textNode.visible(false);
    this.tr.hide();
    this.hideContextMenus()
    this.redrawLayer();
      
    textarea.focus();
    textarea.select(); // Ensures the entire text is selected

    const removeTextarea = () => {
      if (textarea.parentNode) {
        textarea.parentNode.removeChild(textarea);
        window.removeEventListener('click', handleOutsideClick);
        textNode.visible(true);
        setTimeout(() => {
          this.layer.add(this.selectionRectangle)
          this.selectionRectangle.moveToTop()
        }, 200)
        this.redrawLayer();
      }
    };

   /* const setTextareaHeight = (text: string) => {
      const newHeight = this.getTextHeight(text, textNode.fontSize(), textNode.lineHeight());
      textarea.style.height = newHeight + 'px';
      textarea.style.height = textarea.scrollHeight + 'px';
      textNode.height(newHeight); // Update textNode height
      this.layer.batchDraw(); // Redraw the layer to reflect changes
  };*/
  
    const setTextareaWidth = (newWidth: number) => {
      if (!newWidth) {
        newWidth = textNode.placeholder.length * textNode.fontSize();
      }
      textarea.style.width = newWidth + 'px';
    };

    textarea.addEventListener('input', () => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
      // Optionally, update the Konva text node's height if needed
      textNode.height(textarea.scrollHeight);
      textNode.verticalAlign('middle'); // Ensure vertical alignment is middle
      this.redrawLayer(); // Redraw the layer to reflect changes
   //   setTextareaHeight(textarea.value);
  });
  
    textarea.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const shape = textNode.getParent();
        textNode.height(shape.height());
        textNode.verticalAlign('middle'); // Reset vertical alignment
        removeTextarea();
      } else {
       /* setTimeout(() => { // Use setTimeout to ensure the value is updated
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight + 'px';
          textNode.height(textarea.scrollHeight); // Update Konva text node height
          textNode.verticalAlign('middle'); // Ensure vertical alignment is middle
          this.redrawLayer(); // Redraw the layer to reflect changes
        }, 0);*/
      }
      
      if (e.key === 'Enter' && !e.shiftKey) {
        textNode.text(textarea.value);
        const shape = textNode.getParent();
        textNode.height(shape.height());
        textNode.verticalAlign('middle'); // Reset vertical alignment

      //  setTextareaHeight(textarea.value); // Final adjustment of height on Enter
        const index = this.boxContent.findIndex(b => b.key == key)
        if (index > -1) {
          this.boxContent[index].content = textarea.value
        }
        this.stepsToUndo += 1
        this.canvasHistory.push({
          key: key,
          contentKey: key,
          content: textarea.value,
          command: "update",
          shape: "postit",
          width: width * sx,
          height: height * sy,
          color: color,
          strokeWidth: 1,
          points: [],
          x: x,
          y: y,
          rotation: rotation,
          sequence: this.canvasHistory.length,
          fromKey: "",
          toKey: "",
          coverImageURL: "",
          zIndex: 100,
          isExpanded: true,
          dateOfUpdate: new Date(),
          isFixed: false
        })
        this.saveCanvas()
        removeTextarea();
        this.isContentEditing = false
      } else {
        textarea.style.height = textNode.height() - textNode.padding() * 2 + 5 + 'px';
      }
      const scale = textNode.getAbsoluteScale().x;
      setTextareaWidth(textNode.width() * scale);
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 3 + 'px';
      this.tr.show()
    });
  
    const handleOutsideClick = (e: MouseEvent) => {
      if (e.target !== textarea) {
        textNode.text(textarea.value);
        const shape = textNode.getParent();
        textNode.height(shape.height());
        textNode.verticalAlign('middle'); // Reset vertical alignment
        const index = this.boxContent.findIndex(b => b.key == key)
        if (index > -1) {
          this.boxContent[index].content = textarea.value
        }
        this.stepsToUndo += 1
        this.canvasHistory.push({
          key: key,
          contentKey: key,
          content: textarea.value,
          command: "update",
          shape: "postit",
          width:  width * sx,
          height: height * sy,
          color: color,
          strokeWidth: 1,
          points: [],
          x: x,
          y: y,
          rotation: rotation,
          sequence: this.canvasHistory.length,
          fromKey: "",
          toKey: "",
          coverImageURL: "",
          zIndex: 100,
          isExpanded: true,
          dateOfUpdate: new Date(),
          isFixed: false
        })
        this.saveCanvas()
        removeTextarea();
        this.isContentEditing = false
      }
      this.tr.show()
    };
    setTimeout(() => {
      window.addEventListener('click', handleOutsideClick);
    });
  }

  async launchPostitEdit(key: string, sx: number, sy: number) {
    this.isContentEditing = true
    const shape = this.stage.findOne('#' + key); // Find the group (shape) by its key
    if (!shape) {
      this.isContentEditing = false
      return;
    }
    const textNode = shape.findOne('Text');     // Get the Text node within the shape
    const rectNode = shape.findOne('Rect') || shape.findOne('Path')
    this.createTextareaEditor(textNode, key, shape.x(), shape.y(), shape.width(), shape.height(), rectNode.fill() || textNode.fill(), shape.rotation(), sx, sy)
  }

  showSearchPostPopup() {
    if (this.isAnonymous == true) {
      this.firestore.showSnackBar("Please login first and get access to this project to add post from knowledge base.")
    } else {
      this.addPostPopupVisible = true
    }
  }

  showSearchWorkpackagePopup() {
    if (this.isAnonymous == true) {
      this.firestore.showSnackBar("Please login first and get access to this project to add post from task board.")
    } else {
      this.addWorkpackagePopupVisible = true
    }
  }



  isTouchPanning = false

  async setupSelection() {
    this.userArrow.addEventListener('keydown', (e: any) => { // TO NIE DZIALA!!!
      if (e.key === 'Escape') {
        this.clearSelection()
        this.hideContextMenus()
        this.isDrawingArrow = false
        this.userArrow.remove()
      }
    })
    if (this.isProductlyMode == false) {
      this.layer.add(this.tr)
    }
    if (this.selectionRectangle) {
      this.selectionRectangle.destroy()
    }
    this.selectionRectangle = new Konva.Rect({
      id: "selection-rectangle",
      fill: 'rgba(0,0,255,0.5)',
      visible: false,
      listening: false,       // disable events to not interrupt with events
    });
    this.layer.add(this.selectionRectangle)


    this.stage.on('touchstart', (event: any) => {
      this.hideContextMenus();
      const touches = event.evt.touches;
      
      // Handle one-finger pan
      if (touches.length === 1 && event.target === this.stage) {
        this.isTouchPanning = true;
        this.lastTouch = { x: touches[0].clientX, y: touches[0].clientY };
      } 
      // Handle two-finger pinch/zoom
      else if (touches.length === 2) {
        this.isDragging = true;
        this.isTouchPanning = false; // Ensure one-finger pan stops
        
        const touch1 = touches[0];
        const touch2 = touches[1];
        this.initialDistance = this.getTouchDistance(touch1, touch2);
        this.initialScale = this.stage.scaleX();
        this.prevCenter = {
          x: (touch1.clientX + touch2.clientX) / 2,
          y: (touch1.clientY + touch2.clientY) / 2
        };
      }
    });
    
    this.stage.on('touchmove', (event: any) => {
      event.evt.preventDefault();
      const touches = event.evt.touches;
    
      // Logic for one-finger pan
      if (this.isTouchPanning && touches.length === 1) {
        const touch = touches[0];
        if (!this.lastTouch) return;
    
        const deltaX = touch.clientX - this.lastTouch.x;
        const deltaY = touch.clientY - this.lastTouch.y;
        this.lastTouch = { x: touch.clientX, y: touch.clientY };
    
        // FIX: Move the stage by adding the delta
        this.stage.move({ x: deltaX, y: deltaY });
    
      } 
      // Logic for two-finger pinch/zoom
      else if (this.isDragging && touches.length === 2) {
        const touch1 = touches[0];
        const touch2 = touches[1];
    
        const currentCenter = {
          x: (touch1.clientX + touch2.clientX) / 2,
          y: (touch1.clientY + touch2.clientY) / 2
        };
        
        // Calculate new position based on the movement of the center point
        const dx = currentCenter.x - this.prevCenter.x;
        const dy = currentCenter.y - this.prevCenter.y;
        this.stage.move({ x: dx, y: dy });
        this.prevCenter = currentCenter;
    
        // Calculate new scale
        const currentDistance = this.getTouchDistance(touch1, touch2);
        const scaleChange = currentDistance / this.initialDistance;
        const newScale = this.initialScale * scaleChange;
        const clampedScale = Math.max(0.1, Math.min(10, newScale));
    
        // Get the pointer position relative to the stage
        const pointer = this.stage.getPointerPosition();
        const mousePointTo = {
          x: (pointer.x - this.stage.x()) / this.stage.scaleX(),
          y: (pointer.y - this.stage.y()) / this.stage.scaleY(),
        };
    
        this.stage.scale({ x: clampedScale, y: clampedScale });
    
        // Adjust position to zoom around the center point
        const newPos = {
          x: pointer.x - mousePointTo.x * clampedScale,
          y: pointer.y - mousePointTo.y * clampedScale,
        };
        this.stage.position(newPos);
      }
    });
    
    this.stage.on('touchend touchcancel', (event: any) => {
      // Reset all flags when touches end
      this.isDragging = false;
      this.isTouchPanning = false;
      this.lastTouch = {x: 0, y: 0};
    
      if (event.evt.touches.length < 2) {
        this.updateCursorPosition();
        this.updateBackgroundGrid();
      }
    });






  /*  this.stage.on('touchstart', (event: any) => {
      if (event.evt.touches.length === 2) {
        this.isDragging = true;
    
        const touch1 = event.evt.touches[0];
        const touch2 = event.evt.touches[1];
        this.startCenter = this.prevCenter = {
          x: (touch1.clientX + touch2.clientX) / 2,
          y: (touch1.clientY + touch2.clientY) / 2
        };
        this.initialDistance = this.getTouchDistance(touch1, touch2);
        this.initialScale = this.stage.scaleX();
      }
      this.hideContextMenus()
    });

    this.stage.on('touchmove', (event: any) => {
      if (this.isDragging && event.evt.touches.length === 2) {
        event.evt.preventDefault();
    
        const touch1 = event.evt.touches[0];
        const touch2 = event.evt.touches[1];
        const currentCenter = {
          x: (touch1.clientX + touch2.clientX) / 2,
          y: (touch1.clientY + touch2.clientY) / 2
        };
    
        const dx = currentCenter.x - this.prevCenter.x;
        const dy = currentCenter.y - this.prevCenter.y;
    
        this.prevCenter = currentCenter;
    
        const stagePos = {
          x: this.stage.x() + dx / this.stage.scaleX(),
          y: this.stage.y() + dy / this.stage.scaleY()
        };
        this.stage.position(stagePos);
    
        const currentDistance = this.getTouchDistance(touch1, touch2);
    
        const scaleChange = currentDistance / this.initialDistance;
        const newScale = this.initialScale * scaleChange;
    
        const clampedScale = Math.max(0.1, Math.min(10, newScale));
        this.stage.scale({ x: clampedScale, y: clampedScale });
    
       // this.redrawLayer();
        //this.updateBackgroundGrid(); narazie to zakomentowuje aby zobaczyc czy to nie jest przyczyną zawieszen
      }
    });

    this.stage.on('touchend', (event: any) => {
      if (event.evt.touches.length < 2) {
        this.isDragging = false; // Stop the dragging
        this.updateCursorPosition() // updates user cursor position so next canvas can be scrolled to it
        this.updateBackgroundGrid();
      }
    });*/

    this.stage.on('mouseup', (event: any) => {
      this.drawUserArrow() // draw user arrow on mouse up if it was dragged from one of touchpoints
    })
    
    // Also, consider adding a touchcancel listener
   // this.stage.on('touchcancel', (event: any) => {
  //    this.isDragging = false; // Stop the dragging on touch cancel
  //  });


    if (this.isMacBook == false) { // if this is PC
      this.stage.on('wheelstart', (event: any) => {
        this.hideContextMenus()
      })


   /*   this.stage.on('wheel', (event: any) => {
        // Stop the browser from scrolling the page
        event.evt.preventDefault();
    
        const e = event.evt;
        const oldScale = this.stage.scaleX();
        const pointer = this.stage.getPointerPosition();
    
        // Calculate mouse position relative to the canvas zoom
        const mousePointTo = {
          x: (pointer.x - this.stage.x()) / oldScale,
          y: (pointer.y - this.stage.y()) / oldScale,
        };
    
        // Define zoom speed and limits
        const scaleBy = 1.1; // Increased slightly for better feel
        let newScale = e.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
        
        // Constrain zoom between 10% and 1000%
        newScale = Math.max(0.1, Math.min(newScale, 10));
    
        // Apply new scale
        this.stage.scale({ x: newScale, y: newScale });
    
        // Re-calculate position so we zoom "into" the mouse pointer
        const newPos = {
          x: pointer.x - mousePointTo.x * newScale,
          y: pointer.y - mousePointTo.y * newScale,
        };
    
        this.stage.position(newPos);
        this.stage.batchDraw();
        
        // Optional: hide menus during zoom
        this.hideContextMenus();
      }); */


      this.stage.on('wheel', (event: any) => { // ZANIM TO USUNĘ TRZEBA SIE UPEWNIĆ ZE NA PC BĘDZIE DZIAŁAĆ ZOOMOWANIE I PRZESUWANIE Z UŻYCIEM TRACKPADU
        event.evt.preventDefault();
        const e = event.evt;
      
        // If user holds ctrl, zoom; otherwise, PAN!
        if (e.ctrlKey) {
          const oldScale = this.stage.scaleX();
          const pointer = this.stage.getPointerPosition();
          const mousePointTo = {
            x: (pointer.x - this.stage.x()) / oldScale,
            y: (pointer.y - this.stage.y()) / oldScale,
          };
      
          const scaleBy = 1.05;
          let newScale = e.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
          newScale = Math.max(0.1, Math.min(newScale, 10));
      
          this.stage.scale({ x: newScale, y: newScale });
      
          const newPos = {
            x: pointer.x - mousePointTo.x * newScale,
            y: pointer.y - mousePointTo.y * newScale,
          };
          this.stage.position(newPos);
          this.stage.batchDraw();
    //      this.updateBackgroundGrid(); // narazie to zakomentowuje aby zobaczyc czy to nie jest przyczyną zawieszen
      
        } else {
          // PAN: most trackpads send deltaX, deltaY ≠ 0 for two-finger scroll
          const dragDistanceScale = 0.75; // tweak as needed
          const newPosition = {
            x: this.stage.x() - dragDistanceScale * e.deltaX,
            y: this.stage.y() - dragDistanceScale * e.deltaY
          };
          this.stage.position(newPosition);
       //   this.updateBackgroundGrid();
      
          if (this.wheelTimeout) {
            clearTimeout(this.wheelTimeout);
          }
          this.wheelTimeout = setTimeout(() => {
            this.onWheelStop();
          }, 200);
        }
      });

    } else { // if it is macbook
      this.stage.on('wheel', (event: any) => {
        const isTrackpad = this.detectTrackPad(event)
        event.evt.preventDefault();
     //   this.hideContextMenus()
        if (isTrackpad == true) { // user user trackpad
                      // adapted from Inspoboard code courtesy of Jian Jie @liaujianjie
                      if (event.evt.ctrlKey) { // user zooms stage
                        const oldScale = this.stage.scaleX();
                        const mousePointTo = {
                          x: this.stage.getPointerPosition().x / oldScale - this.stage.x() / oldScale,
                          y: this.stage.getPointerPosition().y / oldScale - this.stage.y() / oldScale
                        };
              
                        const unboundedNewScale = oldScale - event.evt.deltaY * 0.01;
                        this.scale = unboundedNewScale;
                        if (unboundedNewScale < 0.1) {
                          this.scale = 0.1;
                        } else if (unboundedNewScale > 10.0) {
                          this.scale = 10.0;
                        }
              
                        const newPosition = {
                          x:
                            -(mousePointTo.x - this.stage.getPointerPosition().x / this.scale) *
                            this.scale,
                          y:
                            -(mousePointTo.y - this.stage.getPointerPosition().y / this.scale) *
                            this.scale
                        };
                        this.stage.position(newPosition)
                        this.stage.scale({ x: this.scale, y: this.scale })
                      } else { // user drags stage

                        const dragDistanceScale = 0.75;
                        const newPosition = {
                          x: this.stage.x() - dragDistanceScale * event.evt.deltaX,
                          y: this.stage.y() - dragDistanceScale * event.evt.deltaY
                        };
                        this.stage.position(newPosition)
                        if (this.wheelTimeout) {  // Clear the previous timeout if it's still running
                          clearTimeout(this.wheelTimeout);
                        }
                          // Set a new timeout to detect when wheel events stop firing
                        this.wheelTimeout = setTimeout(() => {
                          this.onWheelStop();
                        }, 200); // Timeout duration in milliseconds
                      }
                //      this.updateBackgroundGrid()
        } else { // user uses mouse wheel change scale
          const oldScale = this.stage.scaleX();
   
          const pointer = this.stage.getPointerPosition();
          const mousePointTo = {
            x: (pointer.x - this.stage.x()) / oldScale,
            y: (pointer.y - this.stage.y()) / oldScale,
          };
     
          // Adjust the scale based on mouse wheel delta
          const scaleBy = 1.05;
          let newScale = event.evt.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
          newScale = Math.max(0.1, Math.min(newScale, 10));
     
          this.stage.scale({ x: newScale, y: newScale });
     
          const newPos = {
            x: pointer.x - mousePointTo.x * newScale,
            y: pointer.y - mousePointTo.y * newScale,
          };
          this.stage.position(newPos);
          this.redrawLayer();
     
//this.updateBackgroundGrid(); // narazie to zakomentowuje aby zobaczyc czy to nie jest przyczyną zawieszen
     //     this.updateCursorPosition() // updates user cursor position so next canvas can be scrolled to it
        }
      })

    }


    this.stage.on('mousedown', (e: any) => {
      this.hideContextMenus()
      this.shareCanvasPopupVisible = false
      if (e.target !== this.stage) {       // do nothing if we mousedown on any shape
        return;
      }
      e.evt.preventDefault();

      const pointerPosition = this.stage.getRelativePointerPosition()
      this.x1 = pointerPosition.x;
      this.y1 = pointerPosition.y;
      this.x2 = pointerPosition.x;
      this.y2 = pointerPosition.y;
      this.pointerPosition = pointerPosition
      if (this.isProductlyMode == true) {

      } else {
        if (this.isFreeHandDrawingEnabled == true || this.isEraserEnabled == true) {
          this.selectionRectangle.remove();
          this.justPainting = true;
          if (pointerPosition) {
            let strokeWidth = 3
            if (this.isEraserEnabled == true) {
              strokeWidth = 6
            }
            const key = this.paintingMode === 'brush' ? "freeline-"+this.firestore.generateUID() : "eraserline-"+this.firestore.generateUID()
            this.lastPaintedLine = new Konva.Line({
              id: key,
              stroke: this.pickedColor,
              strokeWidth: strokeWidth,
              globalCompositeOperation:
                this.paintingMode === 'brush' ? 'source-over' : 'destination-out',
              // round cap for smoother lines
              lineCap: 'round',
              lineJoin: 'round',
              // add point twice, so we have some drawings even on a simple click
              points: [this.x1, this.y1, this.x1, this.y1],
            });
            this.layer.add(this.lastPaintedLine);
          }
        } else {
          if (this.isPointerEnabled == false) {
            this.selectionRectangle.width(0);
            this.selectionRectangle.height(0);
            this.selecting = true;
            this.selectionRectangle.moveToTop()
          }
        }
      }
    });

    this.stage.on('mousemove', (e: any) => {
    
      if (this.isDrawingArrow) {
        this.dragArrow();
      }
    
      e.evt.preventDefault();
      const pos = this.stage.getRelativePointerPosition();
      this.updatePositionOnCanvas(pos);
    
      if (this.isFreeHandDrawingEnabled || this.isEraserEnabled) {
        if (!this.justPainting) {
          return;
        }
        // Prevent scrolling on touch devices
        e.evt.preventDefault();
    
        if (pos) {
          const newPoints = this.lastPaintedLine.points().concat([pos.x, pos.y]);
          this.lastPaintedLine.points(newPoints);
        }

      } else if (this.selecting) {
        this.x2 = pos.x;
        this.y2 = pos.y;
        this.selectionRectangle.setAttrs({
          visible: true,
          x: Math.min(this.x1, this.x2),
          y: Math.min(this.y1, this.y2),
          width: Math.abs(this.x2 - this.x1),
          height: Math.abs(this.y2 - this.y1),
        });
      }

      if (this.isProductlyMode == true && e.evt.buttons == 1 && this.isDraggingDraggedItem == false) { // dragging stage with mouse for produtly, but do not move stage if dragging dragged item
        const dragDistanceScale = 0.75;
        const newPosition = {
          x: this.stage.x() + dragDistanceScale * e.evt.movementX,
          y: this.stage.y() + dragDistanceScale * e.evt.movementY
        };
        this.stage.position(newPosition)
      }
    
      // Auto-pan logic starts here
      const edgeThreshold = 50; // Distance from edge to start panning
      const panSpeed = 5; // Speed of panning per interval in pixels
    
      // Get the bounding rectangle of the canvas container
      const containerRect = this.stage.container().getBoundingClientRect();
    
      // Calculate mouse position relative to the canvas container
      const mouseX = e.evt.clientX - containerRect.left;
      const mouseY = e.evt.clientY - containerRect.top;
      const containerWidth = containerRect.width;
      const containerHeight = containerRect.height;
    
      let panX = 0;
      let panY = 0;
    
      if (mouseX < edgeThreshold && mouseX > 0) {      // Check horizontal edges
        // Near left edge
        panX = panSpeed;
      } else if (mouseX > containerWidth - edgeThreshold && mouseX < containerWidth) {
        // Near right edge
        panX = -panSpeed;
      }
    

      if (mouseY < edgeThreshold && mouseY > 0) {      // Check vertical edges
        // Near top edge
        panY = panSpeed;
      } else if (mouseY > containerHeight - edgeThreshold && mouseY < containerHeight) {
        // Near bottom edge
        panY = -panSpeed;
      }
    
      // Start or stop panning based on mouse position
      if ((panX !== 0 || panY !== 0) && this.selecting == true) {
        // Set the pan direction
        this.panDirection = { x: panX, y: panY };
        if (!this.panInterval) {
          // Start panning at regular intervals
          this.panInterval = setInterval(() => {
            this.stage.x(this.stage.x() + this.panDirection.x);
            this.stage.y(this.stage.y() + this.panDirection.y);
            this.stage.batchDraw();
    
            // Update selection rectangle coordinates
       //     if (this.selecting == true) {
              this.x1 += this.panDirection.x;
              this.x2 += this.panDirection.x;
              this.y1 += this.panDirection.y;
              this.y2 += this.panDirection.y;
              this.selectionRectangle.setAttrs({
                x: Math.min(this.x1, this.x2),
                y: Math.min(this.y1, this.y2),
                width: Math.abs(this.x2 - this.x1),
                height: Math.abs(this.y2 - this.y1),
              });
        //    }
      //      this.updateBackgroundGrid() // narazie to zakomentowuje aby zobaczyc czy to nie jest przyczyną zawieszen
          }, 30); // Adjust interval time as needed
        }
      } else {
        if (this.panInterval) {  // Stop panning if mouse is not near the edge
          clearInterval(this.panInterval);
          this.panInterval = null;
          this.panDirection = { x: 0, y: 0 };
        }
      }
      
    });

    document.addEventListener('mouseout', (e) => { // turn off panning if mouse leaves the window
      // If the mouse has left the window (relatedTarget is null), stop panning
      if (!e.relatedTarget) {
        this.clearSelection()
        this.isDrawingArrow = false
        this.mouseOverShapeKey = ""
        if (this.panInterval) {
          clearInterval(this.panInterval);
          this.panInterval = null;
          this.panDirection = { x: 0, y: 0 };
        }
      }
    });

    this.stage.on('mouseup', (e: any) => {
      e.evt.preventDefault();
      if (this.isFreeHandDrawingEnabled == true || this.isEraserEnabled == true) {
        this.justPainting = false;
       // const key = this.paintingMode === 'brush' ? "freeline-"+this.firestore.generateUID() : "eraserline-"+this.firestore.generateUID()
       // this.lastPaintedLine.id(key)
        this.stepsToUndo += 1
        this.canvasHistory.push({
          key: this.lastPaintedLine.id(),
          contentKey: this.lastPaintedLine.id(),
          content: "",
          command: "add",
          shape: this.paintingMode,
          width: 0,
          height: 0,
          color: this.lastPaintedLine.stroke(),
          strokeWidth: this.lastPaintedLine.strokeWidth(),
          points: this.lastPaintedLine.points(),
          x: 0,
          y: 0,
          rotation: 0,
          sequence: this.canvasHistory.length,
          fromKey: "",
          toKey: "",
          coverImageURL: "",
          zIndex: 100,
          isExpanded: true,
          dateOfUpdate: new Date(),
          isFixed: false
        })
        this.saveCanvas()
      } else if (this.selecting == true) {
        this.selectionRectangle.visible(false)
        var shapes = this.stage.find('.selectable');
        var box = this.selectionRectangle.getClientRect();
        this.selectedObjects = shapes.filter((shape :any) =>
          Konva.Util.haveIntersection(box, shape.getClientRect()))
          .filter((shape: any) => shape.visible() == true);
        if (this.selectedObjects.length == 0) {
          this.clearSelection()
        } else {
          this.tr.show()
          this.tr.nodes(this.selectedObjects)
        }
      } else {
        this.clearSelection()
      }
      this.selecting = false;
      this.updateBackgroundGrid();
    });

    this.stage.on('click tap', (e: any) => {
      if (this.selectionRectangle.visible() == true) {
        return;
      }
    
      if (e.target === this.stage) {      // if click on empty area - remove all selections
        this.clearSelection()
        return;
      }
      // Find the ancestor with name 'selectable'
      let selectableNode = e.target.findAncestor('.selectable', true); // 'true' looks into the current node as well
    
      if (!selectableNode) {  // do nothing if clicked NOT on our rectangles
        return;
      } else {
        this.selectedObjects.length = 0
        this.selectedObjects.push(selectableNode)
        this.tr.nodes([selectableNode]);
      }
    });

    this.stage.on('dblclick', (e: any) => {
    })

  }

  detectTrackPad(e: any) { // detect if trackpad  or mouse scroll is used by identifying the difference in wheelDeltaY, mouses are more chunky when scrolling, https://stackoverflow.com/questions/10744645/detect-touchpad-vs-mouse-in-javascript
    var isTrackpad = false;
    if (e.evt.wheelDeltaY) {
      if (e.evt.wheelDeltaY === (e.evt.deltaY * -3)) {
        isTrackpad = true;
      }
    }
    else if (e.evt.deltaMode === 0) {
      isTrackpad = true;
    }
    return isTrackpad
  }

  onWheelStop() { // fired when stage scrolling stops
    this.updateCursorPosition()
    this.updateBackgroundGrid();
    this.setFocus()
  }

  getRelativeRectanglePosition(box: {width: number, height: number, x: number, y: number}) {
    const pos = this.stage.getPosition();
    const offset = this.stage.getOffset();
    const scale = this.stage.getScale();

    return {
        x : ((box.x / scale.x) - (pos.x / scale.x) + offset.x),
        y : ((box.y / scale.y) - (pos.y / scale.y) + offset.y)
    };
}

  clearSelection() {
    this.tr.nodes([])
    this.selectedObjects.length = 0
    this.selectionRectangle.visible(false)
    this.selecting = false
    this.hideContextMenus()
    this.userArrow.remove()
  }

  hideContextMenus() {
    this.isContextMenuVisible = false
    this.isContextMenuFrameVisible = false
    this.isContextMenuCollapseExpandVisible = false
    this.isContextMenuCommentlistVisible = false
    this.isContextMenuTreeVisible = false
    this.isManualTreeComponentPopupVisible = false
    this.isDeepSearchPopupVisible = false
    this.isGenerateByAIPopupVisible = false
    this.previousLogLength = 0
    this.progressStatus = ""
    this.researchTargetPrompt = ""
    this.showPermissionsPopup = false
    this.isRightClickMenuVisible = false
    this.removeTouchPoints()
    this.hidePopupMenu()
  }

  private handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'c' && (event.ctrlKey == true || event.metaKey == true) && this.isReadOnly == false && this.site != "productly") {
      this.copySelectedObjects()
    }
    if (event.key === 'v' && (event.ctrlKey == true || event.metaKey == true) && this.isReadOnly == false && this.copiedObjects.length > 0 && this.site != "productly") {
      this.pasteSelectedObjects()
    }
    if ((event.key === 'Delete' || event.key === 'Backspace')&&(this.isContentEditing == false)) {
      this.handleDeleteOrBackspace();
    }
    if (event.key === 'Escape') {
      this.clearSelection()
    }
  }

  @HostListener('document:paste', ['$event'])
  async extractClipboardData(event: ClipboardEvent) {
    if (this.site != "productly") {
      event.preventDefault(); // Prevent the default paste action (if necessary)
      const clipboardData = event.clipboardData;
      const pastedText = clipboardData?.getData('text/plain') || '';
      if (pastedText && this.copiedObjects.length == 0) {
        this.pasteSelectedObjects(pastedText)
      }
    }
  }

  copiedObjects: any[] = []

  copySelectedObjects() {
    this.copiedObjects = this.selectedObjects.map(object => {
      const clonedObject = object.clone();
      clonedObject.setX(object.x() + 10); // Example of adjusting position to avoid overlap
      clonedObject.setY(object.y() + 10);
      return clonedObject;
    });
  }

  async pasteSelectedObjects(pastedText: string = "") {
    const pointerPosition = this.stage.getPointerPosition() || {x: 0, y: 0};
    const transform = this.stage.getAbsoluteTransform().copy().invert();
    const position = transform.point(pointerPosition);
    if (this.copiedObjects.length > 0) {
      for (let i = 0; i < this.copiedObjects.length; i++) {
        const command = this.canvasHistory.filter((h: any) => h.key == this.copiedObjects[i].id())[0]
        if (command) {
          if (this.copiedObjects[i].id().startsWith("postit-")) { // NARAZIE ZROBIONE TYLKO DLA POSTITOW
            this.addPostitContent(position.x, position.y, command.width, command.height, command.content, command.color, false, command.shape);  
          } else if (this.copiedObjects[i].id().startsWith("label-")) {
            this.addLabel(position.x, position.y, command.width, command.height, command.content, command.color);  
          } else if (this.copiedObjects[i].id().startsWith("content-")) {
            this.onAddWorkpackage('content', [{key: command.key, name: command.content, htmlName: command.content, color: command.color, coverImageURL: command.coverImageURL}], 0, 0, {x: position.x, y: position.y, width: command.width, height: command.height})
          } else if (this.copiedObjects[i].id().startsWith("workpackage-")) {
            this.onAddWorkpackage('workpackage', [{key: command.key, name: command.content, htmlName: command.content, color: command.color, coverImageURL: command.coverImageURL}], 0, 0, {x: position.x, y: position.y, width: command.width, height: command.height})
          } else if (this.copiedObjects[i].id().startsWith("image-")) {
            this.addImage(position.x, position.y, command.width, command.height, command.coverImageURL);  
          } 
        }
      };
    } else if (pastedText.length > 0) {
      this.addLabel(position.x, position.y, this.boxWidth, this.boxHeight, pastedText, "#000000");  
    }
    this.saveCanvas()
    this.redrawLayer();
  }

  deletectSelectedCards() {
    let dialogRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {"content": "Are you sure you want to delete selected cards?", "onlyCloseButton": false, "title": "Delete selected cards"}
    })
    dialogRef.afterClosed().subscribe(async (r) => {
      if (r == true) {
            this.firestore.showSnackBar("Deleting selected cards...")
            this.selectedCards = this.treeCards.filter(card => card.card.isCardChecked);
            for (const card of this.selectedCards) {
              await this.deleteOSTCard(card.key)
            }
            this.selectedCards.length = 0
            await this.saveCanvas()
            this.clearSelection()
            this.layer.batchDraw()
      }
    })
  }

  deleteAll() { // delete all shapes and history
    let dialogRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {"content": "Are you sure you want to clean entire canvas?", "onlyCloseButton": false, "title": "Clean canvas"}
    })
    dialogRef.afterClosed().subscribe((r) => {
      if (r == true) {
        dialogRef = this.dialog.open(ConfirmingDialogComponent, {
          data: {"content": "If you click Ok, everthing will be lost. Are you sure?", "onlyCloseButton": false, "title": "Clean canvas"}
        })
        dialogRef.afterClosed().subscribe((r1) => {
          if (r1 == true) {
            this.firestore.showSnackBar("For your safety, most of canvas history is downloaded to local file.")
            this.saveCanvas().then(() => { // I need to create compressed history before downloading
              this.downloadCanvasHistory()
              this.clearSelection()
              this.destroyAllNodes()
              this.layer.batchDraw()
              this.canvasHistory.length = 0
              this.removeTreeCards()
              this.saveTreeCards()
            })
          }
        })
      }
    })
  }

  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
        const reader = new FileReader();
        reader.onload = (e: any) => {         // When the file is read, this callback will be called
            try {
                const data = JSON.parse(e.target.result);                // Parse the JSON data and update canvas history
                this.canvasHistory = [...data || []]; // Make sure to set this property appropriately
                this.compressedHistory = [...data || []];
                this.drawCanvasFromHistory(this.canvasHistory).then(() => {
                    this.sendIsRenderingCompleted.emit(true);
                    this.saveCanvas()
                });
            } catch (error) {
                console.error('Error parsing JSON:', error);
            }
        };
        reader.readAsText(file);        // Read the file as text
    }
}

  downloadCanvasHistory() {
    if (this.canvasHistory.length > 0 || this.compressedHistory.length > 0) {
      if (this.compressedHistory.length == 0) {
        this.compressedHistory = [...this.canvasHistory]
      }
      const jsonBlob = new Blob([JSON.stringify(this.compressedHistory, null, 2)], { type: 'application/json' });  // Convert the canvasHistory array to a JSON string
      const link = document.createElement('a');     // Create a link element
      link.href = URL.createObjectURL(jsonBlob);
      const date = new Date()
      link.download = 'canvasHistory-'+this.canvasName+'-'+date.toISOString()+'.json'; // The name of the file
      document.body.appendChild(link);     // Append the link to the body (required for Firefox)
      link.click();     // Programmatically click the link to trigger the download
      document.body.removeChild(link);     // Remove the link from the body
    }
  }

  deleteConnectedArrows(arrows: any[]) {
    arrows.forEach((arrow: Konva.Arrow) => {
      this.canvasHistory.splice(this.canvasHistory.findIndex(h => h.key == arrow.id()), 1)
      this.connectors = this.connectors.filter(c => c.id != arrow.attrs.id)
      if (arrow) {
        arrow.destroy()
      }
    })
  }

  public handleDeleteOrBackspace() { // Handle your delete or backspace logic here
    if (this.isDeleteDialogVisible == true || this.areCanvasEventsSuspended == true) {
      return
    }
    this.isDeleteDialogVisible = true
    if (this.isShiftPressed == true && this.tr.nodes().length > 0) {
      const dialogRef = this.dialog.open(ConfirmingDialogComponent, {
        data: {"content": "Are you sure you want to delete alle objects connected the selected ones?", "onlyCloseButton": false, "title": "Delete objects"}
      })
      dialogRef.afterClosed().subscribe((r) => {
        this.isDeleteDialogVisible = false
        if (r == true) {
          this.loadingMessage = "Deleting card..."
          this.progressLog.length = 0
          let nodeKeysToDelete: string[] = []
          this.tr.nodes().forEach((shape: any) => {
            nodeKeysToDelete.push(shape.attrs.id)
            nodeKeysToDelete.forEach((key: string) => { // find all connected objects
              const connectedObjectKeys = this.findConnectedObjects(key, [])
              connectedObjectKeys.forEach((key: string) => {
                if (nodeKeysToDelete.includes(key) == false) {
                  nodeKeysToDelete.push(key)
                }
              })
            })
            this.firestore.showSnackBar("For your safety, most of canvas history is downloaded to local file.")
            this.saveCanvas().then(() => { // I need to create compressed history before downloading
              this.downloadCanvasHistory()

              nodeKeysToDelete.forEach((key: string) => { // delete all connected objects
                const arrows = this.findConnectedArrows(key)
              this.stepsToUndo += 1
              this.canvasHistory.push({
                key: key,
                contentKey: key,
                content: "",
                command: "delete",
                shape: "box",
                width: 0,
                height: 0,
                color: "",
                strokeWidth: 0,
                points: [],
                x: 0,
                y: 0,
                rotation: 0,
                sequence: this.canvasHistory.length,
                fromKey: "",
                toKey: "",
                coverImageURL: "",
                zIndex: 100,
                isExpanded: true,
                dateOfUpdate: new Date(),
                isFixed: false
              })
              this.deleteConnectedArrows(arrows)
              const s = this.stage.findOne('#' + key)
              if (s) {
                s.destroy(); // Remove shape
              }
            })
          })
          })
          this.clearSelection()
          this.saveCanvas()
          this.redrawLayer(); // Redraw the layer
        }
      })
    } else if (this.isReadOnly == false && this.showChatbotPopup == false && this.tr.nodes().length > 0) {
      const dialogRef = this.dialog.open(ConfirmingDialogComponent, {
        data: {"content": "Are you sure you want to delete selected objects?", "onlyCloseButton": false, "title": "Delete objects"}
      })
      dialogRef.afterClosed().subscribe((r) => {
        this.isDeleteDialogVisible = false
        if (r == true) {
          this.tr.nodes().forEach((shape: any) => {
            this.stepsToUndo += 1
            this.canvasHistory.push({
              key: shape.attrs.id,
              contentKey: shape.attrs.id,
              content: "",
              command: "delete",
              shape: "box",
              width: 0,
              height: 0,
              color: "",
              strokeWidth: 0,
              points: [],
              x: 0,
              y: 0,
              rotation: 0,
              sequence: this.canvasHistory.length,
              fromKey: "",
              toKey: "",
              coverImageURL: "",
              zIndex: 100,
              isExpanded: true,
              dateOfUpdate: new Date(),
              isFixed: false
            })
            const arrows = this.findConnectedArrows(shape.attrs.id)
            arrows.forEach((arrow: Konva.Arrow) => {
              this.canvasHistory.splice(this.canvasHistory.findIndex(h => h.key == arrow.attrs.id), 1)
              this.connectors = this.connectors.filter(c => c.id != arrow.attrs.id)
              arrow.destroy()
            })
            if (shape) {
              shape.destroy(); // Remove shape
            }
          })
          this.clearSelection()
          this.saveCanvas()
          this.redrawLayer(); // Redraw the layer
        }
      })
    }
  }

  onCanvasEventsSuspended(event: boolean) {
    this.areCanvasEventsSuspended = event
  }

  onCommentListExpanded(event: boolean) {
    if (event == true) {
      this.resizeStage()
    }
  }

  onIsListening(event: boolean) {
    this.isListening = event
  }

  findConnectedArrows(shapeKey: string) {
    let result: any[] = []
    const arrows = this.connectors.filter((arrow: any) => arrow.from == shapeKey || arrow.to == shapeKey)
    arrows.forEach((arrow: any) => {
        const shape = this.stage.findOne('#' + arrow.id)
        if (shape instanceof Konva.Arrow || shape instanceof Konva.Path) {
          result.push(shape)
        }
    })
    return result
  }

  getTouchDistance(touch1: any, touch2: any) {
    const dx = touch2.clientX - touch1.clientX;
    const dy = touch2.clientY - touch1.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  };


  preparePost(child: any, projectName: string) {
    let title: any = child.data()["title"] || ""
    let dateOfCreation: any = child.data()["dateOfCreation"]
    let authorKey: any = child.data()["authorKey"]
    let authorName: any = child.data()["authorName"]
    let dateOfUpdate: any = child.data()["dateOfUpdate"]
    let nameHTML: any = child.data()["nameHTML"] // TO TRZEBA BRAC Z CONTENTU
    const projectKey: any = child.data()["projectKey"]
    let postKey: any = child.id;
    let date = new Date(dateOfCreation)
   // let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    let formattedDate = date.toLocaleDateString("pl-PL");
    let lastCommentDate = new Date(child.data()["lastCommentDate"])
    let commentCount: number = child.data()["commentCount"]
    let categoryKey: any = child.data()["categoryKey"]
    let viewCount: any = child.data()["viewCount"] || 0
    let contentRowsCount: any = child.data()["rowsCount"]
    let name: any = child.data()["name"]
    let isDeleted: any = child.data()["isDeleted"]
    let coverImageURL: any = child.data()["coverImageURL"]
    let isDownloadAvailable: any = child.data()["isDownloadAvailable"] 
    let templateKey: any = child.data()["templateKey"]
    let contentType: any = child.data()["type"]
    let startDate: any = child.data()["startDate"]
    let endDate: any = child.data()["endDate"]
    let manHours: any = child.data()["manHours"]
    let fileType: any = child.data()["fileType"]
    let status: any = child.data()["status"]
    const progressPercent = child.data()["progressPercent"]
    const tags: string[] = child.get("tags") || []
    const tagsSet = new Set(this.tags.map(tag => tag.tag))
    this.tags = Array.from(new Set([...tagsSet, ...tags])).map(t => ({ tag: t as string, isSelected: false })) // add to global tags array and remove duplicates
    const color = child.get("color") || "#ffffff"
    //const embedding: number[] = child.get("embedding") // I resigned from getting embedding vector for each posts for it is too big. Instead I will reloaded when searching for similar posts
    let fields: PostField[] = []
    let snapshotFields = child.get("fields")
    if (snapshotFields) {
      snapshotFields.forEach((childField: PostField) => {
        fields.push(childField)
     })
    }
    if (templateKey == undefined) {
      templateKey = "note"
    }
    if (isDownloadAvailable == undefined) {
      isDownloadAvailable = false
    }
    if (isDeleted != true) {
     // const colorField = this.getTemplateColor(templateKey)
      const templateName = this.templates.find(t => t.key == templateKey)?.name || ""
      let post: Post = {"title": title, "key": postKey, "dateOfCreation": date, "dateOfUpdate": new Date(dateOfUpdate), "formattedDate": formattedDate, "authorKey": authorKey, "authorName": authorName, "nameHTML": nameHTML, "imageURLs": [], "coverImageURL": coverImageURL, "commentCount": commentCount, "viewCount": viewCount, "lastCommentDate": lastCommentDate, "categoryKey": categoryKey, "name": name, "contentRowsCount": contentRowsCount, "organizationKey": this.organizationKey, "projectKey": projectKey, "isNewPost": false, "isDeleted": false, "loggedUserDisplayName": "", "loggedUserKey": "", "isDownloadAvailable": isDownloadAvailable, "projectName": projectName, "templateKey": templateKey, "color": color, "fields": fields, "tags": tags, "contentType": contentType, "embedding": [], "isRead": false, "isTop": false, "isFavourite": false, "progressPercent": progressPercent, "startDate": startDate, "endDate": endDate, "manHours": manHours, "isSelected": false, "templateName": templateName, "isCompleted": false, "parentName": "", "areKidsColored": false, "description": "", "assignedUsers": [], "status": status, "sequence": 0, "parentKey": "", "isExpanded": false, "areKidsTagged": false, "milestoneKey": "", "isChecked": false, "isParent": false, "fileType": fileType}
        return post

    } else {
      this.firestore.showSnackBar("This content has been deleted from knowledge base.")
      const dialogRef = this.dialog.open(ConfirmingDialogComponent, {
        data: {"content": "This content has been deleted from knowledge base. Do you want to revert it?", "onlyCloseButton": false, "title": "Revert deleted content"}
      })
      dialogRef.afterClosed().subscribe((r) => {
        if (r && r == true) {
          this.firestore.revertDeletedContent(this.organizationKey, postKey)
          this.firestore.showSnackBar("The content has been reverted.")
        }
      })
      return null
    }
  }


  getTemplateColor(templateKey: string) {
    for (let i = 0; i < this.templates.length; i++) {
      if (this.templates[i].key == templateKey) {
        return this.templates[i].color
      }
    }
    return "#ffffff"
  }

  async launchPostDialog(contentKey: string, postName: string, postHTMLName: string, isNewPost: boolean, templateKey: string, captureImage: boolean = false, treeCardKey: string = "") {
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    if (this.site == "productly") { // for productly open side panel with content details
      this.areCanvasEventsSuspended = true
      const p = await this.firestore.getPost(this.organizationKey, contentKey)
      this.post = this.preparePost(p, this.projectName)
      if (this.post != null) {
        await this.firestore.getWorkpackageFields(this.organizationKey, this.post.key).then(f => {
          this.selectedPostKey = contentKey
          this.selectedTreeCardKey = treeCardKey
          this.isPostPanelOpen = true
          this.isEditCardNamePopupVisible = false
          let fields = f
          if (fields == undefined && this.post != null && this.post.contentType != "canvas") { // in case of canvas in knowledge base do not generate template fields
            let templateIndex = this.firestore.getTemplateIndex(templateKey, this.templates)
            if (templateIndex > -1) {
              fields = this.firestore.generateFields(this.templates[templateIndex].fields)
            }
          }
        })
      }
    } else { // for wroolo open modal dialog
      if (contentKey != undefined && contentKey != '' && this.isDialogOpened == false) {
        this.isDialogOpened = true
        this.isLoadingCursor = true
        const p = await this.firestore.getPost(this.organizationKey, contentKey).then(p => {
          return p
        }).catch(() => {
          this.isDialogOpened = false
          this.isLoadingCursor = false
        })
  
        if (p == undefined) {
          this.isDialogOpened = false
          this.isLoadingCursor = false
          return
        }
        if (p.get("isDeleted") == true) {
          const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
            //width: '400px',
            data: {"content": "This content is deleted. Do you want to delete this card from the canvas?", "onlyCloseButton": false, "title": "Delete card"}
          });
          dialogConfirmingRef.afterClosed().subscribe((r) => { 
         this.isDialogOpened = false
         this.isLoadingCursor = false
            if (r == true) {
              this.firestore.showSnackBar("The card has been deleted.");
              this.deleteOSTCard(treeCardKey)
            }
          })
          return
        }
        const type = p.get("type")
        const post: Post | null = this.preparePost(p, this.projectName)
        if (post == null) {
          return
        } 
  
        this.getPersonas(post.tags)
        await this.firestore.getWorkpackageFields2(this.organizationKey, contentKey).then(f => {
          if (f == undefined) {
            this.firestore.showSnackBar("This content seems to be broken.")
            return
          }
          let fields = f
          if (fields == undefined && post.contentType != "canvas") { // in case of canvas in knowledge base do not generate template fields
            let templateIndex = this.firestore.getTemplateIndex(templateKey, this.templates)
            if (templateIndex > -1) {
              fields = this.firestore.generateFields(this.templates[templateIndex].fields)
              post.fields = fields
            }
          }
            if (post.contentType != "canvas" && fields != undefined) { // for posts open popup
              if (templateKey == 'diary' && this.isReadOnly == false) { // every time diary post is opened, add new diary fields
                fields = this.firestore.addDiaryFields(fields)
              }
              this.areCanvasEventsSuspended = true
              const dialogRef = this.dialog.open(Details2Component, {
                panelClass: "dialog-container",
                height: 'calc(100vh - 30px)',
                width: 'calc(100vw - 10px)',
                maxWidth: '100vw',
                maxHeight: '100vh', 
                data: {
                  post: post,
                  menuItems: this.menuItems,
                  key: contentKey,
                  name: postName,
                  HTMLname: postHTMLName,
                  isNewPost: isNewPost,
                  organizationKey: this.organizationKey,
                  projectKey: post.projectKey,
                  projectName: this.projectName,
                  color: post.color,
                  content: post.nameHTML,
                  title: post.title,
                  viewCount: post.viewCount,
                  userId: this.userId,
                  userDisplayName: this.userName,
                  loggedUserKey: this.userId,
                  templateKey: templateKey,
                  fields: fields,
                  templates: this.templates,
                  fieldKeyWithLinks: this.fieldKeyWithLinks,
                  channelKey: contentKey,
                  tags: post.tags,
                  coverImageURL: post.coverImageURL,
                  contentType: post.contentType,
                  isRead: post.isRead,
                  isTop: post.isTop,
                  isFavourite: post.isFavourite,
                  isReadOnly: this.isReadOnly,
                  postEmbedding: post.embedding,
                  embeddingModel: this.embeddingModel,
                  captureImage: captureImage,
                  globalTags: this.tags.map(tag => tag.tag.toLowerCase()),
                  type: type,
                  columnKey: p.get("status"),
                  parentKey: p.get("parentKey"),
                  parentName: p.get("parentName"),
                  isParent: p.get("isParent"),
                  startDate: post.startDate,
                  endDate: post.endDate,
                  manHours: post.manHours,
                  progressPercent: post.progressPercent,
                  selectedTeamKey: this.selectedTeamKey
                }, 
              });
      
              const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
                if (size.matches) { // https://blog.andrewwebster.dev/2018/05/angular-material-full-size-dialog-on.html
                  dialogRef.updateSize('100%', '100%');
            } else {
              dialogRef.updateSize('98vw', 'calc(100vh - 30px)');
              }
          });
              dialogRef.afterClosed().subscribe(async (result: any) => { // when post or task dialog is closed, store data in the database
                this.areCanvasEventsSuspended = false
                this.isDialogOpened = false
                this.scrollPosition = window.scrollY
                if ((result != undefined)&&(result != "")) {
                  if (result.isDownloadAvailable == undefined) {
                    result.isDownloadAvailable = false
                  }
                  if (isNewPost == true) {
                    this.firestore.getContent(this.organizationKey, result.key).then(async (p: any) => {
                      const content = p.name
                      if (treeCardKey != "") { // if this is OST card then update its name
                        const card = this.treeCards.find(c => c.key == treeCardKey)
                        if (card) {
                          const index = this.treeCards.findIndex(c => c.key == treeCardKey)
                          if (index != -1) {
                            this.treeCards[index].content = content
                          }

                          if (card.cardType == "Solution") {
                            card.solutionType = await this.detectSolutionType(content, treeCardKey)
                          }
 
                          this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, p.get("parentKey"), result.key, content, "update", p.get("status"))
                          this.saveTreeCards()
                        }
                      } else {
                        const currentPosition = this.getCentralPosition()
                        this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, p.get("parentKey"), result.key, content, "add", p.get("status"))
                        this.onAddWorkpackage('content', [{key: result.key, name: p.name, htmlName: p.nameHTML, color: p.color, coverImageURL: p.coverImageURL}], 0, this.boxHeight*2, {x: currentPosition.x, y: currentPosition.y, width: this.boxWidth, height: this.boxHeight*2})
                      }
                    })
                  } else {
                    this.firestore.getContent(this.organizationKey, result.key).then(async (p: any) => {
                      const content = p.name
                      if (treeCardKey != "") {
                        const card = this.treeCards.find(c => c.key == treeCardKey)
                        if (card) {
                          const index = this.treeCards.findIndex(c => c.key == treeCardKey)
                          if (index != -1) {
                            this.treeCards[index].content = content
                          }
                          this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, p.get("parentKey"), result.key, content, "update", p.get("status"))
                          await this.saveTreeCards()
                        }
                      } else { // if this is not OST card then update save it in the canvas history
                        const key = "content-"+result.key
                        const command = this.getBoxAttributes(key)
                        command.content = p.nameHTML || p.name
                        command.command = "update"
                        command.color = p.color
                        command.shape = "box"
                        command.contentKey = result.key
                        command.sequence = this.canvasHistory.length
                        if (p.coverImageURL != undefined && p.coverImageURL != "") {
                          command.coverImageURL = p.coverImageURL
                        } else {
                          command.coverImageURL = ""
                        }
                        this.stepsToUndo += 1
                        this.canvasHistory.push(command)
                        this.updateBoxContent(command)
                        this.layer.batchDraw()
                        await this.saveCanvas()
                      }
                    })
                  }
                  if (result.isDeleted == true) {
                    if (treeCardKey != "") {
                        this.deleteOSTCard(treeCardKey)
                    }
                  } else if (result.isPostUpdated == true) {
                        if (switchListeningInFunction == true) {
                          this.isListening = true
                        }
                  }
                }
              });
            } else if (post.contentType == 'canvas') { // for canvases just redirect to canvas
              let canvasKey = contentKey
              this.router.navigate(["canvas/"+this.organizationKey+"/"+this.projectKey+"/"+canvasKey])
            } else if (fields == undefined) {
              this.firestore.showSnackBar("This content cannot be displayed.")
              if (this.isReadOnly == false) {
                const dialogConfirmingRef = this.dialog.open(ConfirmingDialogComponent, {
                  //width: '400px',
                  data: {"content": "This content seems to be broken. Do you want to delete it?", "onlyCloseButton": false, "title": "Delete content"}
                });
                dialogConfirmingRef.afterClosed().subscribe((r) => { 
                  this.isLoadingLabelVisible = false
                  if (r == true) {
                    this.firestore.showSnackBar("The task has been deleted.");
                    this.firestore.removePost(contentKey, this.organizationKey, this.projectKey)
                  }
                })
              }
            }
        })
        this.isLoadingCursor = false
      }
    }
  }

  async undo() {
    if (this.canvasHistory.length > 0) {
      this.undoedHistory.push(this.canvasHistory[this.canvasHistory.length - 1])
      this.canvasHistory.pop()
      this.stepsToUndo -= 1
      await this.drawCanvasFromHistory()
      this.saveCanvas()
    }
  }

  async redo() {
    if (this.undoedHistory.length > 0) {
      this.stepsToUndo += 1
      this.canvasHistory.push(this.undoedHistory[this.undoedHistory.length - 1])
      this.undoedHistory.pop()
      this.stepsToUndo = 0
      await this.drawCanvasFromHistory()
      this.saveCanvas()
    }
  }

  updateObjectPositionsOnCanvasHistory() {
    this.canvasHistory.forEach((c: any) => {
      if (c.command == "add" || c.command == "update") {
        const shape = this.layer.findOne('#' + c.key)
        if (shape) {
          c.x = shape.x()
          c.y = shape.y()
          c.width = shape.width()
          c.height = shape.height()
          c.rotation = shape.rotation()
        }
      }
    })
    this.saveCanvas()
  }

  async saveCanvasOperation() {
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
   // this.cleanOldArrows()
    this.compressedHistory.length = 0
    for (let i = 0; i < this.canvasHistory.length; i++) {

      if (this.canvasHistory[i].command == "add") {
        this.compressedHistory.push(this.canvasHistory[i])
      } else if (this.canvasHistory[i].command == "update") {
        const index = this.compressedHistory.findIndex(c => c.key == this.canvasHistory[i].key)
        if (index > -1) {
          this.compressedHistory[index].x = this.canvasHistory[i].x
          this.compressedHistory[index].y = this.canvasHistory[i].y
          this.compressedHistory[index].width = this.canvasHistory[i].width
          this.compressedHistory[index].height = this.canvasHistory[i].height
          this.compressedHistory[index].content = this.canvasHistory[i].content
          this.compressedHistory[index].color = this.canvasHistory[i].color
          this.compressedHistory[index].rotation = this.canvasHistory[i].rotation || 0
          this.compressedHistory[index].fromKey = this.canvasHistory[i].fromKey
          this.compressedHistory[index].toKey = this.canvasHistory[i].toKey
          this.compressedHistory[index].coverImageURL = this.canvasHistory[i].coverImageURL
          this.compressedHistory[index].isFixed = this.canvasHistory[i].isFixed
        }
      } else if (this.canvasHistory[i].command == "delete") {
        const index = this.compressedHistory.findIndex(c => c.key == this.canvasHistory[i].key)
        if (index != -1) {
          this.compressedHistory.splice(index, 1)
        }
      }
    }
    await this.firestore.saveCanvas(this.organizationKey, this.canvasKey, this.compressedHistory)

    const image = this.updateMinimap()
    if (image != null) {
      await this.firestore.updateCanvasMiniPicture(this.organizationKey, this.canvasKey, image)
    }
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
  }

  async saveCanvas() {
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    // Add the save operation to the queue
    this.changeQueue.push(async () => {
      this.isListening = false;
      // Sending changes to Firestore
      await this.saveCanvasOperation();
      if (switchListeningInFunction == true) {
        this.isListening = true;
      }
    });

    // Process the queue if not already processing
    if (!this.isSaving) {
      this.processSaveQueue();
    }
  }

  private async processSaveQueue() {
    this.isSaving = true;
    this.isSavingInstances += 1
    while (this.changeQueue.length > 0) {
      const saveOperation = this.changeQueue.shift();
      if (saveOperation) {
        await saveOperation();
      }
    }

    this.isSavingInstances -= 1
    if (this.isSavingInstances <= 0) {
      this.isSavingInstances = 0
      this.isSaving = false;
    }
  }


  // methods for drawing laser line between cursor positions
  handleLaserPointer(laserPointer: boolean) {
    this.isLaserPointerEnabled = laserPointer
    if (this.isLaserPointerEnabled == true) {
      this.cursorPositions = this.cursorPositions.filter(cursor => cursor.userId !== this.userId);
      this.laserLine.points([])
      this.layer.add(this.laserLine)
      this.startSavingCursorPosition()
    } else {
      this.stopSavingCursorPosition()
      this.cursorPositions = this.cursorPositions.filter(cursor => cursor.userId !== this.userId);
      this.laserLine.remove()
    }
  }

  startSavingCursorPosition() { // Clear any existing interval before starting a new one
    if (this.cursorPositionInterval) {
        clearInterval(this.cursorPositionInterval);
    }

    // Set the interval to call saveCursorPosition every 1000 ms
    this.cursorPositionInterval = setInterval(() => {
      const currentTime = new Date().getTime()
      const firstIndex = this.cursorPositions.findIndex(p => p.userId === this.userId); // Find the first match and return its index
        this.saveCursorPosition(firstIndex);
        // Check if we need to remove the oldest position for the current user
        if (firstIndex !== -1 && (this.cursorPositions.filter(p => p.userId == this.userId).length > this.positionsToRemember || this.cursorPositions[firstIndex].time < currentTime - this.durationToRemember)) {
      //    this.cursorPositions[firstIndex].shape.destroy()
          this.cursorPositions.splice(firstIndex, 1); // remove the element at that index
        }
        this.drawLaserLine(this.userId)
        const pos = this.stage.getRelativePointerPosition();
        this.updatePositionOnCanvas(pos)
    }, this.positionsFrequenceStoring);
  }

  stopSavingCursorPosition() {
      // Stop the interval when needed
      if (this.cursorPositionInterval) {
          clearInterval(this.cursorPositionInterval);
          this.cursorPositionInterval = null;
          const pos = this.stage.getRelativePointerPosition();
          this.updatePositionOnCanvas(pos)
      }
  }

  async saveCursorPosition(firstIndex: number) { 
    this.layer.add(this.laserLine);        // Add the line to the layer
    if (this.stage) {
        const position = this.stage.getRelativePointerPosition();
        const lastIndex = this.cursorPositions
                            .map((p, index) => ({ p, index })) // Create an array of objects storing the original element and its index
                            .reverse() // Reverse the array to check from last to first
                            .find(item => item.p.userId === this.userId)?.index; // Find the first match and return its index
        if (position != null) {
          let isNewPosition = false
          if (lastIndex != undefined) {
            const previousPosition = this.cursorPositions[lastIndex]
            if (previousPosition?.x != position.x && previousPosition?.y != position.y) {
              isNewPosition = true
            }
          }
          if (isNewPosition == true || firstIndex == -1) {
            this.cursorPositions.push({
                userId: this.userId,
                x: position.x,
                y: position.y,
              //  shape: shape,
                time: new Date().getTime()
            });
        }
      }
    }
    console.timeEnd("saveCursorPosition")
  }

  createSmoothPath (points: { x: number, y: number }[]) {
    if (!points.length) return '';

    let path = `M${points[0].x},${points[0].y} `;
    
    for (let i = 1; i < points.length; i++) {
      const p0 = points[i - 1];
      const p1 = points[i];

      // Calculate control points for Bezier curve
      const controlX = (p0.x + p1.x) / 2;
      const controlY = (p0.y + p1.y) / 2;

      path += `Q${controlX},${controlY} ${p1.x},${p1.y} `;
    }
    return path.trim();
  };

  drawLaserLine(userId: string) { // Create laser line between latest cursor positions
    const points = this.cursorPositions.filter(p => p.userId == userId).map(p => [p.x, p.y]).flat()
   // const points = this.cursorPositions.filter(p => p.userId == userId).map(p => ({x: p.x, y: p.y}))
   this.laserLine.strokeWidth(8 / this.scale)
    this.laserLine.points(points)
    this.laserLine.moveToTop()
    this.redrawLayer();
  }

  zoomIn(scaleBy: number, userCentralPosition: boolean = false) {

    const stage = this.stage;
  
    if (userCentralPosition) {
      const oldScale = stage.scaleX();
      const newScale = oldScale + scaleBy;
  
      // Safety check
      if (newScale <= 0) return;
  
      // --- STEP 1: Find the Visual Center of the Canvas ---
      // We use the Konva content wrapper (div.konvajs-content)
      // This wrapper is what actually holds the canvas element.
      const contentDiv = stage.content;
      
      // This gives us the width of the actual drawing area
      const cx = contentDiv.offsetWidth / 2;
      const cy = contentDiv.offsetHeight / 2;
  
      // --- STEP 2: Calculate Coordinates ---
      // Calculate where that center point is in the "Stage World"
      const worldPoint = {
        x: (cx - stage.x()) / oldScale,
        y: (cy - stage.y()) / oldScale,
      };
  
      // Calculate the new position to force that world point back to the center
      const newPos = {
        x: cx - worldPoint.x * newScale,
        y: cy - worldPoint.y * newScale,
      };
  
      // --- STEP 3: Apply ---
      stage.scale({ x: newScale, y: newScale });
      stage.position(newPos);
      this.scale = newScale;
      stage.batchDraw();

    } else {
      this.scale += scaleBy;
      this.stage.scale({ x: this.scale, y: this.scale });
      this.stage.batchDraw();
    }

    
  }



  getValidObjectsFromLayer(layer: Konva.Layer) {
    function isObjectValid(object: any) {
      return (
        object.x !== undefined &&
        object.x !== null &&
        !isNaN(object.x) &&
        object.y !== undefined &&
        object.y !== null &&
        !isNaN(object.y) &&
        object.width !== undefined &&
        object.width !== null &&
        !isNaN(object.width) &&
        object.height !== undefined &&
        object.height !== null &&
        !isNaN(object.height)
        // Add more checks if needed for rotation, scale, etc.
      );
    }
    return layer.children.filter(isObjectValid);
  }

  calculateBoundingBox() {
    const validObjects = this.getValidObjectsFromLayer(this.layer);
    if (validObjects.length === 0) {
      return {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      }; // or some default value indicating no bounding box
    }
  
    let xmin = Infinity, ymin = Infinity;
    let xmax = -Infinity, ymax = -Infinity;
  
    validObjects.forEach((obj: any) => {
      xmin = Math.min(xmin, obj.x);
      ymin = Math.min(ymin, obj.y);
      xmax = Math.max(xmax, obj.x + obj.width);
      ymax = Math.max(ymax, obj.y + obj.height);
    });
  
    return {
      x: xmin,
      y: ymin,
      width: xmax - xmin,
      height: ymax - ymin,
    };
  }

  getPeriferalPosition(direction: string, marginX: number = 0, marginY: number = 0) { // returns periferal position of the stage in order to place new content and don't overlap with existing content
    const boundingBox = this.layer.getClientRect({ skipTransform: true });
  //  const boundingBox = this.calculateBoundingBox()
    let periferalPosition = {
      x: boundingBox.x,
      y: boundingBox.y
    }
    if (direction == "right") {
      periferalPosition.x = boundingBox.x + boundingBox.width + marginX
      periferalPosition.y = boundingBox.y + boundingBox.height / 2
    } else if (direction == "bottom") {
      periferalPosition.y = boundingBox.y + boundingBox.height + marginY
      periferalPosition.x = boundingBox.x + boundingBox.width / 2
    } else if (direction == "left") {
      periferalPosition.x = boundingBox.x - marginX
      periferalPosition.y = boundingBox.y + boundingBox.height / 2
    } else if (direction == "top") {
      periferalPosition.y = boundingBox.y - marginY
      periferalPosition.x = boundingBox.x + boundingBox.width / 2
    } else {
      periferalPosition.x = 0
      periferalPosition.y = 0
    }
    if (isNaN(periferalPosition.x)) {
      periferalPosition.x = 10
    }
    if (isNaN(periferalPosition.y)) {
      periferalPosition.y = 10
    }
    return periferalPosition
  }

 async updateMinimap(width: number = this.minimapWidth, height: number = this.minimapHeight) { // redraws minimap when stage changes
  let image = null
  if (this.isRefreshingTree == true) {
    // Destroy the existing minimap layer if it exists
    if (this.minimapLayer) {
        this.minimapLayer.destroy();
    }
    await new Promise(resolve => setTimeout(resolve, 100)) // wait for the layer to be updated
    this.minimapLayer = this.layer.clone({ listening: false });  // Clone the main layer without event listeners
    if (this.minimapStage) {
      this.minimapStage.add(this.minimapLayer);
      const boundingBox = this.layer.getClientRect({ skipTransform: true });     // Get the bounding box of all content in the main layer, including negative positions
      if (boundingBox.width == 0 || boundingBox.height == 0) {
        return
      }
       const scaleX = width / boundingBox.width;     // Calculate scale factors based on the bounding box dimensions
       const scaleY = height / boundingBox.height;
       // Choose the smaller scale to fit the content within the minimap
       const scale = Math.min(scaleX, scaleY);
   
       // Set the position of the minimap layer to (0, 0)
       // Since we're adjusting the minimap stage position, we don't need to offset the layer itself
       this.minimapLayer.position({ x: 0, y: 0 });
   
       // Apply the scale to the minimap stage
       this.minimapStage.scale({ x: scale, y: scale });
   
       // Adjust the position of the minimap stage to account for negative positions
       // This ensures all shapes are visible in the minimap, even if they are at negative coordinates

       this.minimapStage.position({
           x: -boundingBox.x * scale,
           y: -boundingBox.y * scale,
       });
   
       // Redraw the minimap
       this.minimapStage.batchDraw();
       image = this.minimapLayer.toDataURL()
    }
  }
  return image
  }


  // inside your component class

  async downloadSelectedCardsPDF(forAICoding: boolean = false) {
    this.selectedCards = this.treeCards.filter(card => card.card.isCardChecked);
    if (this.selectedCards.length === 0) {
      this.firestore.showSnackBar("No cards selected to download.");
      return;
    }
    this.firestore.showSnackBar("Preparing PDF...");
    const tempDiv = document.createElement('div');
    tempDiv.className = 'pdf-content-style'; // Use the same CSS classes for styling
    tempDiv.style.width = '750px'; // Set a fixed width for consistent rendering
    tempDiv.style.padding = '20px';
    tempDiv.style.fontFamily = 'Roboto, Arial, sans-serif';
    let reportHtml = `<div style="margin-bottom: 30px;"><h3>Content of ${this.canvasName} tree - cards selected ${this.selectedCards.length}</h3>`
    if (forAICoding == true) {
      reportHtml = "<h3>Generate React application for the following requirements</h3>"
      const solutionCards = this.selectedCards.filter(card => card.cardType == "Solution")
      if (solutionCards.length == 0) {
        this.firestore.showSnackBar("Select at least one solution card to download.");
        return;
      }
      const parentCards = this.treeCards.filter(card => solutionCards.some(sc => sc.parentKey == card.key))
      const parentCardsContent = parentCards.map(card => card?.content || "").join("\n\n")
      reportHtml += `<div style="margin-bottom: 30px;"><h3>Business context</h3><div style="line-height: 1.2; margin-top: 20px; margin-bottom: 40px;">${parentCardsContent}</div></div>`
      const i = this.treeCards.findIndex(card => card.key == parentCards[0].parentKey)
      const grandParentCard = this.treeCards[i]
      if (grandParentCard) {
        reportHtml += `<div style="line-height: 1.2; margin-top: 20px; margin-bottom: 40px;">${grandParentCard.content}</div>`
      }
    }
    let taskCount = 0
    for (const card of this.selectedCards) {
      const contentKey = card.contentKey
      let cardContent = ""
      if (contentKey != "") {
        const ostCard  = await this.firestore.getContent(this.organizationKey, card.contentKey)
        cardContent = ostCard.nameHTML || ostCard.name || ""
      } else {
        cardContent = card.content
      }

      let cardType = card.cardType
      if (cardType == "opportunity") {
        cardType = "Opportunity"
      } else if (cardType == "outcome") {
        cardType = "Outcome"
      } else if (cardType == "solution") {
        cardType = "Solution"
      } else if (cardType == "experiment") {
        cardType = "Experiment"
      } else if (cardType == "task") {
        cardType = "Task"
      }
      if (forAICoding == true && cardType == "Task") {
        reportHtml += `
        <h5 style="color: #333; margin-top: 20px; margin-bottom: 20px;">User story / feature description</h5>
        <div style="line-height: 1.2; margin-top: 20px; margin-bottom: 40px;">${cardContent}</div>`
        taskCount++
      } else {
        reportHtml += `
        <h5 style="color: #333; margin-top: 20px; margin-bottom: 20px;">${cardType}</h5>
        <div style="line-height: 1.2; margin-top: 20px; margin-bottom: 40px;">${cardContent}</div>`
      }

    }
    if (taskCount == 0 && forAICoding == true) {
      this.firestore.showSnackBar("Select at least one task card to download.");
      return;
    }
    reportHtml += `</div>`

    reportHtml += "<p class='footer'>Requirements generated by Prodely (<a href='https://prodely.com'>Prodely</a>). Do not hesitate to contact us at: hello@prodely.com.</p>";

    const contentWidth = 555; 

    tempDiv.innerHTML = `<style>
      @font-face {
      font-family: 'Roboto-Regular';
      src: url('data:application/font-ttf;base64,');
      font-weight: normal;
      font-style: normal;
      }
      .pdf-content-style, .pdf-content-style * {
      width: ${contentWidth}pt;
      box-sizing: border-box;
      white-space: normal !important;
      word-break: break-word !important;
      overflow-wrap: break-word !important;
      font-family: 'Roboto-Regular', sans-serif!important; 
      line-height: 1.4 !important; /* IMPORTANT: Explicit line height for general text */
      }

      .pdf-content-style .footer {
      font-size: 8pt;
      margin-top: 10pt;
      line-height: 1.2;
      }

      .pdf-content-style a {
      word-break: break-all !important;
      }

      .pdf-content-style h1 {
      font-size: 24pt;
      margin-bottom: 18pt;
      line-height: 1.2;
      }
      .pdf-content-style h2 {
      font-size: 18pt;
      margin-top: 24pt;
      margin-bottom: 12pt;
      line-height: 1.3;
      }
      .pdf-content-style h3 {
      font-size: 14pt;
      margin-top: 20pt;
      margin-bottom: 12pt;
      line-height: 1.3;
      }
      .pdf-content-style p {
      font-size: 10pt;
      margin-bottom: 10pt;
      line-height: 1.6; /* Slightly larger line height for paragraphs */
      }
      .pdf-content-style ul, .pdf-content-style ol {
      margin-left: 25pt; /* Indent lists */
      margin-bottom: 10pt;
      padding-left: 0; /* Remove default padding that might cause issues */
      }
      .pdf-content-style li {
      font-size: 10pt;
      margin-bottom: 5pt; /* Space between list items */
      line-height: 1.6; /* Ensure consistent line height */
      }
      .pdf-content-style ul {
      list-style: none;
      }
      /*
      .pdf-content-style td {
      min-width: 100pt;
      font-size: 8pt;
      margin-bottom: 5pt; /* Space between list items */
      line-height: 1.2; /* Ensure consistent line height */
      }*/
      /*.pdf-content-style ul li:before {
      content: "• "; 
      color: black; 
      display: inline-block;
      width: 1em;
      margin-left: -1em
      }</style>`+reportHtml;
    
    document.body.appendChild(tempDiv); 
    const doc = new jsPDF({
      orientation: 'p', // Portrait is usually better for reports
      unit: 'px',
      format: 'a4'
    });
  
    // 3. Convert HTML to PDF
    try {
      await doc.html(tempDiv, {
        callback: (pdf) => {
          const date = new Date().toISOString().split('T')[0];
          let fileName = `${this.canvasName}-documentation-${date}.pdf`;
          if (forAICoding == true) {
            fileName = `${this.canvasName}-ai-coding-requirements-${date}.pdf`;
          }
          pdf.save(fileName);
          
          // Cleanup
          document.body.removeChild(tempDiv);
          this.firestore.showSnackBar("Download complete!");
        },
        x: 15,
        y: 15,
        width: 420, // Target width in the PDF document
        windowWidth: 750, // Match the tempDiv width
        autoPaging: 'text'
      });
    } catch (error) {
      console.error("PDF Generation Error:", error);
      document.body.removeChild(tempDiv);
    }
  }
  
  downloadPDF() {
      this.firestore.showSnackBar("Preparing PDF...")
      this.isMinimapVisible = false;
  
      // A safe maximum dimension for canvas elements in most browsers.
      const MAX_CANVAS_DIMENSION = 16384;
  
      const boundingBox = this.layer.getClientRect({ skipTransform: true });
  
      // --- 1. Calculate Scaling Factor ---
      let scale = 1;
      if (boundingBox.width > MAX_CANVAS_DIMENSION || boundingBox.height > MAX_CANVAS_DIMENSION) {
          // Calculate scale based on the dimension that exceeds the max the most
          scale = Math.min(MAX_CANVAS_DIMENSION / boundingBox.width, MAX_CANVAS_DIMENSION / boundingBox.height);
          console.warn(`Canvas is too large. Scaling down by a factor of ${scale}`);
      }
  
      // --- 2. Define Scaled Dimensions for the Off-screen Stage ---
      const stageWidth = boundingBox.width * scale;
      const stageHeight = boundingBox.height * scale;
  
      const pixelRatio = 1.5; // You can even increase this slightly to regain quality
      const margin = 20;
  
      // --- 3. Create and Prepare the Off-screen Stage ---
      const l = this.layer.clone({ listening: false });
  
      // Create a white background rect
      const bgRect = new Konva.Rect({
          x: boundingBox.x,
          y: boundingBox.y,
          width: boundingBox.width,
          height: boundingBox.height,
          fill: 'white',
          listening: false,
      });
      l.add(bgRect);
      bgRect.moveToBottom();
  
      // Create the off-screen stage with the NEW scaled dimensions
      const s = new Konva.Stage({
          container: document.createElement('div'),
          width: stageWidth,
          height: stageHeight,
      });
  
      s.add(l);
  
      // --- 4. Apply Scale and Position to the Layer ---
      // This is the key: scale the entire layer down to fit the smaller stage
      l.scale({ x: scale, y: scale });
      // Adjust the position based on the new scale
      l.position({ x: -boundingBox.x * scale, y: -boundingBox.y * scale });
  
      s.draw(); // Draw the scaled content onto the smaller stage
  
      // --- 5. Export to Data URL ---
      // The export dimensions are now the full size of the scaled stage
      const imageData = s.toDataURL({
          pixelRatio: pixelRatio, // This will effectively render at (stageWidth * pixelRatio) pixels
          mimeType: 'image/jpeg',
          quality: 1,
      });
  
      if (!imageData || imageData === 'data:,') {
          // this.firestore.showSnackBar('Error: Could not generate image data. The canvas may still be too large.');
          console.error('Failed to generate image data.');
          s.destroy(); // Clean up
          return;
      }
  
      // --- 6. Create PDF (Your existing logic is fine) ---
      const pdf = new jsPDF({
          orientation: 'landscape',
          unit: 'px',
          format: 'a4' // Using standard format is often easier
      });
      
      const pdfPageWidth = pdf.internal.pageSize.getWidth();
      const pdfPageHeight = pdf.internal.pageSize.getHeight();
  
      // The aspect ratio of the exported image
      const aspectRatio = stageWidth / stageHeight;
  
      let pdfImgWidth = pdfPageWidth;
      let pdfImgHeight = pdfImgWidth / aspectRatio;
  
      // If the image is too tall for the page, resize based on height instead
      if (pdfImgHeight > pdfPageHeight) {
          pdfImgHeight = pdfPageHeight;
          pdfImgWidth = pdfImgHeight * aspectRatio;
      }
  
      const offsetX = (pdfPageWidth - pdfImgWidth) / 2;
      const offsetY = (pdfPageHeight - pdfImgHeight) / 2;
  
      pdf.addImage(imageData, 'JPEG', offsetX, offsetY, pdfImgWidth, pdfImgHeight);
  
      const date = new Date();
      const name = this.canvasName + '-' + date.toISOString();
      pdf.save(`${name}.pdf`);
  
      // --- 7. Save Image ---
      const link = document.createElement('a');
      link.download = name + ".jpg";
      link.href = imageData;
      document.body.appendChild(link); // Required for Firefox
      link.click();
      document.body.removeChild(link);
  
      // --- 8. Clean up ---
      s.destroy();
      this.firestore.showSnackBar("Downloaded PDF")
  }

  downloadImage(filename = 'image') {
    this.isMinimapVisible = false;
    const boundingBox = this.layer.getClientRect({ skipTransform: true });
    const imgWidth = boundingBox.width;
    const imgHeight = boundingBox.height;
    const pixelRatio = 1.5;
    const margin = 20;
  
    // Clone layer and add white background
    const l = this.layer.clone({ listening: false });
    const bgRect = new Konva.Rect({
      x: boundingBox.x,
      y: boundingBox.y-200,
      width: boundingBox.width + 100,
      height: boundingBox.height + 400,
      fill: 'white',
      listening: false,
    });
    l.add(bgRect);
    bgRect.moveToBottom();
  
    // Create new stage (off screen)
    const s = new Konva.Stage({
      container: document.createElement('div'), // create offscreen container
      width: imgWidth,
      height: imgHeight,
    });
    s.add(l);
    l.position({ x: -boundingBox.x, y: -boundingBox.y });
    s.draw();
  
    const imageData = s.toDataURL({
      x: boundingBox.x - margin,
      y: boundingBox.y - margin-200,
      width: boundingBox.width + margin * 2,
      height: boundingBox.height + margin + 200,
      pixelRatio: pixelRatio,
      mimeType: 'image/jpeg', // or 'image/png'
      quality: 1,
    });
  
    if (!imageData) {
      this.firestore.showSnackBar('No image data available to export.');
      return;
    }
  
    // Create a download link and trigger download
    const link = document.createElement('a');
    const date = new Date();
    const name = (filename || this.canvasName + '-' + date.toISOString()) + '.jpg'; // or '.png'
    link.download = name;
    link.href = imageData;
    link.click();
  
    // clean up (optional)
    s.destroy();
  }


  showMinimap() {
    this.isMinimapVisible = !this.isMinimapVisible
    if (this.isMinimapVisible == true) {
      this.updateMinimap()
    }
  }

  switchFreeHandDrawing() {
    this.isFreeHandDrawingEnabled = !this.isFreeHandDrawingEnabled
    if (this.isFreeHandDrawingEnabled == true) {
      this.handleLaserPointer(false)
      this.paintingMode = "brush"
      this.isEraserEnabled = false
      this.clearSelection()
    } else {
      this.handleSelectionRectanglePointer(this.isPointerEnabled)
    }
  }

  switchEraser() {
    this.isEraserEnabled = !this.isEraserEnabled
    if (this.isEraserEnabled == true) {
      this.handleLaserPointer(false)
      this.paintingMode = "eraser"
      this.isFreeHandDrawingEnabled = false
      this.clearSelection()
    } else {
      this.handleSelectionRectanglePointer(this.isPointerEnabled)
    }
  }

  setColorClicked() {
    this.isColorPalleteVisible = !this.isColorPalleteVisible
  }

  colorChangeComplete(event: any) {
    this.pickedColor = event.color.hex
    if (this.tr.nodes().length > 0) {
      this.tr.nodes().forEach((shape: any) => {
      //  const shape = this.tr.nodes()[0] 
        if (shape instanceof Konva.Image) {
          const content = this.boxContent.find(b => b.key == shape.id())?.content
          shape.stroke(this.pickedColor)
          this.stepsToUndo += 1
          this.canvasHistory.push({
            key: shape.id(),
            contentKey: shape.id(),
            content: content || "",
            command: "update",
            shape: "box",
            width: shape.width(),
            height: shape.height(),
            color: this.pickedColor,
            strokeWidth: 2,
            points: [],
            x: shape.x(),
            y: shape.y(),
            rotation: shape.rotation(),
            sequence: this.canvasHistory.length,
            fromKey: "",
            toKey: "",
            coverImageURL: "",
            zIndex: shape.zIndex(),
            isExpanded: true,
            dateOfUpdate: new Date(),
            isFixed: false
          })
        } else if (shape instanceof Konva.Group) {
          const rectNode = shape.find('Rect')[0]
          if (rectNode instanceof Konva.Rect) {
            rectNode.fill(this.pickedColor)
            const content = this.boxContent.find(b => b.key == shape.id())?.content
            this.stepsToUndo += 1
            this.canvasHistory.push({
              key: shape.id(),
              contentKey: shape.id(),
              content: content || "",
              command: "update",
              shape: "box",
              width: shape.width(),
              height: shape.height(),
              color: this.pickedColor,
              strokeWidth: 2,
              points: [],
              x: shape.x(),
              y: shape.y(),
              rotation: shape.rotation(),
              sequence: this.canvasHistory.length,
              fromKey: "",
              toKey: "",
              coverImageURL: "",
              zIndex: shape.zIndex(),
              isExpanded: true,
              dateOfUpdate: new Date(),
              isFixed: false
            })
          }
        } else if (shape instanceof Konva.Text) {
          shape.fill(this.pickedColor)
          this.stepsToUndo += 1
          this.canvasHistory.push({
            key: shape.id(),
            contentKey: shape.id(),
            content: shape.text() || "",
            command: "update",
            shape: "label",
            width: shape.width(),
            height: shape.height(),
            color: this.pickedColor,
            strokeWidth: 1,
            points: [],
            x: shape.x(),
            y: shape.y(),
            rotation: shape.rotation(),
            sequence: this.canvasHistory.length,
            fromKey: "",
            toKey: "",
            coverImageURL: "",
            zIndex: shape.zIndex(),
            isExpanded: true,
            dateOfUpdate: new Date(),
            isFixed: false
          })
        }
      })

      this.saveCanvas()
      this.redrawLayer()
    }
    this.isColorPalleteVisible = false
  }

  dragArrow() { // drawing arrow on canvas

    const pos = this.layer.getRelativePointerPosition()
    if (pos == null) {
      return
    }
    const fromShape = this.layer.findOne((obj: any) => obj.id() == this.selectedShapeKey) as Konva.Rect
    const fromRect = new Konva.Rect({
      x: fromShape.x(),
      y: fromShape.y(),
      width: fromShape.width(),
      height: fromShape.height()
    })

    // Calculate the center positions of fromRect
    const fromX = fromRect.x() + fromRect.width() / 2;
    const fromY = fromRect.y() + fromRect.height() / 2;

    const toX = pos.x;
    const toY = pos.y;

    const dx = toX - fromX;
    const dy = toY - fromY;
    const dist = Math.sqrt(dx * dx + dy * dy);

    // Check if the distance is greater than 10 to avoid division by zero or reversing direction
    let x2 = toX;
    let y2 = toY;
    if (dist > 10) {
        const ux = dx / dist;
        const uy = dy / dist;

        x2 = toX - ux * 10;
        y2 = toY - uy * 10;
    }

    const toRect = new Konva.Rect({
      x: x2,
      y: y2,
      width: 5,
      height: 5,
      tension: 0.5
    })
    const points = this.getConnectorPointsBrokenLine(fromRect, toRect, 0)
   // const pathData = this.getCubicBezierPath(points, 0.3)
    const pathData = this.getRoundedPath(points, 4);
    this.userArrow.data(pathData)
    this.redrawLayer()

  }

  startDrawingArrow() {

    this.hideContextMenus()
    this.isDrawingArrow = true
    const shape = this.layer.findOne((obj: any) => obj.id() == this.selectedShapeKey)
    if (shape) {
      this.layer.add(this.userArrow)
      const fromShape = shape as Konva.Rect
      const points = this.getConnectorPointsBrokenLine(fromShape, fromShape)
      const pathData = this.getRoundedPath(points, 4);
      this.userArrow.data(pathData)
      this.userArrow.moveToTop()
      this.redrawLayer()
    }

  }

  showContextMenu(key: string, shape: any) {
    const pos = shape.getAbsolutePosition()
    const contextMenu = document.getElementById('context-menu')
    if (contextMenu) {
      contextMenu.style.left = pos.x  + 'px'
      contextMenu.style.top = pos.y - 50 + 'px'
      this.isContextMenuVisible = true
      this.selectedShapeKey = key
      this.selectedTreeCardType = this.getTreeCardType(this.selectedShapeKey)
    }
    this.showPlusLeftContextMenu(key, shape)
  }

  getTreeCardType(shapeType: string) {

    const index = this.treeCards.findIndex(c => c.cardType == shapeType)
    if (index != -1) {
      return this.treeCards[index].cardType
    }

    return ""
  }

  showTreeContextMenu() {
    const pointerPosition = this.stage.getPointerPosition();
    const contextMenu = document.getElementById('tree-context-menu');
    if (contextMenu) {
      const menuWidth = 200
      const xOffset = this.getScreeenEdgeOffsetX(pointerPosition, menuWidth)
      contextMenu.style.left = (pointerPosition.x - xOffset) + 'px';
      contextMenu.style.top = pointerPosition.y + 'px';
      this.isContextMenuTreeVisible = true;
      this.availableKidCardTypes = this.treeCards.find(c => c.key == this.selectedShapeKey)?.kidCardTypes || []
    }
  }

  getScreeenEdgeOffsetX(pointerPosition: any, menuWidth: number) { // this is used to offset the context menu to the left if it is close to the browser edge
    let xOffset = 0
    const containerRect = this.stage.container().getBoundingClientRect();         // Get canvas position and add it to pointerPosition
    const pointerClientX = containerRect.left + pointerPosition.x;        // Compute screen X coordinate (relative to page)
    const distanceToRightEdge = window.innerWidth - pointerClientX;         // Distance from pointer to right edge of browser
    if (distanceToRightEdge < menuWidth) {
      xOffset = menuWidth - distanceToRightEdge;
    }
    return xOffset
  }

  getScreeenEdgeOffsetY(pointerPosition: any, menuHeight: number) { // this is used to offset the context menu to the bottom if it is close to the browser edge
    let yOffset = 0
    const containerRect = this.stage.container().getBoundingClientRect();         // Get canvas position and add it to pointerPosition
    const pointerClientY = containerRect.top + pointerPosition.y;
    const distanceToBottomEdge = window.innerHeight - pointerClientY;         // Distance from pointer to bottom edge of browser
    if (distanceToBottomEdge < menuHeight) {
      yOffset = distanceToBottomEdge - menuHeight;
    }
    return yOffset
  }

  showCommentList(key: string, shape: any, friendlyNameObjectType: string) {
    const pos = shape.getAbsolutePosition()
    const contextMenu = document.getElementById('context-menu-commentlist')
    if (contextMenu) {
      contextMenu.style.left = pos.x + 'px'
      contextMenu.style.top = pos.y + (shape.height() * shape.scaleY() * this.stage.scaleY()) + 50 + 'px'
      this.isContextMenuCommentlistVisible = true
      this.selectedShapeKey = key
      this.selectedTreeCardType = this.getTreeCardType(this.selectedShapeKey)
      this.friendlyNameObjectType = friendlyNameObjectType
      this.resizeStage()
    }
  }

  showStatusReport(key: string, shape: any) {
    let pos = shape.getAbsolutePosition()
    pos = this.getCentralPosition()
    const contextMenu = document.getElementById('status-report')
    if (contextMenu) {
      contextMenu.style.left =  '0px'
      contextMenu.style.top = '0px'
      contextMenu.style.width = '500px'
      contextMenu.style.height = '500px'
      this.isStatusReportVisible = true
      this.selectedShapeKey = key
      this.selectedTreeCardType = this.getTreeCardType(this.selectedShapeKey)
    //  this.progressPoints.length = 0
    }
  }

  closeStatusReport() {
    this.isStatusReportVisible = false
    this.statusReportContent = ""
  }

  showPlusLeftContextMenu(key: string, shape: Konva.Shape) {
    const pos = shape.getAbsolutePosition()
    const size = shape.getAbsoluteScale()
    let contextMenu = document.getElementById('context-menu-plus-left')
    if (contextMenu) {
      contextMenu.style.left = pos.x + (shape.width() * size.x) + 10 + 'px'
      contextMenu.style.top = pos.y + 'px'
      this.isContextMenuVisible = true
      this.selectedShapeKey = key
      this.selectedTreeCardType = this.getTreeCardType(this.selectedShapeKey)
    }
    contextMenu = document.getElementById('context-menu-collapse-expand')
    if (contextMenu) {
      contextMenu.style.left = pos.x + (shape.width() * size.x) + 40 + 'px'
      contextMenu.style.top = pos.y + (shape.height() * size.y) /2 - 16 + 'px'
      this.isContextMenuCollapseExpandVisible = true
    }
  }

  showContextMenuFrame(key: string) { // this cannot be displayed on top of the shape, because when it overlays transformer, it breaks mouseover and tap events
    const shape = this.layer.findOne((obj: any) => obj.id() == key) as Konva.Shape
    const pos = shape.getAbsolutePosition()
    //const size = shape.getAbsoluteScale()
    const contextMenu = document.getElementById('context-menu-frame')
    if (contextMenu) {
      contextMenu.style.left = pos.x - 65 + 'px'
      contextMenu.style.top = pos.y + 'px'
      this.isContextMenuFrameVisible = true
      this.selectedShapeKey = key
      this.selectedTreeCardType = this.getTreeCardType(this.selectedShapeKey)
    }
  }

  addBoxWithArrow(shapeKey: string, shapeType: string = "postit", direction: string = "right") { // adds box with arrow to canvas for drawing flowcharts
    const shape = this.layer.findOne((obj: any) => obj.id() == shapeKey) as Konva.Shape
    const pos = shape.getPosition()
    const fromKey = shape.id()
    const freeSpaceBelow = this.findConnectedFreeSpaceBelow(fromKey) // finds the lowest position of the connected shapes if there are many connected shapes
    let posX = pos.x + (shape.width()/2) + this.boxWidth
    let posY = freeSpaceBelow
    if (direction == "left") {
      posX = pos.x - this.boxWidth - this.boxWidth/2
      posY = pos.y + shape.height()/2 - this.boxHeight
    } else if (direction == "right") {
      posX = pos.x + (shape.width()/2) + this.boxWidth
      posY = pos.y + shape.height()/2 - this.boxHeight
    } else if (direction == "bottom") {
      posY = pos.y + shape.height() + this.boxHeight/2
      posX = pos.x + shape.width()/2 - this.boxWidth/2
    } else if (direction == "top") {
      posY = pos.y - this.boxHeight*2 - this.boxHeight/2
      posX = pos.x + shape.width()/2 - this.boxWidth/2
    }
    const toKey = this.addPostitContent(posX, posY, this.boxWidth, this.boxHeight*2, this.textPlaceholder, "#ffffff", false, shapeType)
    this.canvasHistory.push({
      key: "arrow-"+fromKey+"-"+toKey,
      fromKey: fromKey,
      toKey: toKey,
      command: "add",
      shape: "arrow",
      contentKey: "", 
      content: "", 
      x: 0, 
      y: 0, 
      width: 0, 
      height: 0, 
      color: "", 
      sequence: this.canvasHistory.length,
      strokeWidth: 1, 
      rotation: 0,
      points: [],
      coverImageURL: "",
      zIndex: 100,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: false
    })
    this.drawConnector(fromKey, toKey)
    this.stepsToUndo += 1
    this.saveCanvas()
  }

  findConnectedShapes(parentKey: string, recursive: boolean = false, currentKey: string = "") {
    const connectedShapeKeys = this.connectors
    .filter(c => c.from === currentKey)
    .map(c => c.to);
    let connectedShapes: Konva.Shape[] = connectedShapeKeys     // Find connected shapes
    .flatMap(id => this.layer.find((obj: Konva.Shape) => obj.id() === id))
    .filter((shape): shape is Konva.Shape => shape !== undefined && shape !== null);
    if (recursive == true) {
      connectedShapes.forEach(shape => {
        if (shape.id() != parentKey) { // avoid loops
          const s = this.findConnectedShapes(parentKey, recursive, shape.id())
          connectedShapes.push(...s)
        }
      })
    }
    connectedShapes = connectedShapes.filter((shape, index, self) =>     //remove duplicates
      index === self.findIndex((t) => t.id() === shape.id())
    ).filter(shape => shape.id() != parentKey);
    return connectedShapes
  }

  findConnectedFreeSpaceBelow(key: string) {
    const sourceRect = this.layer.findOne((obj: any) => obj.id() === key) as Konva.Rect;     // Find the source rectangle by ID
    let maxBottomPosition = 0
    if (sourceRect) {
      const pos = sourceRect.getPosition();
      const connectedShapes = this.findConnectedShapes(key)
  
      let bottomPositions = connectedShapes     // Calculate bottom positions of the connected shapes
         // .filter(shape => shape instanceof Konva.Rect) // Keep only valid shapes of type Shape
          .map(shape => shape.y() + shape.height());
      maxBottomPosition = bottomPositions.length > 0 ? (Math.max(...bottomPositions) + this.boxHeight*0.5) : pos.y;       // Find the maximum bottom position
    }
    return maxBottomPosition; // Return the lowest position among connected shapes
}

  drawConnector(fromKey: string, toKey: string, lineType: string = "broken", lineStyle: string = "solid", color: string = "black", style: string = "nearest", idPrefix: string = "") {
    this.mouseOverShapeKey = ""
    this.selectedShapeKey = ""
    this.hideContextMenus()
    this.isDrawingArrow = false
    this.userArrow.remove()
    const fromShape = this.layer.findOne((obj: any) => obj.id() == fromKey) as Konva.Rect
    const toShape = this.layer.findOne((obj: any) => obj.id() == toKey) as Konva.Rect
    let connector: any
    let points: number[] = []
    if (lineType == "broken") {
      points = this.getConnectorPointsBrokenLine(fromShape, toShape, 0, style)
    if (this.connectorCornerRadius == 0) {
        connector = new Konva.Arrow({
        points: points,
        pointerLength: 10,
        pointerWidth: 10,
        fill: color,
        stroke: color,
        strokeWidth: 2,
        name: "",
        draggable: false,
        id: "arrow-"+fromKey+"-"+toKey,
        tension: 0,
        cornerRadius: 10,
        zIndex: 1
      })
    } else {// Generate the path data with rounded corners
    const pathData = this.getRoundedPath(points, this.connectorCornerRadius);
    // Create a Konva.Path for the rounded line
    connector = new Konva.Path({
      id: "arrow-"+fromKey+"-"+toKey,
      data: pathData,
      stroke: color,
      strokeWidth: 2,
      lineJoin: 'round',
      lineCap: 'round',
      name: "",
      draggable: false,
      zIndex: 1
    });
    if (lineStyle == "dashed") {
      connector.dash([2, 2])
    }

    }
  } else if (lineType == "bezier") {
      const points = this.getConnectorPointsBrokenLine(fromShape, toShape)
      let pathData = this.getCubicBezierPath(points, 0.1)

     // const arrowHeadData = this.getArrowHeadPathData(points[points.length-1], points[points.length-2]);

      // Combine the Bezier curve and arrowhead path data
    //  pathData += arrowHeadData;
      connector = new Konva.Path({
        id: idPrefix+"arrow-"+fromKey+"-"+toKey,
        data: pathData,
        stroke: color,
        strokeWidth: 2,
        lineJoin: 'round',
        lineCap: 'round',
        name: "",
        draggable: false,
        zIndex: 1,
       // listening: false, // Set to false if you don't need event handling on the path
      });
      if (lineStyle == "dashed") {
        connector.dash([2, 3])
      }
    }
    
    this.connectors.push({from: fromKey, to: toKey, id: connector.id()})
    this.layer.add(connector)
    connector.moveToTop()
    if (this.site != "productly") { // in productly, the connectors are not editable
      connector.on("click tap", () => {
        const dialogRef = this.dialog.open(ConfirmingDialogComponent, {
          data: {"content": "Are you sure you want to delete this arrow?", "onlyCloseButton": false, "title": "Delete arrow"}
        })
        dialogRef.afterClosed().subscribe((r) => {
          if (r == true) {
            connector.remove()
            this.connectors = this.connectors.filter(c => c.id != connector.id())
            this.redrawLayer()
            this.canvasHistory = this.canvasHistory.filter(c => c.key != "arrow-"+fromKey+"-"+toKey)
            this.saveCanvas()
          }
        })
      })
      connector.on('mouseenter', () => {
        connector.strokeWidth(4)
      })
      connector.on('mouseleave', () => {
        connector.strokeWidth(2)
      })
    }
  }

  getConnectorBezierCurve(fromShape: Konva.Shape, toShape: Konva.Shape) {
    // Check if shapes are valid
    if (!fromShape || !toShape) {
      return null;
    }

    // Get bounding boxes
    const fromBox = fromShape.getClientRect();
    const toBox = toShape.getClientRect();

    // Get centers
    const fromCenter = {
      x: fromBox.x + fromBox.width / 2,
      y: fromBox.y + fromBox.height / 2
    };

    const toCenter = {
      x: toBox.x + toBox.width / 2,
      y: toBox.y + toBox.height / 2
    };

    // Define start and end points with normals
    const startPoint = this.getEdgeIntersection2(fromBox, toCenter);
    const endPoint = this.getEdgeIntersection2(toBox, fromCenter);

    // Compute the vector from start to end
    const dx = endPoint.x - startPoint.x;
    const dy = endPoint.y - startPoint.y;
    const length = Math.sqrt(dx * dx + dy * dy);

    // Calculate control length based on curvature
    const curvature = 0.5; // Adjust this value between 0 and 1 to change the curve's shape
    const controlLength = curvature * length;

    // Calculate tangent vectors at start and end points
    let tangentStart = { x: -startPoint.normal.y, y: startPoint.normal.x };
    let tangentEnd = { x: -endPoint.normal.y, y: endPoint.normal.x };

    // Normalize tangent vectors
    const tangentStartLength = Math.sqrt(tangentStart.x * tangentStart.x + tangentStart.y * tangentStart.y);
    tangentStart.x /= tangentStartLength;
    tangentStart.y /= tangentStartLength;

    const tangentEndLength = Math.sqrt(tangentEnd.x * tangentEnd.x + tangentEnd.y * tangentEnd.y);
    tangentEnd.x /= tangentEndLength;
    tangentEnd.y /= tangentEndLength;

    // Ensure tangents point towards each other
    const dir = { x: endPoint.x - startPoint.x, y: endPoint.y - startPoint.y };
    const dotStart = tangentStart.x * dir.x + tangentStart.y * dir.y;
    if (dotStart < 0) {
      tangentStart.x *= -1;
      tangentStart.y *= -1;
    }

    const dirEnd = { x: startPoint.x - endPoint.x, y: startPoint.y - endPoint.y };
    const dotEnd = tangentEnd.x * dirEnd.x + tangentEnd.y * dirEnd.y;
    if (dotEnd < 0) {
      tangentEnd.x *= -1;
      tangentEnd.y *= -1;
    }

    // Define control points along the tangents
    const control1 = {
      x: startPoint.x + controlLength * tangentStart.x,
      y: startPoint.y + controlLength * tangentStart.y,
    };

    const control2 = {
      x: endPoint.x + controlLength * tangentEnd.x,
      y: endPoint.y + controlLength * tangentEnd.y,
    };
    return {
      start: { x: startPoint.x, y: startPoint.y },
      control1,
      control2,
      end: { x: endPoint.x, y: endPoint.y },
    };
  }

  getEdgeIntersection2(box: {x: number, y: number, width: number, height: number}, point: {x: number, y: number}) {
    const cx = box.x + box.width / 2;
    const cy = box.y + box.height / 2;
    const px = point.x;
    const py = point.y;

    const dx = px - cx;
    const dy = py - cy;

    const tValues = [];
    const sides: any[] = [];

    if (dx !== 0) {
      const tLeft = (box.x - cx) / dx;
      tValues.push(tLeft);
      sides.push('left');
      const tRight = (box.x + box.width - cx) / dx;
      tValues.push(tRight);
      sides.push('right');
    }
    if (dy !== 0) {
      const tTop = (box.y - cy) / dy;
      tValues.push(tTop);
      sides.push('top');
      const tBottom = (box.y + box.height - cy) / dy;
      tValues.push(tBottom);
      sides.push('bottom');
    }

    // Filter tValues to get valid t in [0, 1]
    const validEntries = tValues
      .map((t, index) => ({ t, side: sides[index] }))
      .filter(entry => entry.t >= 0 && entry.t <= 1);

    if (validEntries.length === 0) {
      return { x: cx, y: cy, normal: { x: 0, y: 0 } };
    }

    // Get the smallest t
    const minEntry = validEntries.reduce((prev, curr) => (curr.t < prev.t ? curr : prev));

    const t = minEntry.t;
    const side = minEntry.side;

    const x = cx + t * dx;
    const y = cy + t * dy;

    // Compute normal vector based on the side
    let normal;
    switch (side) {
      case 'left':
        normal = { x: -1, y: 0 };
        break;
      case 'right':
        normal = { x: 1, y: 0 };
        break;
      case 'top':
        normal = { x: 0, y: -1 };
        break;
      case 'bottom':
        normal = { x: 0, y: 1 };
        break;
      default:
        normal = { x: 0, y: 0 };
    }

    return { x, y, normal };
  }

 getArrowHeadPathData(
  endPoint: { x: number; y: number },
  controlPoint: { x: number; y: number }
) {
  // Compute the direction vector (tangent at the end point)
  const dx = endPoint.x - controlPoint.x;
  const dy = endPoint.y - controlPoint.y;

  const len = Math.sqrt(dx * dx + dy * dy);
  if (len === 0) {
    // Avoid division by zero
    return '';
  }

  const unitX = dx / len;
  const unitY = dy / len;

  // Arrowhead dimensions
  const arrowLength = 10; // Adjust length as needed
  const arrowWidth = 7;   // Adjust width as needed

  // Base of the arrowhead
  const baseX = endPoint.x - arrowLength * unitX;
  const baseY = endPoint.y - arrowLength * unitY;

  // Orthogonal vector (perpendicular to the tangent)
  const orthoX = -unitY;
  const orthoY = unitX;

  // Points of the arrowhead
  const leftX = baseX + (arrowWidth / 2) * orthoX;
  const leftY = baseY + (arrowWidth / 2) * orthoY;

  const rightX = baseX - (arrowWidth / 2) * orthoX;
  const rightY = baseY - (arrowWidth / 2) * orthoY;

  // Construct the path data for the arrowhead as a separate subpath
  const arrowHeadData = ` M ${leftX} ${leftY} L ${endPoint.x} ${endPoint.y} L ${rightX} ${rightY} Z`;

  return arrowHeadData;
}

  updateConnectors(cornerRadius: number) {
    this.connectors.forEach((connector: any) => {
      this.updateConnector(connector.from, connector.to, connector.id, cornerRadius)
    })
    this.redrawLayer()
  }

  updateConnector(fromKey: string, toKey: string, connectorKey: string, cornerRadius: number) {
    const fromShape = this.layer.findOne((obj: any) => obj.id() == fromKey) as Konva.Rect
    const toShape = this.layer.findOne((obj: any) => obj.id() == toKey) as Konva.Rect
    if (fromShape == undefined || toShape == undefined) {
      return
    }
    if (fromShape.visible() == true && toShape.visible() == true) { // if both shapes are visible, draw connector
      const points = this.getConnectorPointsBrokenLine(fromShape, toShape)
      if (cornerRadius == 0) {
        const connector = this.layer.findOne((obj: any) => obj.id() == connectorKey) as Konva.Arrow
        connector.visible(true)
        connector.points(points)
      } else {
        const pathData = this.getRoundedPath(points, cornerRadius);
        const connector = this.layer.findOne((obj: any) => obj.id() == connectorKey) as Konva.Path
        connector.visible(true)
        connector.data(pathData)
      }
    } else { // if one of the shapes is hidden, remove connector
      if (cornerRadius == 0) {
        const connector = this.layer.findOne((obj: any) => obj.id() == connectorKey) as Konva.Arrow
        connector.visible(false)
      } else {
       // const points = this.getConnectorPointsBrokenLine(fromShape, toShape)
       // const pathData = this.getRoundedPath(points, cornerRadius);
        const connector = this.layer.findOne((obj: any) => obj.id() == connectorKey) as Konva.Path
        connector.visible(false)
      }
    }
  }

  async addUserStoryMap() {
    console.time("addUserStoryMap")
    if (this.isLoadingCursor == true) {
      return
    }
    this.firestore.showSnackBar("Generating user story map, it may take a while...")
    this.isStoryMapAdded = true
    this.isLoadingCursor = true
    await this.moveToPeriferalPosition("right")
    let position = this.getPeriferalPosition("right");
    const margin = this.boxWidth + this.boxMargin
    position.x += margin
   // const frameKey = this.firestore.generateUID()
   
    let parentWorkpackages: Post[] = []
    parentWorkpackages = this.getWorkpackageKidsByParentKey("")
    const pW = parentWorkpackages.map(wp => {
      return {
        key: wp.key,
        name: wp.name,
        htmlName: wp.nameHTML,
        color: wp.color,
        coverImageURL: wp.coverImageURL
      }
    })
    this.addLabel(position.x, position.y-this.boxMargin-this.boxHeight, this.boxWidth*3, this.boxHeight*2, "User Story Map", "black", false, 0, 50)
    this.addLabel(position.x-50, position.y+this.boxHeight*2, this.boxHeight*2, this.boxHeight*0.5, "Epics", "blue", false, 270)
    this.addLabel(position.x-50, position.y+this.boxHeight*4 + this.boxMargin, this.boxHeight*2, this.boxHeight*0.5, "User Stories", "green", false, 270)
    this.addLabel(position.x-50, position.y+this.boxHeight*6 + this.boxMargin*2, this.boxHeight*2, this.boxHeight*0.5, "Tasks", "orange", false, 270)
    for (let i = 0; i < pW.length; i++) {
      const parent = pW[i];
      await this.onAddWorkpackage('workpackage', [parent], 0, 0, {x: position.x, y: position.y, width: this.boxWidth, height: this.boxHeight*2}, 5000, "horizontal", false) // at the first level are activities or epics
      this.firestore.showSnackBar("Adding epics "+Math.round(i/pW.length*100)+"% ...")
      let kidPosition: {x: number, y: number} = {x: position.x, y: position.y + this.boxHeight*2 + this.boxMargin}
      const kids = this.getWorkpackageKidsByParentKey(parent.key)
      const kW = kids.map(k => {
        return {
          key: k.key,
          name: k.name,
          htmlName: k.nameHTML,
          color: k.color,
          coverImageURL: k.coverImageURL
        }
      })
      for (let j = 0; j < kW.length; j++) {
        const kid = kW[j];
        await this.onAddWorkpackage('workpackage', [kid], 0, 0, {x: kidPosition.x, y: kidPosition.y, width: this.boxWidth, height: this.boxHeight*2}, 5000, "horizontal", false) // at the second level are steps or user stories
        const grandKids = this.getWorkpackageKidsByParentKey(kid.key)
        const gK = grandKids.map(gk => {
          return {
            key: gk.key,
            name: gk.name,
            htmlName: gk.nameHTML,
            color: gk.color,
            coverImageURL: gk.coverImageURL
          }
        })
        await this.onAddWorkpackage('workpackage', gK, 0, this.boxMargin + this.boxHeight*2, {x: kidPosition.x, y: kidPosition.y, width: this.boxWidth, height: this.boxHeight*2}, 5000, "vertical", false) // at the third level are tasks
        kidPosition.x += (this.boxWidth + this.boxMargin)
      }
      position.x += (this.boxWidth + this.boxMargin) * kids.length
    }
    this.saveCanvas()
    this.isLoadingCursor = false
    console.timeEnd("addUserStoryMap")
  }

  getWorkpackageKidsByParentKey(parentKey: string = "") { // returns workpackages that are children of the parentKey or parents if parentKey is empty
    let w: Post[] = []
    if (parentKey == "") {
      w = this.workpackages.filter(wp => wp.parentKey == "")
    } else {
      w = this.workpackages.filter(wp => wp.parentKey == parentKey)
    }
    return w
  }


  addFrame() {
    const centralPosition = this.getCentralPosition()
    const frameKey = this.firestore.generateUID()
    this.stepsToUndo += 1
    this.canvasHistory.push({
      key: "frame-group-"+frameKey,
      contentKey: frameKey,
      content: this.textPlaceholder,
      command: "add",
      shape: "frame",
      width: this.boxWidth,
      height: this.boxHeight*2,
      color: this.pickedColor,
      strokeWidth: 3,
      points: [],
      x: centralPosition.x,
      y: centralPosition.y,
      rotation: 0,
      sequence: this.canvasHistory.length,
      fromKey: "",
      toKey: "",
      coverImageURL: "",
      zIndex: 90,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: false
    })
    this.drawFrame(this.canvasHistory[this.canvasHistory.length-1])
  }

  async drawFrame(command: any) { // draws frame which groups object on canvas
    const frameGroup = new Konva.Group({
      id: command.key,
      x: command.x,
      y: command.y,
      width: command.width,
      height: command.height,
      draggable: true,
      cornerRadius: 10,
      name: 'selectable',
      rotation: command.rotation,
      stroke: command.color,
    }); 

    const frameRect = new Konva.Rect({
      x: 0,
      y: 0,
      id: "frame-rect-"+command.key,
      stroke: command.color,
      strokeWidth: 2,
      dash: [10, 5], // pattern: 10px dash, 5px space
      width: command.width,
      height: command.height,
      cornerRadius: 10,
     // draggable: true,
    //  zIndex: 1,
   //   name: "selectable",
      strokeScaleEnabled: false,
      //listening: false,
    })

    const frameText = new Konva.Text({
      id: "frame-text-"+command.key,
      x: 10,
      y: 5,
      text: command.content,
      fontSize: 18,
      fontFamily: 'Poppins',
      fill: command.color,
      width: command.width-20,
      padding: 5,
      align: 'left',
      verticalAlign: 'middle',
      cornerRadius: 4,
      //listening: false,
    })

    frameGroup.add(frameText);
    frameGroup.add(frameRect)

    frameGroup.on('dragstart', (e: any) => {
      this.hideContextMenus()
    })
    let previousPosition = { x: frameGroup.x(), y: frameGroup.y() };
    frameGroup.on('dragmove', (e: any) => {
      const currentPosition = e.target.position();
      const dx = currentPosition.x - previousPosition.x;
      const dy = currentPosition.y - previousPosition.y;
      previousPosition.x = currentPosition.x;
      previousPosition.y = currentPosition.y;

      if (this.isShiftPressed == true) {
        this.moveConnectedObjects(command.key, dx, dy)
      }
    })
   // const sx = frameGroup.width() / this.boxWidth
  //  const sy = frameGroup.height() / (this.boxHeight*2)
    frameGroup.on('dragend', (result: any) => {
      let c = {...command}
      c.x = result.target.attrs.x
      c.y = result.target.attrs.y
      const sx = result.target.attrs.scaleX
      const sy = result.target.attrs.scaleY
      c.width = result.target.attrs.width * sx
      c.height = result.target.attrs.height * sy
      c.command = "update"
      c.shape = "frame"
      c.sequence = this.canvasHistory.length
      c.rotation = result.target.attrs.rotation
      c.color = result.target.attrs.stroke
      c.fromKey = ""
      c.toKey = ""
      this.hideContextMenus()
      this.stepsToUndo += 1
      this.canvasHistory.push(c)
      if (this.isShiftPressed == true) { // to powinno być odpalane tylko, gdy user zmieniał położenie wielu obiektów
        this.updateObjectPositionsOnCanvasHistory()
      }
      this.saveCanvas()
    })

    frameGroup.on('transformstart', (e: any) => {
      this.hideContextMenus()
    })

    frameGroup.on('transform', (result: any) => {
      this.selectionRectangle.moveToTop()
      const scaleX = frameGroup.scaleX();
      const scaleY = frameGroup.scaleY();
      frameText.scaleX(1 / scaleX); 
      frameText.scaleY(1 / scaleY);
      frameText.width(frameGroup.width() * scaleX -20)
    });

    frameGroup.on('transformend', (result: any) => {
    //  const width = result.target.attrs.width * result.target.attrs.scaleX
   //   const height = result.target.attrs.height //* sy
   //   const scaleX = frameGroup.scaleX();
   //   const scaleY = frameGroup.scaleY();
    // frameText.width(frameGroup.width() -20)

     // frameText.scaleX(1 / scaleX);       // Apply the inverse scale to the text
     // frameText.scaleY(1 / scaleY);
      let c = {...command}
      c.x = result.target.attrs.x
      c.y = result.target.attrs.y
      const sx = frameGroup.scaleX()
      const sy = frameGroup.scaleY()
      c.width = frameGroup.width() * sx //result.target.attrs.width * sx
      c.height = frameGroup.height() * sy //result.target.attrs.height * sy
      c.command = "update"
      c.shape = "frame"
      c.color = result.target.attrs.stroke
      c.rotation = result.target.attrs.rotation
      c.sequence = this.canvasHistory.length
      c.fromKey = ""
      c.toKey = ""
      this.hideContextMenus()
      this.stepsToUndo += 1
      this.canvasHistory.push(c)
      this.updateConnectors(this.connectorCornerRadius)
      this.saveCanvas()
    });

    frameGroup.on('click tap', (e: any) => {
      this.drawTouchPoints(command.key, frameGroup.x(), frameGroup.y(), frameGroup.width(), frameGroup.height(), 20)
      if (this.isDrawingArrow == false) { // if arrow is not dragged prevent from accidentally creating arrow
        this.mouseOverShapeKey = ""
        this.selectedShapeKey = ""
        this.isEditCardNamePopupVisible = false
        this.isPostPanelOpen = false
        this.manualAddContent = ""
        this.manualAddTitle = ""
      }
      e.target = frameGroup // it detect clicking on child object within group, I need to replace target with group
    //  this.showSelectionRectangle(e)
      this.showContextMenuFrame(e.target.attrs.id)
      this.showCommentList(command.key, frameGroup, "frame")
    })

    frameGroup.on('mouseover mouseenter', (e: any) => { // TU JEST BLAD BO W POSTIT MAM TRZY OBIEKTY: rect, text i group i ŻLE WYKRYWA MOUSEOVER
      const s = frameGroup.findOne('Rect') as Konva.Rect
      if (s.id() == "frame-rect-"+command.key) {
        this.mouseOverShapeKey = frameGroup.id()
        s.shadowColor('black');
        s.shadowBlur(2);
        s.shadowOffset({ x: 1, y: 1});
        s.shadowOpacity(0.5);
      //  s.strokeWidth(6); // Change color on hover
        this.redrawLayer();
      }
    });

    frameGroup.on('mouseleave', (e: any) => {
      if (this.mouseOverShapeKey == frameGroup.id()) {
        this.mouseOverShapeKey = ""
      }
      const s = frameGroup.findOne('Rect') as Konva.Rect
      if (s.id() == "frame-rect-"+command.key) {
       // s.strokeWidth(4); // Reset color
       s.shadowColor('');
       s.shadowBlur(0);
       s.shadowOffset({ x: 0, y: 0 });
       s.shadowOpacity(0);
        this.redrawLayer();
      }
    });
    frameGroup.on("dblclick dbltap", (e: any) => {
      e.target = frameGroup // it detect clicking on child object within group, I need to replace target with group
      const key = command.key
      this.launchPostitEdit(key, frameGroup.scaleX(), frameGroup.scaleY())
    })
    this.layer.add(frameGroup)
    this.redrawLayer()
  }

  showSelectionRectangle(e: any) {
    const metaPressed = e.evt.shiftKey || e.evt.ctrlKey || e.evt.metaKey;      // do we pressed shift or ctrl?
    const isSelected = this.tr.nodes().indexOf(e.target) >= 0;
    if (!metaPressed && !isSelected) { // if no key pressed and the node is not selected
      // select just one
      this.selectedObjects.length = 0
      this.selectedObjects.push(e.target)
      this.tr.nodes([e.target]);
      this.tr.moveToTop()
    } else if (metaPressed && isSelected) {
      // if we pressed keys and node was selected
      // we need to remove it from selection:
      const nodes = this.tr.nodes().slice(); // use slice to have new copy of array
      // remove node from array
      nodes.splice(nodes.indexOf(e.target), 1);
      this.tr.nodes(nodes);
      this.selectedObjects.length = 0
      this.selectedObjects.push(e.target)
    } else if (metaPressed && !isSelected) {
      // add the node into selection
      const nodes = this.tr.nodes().concat([e.target]);
      this.tr.nodes(nodes);
      this.selectedObjects.push(e.target)
    }
  //  this.selecting = true
  }

  detectObjectsInRectangle(detectionRect: rect) { // detect objects in rectangle on Konva stage
    const nodes = this.layer.getChildren(); // Get all nodes in the layer
    const detectedNodes: any[] = [];
  
    nodes.forEach((node: any) => {
      if (node.getClientRect().x < detectionRect.x + detectionRect.width &&
          node.getClientRect().x + node.getClientRect().width > detectionRect.x &&
          node.getClientRect().y < detectionRect.y + detectionRect.height &&
          node.getClientRect().y + node.getClientRect().height > detectionRect.y) {
        detectedNodes.push(node);
      }
    });
  
    return detectedNodes;
  }

  async summarizeContent() {
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    let answer = ""
    this.hideContextMenus()
    const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
    if (selectedNode != null) {
      const detectedNodes = this.detectObjectsInRectangle(selectedNode.getClientRect())
      this.firestore.showSnackBar("Extracting content from nodes...")
      const content = await this.extractContentFromNodes(detectedNodes)
      const promptPrefix = "You are given a text and you need to create a summary of this text. Return result in json format: {'summary', <summary_text>}. The text is: \n\n"
  //    answer = await this.search.getGPTChatResponse(promptPrefix+content)
      answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix+content, this.llmLimit, false, modelKey, 0.1)
    } else {
      this.firestore.showSnackBar("No content was found to create summary from.")
      answer = ""
    }
    return answer
  }

  async createOpportunitySolutionTree() {
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, while opportunity solution tree is being created..."
    this.loadingTitle = "Creating opportunity solution tree..."
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    this.hideContextMenus()
    const promptPrefix = "You are an expert in product discovery workships. You are given a text and you need to create an opportunity solution tree based on this text with levels: 1. desired outcome of the designed product or service, 2. opportunities which can help achieve the desired outcome, 3. solutions which can test and support the linked opportunities, 4. proposed experiments to validate the above linked solutions. Return result in json format: [{'idea', <idea_text>}, {'children', [{'idea', <idea_text>}, ...]}]. The text is: \n\n"
    if (this.isProductlyMode == true) {
      const content = await this.firestore.getContent(this.organizationKey, this.connectedPostKey)
      this.onAddWorkpackageCentrally("postit", [{key: this.connectedPostKey, name: content.name, htmlName: content.nameHTML, color: "#000000", coverImageURL: content.coverImageURL}])
   //   const answer = await this.search.getGPTChatResponse(promptPrefix+content.name)
      const answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix+content.name, this.llmLimit, false, modelKey, 0.1)
      this.createTopDownTree(answer)
    } else {
      const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
      if (selectedNode != null) {
        const detectedNodes = this.detectObjectsInRectangle(selectedNode.getClientRect())
        this.firestore.showSnackBar("Extracting content from nodes...")
        const content = await this.extractContentFromNodes(detectedNodes)
        if (content != "" && content != undefined && content != "undefined") {
          this.firestore.showSnackBar("Creating opportunity solution tree, please wait...")

        //  const answer = await this.search.getGPTChatResponse(promptPrefix+content)
          const answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix+content, this.llmLimit, false, modelKey, 0.1)
          this.createTopDownTree(answer)
        } else {
          this.firestore.showSnackBar("No content was found to create opportunity solution tree from.")
          }
      }
    }
    this.isLoadingLabelVisible = false
  }

  async createMindMap() {
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    this.hideContextMenus()
    const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
    if (selectedNode != null) {
      const detectedNodes = this.detectObjectsInRectangle(selectedNode.getClientRect())
      this.firestore.showSnackBar("Extracting content from nodes...")
      let content = await this.extractContentFromNodes(detectedNodes)
      content = content.trim()
      if (content != "" && content != undefined && content != "undefined") {
        this.firestore.showSnackBar("Creating mind map, please wait...")
        const promptPrefix = "You are an expert in creating mind maps. You are given a text and you need to create a mind map based on this text. Return result in json format: [{'idea', <idea_text>}, {'children', [{'idea', <idea_text>}, ...]}]. The text is: \n\n"
        const answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix+content, this.llmLimit, false, modelKey, 0.1)

        this.createPostItTree(answer)
      } else {
        this.firestore.showSnackBar("No content was found to create mind map from.")
        }
    }
  }

  async convertPostitToTask() { // convert postit to task in project
   // const sel = this.selectedShapeKey
    this.hideContextMenus()
    this.tr.nodes([])
   // this.tr.visible(false)
    const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
    if (selectedNode != null && selectedNode instanceof Konva.Group) {
      const currentPosition = selectedNode.position()
      const currentRectangle = selectedNode.size()
      //const color = selectedNode.attrs.stroke
      const rotation = selectedNode.attrs.rotation
      const textNode = selectedNode.find('Text')[0] as Konva.Text
      const content = textNode.text()
      this.firestore.showSnackBar("Converting card to task in project, please wait...")
      const taskKey = await this.addNewPost(false, content, false, "workpackage")
      let ws: {"key": string;
        "name": string;
        "htmlName": string;
        "color": string;
        "coverImageURL": string;}[] = [
          {
            "key": taskKey,
            "name": content,
            "htmlName": content,
            "color": "#bfbfbf",
            "coverImageURL": ""
          }
        ]
      await this.onAddWorkpackage('workpackage', ws, 0, 0, {x: currentPosition.x, y: currentPosition.y, width: currentRectangle.width, height: currentRectangle.height}, 0, "horizontal", false, rotation)
      selectedNode.remove()
      this.canvasHistory.push({ // removes postit from canvas history
        key: selectedNode.id(),
        contentKey: "",
        content: "",
        command: "delete",
        shape: "box",
        width: 0,
        height: 0,
        color: "",
        strokeWidth: 0,
        points: [],
        x: 0,
        y: 0,
        rotation: 0,
        sequence: this.canvasHistory.length,
        fromKey: "",
        toKey: "",
        coverImageURL: "",
        zIndex: 100,
        isExpanded: true,
        dateOfUpdate: new Date(),
        isFixed: false
      })
      this.replaceArrows(selectedNode.id(), "workpackage-"+taskKey)
      this.saveCanvas()
    }

  }

  deleteShape(key: string) {
    this.canvasHistory.push({
      key: key,
      contentKey: "",
      content: "",
      command: "delete",
      shape: "box",
      width: 0,
      height: 0,
      color: "",
      strokeWidth: 0,
      points: [],
      x: 0,
      y: 0,
      rotation: 0,
      sequence: this.canvasHistory.length,
      fromKey: "",
      toKey: "",
      coverImageURL: "",
      zIndex: 100,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: false
    })
    const shape = this.layer.findOne('#'+key)
    if (shape != null) {
      shape.remove()
    }
  }

  replaceArrows(oldKey: string, newKey: string) {
      for (let i = 0; i < this.connectors.length; i++) {
      if (this.connectors[i].from == oldKey) {
        this.deleteShape(this.connectors[i].id)
        this.addArrow(newKey, this.connectors[i].to)
      } else if (this.connectors[i].to == oldKey) {
        this.deleteShape(this.connectors[i].id)
        this.addArrow(this.connectors[i].from, newKey)
      }
    }
    this.connectors = this.connectors.filter((item: any) => item.from != oldKey && item.to != oldKey)
  }

  addArrow(fromKey: string, toKey: string, idPrefix: string = "") {
    this.stepsToUndo += 1
    this.canvasHistory.push({
      key: "arrow-"+fromKey+"-"+toKey,
      fromKey: fromKey,
      toKey: toKey,
      command: "add",
      shape: "arrow",
      contentKey: "", 
      content: "", 
      x: 0, 
      y: 0, 
      width: 0, 
      height: 0, 
      color: "", 
      sequence: this.canvasHistory.length,
      strokeWidth: 1, 
      rotation: 0,
      points: [],
      coverImageURL: "",
      zIndex: 100,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: false
    })
    this.drawConnector(fromKey, toKey, "broken", "solid", "black", "nearest", idPrefix)
  }

  async getContentCollection(keys: string[]) { // retreives content from firestore for given keys of tasks for the purpose of creating status report
    console.time("getContentCollection")
    const promises: Promise<void>[] = []
    let result: {x: number, y: number, progress: number, label: string, color: string, startDate: string, endDate: string, hours: number}[] = []
    keys.forEach((key: string) => {
      promises.push(this.firestore.getContent(this.organizationKey, key).then((item: any) => {
        let content = ""
        if (item.nameHTML != undefined && item.nameHTML != "") {
          content += item.nameHTML + "\n\n"
        } else {
          content += item.name + "\n\n"
        }
        result.push({x: 0, y: 0, progress: item.progressPercent, label: content, color: item.color, startDate: item.startDate, endDate: item.endDate, hours: item.hours});
      }))
    })
    await Promise.all(promises)
    console.timeEnd("getContentCollection")
    return result
  }

  async extractContentFromNodes(nodes: any[]) {
    console.time("extractContentFromNodes")
    const nodeKeys: string[] = nodes.map((node: any) => node.id())
    let content = ""
    const promises: Promise<void>[] = []
    nodeKeys.forEach((nodeKey: string) => {
      if (!nodeKey.startsWith("arrow-") && !nodeKey.startsWith("frame-group-") && nodeKey != "" && !nodeKey.startsWith("transformer")) {
        if (nodeKey.startsWith("postit-")) { // if node is postit template extract content from it
          const groupNode = this.layer.findOne('#'+nodeKey) as Konva.Group
          const textNode = groupNode.find('Text')[0] as Konva.Text
          if (textNode.text() != this.textPlaceholder) { // if text is not placeholder
          content += textNode.text() + "\n\n"
          }
          nodeKey = nodeKey.replace("postit-", "")
        } else if (nodeKey.startsWith("content-") || nodeKey.startsWith("workpackage-")) {
          const contentKey = nodeKey.replace("content-", "").replace("workpackage-", "")
          promises.push(this.firestore.getContent(this.organizationKey, contentKey).then((item: any) => {
            if (item.nameHTML != undefined && item.nameHTML != "") {
              content += item.nameHTML + "\n\n"
            } else {
              content += item.name + "\n\n"
            }
          }))
        } else if (nodeKey.startsWith("label-")) {
          const labelNode = this.layer.findOne('#'+nodeKey) as Konva.Text
          content += labelNode.text() + "\n\n"
        }
      }
    })
    await Promise.all(promises)
    console.timeEnd("extractContentFromNodes")
    return content
  }

  getCentralPosition() {
    // Get the central position in the stage's coordinates
    const stageX = this.stage.width() / 2;
    const stageY = this.stage.height() / 2;
    
    // Get the current scale
    const scaleX = this.stage.scaleX();
    const scaleY = this.stage.scaleY();
    
    // Adjust the central position based on the current scale
    const centralX = (stageX - this.stage.x()) / scaleX;
    const centralY = (stageY - this.stage.y()) / scaleY;
  
    return { x: centralX, y: centralY };
  }

  async moveToPeriferalPosition(direction: string) {
    // Potential Logic for Ensuring Margins Based on Requirements
    const useRightMargin = direction === "right" ? 300 : 0;
    const useDownMargin = direction === "bottom" ? 300 : 0;
  
    // Fetch Peripheral Position
    const periferalPosition = this.getPeriferalPosition(direction, useRightMargin, useDownMargin);
    
    // Current stage dimensions
    const scale = this.stage.scaleX();
    const stageWidth = this.stage.width();
    const stageHeight = this.stage.height();
    
    // Determine new position to center peripheral coordinates
    const stageX = -periferalPosition.x * scale + stageWidth / 2;
    const stageY = -periferalPosition.y * scale + stageHeight / 2;
    
    await this.moveToPosition(stageX, stageY, scale);
    return {x: stageX, y: stageY};
  }

  async moveToPosition(x: number, y: number, userScale: number) {
    this.hideContextMenus()
    if (this.isCursorCurrrentlyMoving == false) {
      this.isCursorCurrrentlyMoving = true
      const duration = 1000
      this.stage.to({
        x: x,
        y: y,
        scaleX: userScale,
        scaleY: userScale,
        duration: duration/1000, // Duration in seconds
        easing: Konva.Easings.EaseInOut, // Easing function
      })
      await new Promise(resolve => setTimeout(resolve, duration));
      this.isCursorCurrrentlyMoving = false
      this.updateBackgroundGrid()
    }
  }

  createPostItTree(json: string) {
    try {
      const j = this.search.extractJsonFromString(json);
      const jsonObject = j
      const periferalPosition = this.getPeriferalPosition("right")
      jsonObject.forEach((item: any) => {
        this.drawPostItTreeItem(item, null, periferalPosition.x, periferalPosition.y, this.boxWidth, 100, 0, 1, ""); // Starting from central point (0,0) with a level of 1
      });
      this.saveCanvas()
      this.moveToPeriferalPosition("right")
    } catch (error) {
      this.firestore.showSnackBar("Error parsing JSON: " + error);
    }

    this.createForceDirectedLayout()
    this.physicsNodesData.length = 0
    this.physicsLinksData.length = 0
  }
  
  drawPostItTreeItem(item: any, parentItem: any, x: number, y: number, width: number, height: number, angle: number, depth: number, fromKey: string) {
    const toKey = this.addPostitContent(x, y, width, height, item.idea, "", false);     // Draw the current node at position x, y
      // Store node data for force simulation
    this.physicsNodesData.push({
      id: toKey,
      x: x,
      y: y,
    });
    if (fromKey != "") {
        this.physicsLinksData.push({
          source: fromKey,
          target: toKey,
        });
      this.stepsToUndo += 1
      this.canvasHistory.push({
        key: "arrow-"+fromKey+"-"+toKey,
        fromKey: fromKey,
        toKey: toKey,
        command: "add",
        shape: "arrow",
        contentKey: "", 
        content: "", 
        x: 0, 
        y: 0, 
        width: 0, 
        height: 0, 
        color: "", 
        sequence: this.canvasHistory.length,
        strokeWidth: 1, 
        rotation: 0,
        points: [],
        coverImageURL: "",
        zIndex: 100,
        isExpanded: true,
        dateOfUpdate: new Date(),
        isFixed: false
      })
      this.drawConnector(fromKey, toKey)
    }
    const siblings = parentItem != null ? parentItem.children.length : 0;
    const numChildren = item.children ? item.children.length : 0;
    if (numChildren === 0) return;
    let angleMultiplier = 0 
    if (parentItem != null) {
      parentItem.children.forEach((child: any) => {
        angleMultiplier += child.children.length / 30
      })
    }
    const angleStep = (Math.PI / (2 - angleMultiplier)) / (numChildren - 1 || 1); // Adjust the spread of child nodes
    const startAngle = angle - (angleStep * (numChildren - 1)) / 2;
    const radiusMultiplier = 1 + (numChildren / 10 + siblings / 8) - depth*50; // distance from parent to child, adjust as needed, it is dicreasing with depth
    const radius = width*2.2 + radiusMultiplier; // distance from parent to child, adjust as needed
  
    item.children.forEach((child: any, index: number) => {
      const childAngle = startAngle + index * angleStep;
      const childX = x + radius * Math.cos(childAngle);
      const childY = y + radius * Math.sin(childAngle);
      this.drawPostItTreeItem(child, item, childX, childY, width, height, childAngle, depth + 1, toKey);
    });
  }

  async createTopDownTree(json: string, colors: string[] = []) {
    try {
      const j = this.search.extractJsonFromString(json);
      const jsonObject = j
      const periferalPosition = this.getPeriferalPosition("bottom")
      this.topDownTreenextPos = 0; // Initialize nextPos

      // First, compute positions for all nodes
      jsonObject.forEach((item: any) => {
        this.computeNodePositions(item, 0);
      });

      // Optional: Center the tree horizontally
      const allXPositions = this.collectPositions(jsonObject, 'x');
      const minX = Math.min(...allXPositions);
      const maxX = Math.max(...allXPositions);
      const centerOffsetX = - (minX + maxX) / 2;
      this.adjustPositions(jsonObject, centerOffsetX, 0);

      // Now, draw the tree
      jsonObject.forEach((item: any) => {
        this.drawTopDownTree(item, "", periferalPosition.x, periferalPosition.y+20, 0, colors);
        this.moveToPeriferalPosition("bottom")
      });
      this.saveCanvas()
    } catch (e) {
      console.error("Error creating tree:", e);
    }
  }

  computeNodePositions(item: any, depth: number) {
    // Set the vertical position based on the depth
    item.y = depth * (this.boxHeight + this.verticalSpacingTopDownTree);

    if (!item.children || item.children.length === 0) {
      // Leaf node: set x position and increment nextPos
      item.x = this.topDownTreenextPos;
      this.topDownTreenextPos += this.boxWidth + this.horizontalSpacingTopDownTree;
    } else {
      // Compute positions for all children
      item.children.forEach((child: any) => {
        this.computeNodePositions(child, depth + 1);
      });
      // Set x position to the midpoint of the children's positions
      const childXs = item.children.map((child: any) => child.x);
      item.x = (Math.min(...childXs) + Math.max(...childXs)) / 2;
    }
  }

  drawTopDownTree(item: any, fromKey: string, x: number, y: number, level: number, colors: string[]) {// Draw the current node at its computed position
    const color = colors[level % colors.length] || "" // if no color is provided, use default color, otherwise use provided color according to level
    const toKey = this.addPostitContent(item.x + x, item.y + y, this.boxWidth, this.boxHeight, item.idea, color, false);
    // Draw a connector from the parent node to this node
    if (fromKey) {
      this.stepsToUndo += 1
      this.canvasHistory.push({
        key: "arrow-"+fromKey+"-"+toKey,
        fromKey: fromKey,
        toKey: toKey,
        command: "add",
        shape: "arrow",
        contentKey: "", 
        content: "", 
        x: 0, 
        y: 0, 
        width: 0, 
        height: 0, 
        color: "#c6c6c6", 
        sequence: this.canvasHistory.length,
        strokeWidth: 1, 
        rotation: 0,
        points: [],
        coverImageURL: "",
        zIndex: 100,
        isExpanded: true,
        dateOfUpdate: new Date(),
        isFixed: false
      })
      this.drawConnector(fromKey, toKey);
    }

    // Recursively draw all child nodes
    if (item.children && item.children.length > 0) {
      item.children.forEach((child: any) => {
        this.drawTopDownTree(child, toKey, x, y, level+1, colors);
      });
    }
  }

  collectPositions(items: any[], prop: string): number[] {
    let positions: number[] = [];
    items.forEach((item: any) => {
      positions.push(item[prop]);
      if (item.children && item.children.length > 0) {
        positions = positions.concat(this.collectPositions(item.children, prop));
      }
    });
    return positions;
  }

  adjustPositions(items: any[], offsetX: number, offsetY: number) {
    items.forEach((item: any) => {
      item.x += offsetX;
      item.y += offsetY;
      if (item.children && item.children.length > 0) {
        this.adjustPositions(item.children, offsetX, offsetY);
      }
    });
  }

  async createTasks() {
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    this.hideAllPopups()
    const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
    if (selectedNode != null) {
      const detectedNodes = this.detectObjectsInRectangle(selectedNode.getClientRect())
      this.firestore.showSnackBar("Extracting content from nodes...")
      const content = await this.extractContentFromNodes(detectedNodes)
      if (content != "" && content != undefined && content != "undefined") {
        this.firestore.showSnackBar("Creating task list, please wait...")
        const promptPrefix = "You are an project manager. You are given a text and you need to create a list of tasks based on this text. Return result in json format: [{'task', <task description>}, ...}]. The text is: \n\n"
      //  const answer = await this.search.getGPTChatResponse(promptPrefix+content)
        const answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix+content, this.llmLimit, false, modelKey, 0.1)
        this.createPostItList(answer)
      } else {
        this.firestore.showSnackBar("No content was found to create mind map from.")
        }
    }
  }

  async createStatusReport() {
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    this.hideAllPopups()
    this.isLoadingCursor = true
    const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
    if (selectedNode != null) {
      let detectedNodes = this.detectObjectsInRectangle(selectedNode.getClientRect())
      detectedNodes = detectedNodes.filter((node: any) => node.id().startsWith("workpackage"))
      if (detectedNodes.length == 0) {
        this.isLoadingCursor = false
        this.firestore.showSnackBar("No tasks were found in the frame to create status report from.")
      } else {
        let keys: string[] = []
        detectedNodes.forEach((node: any) => {
           keys.push(node.id().replace("content-", "").replace("workpackage-", ""))   
        })
        const points = await this.getContentCollection(keys)
        let content = ""
        points.forEach((point: any) => {
          content += "Task: "+point.label
          if (point.progress != undefined) {
            content += " Current progress - " + point.progress + "%. "
          }
          if (point.startDate != undefined) {
            content += " Estimated start date - " + point.startDate + ". "
          }
          if (point.endDate != undefined) {
            content += " Estimated end date - " + point.endDate + ". "
          }
          content += "\n\n"
        })
        
        const promptPrefix = "You are an project manager. You are given a descirption of set of tasks and their status, and you need to create a task status report based on this information. Return result in json format: [{'task', <task name>, 'status', <description of current progress and condition of the task>, 'issues', <main issues, opportunities and risk and other relevant information>}, ...]. Deliver response in the language of the text. The text is: \n\n"
        this.firestore.showSnackBar("Creating status report, please wait...")
      //  const answer = await this.search.getGPTChatResponse(promptPrefix+content)
        const answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix+content, this.llmLimit, false, modelKey, 0.1)
        const j = this.search.extractJsonFromString(answer);
        this.firestore.showSnackBar("Half way there in creating your status report, please wait...")
        const promptPrefix2 = "You are an project manager. You are given a descirption of set of tasks and their status, and you need to create a general summary of the project status report based on this information. Return result in json format: [{'general_summary', <general summary of the project>}, {'next_steps', <summary ofnext steps to be taken>}, {'risks', <summary of risks desccription>}, {'dependencies', <external dependencies if any of them are mentioned in the tasks description>}]. Deliver response in the language of the values in the json. The text is: \n\n"
        //const answer2 = await this.search.getGPTChatResponse(promptPrefix2+j)
        const answer2 = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, promptPrefix2+j, this.llmLimit, false, modelKey, 0.1)
        this.firestore.showSnackBar("Your report is ready.")
        const j2 = this.search.extractJsonFromString(answer2)
        const jsonObject2 = j2
        this.statusReportContent = this.createHtmlString(jsonObject2)
        setTimeout(() => {
          this.progressPoints = [...points.filter((point: any) => point.progress != undefined)]
          this.showStatusReport(this.selectedShapeKey, selectedNode)
          this.isLoadingCursor = false
        }, 100)
      }
    }
  }

  createHtmlString(jsonObject: any) {
    let htmlString = '<ul style="font-size: 0.8em; font-family: Poppins; font-style: normal; font-weight: 400; line-height: 1.2em; color: #000000;">';
    jsonObject.forEach((item: any) => {
      Object.keys(item).forEach((key: any) => {
        htmlString += `<li>${item[key]}</li>`;
      });
    });
    htmlString += '</ul>';
    return htmlString
  }

  hideAllPopups() {
    console.time("hideAllPopups")
    this.statusReportContent = ""
    this.hideContextMenus()
    this.isStatusReportVisible = false
    this.isPromptPopupAddButtonVisible = false
    this.isPromptPopupVisible = false
    console.timeEnd("hideAllPopups")
  }

  createPostItList(json: string) {
    const selectedNode = this.layer.findOne('#'+this.selectedShapeKey)
    let nodeX = 0
    let nodeY = 0
    if (selectedNode) {
      nodeX = selectedNode.x() + selectedNode.width() / 2
      nodeY = selectedNode.y() + selectedNode.height()
    }
    try {
      const j = this.search.extractJsonFromString(json);
      const jsonObject = j
      const periferalPosition = this.getPeriferalPosition("bottom")
      if (isNaN(periferalPosition.x)) {
        if (nodeX == 0) {
          periferalPosition.x = 10
        } else {
          periferalPosition.x = nodeX
        }
      }
      if (isNaN(periferalPosition.y)) {
        if (nodeY == 0) {
          periferalPosition.y = 10
        } else {
          periferalPosition.y = nodeY
        }
      }
      let i = 0
      let x = 0
      let y = 0
      jsonObject.forEach((item: any) => {
        x = periferalPosition.x
        y = periferalPosition.y+(i*(this.horizontalSpacingTopDownTree+this.boxHeight))
        this.addPostitContent(x, y, this.boxWidth, this.boxHeight, item.task, "", false);
        i += 1
      });
      const stageX = (-x) * this.scale + this.stageWidth / 2; // I need to recalculate the position of the stage taking into account the zoom
      const stageY = (-y) * this.scale + this.stageHeight / 2;
      this.moveToPosition(stageX, stageY, 1)

      this.saveCanvas()
    } catch (e) {
      console.error("Error creating tree:", e);
    }
  }

  createForceDirectedLayout() {
    const simulation = d3.forceSimulation(this.physicsNodesData)
      .force('link', d3.forceLink(this.physicsLinksData).id((d: any) => d.id).distance(150))
      .force('charge', d3.forceManyBody().strength(-300))
      .force('center', d3.forceCenter(this.stage.width() / 2, this.stage.height() / 2))
      .on('tick', () => {
        // Update node positions
        this.physicsNodesData.forEach((node: any) => {
          const konvaNode = this.layer.findOne(`#${node.id}`) as Konva.Group;
          if (konvaNode) {
            konvaNode.position({
              x: node.x,
              y: node.y,
            });
          }
        });
        this.updateConnectors(10);
        this.layer.batchDraw();

        // Stop simulation if alpha is low
        if (simulation.alpha() < 0.01) {
          simulation.stop();
        }
      });

    simulation.alphaTarget(0.3).restart();
  }

  addImage(x: number, y: number, width: number, height: number, url: string) {
    const yOffset = 20
    const xOffset = 20
    const key = this.firestore.generateUID()
    this.firestore.showSnackBar("Adding image to canvas...")
    this.stepsToUndo += 1
    this.canvasHistory.push({
      key: "image-"+key,
      contentKey: key,
      content: "",
      command: "add",
      shape: "image",
      width: width,
      height: height,
      color: "#ffffff",
      strokeWidth: 1,
      points: [],
      x: xOffset+x,
      y: yOffset+y,
      rotation: 0,
      sequence: this.canvasHistory.length,
      fromKey: "",
      toKey: "",
      coverImageURL: url,
      zIndex: 100,
      isExpanded: true,
      dateOfUpdate: new Date(),
      isFixed: false
    })
    this.drawImageContent(this.canvasHistory[this.canvasHistory.length-1])
  }

  openUploadDialog(x: number, y: number, width: number, height: number, saveCanvas: boolean = false) { // opens popup which upload image from disk
    if (this.isAnonymous == true && this.canvasPermissions.canAnonymousAddCards == false) {
      this.firestore.showSnackBar("Please login first and get access to this project to add image.")
      return
    }
    const dialogRef = this.dialog.open(AddfiledialogComponent, {
      panelClass: "dialog-container",
      width: '350px',
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '300px',
      data: {
        organizationKey: this.organizationKey,
        contentKey: this.canvasKey,
        userId: this.userId,
        closeAfterImageCapture: true,
        imagesOnly: true
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => { // when dialog is closed, store data in the database
      if ((result != undefined)&&(result != "")&&(result.storageUrl != "")) {
        const currentPosition = this.getCentralPosition()
        this.addImage(currentPosition.x, currentPosition.y, this.boxWidth, this.boxHeight*2, result.storageUrl)
      }
    });
  }

  async drawImageContent(command: any) {
    console.time("drawImageContent")
    // this.boxContent.push({key: command.key, content: command.content})
     const sx = command.width / this.boxWidth
     const sy = command.height / (this.boxHeight*2)
     if (command.color == undefined || command.color == "" || command.color == "#000000") {
       command.color = "#bfbfbf"
     }
     await this.generateImagesFromDOM("", command.key, command.color || "#ffffff", this.boxWidth * sx, this.boxHeight*2 * sy, command.coverImageURL).then(canvas => {
       const shape = new Konva.Image({
         id: command.key,
         x: command.x,
         y: command.y,
         width: this.boxWidth * sx,
         height: this.boxHeight*2 * sy,
         draggable: true,
         stroke: command.color,
         strokeWidth: 1,
         fill: "#ffffff",
         cornerRadius: 4,
         image: canvas,
        // zIndex: 1,
         name: 'selectable',
         rotation: command.rotation,
       });
 
       shape.on('dragstart', (e: any) => {
         this.hideContextMenus()
       })

       let previousPosition = { x: shape.x(), y: shape.y() };
       shape.on('dragmove', (e: any) => {
         const currentPosition = e.target.position();
         const dx = currentPosition.x - previousPosition.x;
         const dy = currentPosition.y - previousPosition.y;
         previousPosition.x = currentPosition.x;
         previousPosition.y = currentPosition.y;
   
         if (this.isShiftPressed == true) {
           this.moveConnectedObjects(command.key, dx, dy)
         }
         this.updateConnectors(this.connectorCornerRadius)
       })
 
         shape.on('dragend', (result: any) => {
           let c = {...command}
           c.x = result.target.attrs.x
           c.y = result.target.attrs.y
           const sx = result.target.attrs.scaleX
           const sy = result.target.attrs.scaleY
           c.width = result.target.attrs.width * sx
           c.height = result.target.attrs.height * sy
           c.rotation = result.target.attrs.rotation
           c.color = result.target.attrs.stroke
           c.command = "update"
           c.sequence = this.canvasHistory.length
           c.fromKey = ""
           c.toKey = ""
           this.hideAllPopups()
           this.stepsToUndo += 1
           this.canvasHistory.push(c)
           if (this.isShiftPressed == true) { // to powinno być odpalane tylko, gdy user zmieniał położenie wielu obiektów
             this.updateObjectPositionsOnCanvasHistory()
           }
           this.saveCanvas()
         })
 
         shape.on('transformend', (result: any) => {
             let c = {...command}
             c.x = result.target.attrs.x
             c.y = result.target.attrs.y
             const sx = result.target.attrs.scaleX
             const sy = result.target.attrs.scaleY
             c.width = result.target.attrs.width * sx
             c.height = result.target.attrs.height * sy
             c.command = "update"
             c.sequence = this.canvasHistory.length
             c.rotation = result.target.attrs.rotation
             c.color = result.target.attrs.stroke
             c.fromKey = ""
             c.toKey = ""
             this.hideAllPopups()
             this.stepsToUndo += 1
             this.canvasHistory.push(c)
             this.saveCanvas()
             this.generateImagesFromDOM("", command.key, command.color || "#ffffff", c.width, c.height, command.coverImageURL).then(im => {
               shape.image(im)
             })
             this.updateConnectors(this.connectorCornerRadius)
         });
         shape.on('dblclick dbltap', (e: any) => {
         })
 
         shape.on('click tap', (e: any) => {
          this.drawTouchPoints(command.key, shape.x(), shape.y(), shape.width(), shape.height(), 20)
          if (this.isDrawingArrow == false) { // if arrow is not dragged prevent from accidentally creating arrow
            this.mouseOverShapeKey = ""
            this.selectedShapeKey = ""
            this.isEditCardNamePopupVisible = false
            this.isPostPanelOpen = false
            this.manualAddContent = ""
            this.manualAddTitle = ""
          }
           if (this.mouseOverShapeKey != "" && this.selectedShapeKey != "" && this.isDrawingArrow == true && this.mouseOverShapeKey != this.selectedShapeKey) {
            if (this.findExistingArrow(this.selectedShapeKey, this.mouseOverShapeKey) == undefined) {
              this.stepsToUndo += 1
             this.canvasHistory.push({
               key: "arrow-"+this.selectedShapeKey+"-"+this.mouseOverShapeKey,
               fromKey: this.selectedShapeKey,
               toKey: this.mouseOverShapeKey,
               command: "add",
               shape: "arrow",
               contentKey: "", 
               content: "", 
               x: 0, 
               y: 0, 
               width: 0, 
               height: 0, 
               color: "", 
               sequence: this.canvasHistory.length,
               strokeWidth: 1, 
               rotation: 0,
               points: [],
               coverImageURL: "",
               zIndex: 100,
               isExpanded: true,
               dateOfUpdate: new Date(),
               isFixed: false
             })
             this.saveCanvas()
             this.drawConnector(this.selectedShapeKey, this.mouseOverShapeKey)
            } else {
              this.firestore.showSnackBar("This arrow already exists.")
            }
             return
           }
         //  const domPos = this.getShapePosition(shape);
           this.showContextMenu(command.key, shape);
           this.showCommentList(command.key, shape, "image");
         })
 
         shape.on('mouseover mouseenter', (e: any) => {
           if (shape.id() != "rect-"+command.key && this.isDrawingArrow == true) {
             this.mouseOverShapeKey = shape.id()
             shape.strokeWidth(4); // Change width on hover
             this.redrawLayer();
           }
         });
     
         shape.on(' mouseleave', (e: any) => {
           if (this.mouseOverShapeKey == shape.id()) {
             this.mouseOverShapeKey = ""
           }
           if (shape.id() != "rect-"+command.key) {
             shape.strokeWidth(1); // Reset color
             this.redrawLayer();
           }
         });
     
         this.layer.add(shape);
         this.selectionRectangle.moveToTop()
         this.redrawLayer();
       })
       console.timeEnd("drawImageContent")
   }

   findExistingArrow(fromKey: string, toKey: string) {
    const arrow = this.canvasHistory.find((c: any) => (c.fromKey == fromKey) && (c.toKey == toKey))
    return arrow
   }

  async updateImageContent(command: any) {
    const shape = this.layer.findOne('#' + command.key);
    if (shape) {
      shape.position({
        x: command.x,
        y: command.y,
      });
      shape.size({
          width: command.width,
          height: command.height,
      });
      shape.rotation(command.rotation)
      const sx = command.width / this.boxWidth
      const sy = command.height / (this.boxHeight*2)
      if (shape instanceof Konva.Image ) {
        shape.stroke(command.color)
        this.generateImagesFromDOM("", command.key, command.color || "#ffffff", this.boxWidth * sx, this.boxHeight*2 * sy, command.coverImageURL).then(im => {
          shape.image(im)
        })
      }
    }
  }

  cleanOldArrows() {
    this.canvasHistory.forEach((command: any) => {
      if (command.shape == "arrow") {
        const toKey = command.toKey
        const fromKey = command.fromKey
        let c = this.canvasHistory.filter((c: any) => (c.key == toKey) || (c.key == fromKey))
        if (c.length < 2) {
          this.canvasHistory = this.canvasHistory.filter((c: any) => (c.key != command.key) && (c.fromKey != fromKey) && (c.toKey != toKey))
        }
      }
    })
  }  

  drawTaskBox(key: string, rect: rect, color: string) {
    const g = new Konva.Group({
      id: key,
      draggable: true,
      fill: color,
      name: 'selectable',
    })
  
    const r = new Konva.Rect({
      key: "workpackage-rect-"+key,
      x: 0,
      y: 0,
      width: rect.width,
      height: rect.height,
      fill: color,
      cornerRadius: 4,
    })
  
    const plusIcon = new Konva.Path({
      key: "workpackage-plus-"+key,
      x: rect.width / 2 - 10,
      y: rect.height / 2 - 10,
      width: 20,
      height: 20,
      fill: "black",
      stroke: "black",
      strokeWidth: 1,
      data: "M 0 10 L 20 10 M 10 0 L 10 20",  // Draw a plus sign
      scaleX: 1, // Ensure scale is 1 to maintain size
      scaleY: 1  // Ensure scale is 1 to maintain size
    })

    g.add(r)
    g.add(plusIcon)
    g.position({ x: rect.x, y: rect.y })
  
    g.on('dragstart', (e: any) => {
      const index = this.nestedTasksKeys.findIndex((r: any) => r.key == key)
      this.nestedTasksKeys[index].kids.forEach((k: string) => {
        const kid = this.layer.findOne('#' + k)
        if (kid) {
          this.nestedTasksKeys[index].xOffset = kid.x() - g.x()
          this.nestedTasksKeys[index].yOffset = kid.y() - g.y()
        }
      })
    })

    g.on('transformstart', (e: any) => {
      this.hideContextMenus()
    })
  
    g.on('dragmove transform', (e: any) => {
      const index = this.nestedTasksKeys.findIndex((r: any) => r.key == key)
      const parentKey = this.nestedTasksKeys[index].parentKey
      if (parentKey != "") {
        const parent = this.layer.findOne('#' + parentKey)
        if (parent) {
          const parentBoundingBox = parent.getClientRect()
          const groupBoundingBox = g.getClientRect()
          if (!this.isRectInRect(parentBoundingBox, groupBoundingBox)) {
            // Adjust position to stay within parent
            if (groupBoundingBox.x < parentBoundingBox.x) {
              g.x(parent.x())
            } else if (groupBoundingBox.x + groupBoundingBox.width > parentBoundingBox.x + parentBoundingBox.width) {
              g.x(parent.x() + parentBoundingBox.width - groupBoundingBox.width)
            }
            if (groupBoundingBox.y < parentBoundingBox.y) {
              g.y(parent.y())
            } else if (groupBoundingBox.y + groupBoundingBox.height > parentBoundingBox.y + parentBoundingBox.height) {
              g.y(parent.y() + parentBoundingBox.height - groupBoundingBox.height)
            }
          }
        }
      }
      this.moveRectKids(g)
    })
  
    g.on('dragend transformend', (e: any) => {
      const index = this.nestedTasksKeys.findIndex((r: any) => r.key == key)
      const parentKey = this.nestedTasksKeys[index].parentKey
      if (parentKey != "") {
        const parent = this.layer.findOne('#' + parentKey)
        if (parent) {
          const dx = g.x() - parent.x()
          const dy = g.y() - parent.y()
          this.nestedTasksKeys[index].xOffset = dx
          this.nestedTasksKeys[index].yOffset = dy
        }
      } else {
        this.nestedTasksKeys[index].xOffset = g.x()
        this.nestedTasksKeys[index].yOffset = g.y()
      }
      this.updateConnectors(this.connectorCornerRadius)
    })
    // Add the Transformer to kid shapes only
  /*  const index = this.nestedTasksKeys.findIndex((rect) => rect.key === key);
    if (this.nestedTasksKeys[index].parentKey !== "") {
      addTransformer.call(this, g, key);
    }*/
    return g
  }

  /*addTransformer(g: any, key: any) { // TO NIE JST NARAZIE UZywane!!! ma służy do limitowania zmiany rozmiaru i położenia obiektu w ramach jego rodzica
  const transformer = new Konva.Transformer({
    id: "transformer",
    nodes: [g],
    padding: 10,
    anchorSize: 10,
    anchorStroke: 'green',
    anchorFill: 'green',
    anchorStrokeWidth: 2,
    flipY: false,
    flipX: false,
    resizeEnabled: true, // Enable resizing
    rotateEnabled: false, // Disable rotation if not needed
    enabledAnchors: [
      'top-left', 'top-right', 'bottom-right', 'bottom-left',
      'middle-left', 'middle-right', 'top-center', 'bottom-center'
    ],
    keepRatio: false, // Set to false to disable proportional resizing
    boundBoxFunc: (oldBox, newBox) => {
      // Get the parent node
      const index = this.nestedTasksKeys.findIndex((r) => r.key === key);
      const parentKey = this.nestedTasksKeys[index].parentKey;
      if (parentKey !== "") {
        const parent = this.layer.findOne('#' + parentKey);
        if (parent) {
          const parentRect = parent.getClientRect();
          let adjustedBox = { ...newBox };           // Create copies of the newBox to adjust
          if (adjustedBox.x < parentRect.x) {           // Adjust the newBox to stay within the parentRect
            adjustedBox.x = parentRect.x;
          }
          if (adjustedBox.y < parentRect.y) {
            adjustedBox.y = parentRect.y;
          }
          if (adjustedBox.x + adjustedBox.width > parentRect.x + parentRect.width) {
            adjustedBox.width = parentRect.x + parentRect.width - adjustedBox.x;
          }
          if (adjustedBox.y + adjustedBox.height > parentRect.y + parentRect.height) {
            adjustedBox.height = parentRect.y + parentRect.height - adjustedBox.y;
          }

          return adjustedBox;
        }
      }
      return newBox;
    },
  });
  this.layer.add(transformer);
}*/

  moveRectKids(g: Konva.Node) {
    const index = this.nestedTasksKeys.findIndex((rect: any) => rect.key == g.id())
    this.nestedTasksKeys[index].kids.forEach((k: string) => {
      const kidIndex = this.nestedTasksKeys.findIndex((rect: any) => rect.key == k)
      const kid = this.layer.findOne('#' + k)
      if (kid) {
        kid.position({
          x: g.x() + this.nestedTasksKeys[kidIndex].xOffset,
          y: g.y() + this.nestedTasksKeys[kidIndex].yOffset
        })
        this.moveRectKids(kid)
      }
    })
  }

  launchNestedRectangles() {
    this.nestedTasksKeys = [
      { key: "parent", parentKey: "", kids: ["kid1", "kid2"], xOffset: 100, yOffset: 100, width: 200, height: 200, color: "yellow" },
      { key: "kid1", parentKey: "parent", kids: [], xOffset: 10, yOffset: 10, width: 50, height: 50, color: "blue" },
      { key: "kid2", parentKey: "parent", kids: ["kid3"], xOffset: 50, yOffset: 50, width: 80, height: 80, color: "red" },
      { key: "kid3", parentKey: "kid2", kids: [], xOffset: 5, yOffset: 0, width: 50, height: 50, color: "orange" }
    ]
  
    this.nestedTasksKeys.forEach((rect: any) => {
      const r = this.drawTaskBox(rect.key, {
        x: rect.xOffset,
        y: rect.yOffset,
        width: rect.width,
        height: rect.height
      }, rect.color)
      this.layer.add(r)
    })
  
    this.redrawLayer()
  }
  
  isRectInRect(outsideRect: rect, insideRect: rect) {
    return (
      insideRect.x >= outsideRect.x &&
      insideRect.x + insideRect.width <= outsideRect.x + outsideRect.width &&
      insideRect.y >= outsideRect.y &&
      insideRect.y + insideRect.height <= outsideRect.y + outsideRect.height
    )
  }

  async updatePositionOnCanvas(position: {x: number, y: number}) { // in realtime updates cursor position on canvas
    if (isNaN(position.x) || isNaN(position.y)) {
      return
    }
    await this.realtime.updateCursorPositionOnCanvas(this.canvasKey, this.userId, position, this.userName, this.isLaserPointerEnabled, this.laserLine.points(), this.colors[this.randomFace])
  }

  closeShareCanvasPopup() {
    this.shareCanvasPopupVisible = false
    this.isCanvasVisibleForKnowledgeBase = true
  }

  shareCanvas() {
    this.firestore.getAvailableAnonymousStatus(this.organizationKey, this.canvasKey).then((status: any) => {
      if (status.contentAvailableAnonymously == true && status.organizationAvailableAnonymously == true) {
        this.shareCanvasPopupVisible = true
        this.isCanvasVisibleForKnowledgeBase = false
      } else {
        this.shareCanvasPopupVisible = false
        this.isCanvasVisibleForKnowledgeBase = true
        this.firestore.showSnackBar("Canvas is not shared with anonymous users")
        const refDialog = this.dialog.open(ConfirmingDialogComponent, {data: {"content": "You need to enable anonymous sharing in canvas and organization settings. Do you want to let anonymous users access this canvas and organization content?", "onlyCloseButton": false, "title": "Share canvas"}})
        refDialog.afterClosed().subscribe(result => {
          if (result == true) {
            let switchListeningInFunction = true
            if (this.isListening == false) {
              switchListeningInFunction = false
            }
            this.isListening = false
            this.firestore.updateAvailableAnonymousStatus(this.organizationKey, this.canvasKey, true, true).then(() => {
              this.shareCanvasPopupVisible = true
              if (switchListeningInFunction == true) {
                this.isListening = true
              }
              this.firestore.showSnackBar("Canvas can be shared with anonymous users.")
            })
          }
        })
      }
    })
  }

  copyCanvasLink() {
    navigator.clipboard.writeText(this.canvasLink)
    this.firestore.showSnackBar("Link copied to clipboard.")
    this.shareCanvasPopupVisible = false
    this.isCanvasVisibleForKnowledgeBase = true
  }

  showPromptPopup() {
    this.promptFoundMessage = ""
    this.hideAllPopups()
    this.areCanvasEventsSuspended = true
    this.isPromptPopupVisible = !this.isPromptPopupVisible
    if (this.isPromptPopupVisible == false) {
      this.prompt = ""
    }
  }

  closePromptPopup() {
    this.isPromptPopupVisible = false
    this.prompt = ""
  }

  async searchContent() {
    this.areCanvasEventsSuspended = false
    this.firestore.showSnackBar("Searching for content. It may take a minute...")
   // const promptPrefix = ""
    this.promptFoundMessage = "Searching for content..."
    let embedding: number[] = []
    const chunk = [{"key": "000", "chunk": this.prompt}]
    await this.geminiService.getGeminiEmbeddings(chunk).then(res => { // getting embedding vector for prompt typed by user
      if (res != undefined && res[0].embedding != undefined) {
        embedding = res[0].embedding
        this.firestore.showSnackBar("We are half way there...")
      }
    }).catch((error: any) => {
      this.promptFoundMessage = ""
      this.isPromptPopupVisible = false
      this.firestore.showSnackBar("Error getting embedding vector for prompt typed by user")
    })

    let results = []
    let contentTypes: string[] = []
    if (this.searchPosts == true) {
      contentTypes.push("post")
    }
    if (this.searchTasks == true) {
      contentTypes.push("workpackage")
    }
    if (contentTypes.length == 0) {
      contentTypes.push("post")
      contentTypes.push("workpackage")
    }
    await this.search.queryVector(this.organizationKey, embedding, contentTypes).then((res: any) => {
      this.firestore.showSnackBar("Tasks and knowledge found. You can add them to canvas.")
      results = res.responseSourceDocuments
      results = results.filter((r: any) => r.projectKey == this.projectKey).filter((r: any) => contentTypes.includes(r.contentType)).filter((r: any) => r.score > 0.4)
      this.contentFoundByPrompt = results.map((r: any) => ({
        key: r.contentKey,
        name: r.name || "",
        htmlName: r.htmlName || r.name,
        color: r.color || "#ffffff",
        coverImageURL: r.coverImageURL || "",
        contentType: r.contentType
      })
    );
      this.promptFoundMessage = "I found " + this.contentFoundByPrompt.length + " tasks and knowledge related to your prompt."
      this.isPromptPopupAddButtonVisible = true
    }).catch((error: any) => {
      this.firestore.showSnackBar("Error searching for content")
      this.isPromptPopupVisible = false
      this.promptFoundMessage = ""
      this.isPromptPopupAddButtonVisible = false
    });
    
    this.prompt = ""
  }

  addPromptFoundContent() {
    this.isLoadingCursor = true
    this.firestore.showSnackBar("Adding content to canvas...")
      const posts = this.contentFoundByPrompt.filter((r: any) => r.contentType == "post").map((r: any) => ({key: r.key, name: r.name, htmlName: r.htmlName, color: r.color, coverImageURL: r.coverImageURL, contentType: r.contentType}))
      const workpackages = this.contentFoundByPrompt.filter((r: any) => r.contentType == "workpackage").map((r: any) => ({key: r.key, name: r.name, htmlName: r.htmlName, color: r.color, coverImageURL: r.coverImageURL, contentType: r.contentType}))
      const currentPosition = this.getCentralPosition()
      this.onAddWorkpackage('content', posts, 0, this.boxHeight*2, {x: currentPosition.x, y: currentPosition.y, width: this.boxWidth, height: this.boxHeight*2})
      this.onAddWorkpackage('workpackage', workpackages, 0, this.boxHeight*2, {x: currentPosition.x, y: currentPosition.y, width: this.boxWidth, height: this.boxHeight*2})
      this.isPromptPopupVisible = false
      this.promptFoundMessage = ""
      this.isPromptPopupAddButtonVisible = false
    setTimeout(() => {
      this.isLoadingCursor = false
    }, 1000)
  }

  onProgressHillUpdated(points: { x: number, y: number, progress: number, label: string, color: string }[]) {
    this.progressPoints = points
  }

  async onAddComment(comments: Comment[]) {
    const key = comments[0].canvasObjectKey
    const card = this.treeCards.find(c => c.key == key)
    if (card) {
      const commentCount = await this.firestore.getCommentCount(this.organizationKey, this.canvasKey, key)
      card.card.commentsCount = commentCount
      card.card.createNameImage(card.card.name, card.card.commentsCount, card.card.emoticonsString, true, card.startDate, card.endDate, card.percentProgress)
    }
  }

  onProgressPercentUpdate(event: {startDate: string, endDate: string, progressPercent: number}) {
    const card = this.treeCards.find(c => c.key == this.selectedShapeKey)
    if (card) {
      card.startDate = event.startDate
      card.endDate = event.endDate
      card.percentProgress = event.progressPercent
      card.card.createNameImage(card.card.name, card.card.commentsCount, card.card.emoticonsString, true, card.startDate, card.endDate, card.percentProgress)
    }
  }

  onUpdateEmoticons(event: {canvasObjectKey: string, emoticons: string}) {
    const card = this.treeCards.find(c => c.key == event.canvasObjectKey)
    if (card) {
      card.card.emoticonsString = event.emoticons
      card.card.createNameImage(card.card.name, card.card.commentsCount, card.card.emoticonsString, true, card.startDate, card.endDate, card.percentProgress)
    }
  }

  collapseExpand() {
    this.isSelectedShapeExpanded = !this.isSelectedShapeExpanded
    const historyIndex = this.canvasHistory.findIndex((r: any) => r.key == this.selectedShapeKey)
    if (historyIndex != -1) {
      this.canvasHistory[historyIndex].isExpanded = this.isSelectedShapeExpanded
    }
    const connectedShapes = this.findConnectedShapes(this.selectedShapeKey, true, this.selectedShapeKey)
    connectedShapes.forEach((s: any) => {
      s.visible(this.isSelectedShapeExpanded)
      s.listening(this.isSelectedShapeExpanded)
      s.draggable(this.isSelectedShapeExpanded)
    })
    if (this.isSelectedShapeExpanded == false) {
      const parentCard = this.treeCards.find(c => c.key == this.selectedShapeKey)
      if (parentCard) {

      }
    }
    this.updateConnectors(this.connectorCornerRadius)
  }

  async createOutcomeCard(contentKey: string) {
    const content = await this.firestore.getContent(this.organizationKey, contentKey)
    const x = -150
    const y = -300
    const cardKey = this.firestore.generateUID()
    const card = new OutcomeCard(this.canvasKey, cardKey, contentKey, content.name, x, y, this.treeCardWidth, this.treeCardHeight*1.5, 0, [], (message: string) => this.onTreeCardClick(message, contentKey, cardKey), (card: Konva.Group) => this.startDraggTreeCard(card, cardKey), (cardKey: string, isCollapsed: boolean) => this.onCollapseClick(cardKey, isCollapsed), this.isAnonymous || this.canvasPermissions.canAnonymousAddCards == true)
    this.layer.add(await card.createCard(false, 0, "", ""))
    const leftPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, "Opportunity", [], "left")
    leftPlaceholder.rotatePlaceholder(false)
    const rightPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, "Opportunity", [], "right")
    rightPlaceholder.rotatePlaceholder(false)
    const kidCardTypes = this.getKidCardTypes("Outcome")
    this.treeCards.push({key: cardKey, card: card, leftPlaceholder: leftPlaceholder, rightPlaceholder: rightPlaceholder, parentKey: "", kidCardKeys: [], cardType: "Outcome", horizontalSpace: this.treeCardWidth, content: content.name, topBorderColor: "black", status: "accepted", rowSide: "", doAddButtons: false, tag: "", priority: 0, contentKey: contentKey, isKanbanTask: false, isKnowledgeBaseItem: false, treeLevel: 0, order: 0, kidCardTypes: kidCardTypes, startDate: "", endDate: "", percentProgress: 0, solutionType: ""})
    this.treeRootKey = cardKey
    this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, "", cardKey, content.name, "add", "accepted")
    await this.saveTreeCards()
    const position = this.getCentralPosition()
    this.moveToPosition(position.x, position.y, 1)
  }

  drawDot(x: number, y: number) { // for debugging purposes
    const dot = new Konva.Circle({
      x: x,
      y: y,
      radius: 5,
      fill: "pink",
    })
    this.layer.add(dot)
  }

  async onNameImageUpdated(organizationKey: string, canvasKey: string, cardKey: string, nameImageURL: string) { // this is callback from treecards.ts, updating card cover image url
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
    const card = this.treeCards.find(c => c.key == cardKey)
    if (card) {
      card.card.nameImageURL = nameImageURL
    }
    await this.firestore.updateCanvasTreeCardCoverImageUrl(organizationKey, canvasKey, cardKey, nameImageURL)
      if (switchListeningInFunction == true) {
        this.isListening = true
      }
  }

  onCollapseClick(cardKey: string, isCollapsed: boolean) { // this is callback from treecards.ts
    const card = this.treeCards.find(c => c.key == cardKey)
    if (card) {
      const kids = card.kidCardKeys
      this.collapseKids(kids, isCollapsed)
    }
    this.refreshOSTTree()
    this.removeAddPlaceholders()
    this.addAddPlaceholders()
    card?.card.updateCollapseIcon(isCollapsed)
  }

  collapseKids(keys: string[], isCollapsed: boolean) {
    if (keys && keys.length > 0) {
      keys.forEach((k: string) => {
        const card = this.treeCards.find(c => c.key == k)
        if (card) {
          card.card.isHidden = isCollapsed
          if (isCollapsed == true) {
            card.card.card.remove()
          } else {
            this.layer.add(card.card.card)
          }
          const kids = card.kidCardKeys
          this.collapseKids(kids, isCollapsed)
        }
      })
    }
  }

  createNewItemPlaceholder(contentKey: string, parentKey: string, title: string, x: number, y: number, width: number, height: number, cardType: string, kids: [], side: string) {
    const cardKey = "addplaceholder"+side+"-"+parentKey
    const card = new AddCardPlaceholder(cardKey, parentKey, contentKey, title, x, y, width, height, side, kids, (message) => this.onAddOpportunity(message, cardType, parentKey))
    if (this.isAnonymous == false || this.canvasPermissions.canAnonymousAddCards == true) {
      this.layer.add(card.createCard())
    }
    return card
  }

  async onTreeCardClick(message: string, contentKey: string, cardKey: string) {
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, while card is being processed..."
    this.loadingTitle = "Processing card..."
    this.progressLog.length = 0
   // this.isCanvasVisible = false
    const index = this.treeCards.findIndex(c => c.key == cardKey)
    const isKanbanTask = this.treeCards.find(c => c.key == cardKey)?.isKanbanTask
    const isKnowledgeBaseItem = this.treeCards.find(c => c.key == cardKey)?.isKnowledgeBaseItem
    const startDate = this.treeCards.find(c => c.key == cardKey)?.startDate || ""
    const endDate = this.treeCards.find(c => c.key == cardKey)?.endDate || ""
    const percentProgress = this.treeCards.find(c => c.key == cardKey)?.percentProgress || 0
    const cardType = this.treeCards.find(c => c.key == cardKey)?.cardType.toLowerCase() || ""
    const templateKey = this.templates.find(t => t.name.toLowerCase() == cardType)?.key || ""
    const card = this.treeCards.find(c => c.key == cardKey)
    this.selectedShapeKey = cardKey
    if ((isKanbanTask == true || isKnowledgeBaseItem == true ) && contentKey != "") { // if this card was converted to kanban task or knowledge base item, we need to launch post dialog
      if (message == "research") { // research card
        if (index != -1) {
          this.researchCard(cardKey)
        }
      } else if (message == "check") { // check card
        if (card) {
          card.card.setCardChecked(true)
        }
      } else if (message == "uncheck") { // uncheck card
        if (card) {
          card.card.setCardChecked(false)
        }
      } else if (message != "collapse") {
        this.launchPostDialog(contentKey, "", "", false, templateKey, false, cardKey) // full card with template
      }
    } else if (message == "reject") { // remove card and placeholder
      this.isManualTreeComponentPopupVisible = false
      this.hideContextMenus()
      await this.deleteOSTCard(cardKey)
    } else if (message == "accept") { // aprove card
      if (card) {
        card.card.setStatus("accepted")
        if (index != -1) {
          this.treeCards[index].status = "accepted"
        }
        this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, card.parentKey, cardKey, card.content, "update_status", "accepted")
        await this.saveTreeCards()
      }
    } else if (message == "research") { // research card
      if (index != -1) {
        this.researchCard(cardKey)
      }
    } else if (message == "collapse") { // collapse card
      if (index != -1) {
        this.onCollapseClick(cardKey, this.isSelectedShapeExpanded)
        this.isSelectedShapeExpanded = !this.isSelectedShapeExpanded
      }
    } else if (message == "check") { // check card
      if (card) {
        card.card.setCardChecked(true)
      }
    } else if (message == "uncheck") { // uncheck card
      if (card) {
        card.card.setCardChecked(false)
      }
    } else if (contentKey != "") {
      this.launchPostDialog(contentKey, "", "", false, templateKey, false, cardKey)
    } else if (cardKey != "") { //if everything else fails, show edit card name popup
      this.selectedTreeCardType = this.treeCards[index].cardType
      this.manualAddContent = message
      this.showEditCardNamePopup() // simplified card 
    }
   // this.isCanvasVisible = true
    this.isLoadingLabelVisible = false
  }

  async researchCard(cardKey: string) {
    setTimeout(() => {
    this.hideContextMenus()
    this.isEditCardNamePopupVisible = false
    this.isPostPanelOpen = false
    this.manualAddContent = ""
    this.manualAddTitle = ""
    }, 100)
    const card = this.treeCards.find(c => c.key == cardKey)
    if (card) {
      const dialog = this.dialog.open(ConfirmingDialogComponent, {
        data: {"content": "Do you want to research the card? It will take a minute to complete.", "onlyCloseButton": false, "title": "Research idea"}
      })
      const result = await dialog.afterClosed().toPromise()
      if (result == true) {
        this.researchPopupContent = await this.runResearchCard(card.cardType, card.content)
        if (card.cardType == "Solution") {
          card.solutionType = await this.detectSolutionType(this.researchPopupContent.content, cardKey)
        }
      }
      this.selectedShapeKey = cardKey
    }
  }

  async runResearchCard(cardType: string, cardContent: string, addContentAutomatically: boolean = false) {
    this.progressLog.length = 0
    this.progressStatus = ""
    this.isLoadingLabelVisible = true
    this.loadingTitle = "Researching card"
    this.loadingMessage = "Please wait, researching card. It usually takes 1 minute..."
    let modelKey = "gemini-2.5-pro" //"gemini-2.5-pro"
    if (this.canvasPermissions.isFastAIUsed == true) {
      modelKey = "gemini-2.5-flash-lite"
    }
    const refinementPrompt = this.research.componentDefinitionPrompts.find(prompt => prompt.componentType == cardType)?.refinementPrompt || ""
    let content = await this.refineContent(cardContent, cardType, this.llmLimit, modelKey, 0, refinementPrompt)
    this.isResearchPopupVisible = true
    let sources = ""
    if (content.sources.length > 0) {
      if (addContentAutomatically == false) {
        sources += "<ul>"
        content.sources.forEach((source: any) => {
          sources += "<li><a href='"+source.web.uri+"' target='_blank'>"+source.web.title+"</a></li>"
        })
        sources += "</ul>"
      }
    }
    const researchPopupContent = {title: content.title, content: content.responseText, sources: sources}
    this.isLoadingLabelVisible = false
    this.progressLog.length = 0
    this.progressStatus = ""
    return researchPopupContent
  }

  async researchSelectedCards() {
    this.selectedCards = this.treeCards.filter(card => card.card.isCardChecked);
    if (this.selectedCards.length === 0) {
      this.firestore.showSnackBar("No cards selected to research.");
      return;
    }
    if (this.selectedCards.length > 0) {
      const dialog = this.dialog.open(ConfirmingDialogComponent, {
        data: {"content": "Do you want to research "+this.selectedCards.length+" cards? It will take a while to complete.", "onlyCloseButton": false, "title": "Research cards"}
      })
      const result = await dialog.afterClosed().toPromise()
      if (result == true) {
        for (const card of this.selectedCards) {
          this.selectedShapeKey = card.key
          const type = card.cardType
          const content = card.content
          const researchPopupContent = await this.runResearchCard(type, content, true)
          if (type == "Solution") {
            card.solutionType = await this.detectSolutionType(researchPopupContent.content, card.key)
          }
          if (researchPopupContent) {
            this.addResearchReport(researchPopupContent)
          }
        }
        this.selectedShapeKey = ""
      }

    }
  }

  async detectSolutionType(content: string, cardKey: string) {
    const prompt = "Detect the type of the solution based on the following content: \n\n" + content + "\n\n\nReturn answer in JSON format: {type: <solution type>}. The solution type should be one of the following: " + this.solutionTypes.join(", ") + ". If you are not sure, return 'Other'."
    const type = await this.research.getPromptResponse(prompt, this.organizationKey, this.projectKey, this.userId, this.llmLimit, [], true, "gemini-2.5-flash-lite")
    const result = this.search.extractJsonFromString(type.responseText) as {type: string}[]
    if (result.length > 0) {
      const index = this.treeCards.findIndex(c => c.key == cardKey)
      if (index != -1) {
        this.treeCards[index].solutionType = result[0].type
      }
      return result[0].type
    } else {
      return "Other"
    }
  }

  closeTreeComponentSlidePanel() {
    this.isRTFEditorClicked = false
    this.isEditCardNamePopupVisible = false
    this.isPostPanelOpen = false
    this.manualAddContent = ""
    this.manualAddTitle = ""
    this.isManualTreeComponentPopupVisible = false
    this.isResearchPopupVisible = false
    this.isGenerateByAIPopupVisible = false
    this.isDeepSearchPopupVisible = false
    this.hideContextMenus()
  }

  closeResearchPopup() {
    this.isResearchPopupVisible = false
    this.researchPopupContent = {title: "", content: "", sources: ""}
    this.isCanvasVisible = true
  }

  copyResearchReport() {
    const content = this.researchPopupContent.content; // Assuming this.content holds your HTML formatted string
    // Use the ClipboardItem API for copying formatted content
    const blob = new Blob([content], { type: 'text/html' });
    const item = new ClipboardItem({
      'text/html': blob,
      'text/plain': new Blob([content], { type: 'text/plain' }) // Optional: Provide a fallback plain text version
    });
  
    navigator.clipboard.write([item])
      .then(() => {
        this.firestore.showSnackBar("Research report copied to clipboard.");
      })
      .catch(err => {
        console.error('Could not copy research report: ', err);
        // Optional: Show an error message to the user
        this.firestore.showSnackBar("Failed to copy report.");
      });
  }

  async addResearchReport(report: {title: string, content: string, sources: string}) {
    const card = this.treeCards.find(c => c.key == this.selectedShapeKey)
    if (card) {
      const contentKey = card.contentKey
      let newContent = "<h1>"+report.title+"</h1><br/>" + card.content + "<p><b>Research report</b></p>"+report.content 
      if (report.sources != "") {
        newContent += "<h3>References</h3>"+report.sources 
      }
      card.content = newContent
      const index = this.treeCards.findIndex(c => c.key == card.key)
      if (index != -1) {
        if (contentKey != "") { // if content key is not empty, then treat it as post from knowledge base, if it is empty, then treat it as OST card
          await this.firestore.getPost(this.organizationKey, contentKey).then(p => {
            const post: Post | null = this.preparePost(p, this.projectName)
            if (post != null) {
              this.fileName = post.name.slice(0, 40)
              post.fields = this.firestore.addLabelField(post.fields, "Research report")
              post.fields = this.firestore.addHTMLField(post.fields, newContent)
            //  post.fields[post.fields.length - 1].label = newContent
              this.savePost(post)
            } 
          })
        }

        this.treeCards[index].card.updateName(newContent)
        this.treeCards[index].card.setStatus("researched")
        this.treeCards[index].content = newContent
      }
      if (card.cardType == "Solution") {
        card.solutionType = await this.detectSolutionType(newContent, card.key)
      }
      this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, card.parentKey, this.selectedShapeKey, newContent, "update_content", "")
      await this.saveTreeCards()
    }
    this.closeResearchPopup()
  }

  async savePost(post: Post) {
    await this.firestore.updateWorkpackageFields(this.organizationKey, post.key, post.fields)
  }

  async getResearchReport(reportKey: string) {
    const report = await this.firestore.loadResearchReport(this.organizationKey, this.userId, reportKey)
    return report
  } 

  onAddOpportunity(message: string, cardType: string, parentKey: string) {
    const shape = this.layer.findOne('#' + parentKey)
    if (shape && this.isLoadingLabelVisible == false) {
      this.selectedShapeKey = parentKey
      this.selectedTreeCardType = cardType
      this.placeholderRowSide = message
      const treeItem = this.treeCards.find(c => c.key == parentKey)
      if (treeItem) { // if add placeholder shape is partially hidden behind the edge of the canvas, scroll to the shape
        if (message == "right") {
       //   this.scrollToShape(treeItem.rightPlaceholder.card)
        } else if (message == "left"  ) {
       //   this.scrollToShape(treeItem.leftPlaceholder.card)
        }
      }
      this.showTreeContextMenu()
    }
  }

  scrollToShape(shape: Konva.Group) { // scroll to shape if it is partially hidden behind the edge of the canvas
    const containerWidth = this.stage.width();   // Get visible area size (container)
    const containerHeight = this.stage.height();
    const visibleRect = {
      x: -this.stage.x(),
      y: -this.stage.y(),
      width: containerWidth,
      height: containerHeight
    };

    // Get shape's bounding box in stage coordinates
    const shapeRect = shape.getClientRect({ relativeTo: this.stage });
    let newX = this.stage.x();
    if (shapeRect.x < visibleRect.x) {   // If shape's left edge is hidden, scroll right
      newX = -shapeRect.x;
    } else if ((shapeRect.x + shapeRect.width) > (visibleRect.x + visibleRect.width)) {   // If shape's right edge is hidden, scroll left
      newX = -(shapeRect.x + shapeRect.width - visibleRect.width);
    }
    this.stage.to({ 
      x: newX,
      duration: 0.3,
      easing: Konva.Easings.EaseInOut,
    });
  }

  getChildCardType(cardType: string) {
    if (cardType == "Outcome") {
      return "Opportunity"
    } else if (cardType == "Opportunity") {
      return "Solution"
    } else if (cardType == "Solution") {
      return "Experiment"
    } else if (cardType == "Experiment") {
      return "Task"
    } else {
      return "Card"
    }
  }

  async generateByAI(reportContent: string = "") {
    this.isListening = false
    this.loadingTitle = "Generating "+this.selectedTreeCardType+"..."
    this.hideContextMenus()
    this.isLoadingLabelVisible = false
    if (this.selectedContent.length == 0 && reportContent == "") {
      this.firestore.showSnackBar("Please select data sources from knowledge base to generate Opportunity Solution Tree components using AI.")
      this.isDataSourcesVisible = true
      this.contentListContextMessage = "Select at least 1 content to generate OST components using AI."
      this.isCanvasVisible = true
      this.loadingMessage = ""
      this.loadingTitle = ""
      this.progressLog.length = 0
      this.progressStatus = ""
      return
    }
    this.isCanvasVisible = false
    const useMoePrompts = true
    const moePrompts = [
      {name: "creator", prompt: "You are a creator of ideas. You provide novel and original ideas. You can see the challenge from broader and new perspective. You broaden the horizons by finding analogies and connections from other markets, customer segments and countries. The most important for you is to provide ideas that are not obvious and that are not already known. You are not limited to the data sources provided, you can use your own knowledge and experience to create new ideas."},
      {name: "critic", prompt: "You are a reviewer of ideas, concentrating on details. You focus on feasibility and reliability of ideas. You rather not provide ideas if you don't have enough data to support them. You believe in detailed analysis supported by data. You like to find defects and faults in ideas in order to eliminate them quickly."},
      {name: "visioner", prompt: "You are a visioner. You love ideas which are very longterm and have a big impact on the future. You rather see broad perspective and global trends. You stronhly believe that anything is possible, people just need to be given the right opportunity and believe in vision. You are not afraid of taking risk."},
      {name: "optimizer", prompt: "You are an optimizer. You love to find the best way to do something. You focus on small improvements which are available at hand. You believe in small steps and incremental changes implpemented right now. The change should be visible and measurable."},
      {name: "emotional", prompt: "You believe that not everything can be measured and calculated. You believe that emotions and feelings are important and should be taken into account, especially when it comes to customer needs and expectations. Only when you have a clear understanding of the customer's needs and expectations, you can provide the best solution. You rather guess the customer's needs and expectations than to rely on data only."},
    ]
    const parentKey = this.selectedShapeKey
    let cardDirection = "horizontal"
    let color = this.getColorForCardType(this.selectedTreeCardType)
    let parentType = "Outcome"
    let childType = "Solution"
    if (this.selectedTreeCardType == "Solution") {
      parentType = "Opportunity"
      childType = "Experiment"
    } else if (this.selectedTreeCardType == "Experiment") {
      parentType = "Solution"
      childType = "Task"
    } else if (this.selectedTreeCardType == "Task") {
      childType = "Task"
    }
    const shape = this.layer.findOne('#' + parentKey)
    if (shape) {
      const middleX = shape.x() + shape.width()/2
      const y = shape.y() //+ shape.height() + this.treeCardMargin
      this.loadingTitle = "Generating "+this.selectedTreeCardType+"..."
      this.loadingMessage = "Please wait, extracting selected content from knowledge base...<br/>(refresh page if you want to interrupt thinking process)"
      this.progressLog.push("Extracting selected content from knowledge base...")
     const aiUtilizedContentKeys = await this.firestore.getTreeSelectedContentKeys(this.organizationKey, this.canvasKey, this.userId, parentKey)
     const areNewDocs = this.checkNewDocs(aiUtilizedContentKeys, this.selectedContent.map(c => c.key))
     if (areNewDocs === false) {
      // Create a promise to handle the dialog's result asynchronously
      const confirmResult = await new Promise<boolean | undefined>(resolve => {
          const dialogRef = this.dialog.open(ConfirmingDialogComponent, {
              data: {
                  "content": "Cards were already generated based on selected content. This may not bring novel ideas. It is adviced to add new content to get new ideas. Do you want to continue anyway?",
                  "onlyCloseButton": false,
                  "title": "No new content"
              }
          });

          // Resolve the promise when the dialog is closed
          dialogRef.afterClosed().subscribe((result: any) => {
              resolve(result);
          });
      });
      // The code execution pauses here until the user closes the dialog
      
      // If the user did not confirm to continue (result is false or undefined/closed)
      if (confirmResult === false) {
          this.firestore.showSnackBar("Interrupted tree generation by user.")
          this.isListening = true
          this.isLoadingLabelVisible = false
          this.loadingMessage = this.standardLoadingMessage
          this.isCanvasVisible = true
          this.progressLog.length = 0
          return; // Exit the function if the user chose to quit
      }
      // If the user chose to continue (result is typically true, based on your dialog implementation)
  }

     let elementContentArray: string[] = []
     if (reportContent == "") { // if report content is not provided, extract content from knowledge base
        elementContentArray = await this.getSelectedContent(this.minContentLengthForOST, this.maxContentLengthForOST, false) // 10000 is max length of content to extract, content is  divided into chunks for better prompt response
     } else { // if report content is provided, decompose it into chunks directly
      elementContentArray = this.research.decomposeContent(reportContent, this.minContentLengthForOST, this.maxContentLengthForOST)
     }
     const numberOfSteps = elementContentArray.length
     let step = 0
  //   const promiseArray: any[] = []
     this.promptLanguage = this.researchReport.language
     if (elementContentArray.length > 0 && (this.promptLanguage == undefined || this.promptLanguage == "")) { // if language is not set, detect it
        this.promptLanguage = await this.research.detectLanguage(elementContentArray[0], this.organizationKey, this.projectKey, this.userId, this.llmLimit)
     }
     let contentArray: string[] = []
      for (let elementContent of elementContentArray) { // generate cards for each content chunk iteratively
        step++
        this.loadingMessage = "Please wait, generating ideas may take up to few minutes...<br/>(refresh page if you want to interrupt thinking process)<br/>Step "+step+" of "+numberOfSteps
        this.progressLog.push("Generating ideas - step "+step+" of "+numberOfSteps+".")
        const parentSolutionType = this.treeCards.find(c => c.key == parentKey)?.solutionType || ""
        const card = this.treeCards.find(c => c.key == parentKey)
        let isITTask = false
        if (card?.cardType == "Solution" && parentSolutionType == "IT application") {
          isITTask = true
        }
        if (useMoePrompts == true) {
          contentArray.push(await this.createOSTComponent(elementContent, this.selectedTreeCardType, step, numberOfSteps, moePrompts, this.promptLanguage, isITTask))
        } else {
          contentArray.push(await this.createOSTComponent(elementContent, this.selectedTreeCardType, step, numberOfSteps, [], this.promptLanguage, isITTask))
        }
     }

     let jsonCards: any[] = []
     contentArray.forEach(async (content: string) => {
      const jsonCard: any[] = this.search.extractJsonFromString(content)
      if (jsonCard) {
        jsonCards = jsonCards.concat(jsonCard)
      }
     })
     const generatedCards = jsonCards.length
     this.firestore.showSnackBar("AI generated "+generatedCards+" ideas.")
     this.progressLog.push("AI generated "+generatedCards+" ideas.")


     this.loadingMessage = "Please wait, consolidating ideas..."
     this.progressLog.push(this.loadingMessage)
     const cardKeys = await this.consolidateTreeCards(jsonCards, parentKey)
     if (cardKeys.length > 0) {
       this.firestore.showSnackBar("AI reduced the number of cards to "+cardKeys.length+".")
       this.progressLog.push("AI reduced the number of cards to "+cardKeys.length+".")

       //TUTAJ WSTAWIC AUTOMATYCZNY RESEARCH MOŻĘ!!!
       const dialogRef2 = this.dialog.open(ConfirmingDialogComponent, {
         data: {"content": "Do you want to automatically refine and deepen the ideas generated by AI? This may take up to few minutes.", "onlyCloseButton": false, "title": "Refine ideas"}
       })
       dialogRef2.afterClosed().subscribe(async (result: any) => {
         if (result) {
           this.loadingMessage = "Please wait, refining ideas..."
           this.progressLog.push(this.loadingMessage)
           const refinedCards = await this.refineTreeCards(cardKeys)
           this.progressLog.push("Refined "+refinedCards+" ideas.")
         }
 
         let lastCardKey = this.treeCards.find(c => c.cardType == this.selectedTreeCardType && c.parentKey == parentKey)?.key
         if (lastCardKey) {
           await this.moveLastCard(lastCardKey, parentKey)
         }
       })
     } else {
       this.firestore.showSnackBar("AI didn't find any duplicate ideas to consolidate.")
       this.progressLog.push("AI didn't find any duplicate ideas to consolidate.")
       const parentSolutionType = this.treeCards.find(c => c.key == parentKey)?.solutionType || ""
       const cardKeys = await this.generateSetOfCards(jsonCards, middleX, y, cardDirection, shape, color, parentKey)
       const lastCardKey = cardKeys[cardKeys.length - 1] || ""
       this.loadingMessage = "Please wait, adding cards to canvas...<br/>Step "+step+" of "+elementContentArray.length
       this.progressLog.push("Added "+generatedCards+" cards to canvas...")
       await this.moveLastCard(lastCardKey, parentKey)
     }

    }
    this.isListening = true
    this.isLoadingLabelVisible = false
    this.loadingMessage = this.standardLoadingMessage
    this.isCanvasVisible = true
    this.progressLog.length = 0
  }

  checkNewDocs(aiUtilizedContentKeys: string[], selectedContentKeys: string[]) {
    const newDocs = selectedContentKeys.filter(c => !aiUtilizedContentKeys.includes(c))
    return newDocs.length > 0
  }

  async moveLastCard(lastCardKey: string, parentKey: string) {
    const card = this.layer.findOne('#' + lastCardKey)
    const minScale = 1;
    if (card) {
        let scale = this.stage.scaleX();
        if (scale < minScale) scale = minScale;
        const cardRect = card.getClientRect({relativeTo: this.layer});
        const cardCenterX = cardRect.x + cardRect.width / 2;
        const cardCenterY = cardRect.y + cardRect.height / 2;
        const containerWidth = this.stage.width();
        const containerHeight = this.stage.height();
        const newX = -(cardCenterX * scale) + containerWidth / 2;
        const newY = -(cardCenterY * scale) + containerHeight / 2;
        this.moveToPosition(newX, newY, scale);
    }
    await this.firestore.updateTreeSelectedContentKeys(this.organizationKey, this.canvasKey, this.userId, parentKey, this.selectedContent.map(c => c.key))
  }

  async refineTreeCards(cardKeys: string[]) {
    this.isLoadingLabelVisible = true
    this.isCanvasVisible = false
    this.loadingTitle = "Refining ideas..."
    this.loadingMessage = "Please wait, refining ideas..."
    this.progressLog.push(this.loadingMessage)
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    const cards = this.treeCards.filter(c => cardKeys.includes(c.key))
    if (cards.length > 0) {
      let promiseArray: any[] = []
      const promptLanguage = await this.research.detectLanguage(cards[0].content, this.organizationKey, this.projectKey, this.userId, this.llmLimit)
      let index = 0
      for (const card of cards) {
      //  await new Promise(resolve => setTimeout(resolve, 200))
        const refinementPrompt = this.research.componentDefinitionPrompts.find(prompt => prompt.componentType == card.cardType)?.refinementPrompt || ""
        promiseArray.push(this.refineContent(card.content, card.cardType,  this.llmLimit, modelKey, index, refinementPrompt, promptLanguage))
        index++
      }
      const refinedCards = await Promise.all(promiseArray) // wait for all refined content to be generated
      refinedCards.sort((a, b) => a.index - b.index)
      for (let index = 0; index < refinedCards.length; index++) {
        const refinedCard = refinedCards[index];
   //   refinedCards.forEach(async (refinedCard: any, index: number) => {
        if (refinedCard) {
          this.loadingMessage = "Updating: "+refinedCard.title
          this.progressLog.push(this.loadingMessage)
          let content = "<h1>" + refinedCard.title + "</h1>" + cards[index].content + "<br/><br/><br/><br/>" + refinedCard.responseText
          let sources = ""
          if (refinedCard.sources.length > 0) {
            sources += "<ul>"
            refinedCard.sources.forEach((source: any) => {
              sources += "<li><a href='"+source.web.uri+"' target='_blank'>"+source.web.title+"</a></li>"
            })
            sources += "</ul>"
            content += "<h3>References</h3>"+sources 
          }
          await cards[index].card.updateName(content)
          const i = this.treeCards.findIndex(c => c.key == cards[index].key)
          if (index != -1) {
            this.treeCards[i].content = content
            const cardKey = this.treeCards[i].key
            const parentKey = this.treeCards[i].parentKey
            this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, parentKey, cardKey, content, "refine", "")
            if (cards[index].cardType == "Solution") {
              this.treeCards[i].solutionType = await this.detectSolutionType(content, cardKey)
            }
          }
          //await new Promise(resolve => setTimeout(resolve, 200)) // jak tego nie dam, to czasem nie generuje okładki karty i wyśweitla błąd 403
        }
      }//)
    }

    await this.saveTreeCards()
    this.isLoadingLabelVisible = false
    this.isCanvasVisible = true
    this.loadingTitle = this.standardLoadingMessage
    this.stage.batchDraw()
  }

  async refineContent(content: string, cardType: string, llmLimit: number, modelKey: string, index: number, refinementPrompt: string = "", promptLanguage: string = "") {
    const refinedContent = await this.research.refineContent(content, cardType, this.organizationKey, this.projectKey, this.userId, llmLimit, modelKey, refinementPrompt, promptLanguage)
    return refinedContent
  }

  async exportToCSV(treeCards: any[]) {
   // await this.uploadResearchReportPDF([], this.researchReport, this.researchReport.companyName, this.researchReport.title)

    if (treeCards.length == 0) {
      this.firestore.showSnackBar("No cards to export.")
      return
    }

    function escapeCSV(val: string): string {
      if (val == null) return "";
      val = val.toString();
      val = val.replace(/"/g, '""');
      if (val.includes(';') || val.includes('\n') || val.includes('\r')) {
        val = `"${val}"`;
      }
      return val;
    }
  
    const header = ['Content', 'CardType', 'Status', 'Tag', 'Priority', 'Card Key', 'Parent card Key'];
  
    const csvContent = [
      header.join(';'),
      ...treeCards.map(card =>
        [
          escapeCSV(card.content),
          escapeCSV(card.cardType),
          escapeCSV(card.status),
          escapeCSV(card.tag),
          escapeCSV(card.priority),
          escapeCSV(card.key),
          escapeCSV(card.parentKey)
        ].join(';')
      )
    ].join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
  
    // Use download instead of window.open
    const a = document.createElement('a');
    a.href = url;

    a.download = this.fileName+'.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  
    this.firestore.showSnackBar("CSV file with OST cards was exported to your browser.");
  }

  async generateSetOfCards(j: any, middleX: number, y: number, cardDirection: string, shape: Konva.Node, color: string, parentKey: string) {
    let lastCardKey = ""
    let cardKeys: string[] = []
    try {
      const jsonObject = j
      const numberOfCards = jsonObject.length
      const rowWidth = (this.treeCardWidth+this.treeCardMargin)*numberOfCards + (this.treeCardWidth - this.treeCardWidth/1.5)/2
      const x = middleX - rowWidth/2
      let i = 0
      for (const r of jsonObject) {
        let c: string = this.search.jsonToText(r)
        const c2 = r.content
        if (c2 != undefined) { // if content is defined, use it instead of the description
          c = c2
        }
        let xCard = x + i*(this.treeCardWidth+this.treeCardMargin)
        let yCard = y //+this.treeCardMargin
        if (cardDirection == "vertical") {
          xCard = shape.x() - shape.width()/2 - this.treeCardMargin
          yCard = y + i*(this.treeCardHeight+this.treeCardMargin)
        }
        lastCardKey = await this.addOSTCard(xCard, yCard, c, color, "AI", parentKey, this.placeholderRowSide, true, "AI", i, 0)
        this.progressLog.push("Generating OST card: "+c.slice(0, 30) + "...")
        cardKeys.push(lastCardKey)
        i++
      }
   //   })
    } catch (error) {
      const numberOfCards = 1
      const rowWidth = (this.treeCardWidth+this.treeCardMargin)*numberOfCards + (this.treeCardWidth - this.treeCardWidth/1.5)/2
      const x = middleX - rowWidth/2
      let xCard = x + (this.treeCardWidth+this.treeCardMargin)
      let yCard = y //+this.treeCardMargin
      if (cardDirection == "vertical") {
        xCard = shape.x() - shape.width()/2 - this.treeCardMargin
        yCard = y + (this.treeCardHeight+this.treeCardMargin)
      }
      let content = JSON.stringify(j)
      const order = this.treeCards.length
      lastCardKey = await this.addOSTCard(xCard, yCard, content, color, "AI", parentKey, this.placeholderRowSide, true, "AI", order, 0)
      const card = this.treeCards.find(c => c.key == lastCardKey)
      this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, parentKey, lastCardKey, content, "add", "accepted")
      if (card && card.cardType == "Solution") {
        await this.detectSolutionType(content, lastCardKey)
      }
      this.progressLog.push("Generating OST card: "+content.slice(0, 30) + "...")
      this.firestore.showSnackBar("Error generating Opportunity Solution Tree. Try again, please.")
    }
    await this.saveTreeCards()
    return cardKeys
  }

  async getDocumentOntology(documentKey: string, minLevel: number = 2) {
    const ontology = await this.firestore.getOntology(this.organizationKey, documentKey)
    if (ontology && ontology.length > 0) {
      const filteredOntology = ontology.filter((item: any) => item.iteration >= minLevel) // take last two iterations in ontology creating process
      const content = JSON.stringify(filteredOntology)
      return content
    } else {
      return ""
    }
  }

  async getSelectedContent(minLength: number = 1000, maxLength: number = 100000, useFullContent: boolean = true) {
    let promiseArray: any[] = [];
    let responseArray: string[] = [];
    let content = "";
    for (let post of this.selectedContent) {
      if (post.contentType === "post") {
        // 1. Handle regular 'post' content
        promiseArray.push(this.firestore.getContent(this.organizationKey, post.key));
      } else if (post.contentType.toLowerCase() === "document") {
        if (useFullContent === false) {
          // 2. Handle 'document' with conditional loading: Ontology FIRST, then Full Content
          
          // Use an immediately invoked async function to handle the promise logic
          promiseArray.push((async () => {
            // --- ATTEMPT 1: Get Ontology ---
            // 'content' will be the string content of the ontology (or an empty string if not found/empty)
            const ontologyContent: string = await this.getDocumentOntology(post.key); 
            if (ontologyContent && ontologyContent.length > 20) {
              // If ontology exists and has content, return it.
              return ontologyContent;
            } else {
              // --- ATTEMPT 2: Get Full Document Content ---
              const documentContent = await this.firestore.getDocumentContent(this.organizationKey, post.key);
              // Assuming getDocumentContent returns an object like { textContent: string }
              if (documentContent && documentContent.textContent && documentContent.textContent.length > 0) {
                return documentContent.textContent;
              } else {
                // Fallback if neither exists
                return "";
              }
            }
          })()); // <-- The result of this entire async block is pushed to the promiseArray
        } else {
          // 3. Handle 'document' when full content is explicitly requested (useFullContent == true)
          promiseArray.push(this.firestore.getDocumentContent(this.organizationKey, post.key));
        }
      }
    }

    const contentArray = await Promise.all(promiseArray);


    // Helper function to split long content on suitable boundaries
    function splitSmart(text: string, maxLen: number, minLen: number): string[] {
      let res: string[] = [];
      while (text.length > maxLen) {
        // Try splitting by \n, then by markdown headlines (\n#), then by **
        let idx = -1;
    
        // Try to split at the last newline within maxLen
        idx = text.lastIndexOf('\n', maxLen);
        // If not found, try special markdown split points within maxLen
        if (idx < 0) {
          let headlines = ['\n###', '\n##', '\n#', '**'];
          for (let marker of headlines) {
            let tempIdx = text.lastIndexOf(marker, maxLen);
            if (tempIdx > idx) idx = tempIdx;
          }
        }
        // Fallback: just split at maxLen
        if (idx < 0 || idx < maxLen * 0.3) idx = maxLen; // avoid splitting too early
    
        res.push(text.slice(0, idx).trim());
        text = text.slice(idx);
      }
      if (text.trim() !== '') {
        res.push(text.trim());
      }
    
      // Combine last part with previous if shorter than minLen
      if (res.length >= 2 && res[res.length - 1].length < minLen) {
        res[res.length - 2] += "\n" + res[res.length - 1];
        res.pop();
      }
      return res;
    }
  
    contentArray.forEach((c: any) => {
      let unitContent = (c.name || c || "") + "\n" + (c.textContent || "") + "\n\n\n";
      // If the unit itself is longer, split it smartly
      if (unitContent.length > maxLength) {
        let parts = splitSmart(unitContent, maxLength, minLength);
        for (let p of parts) {
          if (content.length + p.length > maxLength) {
            if (content.length > 0) responseArray.push(content);
            content = "";
          }
          if (p.length > maxLength) {
            // if part is STILL too large (no split points), just chunk it
            for (let i = 0; i < p.length; i += maxLength) {
              responseArray.push(p.slice(i, i + maxLength));
            }
            content = "";
          } else {
            content += p;
          }
        }
      } else {
        content += unitContent;
      }
  
      if (content.length > maxLength) {
        responseArray.push(content);
        content = "";
      }
    });
  
    if (content.length > 0) {
      responseArray.push(content);
    }

    return responseArray;
  }

  async loadOSTCard(cardContent: any, cardKey: string, x: number, y: number, width: number, height: number, content: string, color: string, status: string, parentKey: string, rowSide: string = "left", doAddButtons: boolean, tag: string, priority: number, cardType: string, contentKey: string, horizontalSpace: number, kidCardKeys: string[], borderColor: string, isKanbanTask: boolean, isKnowledgeBaseItem: boolean, emoticonsString: string, commentsCount: number, nameImageURL: string, order: number, startDate: string, endDate: string, percentProgress: number, solutionType: string) { // create new card from loaded data
    const isReadOnly = this.isAnonymous == true && (this.canvasPermissions.canAnonymousAddCards == false || this.canvasPermissions.canAnonymousEditCards == false)
    const kidCardTypes = this.getKidCardTypes(cardType)
      if (cardType == "Outcome") { // root card
       const content = cardContent
        const card = new OutcomeCard(this.canvasKey, cardKey, contentKey, content.name, x, y, width, height, 0, [],(message: string, contentKey: string, cardKey: string) => this.onTreeCardClick(message, contentKey, cardKey), (card: Konva.Group) => this.startDraggTreeCard(card, cardKey), (cardKey: string, isCollapsed: boolean) => this.onCollapseClick(cardKey, isCollapsed), isReadOnly)
        this.layer.add(await card.createCard(false, commentsCount, emoticonsString, nameImageURL))
        card.setStatus(status)
        const leftPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, "Opportunity", [], "left")
        leftPlaceholder.rotatePlaceholder(true)
        const rightPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, "Opportunity", [], "right")
        rightPlaceholder.rotatePlaceholder(true)
        this.treeCards.push({key: cardKey, card: card, leftPlaceholder: leftPlaceholder, rightPlaceholder: rightPlaceholder, parentKey: parentKey, kidCardKeys: kidCardKeys, cardType: "Outcome", horizontalSpace: horizontalSpace, content: content.name, topBorderColor: "black", status: status, rowSide: rowSide, doAddButtons: doAddButtons, tag: tag, priority: priority, contentKey: contentKey, isKanbanTask: false, isKnowledgeBaseItem: false, treeLevel: 0, order: order, kidCardTypes: kidCardTypes, startDate: startDate, endDate: endDate, percentProgress: percentProgress, solutionType: ""})
        this.treeRootKey = cardKey
      } else { // other card types then Outcome
        const kidType = this.getChildCardType(cardType)
        const card = new OpportunityCard(this.organizationKey, this.canvasKey, cardKey, contentKey, cardType, content, x, y, width, height, color, tag, "", priority, [],  (message: string, contentKey: string, cardKey: string) => this.onTreeCardClick(message, contentKey, cardKey), doAddButtons, status, (card: Konva.Group) => this.startDraggTreeCard(card, cardKey), (cardKey: string, isCollapsed: boolean) => this.onCollapseClick(cardKey, isCollapsed), (organizationKey: string, canvasKey: string, cardKey: string, nameImageURL: string) => this.onNameImageUpdated(organizationKey, canvasKey, cardKey, nameImageURL), isReadOnly, this.isAnonymous == false || this.canvasPermissions.canAnonymousLaunchAI == true, this.isAnonymous == false || this.canvasPermissions.canAnonymousDeleteCards == true)
        card.isKanbanTask = isKanbanTask
        card.isKnowledgeBaseItem = isKnowledgeBaseItem
        card.startDate = startDate
        card.endDate = endDate
        card.percentProgress = percentProgress
        card.solutionType = solutionType
        this.layer.add(await card.createCard(false, commentsCount, emoticonsString, nameImageURL))
      /*  if ((isKanbanTask == true || isKnowledgeBaseItem == true) && cardContent) { // TO PRAWDOPODOBNIE BYŁ POTRZEBNE PO TO, ŻE GDY DANY CONTENT JEST AKTUALIZOWANY NA KANBAN LUB W BAZIE WIEDZY, TO TRZEBA ODSWIEŻYĆ JEGO KARTĘ NA DRZEWIE
          card.convertToTask(contentKey)
          const content = cardContent.content || ""
          await card.updateName(content.name)
        }*/
        card.setStatus(status)
        const leftPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, kidType, [], "left") // to hest troche na pałę, bo trzeba jakoś pobierać cardKey parenta
        leftPlaceholder.rotatePlaceholder(true)
        const rightPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, kidType, [], "right") // to hest troche na pałę, bo trzeba jakoś pobierać cardKey parenta
        rightPlaceholder.rotatePlaceholder(true)
        const level = this.getCardLevel(cardType)
        this.treeCards.push({key: cardKey, card: card, leftPlaceholder: leftPlaceholder, rightPlaceholder: rightPlaceholder, parentKey: parentKey, kidCardKeys: kidCardKeys, cardType: cardType, horizontalSpace: horizontalSpace, content: content, topBorderColor: borderColor, status: status, rowSide: rowSide, doAddButtons: doAddButtons, tag: tag, priority: priority, contentKey: contentKey, isKanbanTask: isKanbanTask, isKnowledgeBaseItem: isKnowledgeBaseItem, treeLevel: level, order: order, kidCardTypes: kidCardTypes, startDate: startDate, endDate: endDate, percentProgress: percentProgress, solutionType: card.solutionType}) // add card to tree
        if (parentKey != "") { // add card key to parent card kids
          const parentCard = this.treeCards.find(c => c.key == parentKey)
          if (parentCard && !parentCard.kidCardKeys.includes(cardKey)) {
            if (rowSide == "right") {
              parentCard.kidCardKeys.push(cardKey)
            } else {
              parentCard.kidCardKeys.unshift(cardKey)
            }
            parentCard.leftPlaceholder.updateKids(parentCard.kidCardKeys)
            parentCard.rightPlaceholder.updateKids(parentCard.kidCardKeys)
          }
        }
        const parentCard = this.treeCards.find(c => c.key == parentKey)
        if (parentCard) {
          parentCard.card.updateKids(parentCard.kidCardKeys)
          parentCard.card.updateCollapseIcon(false)
        }
      }
  return cardKey
}

async handleConvertedOSTCardToTask(event: { cardKey: string; contentType: string }) {
  const { cardKey, contentType } = event;
  // Now you have the two string variables for any further calls
  await this.convertOSTCardToTask(cardKey, contentType); 
}

getTemplateIndex(templateKey: string) {
  for (let i = 0; i < this.templates.length; i++) {
    if (this.templates[i].key == templateKey) {
      return i
    }
  }
  return -1
}

  async convertOSTCardToTask(cardKey: string, contentType: string) {
    if (cardKey == "") {
      cardKey = this.selectedShapeKey
    }
    const card = this.treeCards.find(c => c.key == cardKey)
    const cardType = card?.cardType
    if (card) {
      let contentKey = ""
      if (contentType == "post") {
        const selectedTemplate = this.templates.filter(t => t.type == contentType && t.name.toLowerCase() == cardType?.toLowerCase())[0] // extract template for this card type based on tree card type
        let templateKey = this.templates[0].key // by default use first template 
        if (selectedTemplate) { // but if there is a template for this card type, use it
          templateKey = selectedTemplate.key
        }
        card.isKanbanTask = false
        card.isKnowledgeBaseItem = true
        card.startDate = ""
        card.endDate = ""
        card.percentProgress = 0
         contentKey = await this.addNewPost(false, card.content, false, contentType, "", false, templateKey)
         card.card.convertToKnowledgeBaseItem(contentKey, true)
        } else if (contentType == "workpackage") {
          const selectedTemplate = this.templates.filter(t => t.type == contentType && t.name.toLowerCase() == cardType?.toLowerCase())[0] // extract template for this card type based on tree card type
          let templateKey = this.templates[0].key // by default use first template 
          if (selectedTemplate) { // but if there is a template for this card type, use it
            templateKey = selectedTemplate.key
          }
          card.isKanbanTask = true
          card.isKnowledgeBaseItem = false
          card.startDate = ""
          card.endDate = ""
          card.percentProgress = 0
          contentKey = await this.addNewPost(false, card.content, false, contentType, "", false, templateKey)
          card.card.convertToTask(contentKey, true, card.startDate, card.endDate, card.percentProgress)
        }
        card.card.contentKey = contentKey
        const index = this.treeCards.findIndex(c => c.key == cardKey)
        if (index != -1) { // register that this card on OST tree is a kanban task
          if (contentType == "post") {
            this.treeCards[index].isKanbanTask = false
            this.treeCards[index].isKnowledgeBaseItem = true
            this.treeCards[index].startDate = ""
            this.treeCards[index].endDate = ""
            this.treeCards[index].percentProgress = 0
          } else if (contentType == "workpackage") {
            this.treeCards[index].isKanbanTask = true
            this.treeCards[index].isKnowledgeBaseItem = false
            this.treeCards[index].startDate = ""
            this.treeCards[index].endDate = ""
            this.treeCards[index].percentProgress = 0
          }
          this.treeCards[index].contentKey = contentKey
      //   this.treeCards[index].key = "workpackage-"+contentKey // tu trzeba zmienić też atrybuty w sameym obiekcie card
        }
        this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, card.parentKey, cardKey, card.content, "convert_to_task", "")
        await this.saveTreeCards()
    }
    if (contentType == "post") {
      this.firestore.showSnackBar("The card has been added to the knowledge base. You can now edit it.")
    } else if (contentType == "workpackage") {
      this.firestore.showSnackBar("The card has been added to the kanban. You can now edit it.")
    }
    this.hideContextMenus()
    this.isEditCardNamePopupVisible = false
  }

  getCardLevel(cardType: string) {
    let level = 0
    if (cardType == "Opportunity") {
      level = 1
    } else if (cardType == "Solution") {
      level = 2
    } else if (cardType == "Experiment") {
      level = 3
    } else if (cardType == "Task") {
      level = 4
    }
    return level
  }

  onTreeCardIsUpdated(treeCards: any[]) {
    this.treeCards = treeCards
    this.saveTreeCards()
  }

  getKidCardTypes(cardType: string) { // this defines structure of tree
    let kidCardTypes: string[] = []
    if (cardType == "Outcome") {
      kidCardTypes = ["Opportunity"]
    } else if (cardType == "Opportunity") {
      kidCardTypes = ["Solution", "Task"]
    } else if (cardType == "Solution") {
      kidCardTypes = ["Experiment", "Task"]
    } else if (cardType == "Experiment") {
      kidCardTypes = ["Task"]
    } else if (cardType == "Task") {
      kidCardTypes = ["Task"]
    }
    return kidCardTypes
  }

  async addOSTCard(x: number, y: number, content: string, color: string, status: string, parentKey: string, rowSide: string, doAddButtons: boolean, tag: string, order: number, priority: number) { // add  card
    const isReadOnly = this.isAnonymous == true && (this.canvasPermissions.canAnonymousAddCards == false || this.canvasPermissions.canAnonymousEditCards == false)
    let switchListeningInFunction = true
    if (this.isListening == false) { // if islistening was set to off outside, do not change it here
      switchListeningInFunction = false
    }
    let kidCardTypes = this.getKidCardTypes(this.selectedTreeCardType)
    this.isListening = false
      const cardKey = this.firestore.generateUID()
      y += this.treeCardHeight*1.5+this.treeCardMargin
      const kidType = this.getChildCardType(this.selectedTreeCardType)
      const type = this.selectedTreeCardType
      if (type == "Solution") {
        this.firestore.updateOrganizationContentCount(this.organizationKey, this.projectKey, "solution", 1)
      } else if (type == "Opportunity") {
        this.firestore.updateOrganizationContentCount(this.organizationKey, this.projectKey, "opportunity", 1)
      }
      const contentKey = "" // we don't add this to knowledge base yet
      const card = new OpportunityCard(this.organizationKey, this.canvasKey, cardKey, contentKey, this.selectedTreeCardType, content, x, y, this.treeCardWidth, this.treeCardHeight*1.5, color, tag, "", priority, [], (message: string, contentKey: string, cardKey: string) => this.onTreeCardClick(message, contentKey, cardKey), doAddButtons, status, (card: Konva.Group) => this.startDraggTreeCard(card, cardKey), (cardKey: string, isCollapsed: boolean) => this.onCollapseClick(cardKey, isCollapsed),(organizationKey: string, canvasKey: string, cardKey: string, nameImageURL: string) => this.onNameImageUpdated(organizationKey, canvasKey, cardKey, nameImageURL), isReadOnly, this.isAnonymous == false || this.canvasPermissions.canAnonymousLaunchAI == true, this.isAnonymous == false || this.canvasPermissions.canAnonymousDeleteCards == true)
      this.layer.add(await card.createCard(false, 0, "", ""))
      const borderColor = card.topBorderColor
      const leftPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, kidType, [], "left") // addding add placeholders located below new card to hest troche na pałę, bo trzeba jakoś pobierać cardKey parenta
      const rightPlaceholder = this.createNewItemPlaceholder("", cardKey, "Add", x, y, this.treeCardWidth, this.treeCardHeight*1.5, kidType, [], "right") // to hest troche na pałę, bo trzeba jakoś pobierać cardKey parenta
      const level = this.getCardLevel(kidType)
      this.treeCards.push({key: cardKey, card: card, leftPlaceholder: leftPlaceholder, rightPlaceholder: rightPlaceholder, parentKey: parentKey, kidCardKeys: [], cardType: this.selectedTreeCardType, horizontalSpace: this.treeCardWidth, content: content, topBorderColor: borderColor, status: status, rowSide: rowSide, doAddButtons: doAddButtons, tag: tag, priority: priority, contentKey: contentKey, isKanbanTask: false, isKnowledgeBaseItem: false, treeLevel: level, order: order, kidCardTypes: kidCardTypes, startDate: "", endDate: "", percentProgress: 0, solutionType: ""}) // add card to tree
      if (parentKey != "") { // add card key to parent card kids
        const parentCard = this.treeCards.find(c => c.key == parentKey)
        if (parentCard && !parentCard.kidCardKeys.includes(cardKey)) {
          if (rowSide == "right") {
            parentCard.kidCardKeys.push(cardKey)
          } else {
            parentCard.kidCardKeys.unshift(cardKey)
          }
          parentCard.leftPlaceholder.updateKids(parentCard.kidCardKeys)
          parentCard.leftPlaceholder.rotatePlaceholder(true) // when placeholder is displaed on sides of kid card, it must be rotated
          parentCard.rightPlaceholder.updateKids(parentCard.kidCardKeys)
          parentCard.rightPlaceholder.rotatePlaceholder(true)
          parentCard.card.updateKids(parentCard.kidCardKeys)
          parentCard.card.updateCollapseIcon(false)
          const grandParentCard = this.treeCards.find(c => c.key == parentCard?.parentKey)
          let hasCousins = false
          let uncleCards: any[] = []
          if (parentCard && grandParentCard) {
            grandParentCard?.kidCardKeys.forEach((k: string) => {
              const uncleCard = this.treeCards.find(c => c.key == k)
              if (uncleCard) {
                if (uncleCard.kidCardKeys.length > 0 && uncleCard.key != parentCard.key) {
                  hasCousins = true
                  uncleCards.push(uncleCard)
                }
              }
            })
            if (parentCard.kidCardKeys.length > 0 && uncleCards.length > 0 && hasCousins) {
              parentCard.leftPlaceholder.rotatePlaceholder(true)
              parentCard.rightPlaceholder.rotatePlaceholder(true)
              uncleCards.forEach((u: any) => {
                u.leftPlaceholder.rotatePlaceholder(true)
                u.rightPlaceholder.rotatePlaceholder(true)
              })
            }
          }
        }
      }

      if (type == "Solution") {
        await this.detectSolutionType(content, cardKey)
      }

    this.refreshOSTTree()
    await this.saveTreeCards()
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
    return cardKey
  }

  setTreeCardPriority(priority: number) {
    this.treeCardPriority = priority

    const card = this.treeCards.find(c => c.key == this.selectedShapeKey)?.card
    if (card) {
      card.setPriority(priority)
      this.saveTreeCards()
      card.createNameImage(card.name, card.commentsCount, card.emoticonsString, true, card.startDate, card.endDate, card.percentProgress)
    }

  }

  removeTreeCards() {
    this.connectors.forEach((c: any) => {
      this.deleteConnectedArrows(this.findConnectedArrows(c.from))
    })
    this.treeCards.forEach((c: any) => {
      c.card.card.destroy()
      if (this.isAnonymous == false || this.canvasPermissions.canAnonymousAddCards == true) {
        c.leftPlaceholder.card.destroy()
        c.rightPlaceholder.card.destroy()
      }
    })
    
    this.treeCards.length = 0
  }

  rearrangeTreeCards() {
    this.countHorizontalSpace(this.treeRootKey, this.treeCardWidth+this.treeCardMargin)
    this.rearrangeTreeCardsByCard(this.treeRootKey, 100)
  }

  redrawOSTConnectors() {
    const shapesStartingWithArrow = this.layer.getChildren((node: any) =>
      node.id() && node.id().startsWith("arrow")
    );
    shapesStartingWithArrow.forEach((a: any) => {
      a.destroy()
    })

    this.treeCards.forEach((c: any) => {
        for (let i = 0; i < c.kidCardKeys.length; i++) {
          const kidCardKey = c.kidCardKeys[i]
          const kidCard = this.treeCards.find(c => c.key == kidCardKey)
          if (kidCard && kidCard.card.isHidden == false && c.card.isHidden == false) {
            this.drawConnector(c.key, kidCard.key, "broken", "dashed", "#d5dbe2", "fromBottomToTop")
          }
        }
    })
  }

  removeAddPlaceholders() {
    this.treeCards.forEach((c: any) => {
      if (c.leftPlaceholder.card) {
        c.leftPlaceholder.card.remove()
      }
      if (c.rightPlaceholder.card) {
        c.rightPlaceholder.card.remove()
      }
    })
  }

  addAddPlaceholders() {
    this.treeCards.forEach((c: any) => {
      if (c.card.isHidden == false) {
        const wisibleKids = c.kidCardKeys.filter((k: string) => this.treeCards.find(c => c.key == k)?.card.isHidden == false)
        const kids = c.kidCardKeys
        if (wisibleKids.length > 0 || kids.length == 0) {
          if (c.leftPlaceholder.card) {
          this.layer.add(c.leftPlaceholder.card)
          }
          if (c.rightPlaceholder.card) {
            this.layer.add(c.rightPlaceholder.card)
          }
        }
      }
    })
  }

  addDropPlaceholders(cardKey: string) {
    const card = this.treeCards.find(c => c.key == cardKey)
    const parentCard = this.treeCards.find(c => c.key == card?.parentKey)
   // const grandParentCard = this.treeCards.find(c => c.key == parentCard?.parentKey)
    const parentCardType = parentCard?.cardType
    if (card && parentCard) {
      const siblingKeys = parentCard.kidCardKeys
      if (siblingKeys.length > 0) { // add drop placeholders for each sibling card
        siblingKeys.forEach((sibling: string) => {
          const siblingCard = this.treeCards.find(c => c.key == sibling)
          if (siblingCard && sibling != cardKey) {
            const placeholder: Konva.Group = new Konva.Group({
              x: siblingCard.card.card.x(),
              y: siblingCard.card.card.y(),
              width: this.treeCardWidth,
              height: this.treeCardHeight*1.5,
            })
            const rect = new Konva.Rect({
              x: 0,
              y: 0,
              width: this.treeCardWidth,
              height: this.treeCardHeight*1.5,
              fill: "white",
              stroke: "grey",
              dash: [2, 2],
              strokeWidth: 1,
              cornerRadius: 5
            })
            const text = new Konva.Text({
              x: 0,
              y: 0,
              width: this.treeCardWidth,
              height: this.treeCardHeight*1.5,
              text: "Drop here",
              fontSize: 12,
              fontFamily: "Arial",
              fill: "black",
              align: "center",
              verticalAlign: "middle"
            })
            placeholder.add(rect)
            placeholder.add(text)
            this.layer.add(placeholder)
            this.dropPlaceholders.push(placeholder)
            placeholder.on("mouseenter", () => {
              rect.fill("#f0f0f0")
              this.hoverDropPlaceholderKey = sibling
            })
            placeholder.on("mouseleave", () => {
              rect.fill("white")
              this.hoverDropPlaceholderKey = ""
            })
          }
        })
      } 
      const uncleKeys = this.treeCards.filter(c => c.cardType == parentCardType).map(c => c.key)
      if (uncleKeys.length > 0) {
        uncleKeys.forEach((uncle: string) => {
          const uncleCard = this.treeCards.find(c => c.key == uncle)
          if (uncleCard && uncle != parentCard.key) {
            const placeholder: Konva.Group = new Konva.Group({
              x: uncleCard.card.card.x(),
              y: uncleCard.card.card.y()+this.treeCardHeight*1.5+this.treeCardMargin,
              width: this.treeCardWidth,
              height: this.treeCardHeight*1.5,
            })
            const rect = new Konva.Rect({
              x: 0,
              y: 0,
              width: this.treeCardWidth,
              height: this.treeCardHeight*1.5,
              fill: "white",
              stroke: "grey",
              dash: [2, 2],
              strokeWidth: 1,
              cornerRadius: 5
            })
            const text = new Konva.Text({
              x: 0,
              y: 0,
              width: this.treeCardWidth,
              height: this.treeCardHeight*1.5,
              text: "Drop here",
              fontSize: 12,
              fontFamily: "Arial",
              fill: "black",
              align: "center",
              verticalAlign: "middle"
            })
            placeholder.add(rect)
            placeholder.add(text)
            this.layer.add(placeholder)
            this.dropPlaceholders.push(placeholder)
            placeholder.on("mouseenter", () => {
              rect.fill("#f0f0f0")
              this.hoverDropPlaceholderKey = uncle
            })
            placeholder.on("mouseleave", () => {
              rect.fill("white")
              this.hoverDropPlaceholderKey = ""
            })
          }
        })
      }
     /*  if (grandParentCard) {
        const uncles = grandParentCard.kidCardKeys
        if (uncles.length > 0) {
          uncles.forEach((uncle: string) => {
            const uncleCard = this.treeCards.find(c => c.key == uncle)
            if (uncleCard && uncle != parentCard.key) {
              const placeholder: Konva.Group = new Konva.Group({
                x: uncleCard.card.card.x(),
                y: uncleCard.card.card.y()+this.treeCardHeight*1.5+this.treeCardMargin,
                width: this.treeCardWidth,
                height: this.treeCardHeight*1.5,
              })
              const rect = new Konva.Rect({
                x: 0,
                y: 0,
                width: this.treeCardWidth,
                height: this.treeCardHeight*1.5,
                fill: "white",
                stroke: "grey",
                dash: [2, 2],
                strokeWidth: 1,
                cornerRadius: 5
              })
              const text = new Konva.Text({
                x: 0,
                y: 0,
                width: this.treeCardWidth,
                height: this.treeCardHeight*1.5,
                text: "Drop here",
                fontSize: 12,
                fontFamily: "Arial",
                fill: "black",
                align: "center",
                verticalAlign: "middle"
              })
              placeholder.add(rect)
              placeholder.add(text)
              this.layer.add(placeholder)
              this.dropPlaceholders.push(placeholder)
              placeholder.on("mouseenter", () => {
                rect.fill("#f0f0f0")
                this.hoverDropPlaceholderKey = uncle
              })
              placeholder.on("mouseleave", () => {
                rect.fill("white")
                this.hoverDropPlaceholderKey = ""
              })
            }
          })
        }
      }*/
    }
    
  }

  removeDropPlaceholders() {
    this.dropPlaceholders.forEach((p: Konva.Group) => {
      p.remove()
    })
    this.dropPlaceholders.length = 0
  }

  rearrangeTreeCardsByCard(parentKey: string, xOffset: number) {
    const parentCard = this.treeCards.find(c => c.key == parentKey)
    if (parentCard) {
      const kidCardKeys = parentCard.kidCardKeys
      let x = parentCard.horizontalSpace / 2 - this.treeCardWidth/2 //+ this.treeCardMargin/2
      parentCard.card.setX(x + xOffset)
     /* kidCardKeys.sort((a: string, b: string) => { // sort kidCardKeys by order
        const aCard = this.treeCards.find(c => c.key == a)
        const bCard = this.treeCards.find(c => c.key == b)
        if (aCard && bCard) {
          return aCard.order - bCard.order
        }
        return 0
      })*/
      kidCardKeys.forEach((k: string) => {
        const kidCard = this.treeCards.find(c => c.key == k)
        if (kidCard) {
          this.rearrangeTreeCardsByCard(k, xOffset)
          xOffset += kidCard.horizontalSpace + this.treeCardMargin
        }
      })
    }
  }

  countHorizontalSpace(cardKey: string, minSpace: number = 0) {
    let horizontalSpace = 0
    const card = this.treeCards.find(c => c.key == cardKey)
    if (card) {
      if (card.kidCardKeys.length > 0) {
        card.kidCardKeys.forEach((kidCardKey: string) => {
          horizontalSpace += this.countHorizontalSpace(kidCardKey, minSpace)
        })
        card.horizontalSpace = horizontalSpace - this.treeCardMargin
      } else {
        horizontalSpace = minSpace
      }
    } else {
      horizontalSpace = minSpace
    }
    return horizontalSpace
  }

  rearrangeAddPlaceholders() { // move add placeholders to the left and right of the row of cards
    this.treeCards.forEach((c: any) => {
      this.rearrangeAddPlaceholdersByCard(c.key)
    })
  }

  updateOSTCard(content: string, status: string, cardKey: string = "", priority: number = 0) { // update card
    const card = this.treeCards.find(c => c.key == cardKey)
    if (card) {
      card.content = content
      card.card.updateName(content)
      if (status != "") {
        card.card.setStatus(status)
      }
      card.card.setPriority(priority)
      //  card.card.updatePriorityStars()
      this.firestore.saveContentVersion(this.organizationKey, cardKey, this.userId, this.userName, content, card.parentKey, "ost card", "", content, [])
    }
    this.selectedShapeKey = ""
    this.isEditCardNamePopupVisible = false
    this.isPostPanelOpen = false
    this.selectedParentKey = ""
    this.selectedTreeCardType = ""
    this.manualAddTitle = ""
    this.manualAddContent = ""
    this.treeCardPriority = 0
    return cardKey
  }

  rearrangeAddPlaceholdersByCard(cardKey: string) { // move add placeholders to the left and right of the row of cards
    if (this.isAnonymous == false || this.canvasPermissions.canAnonymousAddCards == true) {
    const treeItem = this.treeCards.find(c => c.key == cardKey)
    if (treeItem) {
      const kidCardKeys = treeItem.kidCardKeys
      const placeholderWidth = treeItem.leftPlaceholder.card.width()
      if (kidCardKeys.length > 0) {
        const kidCards: any[] = []
        kidCardKeys.forEach((k: string) => {
          const kidCard = this.treeCards.find(c => c.key == k)
          if (kidCard) {
            kidCards.push(kidCard.card.card)
          }
        })
        const boundingRect = this.getBoundingRect(kidCards)
        if (boundingRect) {
          treeItem.leftPlaceholder.setX(boundingRect.x - placeholderWidth - this.treeCardMargin/2)
          treeItem.rightPlaceholder.setX(boundingRect.x + boundingRect.width + this.treeCardMargin/2)
          treeItem.leftPlaceholder.setY(boundingRect.y + boundingRect.height/2 - treeItem.leftPlaceholder.card.height()/2)
          treeItem.rightPlaceholder.setY(boundingRect.y + boundingRect.height/2 - treeItem.rightPlaceholder.card.height()/2)
          if (treeItem.leftPlaceholder.rotation != 0) { //addjust position if placeholder is rotated
            treeItem.leftPlaceholder.setX(treeItem.leftPlaceholder.card.x() + treeItem.leftPlaceholder.card.width() + 14)
          }
          if (treeItem.rightPlaceholder.rotation != 0) {
            treeItem.rightPlaceholder.setX(treeItem.rightPlaceholder.card.x() - 14)
          }
        }
      } else { // No kids to calculate boundingRect from
        const y = treeItem.card.y + treeItem.card.height + this.treeCardMargin/2
        treeItem.leftPlaceholder.setX(treeItem.card.x + (treeItem.card.width - placeholderWidth)/2)
        treeItem.leftPlaceholder.setY(y)
        treeItem.rightPlaceholder.setX(treeItem.card.x + (treeItem.card.width - placeholderWidth)/2)
        treeItem.rightPlaceholder.setY(y)
        treeItem.leftPlaceholder.card.rotation(0)
        treeItem.rightPlaceholder.card.rotation(0)
      }
    }
    }
  }

  getBoundingRect(shapes: any[]) {
    if (shapes.length === 0) return null;
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    shapes.forEach(shape => {
      const box = shape.getClientRect({ relativeTo: shape.getStage() });
      if (box.x < minX) minX = box.x;
      if (box.y < minY) minY = box.y;
      if (box.x + box.width > maxX) maxX = box.x + box.width;
      if (box.y + box.height > maxY) maxY = box.y + box.height;
    });

    return {
      x: minX,
      y: minY,
      width: maxX - minX,
      height: maxY - minY
    };
  }   

  async createOSTComponent(content: string, componentType: string, step: number, numberOfSteps: number, moePrompts: {name: string, prompt: string}[] = [], promptLanguage: string, isItTask: boolean) {
    this.hideContextMenus()
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    const card = this.treeCards.find(c => c.key == this.selectedShapeKey)
    const siblings = this.treeCards.filter(c => c.parentKey == this.selectedShapeKey)

    const siblingNames = siblings.map(c => c.card.name)
   // const theory = "The Opportunity Solution Tree (OST) is a visual framework designed to help product teams explore opportunities and ideate potential solutions systematically. It serves as a tool for product managers and teams to align on user needs and potential product solutions.\nKey Components of the Opportunity Solution Tree:\nOpportunities, Solutions, Experiments.\n\nStructure of the Tree:\nRoot: The main goal or objective of the product, representing what the team is trying to achieve.\nBranches: The opportunities identified, branching out from the root. Each branch can represent a different user need or problem.\nLeaves: The solutions and corresponding experiments attached to each opportunity branch.\n\n\n"
    let componentDefinition = ""
    if (componentType == 'Opportunity') {
      componentDefinition = "\n\n" + this.research.componentDefinitionPrompts.find(prompt => prompt.componentType == componentType)?.componentDefinition || "" + "\n\n"


    }
    if (componentType == 'Solution') {
      componentDefinition = "\n\n\nSolution definition within context of the Opportunity Solution Tree: specific, actionable idea that can be implemented to address the opportunity. Solutions should be concrete, measurable, and aligned with the opportunity. Solution is potential set of features, improvements, and product or service that if delivered will fill the gap in the opportunity and heal painpoint. Describe end state vision of working solution, and concept of executing it. Do not hallucinate, if there is no information, do not add any information. Also in brackets provide part of source text indictating a problem which this opportunity addresses. Example: Solution: Add a search bar to the product (source: 80% of customers reporting problem related to this solution)\n\n"
    }
    if (componentType == 'Experiment') {
      componentDefinition = "\n\n\nExperiment definition within context of the Opportunity Solution Tree: a method to test a hypothesis related to the solution. It is a small, focused envdevour that can be used for test to see if the solution addresses the opportunity. Experiment should validate main risks, uncertainties and assumptions of the solution. Explain target hypothesis of the experiment, what will be measured, and provide a plan of execution. Also in brackets provide  provide a risk, uncertaintity or assumption that the experiment will validate. Do not hallucinate, if there is no information, do not add any information. Example: Create a fake landing page for the product (Hypothesis: Customer will be interested in the product and will fill a contact form.)) \n\n"
    }
    if (componentType == 'Task') {

      if (isItTask == false) {
        componentDefinition = "\n\n\nTask definition within context of the Opportunity Solution Tree: a specific action or activity that can be taken to implement the solution or experiment. It is a small piece of effort that can be done by a single person or small team in a couple of days. Example: (Task: Create web design for landing page.) Prepare scope of tasks needed to conduct the experiment, it may be in the form of product backlog. All tasks should be related to the experiment, set of tasks should be complete and cover all aspects of the experiment. There shouldn't be contradictory or overlapping tasks. There should be no tasks that are not related to the experiment or solution.\n\n"
      } else {
        componentDefinition = "\n\n\nYou plan product backlog within context of the Opportunity Solution Tree. Each backlog component represents a user story, a feature or function of IT system defined from perspective of a user. Description of each component should include its purpose, expected outcome, and acceptance criteria in plain text. There shouldn't be contradictory or overlapping tasks. There should be no tasks that are not related to the experiment or solution. User story should follow template: As a <role in the system>, I want to <goal, feature description> so that <benefit from the feature or function>.\n\n"
      }
    }
    componentDefinition += "\n\n"
    componentDefinition += "Deliver only components directly related to the "+card?.cardType+": "+card?.content+"\n\n\n"
    const parent = this.treeCards.find(c => c.key == card?.parentKey)
    const parentContent = parent?.content
    const parentType = parent?.cardType
    if (parentContent) {
      const grandParent = this.treeCards.find(c => c.key == parent?.parentKey)
      const grandParentContent = grandParent?.content
      const grandParentType = grandParent?.cardType
      componentDefinition += "Related "+parentType+": "+parentContent+"\n\n\n"
      if (grandParentContent) {
        componentDefinition += "Related "+grandParentType+": "+grandParentContent+"\n\n\n"
      }
    }
    const prompt = "\n\nYou are an expert in product discovery analyzing provided insights. You are very detailed and specific in your analysis. You rely on provided data and never hallucinate. You provide answer to questions based on provided data and additional information about the context. You are given a text and you need to create one or more "+componentType+" as a part an Opportunity Solution Tree based on this description of: \n\n\nReturn only array of content of the "+componentType+", nothing else related to the "+card?.cardType+": "+card?.content+". "
    const promptSuffix = "\n\n\nReturn answer in "+promptLanguage+" language.\nReturn array in JSON format: [{content: <description of component>}, {content: <description of component>}, ...]"

    content = "\n\n\nSource content:\n"+content+"\n\n\n\n"
    const finalPrompt = componentDefinition+"\n\n"+prompt+promptSuffix+"\n\n\n"+content
    let output = ""
    let answerArray: any[] = []

    if (moePrompts.length > 0 && this.useMOE == true) { // mixture of experts is utilized
      let promiseArray: any[] = []
      this.loadingMessage = "Collecting ideas from team of experts...<br/>(refresh page if you want to interrupt thinking process)<br/>Step "+step+" of "+numberOfSteps
      for (let i = 0; i < moePrompts.length; i++) {
        const prompt = finalPrompt + "\n\n\n" + moePrompts[i].prompt
        promiseArray.push(this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, prompt, this.llmLimit, false, modelKey, 0.1))
        //let a = this.search.extractJsonFromString(answer)
        //answerArray = answerArray.concat(a)
      }
      const answers = await Promise.all(promiseArray)
      for (let i = 0; i < answers.length; i++) {
        const answer = answers[i]
        const a = this.search.extractJsonFromString(answer)
        answerArray = answerArray.concat(a)
      }
    } else { // single expert is utilized
      let answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, finalPrompt, this.llmLimit, false, modelKey, 0.1)
      if (answer.isError) {
       // this.llmGenerationErrorMessage = answer.errorType
       console.error("Error generating: "+answer.errorType)
      }
      answerArray = this.search.extractJsonFromString(answer.responseText)
    }

    let a = JSON.stringify(answerArray)
    if (siblingNames.length > 0 && this.canvasPermissions.isFastAIUsed == false) { // remove duplicates from answer
      const refinePrompt = "The list of items generated so far is like this:\n\n\n"+siblingNames.join(",\n\n")+"\n\n\n\nFrom the list of new items below remove duplicates that occur in the previous list of items: "+a+"\n\nRemove also items not related to the desired "+componentType+": "+parentContent+"\n\n\nReturn array in JSON format: [{content: string}, {content: string}, ...]"
      const refinedAnswer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, refinePrompt, this.llmLimit, false, modelKey, 0.1)
      a = refinedAnswer.responseText
    }
    try {
      a = a.replace(/\(/g, "\\n\\n("); // add new line before every item
    } catch (error) {
      console.error(error)
    }
    output = a
    this.firestore.showSnackBar("AI generated "+componentType)

    return output
  }

  async consolidateTreeCards(jsonCards: any, parentKey: string) { // reduce number of cards by consolidating similar ideas
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    this.isLoadingLabelVisible = true
    this.loadingMessage = "Please wait, reviewing and consolidating ideas...<br/>(refresh page if you want to interrupt thinking process)"
    this.loadingTitle = "AI is consolidating ideas..."
    let t: any[] = []
    jsonCards.forEach((c: any) => {
      t.push(c.content)
    })
    let cardKeys: string[] = []
    if (t.length > 0) {
      this.loadingMessage = "Please wait, reviewing and consolidating ideas...<br/>(refresh page if you want to interrupt thinking process)"
      let cardTitles = t.join(",\n\n")
      try {
        cardTitles = cardTitles.replace(/"/g, '\\"');
      } catch (error) {
        console.error(error)
      }
      const prompt = "You are very detailed and specific in your analysis. Analyze the following list of ideas and consolidate them if some of them are identical to each other, and remove duplicates from the list. Rephrase the combined idea to be concise and clear. If ideas are not overlapping each other, return them as is. Return only array of content of the ideas, nothing else.\n\nList of ideas:\n\n"
      const answer = await this.gemini.getGeminiResponseSimple(this.organizationKey, this.projectKey, this.userId, prompt+cardTitles+"\n\n\nReturn array in JSON format: [{content: string}, {content: string}, ...]", this.llmLimit, false, modelKey, 0)
      const answerArray = this.search.extractJsonFromString(answer.responseText)
   //   if (answerArray.length > 0 && answerArray.length < t.length) { // if there are fewer cards in the answer than in the original list, then delete the duplicate cards and replace them with the new cards
          this.treeCards.forEach((c: any) => {
            if ((c.status == "aiproposal" || c.status == undefined || c.status == "AI") && c.tag == "AI" && c.parentKey == parentKey) {
              this.deleteOSTCard(c.key)
            } 
          })

        const shape = this.layer.findOne('#' + parentKey)
        if (shape) {
          const middleX = shape.x() + shape.width()/2
          const y = shape.y() //+ shape.height() + this.treeCardMargin
          const cardDirection = "horizontal"
          const color = this.getColorForCardType(this.selectedTreeCardType)
          cardKeys = await this.generateSetOfCards(answerArray, middleX, y, cardDirection, shape, color, parentKey)
        }
   //   } else {
   //     this.firestore.showSnackBar("AI didn't find any similar ideas to consolidate.")
   //   }
  } else {
    this.firestore.showSnackBar("No AI cards to consolidate.")
  }
    this.isLoadingLabelVisible = false
    return cardKeys
  }
 
  showManualTreeComponentPopup(cardType: string) {
    this.selectedTreeCardType = cardType
    const shape = this.layer.findOne('#' + this.selectedShapeKey)
    if (this.isManualTreeComponentPopupVisible == false && shape) {
      setTimeout(() => {
        this.treeCardNameAddInput?.nativeElement.focus();
      }, 0);
      const pointerPosition = this.stage.getPointerPosition();
      const contextMenu = document.getElementById('manual-tree-component-popup')
      if (contextMenu) {
        const xOffset = this.getScreeenEdgeOffsetX(pointerPosition, 350)
        const yOffset = this.getScreeenEdgeOffsetY(pointerPosition, 500)
        contextMenu.style.left = pointerPosition.x - xOffset + 'px'
        contextMenu.style.top = pointerPosition.y + yOffset + 'px'
        contextMenu.style.width = '300px'
        contextMenu.style.border = 'border-top: 2px solid #0D0D0D;'
        this.isContextMenuTreeVisible = true
        this.availableKidCardTypes = this.treeCards.find(c => c.key == this.selectedShapeKey)?.kidCardTypes || []
      }
      this.isManualTreeComponentPopupVisible = true
      this.selectedParentKey = this.selectedShapeKey
      this.selectedShapeKey = ""
      this.isEditCardNamePopupVisible = false
      this.isPostPanelOpen = false
      this.manualAddContent = ""
      this.manualAddTitle = ""
      this.manualAddTitle = this.selectedTreeCardType
    }
  }

  showEditCardNamePopup() {
    if (this.isEditCardNamePopupVisible == false && this.selectedShapeKey != "") {
      this.isEditCardNamePopupVisible = true
      this.isRTFEditorClicked = false
      this.isPostPanelOpen = false
      setTimeout(() => {
        this.treeCardNameEditInput?.nativeElement.focus();
      }, 0);

      const pointerPosition = this.stage.getPointerPosition();
      const contextMenu = document.getElementById('manual-edit-tree-component-popup')
      if (contextMenu) {
        const xOffset = this.getScreeenEdgeOffsetX(pointerPosition, 500)
        let left = pointerPosition.x - xOffset - 250 
        if (left < 0) {
          left = 0
        }
        contextMenu.style.left = left + 'px'
        contextMenu.style.top = pointerPosition.y + 'px'
     //   contextMenu.style.width = '300px'
      }
      const treeCard = this.treeCards.find(c => c.key == this.selectedShapeKey)
      this.treeCardPriority = treeCard?.card.priority || 0
      this.selectedTreeCardType = treeCard?.cardType || ""
      this.manualAddTitle = this.selectedTreeCardType
      this.manualAddContent = treeCard?.card.name || ""
    }
  }

  getLeftPositionTreeCards(cardType: string) {
    console.time("getLeftPositionTreeCards")
    let x = 0
    let y = 0
    this.treeCards.forEach((c: any) => {
      if (c.card.cardType == cardType && x < c.card.x() + c.card.width() + this.treeCardMargin) {
        x = c.card.x() + c.card.width() + this.treeCardMargin
        y = c.card.y()
      }
    })
    console.timeEnd("getLeftPositionTreeCards")
    return {x: x, y: y}
  }

  getColorForCardType(cardType: string) {
    if (cardType == "Outcome") {
      return "blue"
    } else if (cardType == "Opportunity") {
      return "green"
    } else if (cardType == "Solution") {
      return "yellow"
    } else if (cardType == "Experiment") {
      return "orange"
    } else {
      return ""
    }
  }

  async onManualAddTitleKeyUp() { // add card manually
    const content = this.manualAddContent
    const shape = this.layer.findOne('#' + this.selectedParentKey)
    if (shape) {
      const middleX = shape.x()
      const y = shape.y() //+ shape.height() + this.treeCardMargin
      const color = this.getColorForCardType(this.selectedTreeCardType)
      this.isLoadingLabelVisible = true
      this.loadingMessage = "Please wait while adding card..."
      this.loadingTitle = "Adding card..."
      this.closeTreeComponentSlidePanel()
      const cardKey = await this.addOSTCard(middleX, y, content, color, "accepted", this.selectedParentKey, this.placeholderRowSide, false, "", this.treeCards.length, this.treeCardPriority)
      this.firestore.showSnackBar("Card added successfully.")
      this.selectedParentKey = ""
      this.isLoadingLabelVisible = false
    }
  }

  async onManualEditTitleKeyUp() {
    const shape = this.layer.findOne('#' + this.selectedShapeKey)
    if (shape) {
      const card = this.treeCards.find(c => c.key == this.selectedShapeKey)
      if (card && card.cardType == "Solution") {
        await this.detectSolutionType(this.manualAddContent, this.selectedShapeKey)
      }
      this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, "", this.selectedShapeKey, this.manualAddContent, "update_content", "")
      await this.updateOSTCard(this.manualAddContent, "", this.selectedShapeKey, this.treeCardPriority)
      this.selectedParentKey = ""
      await this.saveTreeCards()
    }
    this.hideContextMenus()
  }

  async askDeleteOSTCard(cardKey: string) {
    const dialogRef = this.dialog.open(ConfirmingDialogComponent, {
      data: {
        title: "Delete card",
        content: "Are you sure you want to delete this card?"
      }
    })
    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
        await this.deleteOSTCard(cardKey)
        this.hideContextMenus()
        this.isEditCardNamePopupVisible = false
        this.isPostPanelOpen = false
        this.isManualTreeComponentPopupVisible = false
        this.manualAddContent = ""
        this.manualAddTitle = ""
      }
    })
  }

  async deleteOSTCard(cardKey: string, refreshTree: boolean = true) { // delete card and all its children recursively
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
    this.hideContextMenus()
    const card = this.treeCards.find(c => c.key == cardKey)

    if (card) {
      const type = card.cardType
      if (type == "Solution") {
        await this.firestore.updateOrganizationContentCount(this.organizationKey, this.projectKey, "solution", -1)
      } else if (type == "Opportunity") {
        await this.firestore.updateOrganizationContentCount(this.organizationKey, this.projectKey, "opportunity", -1)
      }
      const parentCard = this.treeCards.find(c => c.kidCardKeys.includes(cardKey))
      if (parentCard) {
        parentCard.kidCardKeys = parentCard.kidCardKeys.filter(k => k != cardKey)
        parentCard.card.updateKids(parentCard.kidCardKeys)
        parentCard.card.updateCollapseIcon(false)
        parentCard.leftPlaceholder.updateKids(parentCard.kidCardKeys)
        parentCard.rightPlaceholder.updateKids(parentCard.kidCardKeys)
        parentCard.card.updateCollapseIcon(false)
      }
      card.card.card.destroy()
      card.leftPlaceholder.card.destroy()
      card.rightPlaceholder.card.destroy()
      if (card.kidCardKeys.length > 0) {
        //card.kidCardKeys.forEach(async (k: string) => {
         for (const k of card.kidCardKeys) {
          await this.deleteOSTCard(k, false) // don't refresh tree if we are deleting kid cards
         }
        //})
      }

      this.treeCards = this.treeCards.filter(c => c.key != cardKey)
      if (this.isRefreshingTree == false && refreshTree == true) { // don't save tree cards if we are still refreshing tree after previous operation
        this.refreshOSTTree()
        this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, card.parentKey, cardKey, card.content, "delete", "deleted")
        await this.saveTreeCards()
      }
    }
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
  }

  startDraggTreeCard(node: Konva.Group, cardKey: string) {
   // const card = this.treeCards.find(c => c.key == cardKey)
    if (this.isDraggingDraggedItem) {
      return
    }
    this.isDraggingDraggedItem = true
    if (this.draggedItem) {
      this.draggedItem.remove()
      this.draggedItem = null
    }
    node.draggable(false)
    const d = node.clone()
    const rect = d.findOne('#rect') as Konva.Rect
    d.draggable(true)
    d.zIndex(200)
    d.listening(false)

   this.layer.add(d)
   this.layer.batchDraw()
    const rotationAnimation = new Konva.Tween({
      node: d,
      duration: 0.3, // duration in seconds
      rotation: 10, // target rotation in degrees
      easing: Konva.Easings.EaseInOut,
      onFinish: () => {
          this.draggedItem = d
      }
    });
    rotationAnimation.play();
    if (rect) {
      node.opacity(0.5)
      rect.opacity(1)
      rect.shadowColor('grey')
      rect.shadowBlur(10)
      rect.shadowOffset({ x: 10, y: 10 })
      rect.shadowOpacity(0.7)
    }

    d.on('dragstart', (e: any) => {
      this.hideContextMenus()
      this.removeAddPlaceholders()
      this.addDropPlaceholders(cardKey)
      d.moveToTop()
      this.isDraggingDraggedItem = true
    })

    d.on('dragmove', (e: any) => {
      e.cancelBubble = true;
    })

    d.on('dragend', (e: any) => { // dropping card on a sibling card under the same or different parent
      this.removeDropPlaceholders()
      this.isDraggingDraggedItem = false
      d.remove()
      node.draggable(true);
      node.listening(true);
      const rect = node.findOne('Rect') as Konva.Rect
      if (rect) {
        rect.opacity(1)
      }
      const text = node.findOne('Text') as Konva.Text
      if (text) {
        text.opacity(1)
      }
      if (this.hoverDropPlaceholderKey != "") {
        const parentCard = this.treeCards.find(c => c.kidCardKeys.includes(cardKey))
        if (parentCard) {
          let newIndex = parentCard.kidCardKeys.indexOf(this.hoverDropPlaceholderKey)
          const grandParentCard = this.treeCards.find(c => c.key == parentCard.parentKey)
          const parentCardType = parentCard?.cardType
          const uncleKeys = this.treeCards.filter(c => c.cardType == parentCardType).map(c => c.key)
         // const grandGrandParentCard = this.treeCards.find(c => c.key == grandParentCard?.parentKey)
          if (newIndex != -1) { // dropping card on a sibling card under the same parent
            const targetItem = this.treeCards.find(c => c.key == this.hoverDropPlaceholderKey)

            if (targetItem) {
              this.animateReturnDragItem(d, targetItem.card.card).then(() => {
                parentCard.kidCardKeys = parentCard.kidCardKeys.filter(k => k != cardKey)
                parentCard.kidCardKeys.splice(newIndex, 0, cardKey)
                node.opacity(1)
                let order = 0
                const kidKeys = parentCard.kidCardKeys
                kidKeys.forEach((kidKey: any) => { // for all kids of the parent card, update the order
                  const kidCardIndex = this.treeCards.findIndex(c => c.key == kidKey)
                  if (kidCardIndex != -1) {
                    this.treeCards[kidCardIndex].order = order
                    order++
                  }
                })
                this.refreshOSTTree()
                this.saveTreeCards()
              })
            } else {
              this.animateReturnDragItem(d, node).then(() => {
                this.refreshOSTTree()
                this.saveTreeCards()
              })
            }
          } else if (grandParentCard) { // dropping card on a different parent
        //    const uncles = grandParentCard.kidCardKeys
            if (uncleKeys.length > 0) {
              const uncleIndex = uncleKeys.indexOf(parentCard.key)
              if (uncleIndex != -1) {
                const uncleCard = this.treeCards.find(c => c.key == this.hoverDropPlaceholderKey)
                if (uncleCard) {
                  const g = new Konva.Group({
                    x: uncleCard.card.card.x(),
                    y: uncleCard.card.card.y() + this.treeCardHeight*1.5 + this.treeCardMargin ,
                    width: this.treeCardWidth,
                    height: this.treeCardHeight*1.5,
                  })
                  this.animateReturnDragItem(d, g).then(() => {
                    node.opacity(1)
                    uncleCard.kidCardKeys.push(cardKey) // add card to new uncle
                    const card = this.treeCards.find(c => c.key == cardKey)
                    if (card) {
                      card.parentKey = uncleCard.key
                    }
                    parentCard.kidCardKeys = parentCard.kidCardKeys.filter(k => k != cardKey)
                    parentCard.leftPlaceholder.updateKids(parentCard.kidCardKeys)
                    parentCard.leftPlaceholder.rotatePlaceholder(true)
                    parentCard.rightPlaceholder.updateKids(parentCard.kidCardKeys)
                    parentCard.rightPlaceholder.rotatePlaceholder(true)
                    parentCard.card.updateKids(parentCard.kidCardKeys)
                    parentCard.card.updateCollapseIcon(false)
                    uncleCard.leftPlaceholder.updateKids(uncleCard.kidCardKeys)
                    uncleCard.leftPlaceholder.rotatePlaceholder(true)
                    uncleCard.rightPlaceholder.updateKids(uncleCard.kidCardKeys)
                    uncleCard.rightPlaceholder.rotatePlaceholder(true)
                    uncleCard.card.updateKids(uncleCard.kidCardKeys)
                    uncleCard.card.updateCollapseIcon(false)
                    this.refreshOSTTree()
                    this.saveTreeCards()
                  })
                } else {
                  this.animateReturnDragItem(d, node).then(() => {
                    this.refreshOSTTree()
                    this.saveTreeCards()
                  })
                }
              }
            }
          }

        }
      } else {
        this.animateReturnDragItem(d, node)
        this.hoverDropPlaceholderKey = ""
      }

      this.layer.batchDraw()
    })

    d.startDrag()
  }

  isRefreshingTree = false

  refreshOSTTree() {
    if (this.isRefreshingTree == false) {
      this.isRefreshingTree = true
      this.hoverDropPlaceholderKey = ""
      this.rearrangeTreeCards()
      this.rearrangeAddPlaceholders()
      this.redrawOSTConnectors()
      this.updateMinimap()
      this.isRefreshingTree = false
    }
  }

  async animateReturnDragItem(draggedItem: Konva.Group, targetItem: Konva.Group) {
    this.layer.add(draggedItem);
    this.redrawLayer();
    const targetPos = targetItem.position();     // Get target position (relative to layer)
  
    await new Promise<void>((resolve) => {
      let finishedCount = 0;
  
      const checkFinish = () => {
        finishedCount++;
        if (finishedCount === 2) {
          draggedItem.remove();
          targetItem.opacity(1);
          this.addAddPlaceholders();
          resolve();
        }
      };
  
      const tween = new Konva.Tween({
        node: draggedItem,
        duration: 0.5,
        x: targetPos.x,
        y: targetPos.y,
        easing: Konva.Easings.EaseInOut,
        onFinish: checkFinish,
      });
      tween.play();
  
      const rotationAnimation = new Konva.Tween({
        node: draggedItem,
        duration: 0.4,
        rotation: 0,
        easing: Konva.Easings.EaseInOut,
        onFinish: checkFinish,
      });
      rotationAnimation.play();
    });
  }
  
  showDataSources(show: boolean) { // this is used to show the data sources in the canvas
    if (show == false) {
      this.isDataSourcesVisible = false
      this.contentListContextMessage = ""
      this.donotShowContentList = false
      this.isCanvasVisibleForKnowledgeBase = true
    } else {
      this.isDataSourcesVisible = true
      this.donotShowContentList = false
      this.skippedContentKeys.length = 0
      this.isCanvasVisibleForKnowledgeBase = false
      if (this.connectedPostKey != "" && this.connectedPostKey != null && this.connectedPostKey != undefined) {
        this.skippedContentKeys.push(this.connectedPostKey)
      }
      this.skippedContentKeys.push(this.canvasKey)
    }
    console.log("showDataSources 1 isCanvasVisibleForKnowledgeBase ", this.isCanvasVisibleForKnowledgeBase)
    this.hideContextMenus()
  }

  onSelectedContent(posts: Post[]) { // this is used to show the selected content in the canvas
    this.selectedContent = posts
  }

  onListenContent(listen: boolean) {
    this.isListening = listen
  }

  close(event: any) {
    this.closePostPanel(event)
  }

  async closePostPanel(event: any) {
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isPostPanelOpen = false
    this.selectedPostKey = ""
    this.areCanvasEventsSuspended = false
    this.isDialogOpened = false
    this.scrollPosition = window.scrollY
      if (event.isDownloadAvailable == undefined) {
        event.isDownloadAvailable = false
      }
      if (event.isNewPost == true) {
        await this.firestore.getContent(this.organizationKey, this.selectedPostKey).then(async (p: any) => {
          const content = p.name
          if (this.selectedTreeCardKey != "") { // if this is OST card then update its name
            const card = this.treeCards.find(c => c.key == this.selectedTreeCardKey)
            if (card) {
              card.card.updateName(content)
              const index = this.treeCards.findIndex(c => c.key == this.selectedTreeCardKey)
              if (index != -1) {
                this.treeCards[index].content = content
              }
              this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, card.parentKey, this.selectedTreeCardKey, content, "update_content", p.status)
              if (card.cardType == "Solution") {
                card.solutionType = await this.detectSolutionType(content, card.key)
              }
              this.saveTreeCards()
            }
          } else {
            const currentPosition = this.getCentralPosition()
            this.firestore.updateCanvasCardLog(this.organizationKey, this.canvasKey, this.userId, "", this.selectedPostKey, p.name, "add", p.status)
            this.onAddWorkpackage('content', [{key: this.selectedPostKey, name: p.name, htmlName: p.nameHTML, color: p.color, coverImageURL: p.coverImageURL}], 0, this.boxHeight*2, {x: currentPosition.x, y: currentPosition.y, width: this.boxWidth, height: this.boxHeight*2})
          }
        })
      } else {
          if (this.selectedTreeCardKey != "") {
            const card = this.treeCards.find(c => c.key == this.selectedTreeCardKey)
            if (card) {
              const index = this.treeCards.findIndex(c => c.key == this.selectedTreeCardKey)
              if (index != -1) {
                this.treeCards[index].content = event.name
              }
            }
          } else { // if this is not OST card then update save it in the canvas history
            const p =await this.firestore.getContent(this.organizationKey, this.selectedPostKey)
            const key = "content-"+this.selectedPostKey
            const command = this.getBoxAttributes(key)
            command.content = p.nameHTML || p.name
            command.command = "update"
            command.color = p.color
            command.shape = "box"
            command.contentKey = this.selectedPostKey
            command.sequence = this.canvasHistory.length
            if (p.coverImageURL != undefined && p.coverImageURL != "") {
              command.coverImageURL = p.coverImageURL
            } else {
              command.coverImageURL = ""
            }
            this.stepsToUndo += 1
            this.canvasHistory.push(command)
            this.updateBoxContent(command)
            this.layer.batchDraw()
            this.saveCanvas()
          }
      } 

    if (event.isPostUpdated == true) {
      if (event.isDeleted == true) {
        if (this.selectedTreeCardKey != "") {
            await this.deleteOSTCard(this.selectedTreeCardKey)
        }
      } else if (event.isPostUpdated == true) {
            if (switchListeningInFunction == true) {
              this.isListening = true
            }
      }
    }

// TU TRZEBA ZROBIC ZMIANĘ W MOMENCIE ZAMYKANIA PANELU BO NIE ZAPISUJE SIĘ ZMIANY W PANELU!!!

  }

  // methods for generating research report and ideas by AI
  showGenerateByAIPopup(cardType: string) {
    this.selectedTreeCardType = cardType
  //  const card = this.treeCards.find(c => c.key == this.selectedShapeKey)
   // const kidsCount = card?.kidCardKeys.length
   // const cardType = card?.cardType
    if (cardType == "Opportunity" ) {
      this.isGenerateByAIPopupVisible = true
    } else {
      if (this.llmLimit <= 0) {
        this.firestore.showSnackBar("You don't have any credits for LLM reasoning left. Please buy more credits. Contact us at: hello@prodely.com")
      } else {
        this.generateByAI()
      }
    }
  }

  showDeepSearchPopup() {
    this.hideContextMenus()
    this.isDeepSearchPopupVisible = true
  }

  closeDeepSearchPopup() {
    this.hideContextMenus()
    this.isCanvasVisible = true
  }

  initialQuestionsAsked = 0

  onSendComment(event: {comment: string, dialogKey: string}) { // launched when user sends a comment to AI from ragchat
    this.chatComments.push({"content": event.comment, "isAI": false})
    this.isRagchatVisible = false

    if (this.initialQuestionsAsked < this.researchReport.initialQuestions.length && this.initialQuestionsAsked < 3) { // keep asking initial questions until all are answered
      this.chatComments = [...this.chatComments, {"content": this.researchReport.initialQuestions[this.initialQuestionsAsked], "isAI": true}] // I need to do it this way, because chatComments is an input for ragchat component and if I push it, it doesn't fiere ngOnchanges in subcomponent
      this.isRagchatVisible = true
      this.isLoadingLabelVisible = false
      this.initialQuestionsAsked += 1
    } else {
      if (event.dialogKey == "ambiguity") {
        this.resolveAmbiguity()
      } else if (event.dialogKey == "promptCriteria") {
        if (this.canvasPermissions.isFastAIUsed == true) {
          this.fastAIResearch()
        } else {
          this.deepResearch()
        }
      }
    }
  }

  async initialDeepResearch(researchTargetPrompt: string) {
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    if (this.llmLimit <= 0) {
      this.firestore.showSnackBar("You don't have any credits left. Please buy more credits. Contact us at: hello@prodely.com")
      return
    }
    this.isCanvasVisible = false
    this.service.changeSelectedContentKeys([])
    this.researchReportKey = ""
    this.progressLog.length = 0
    this.progressStatus = ""
    this.hideContextMenus()
    this.researchReport.researchTargetPrompt = researchTargetPrompt

   this.loadingTitle = "Generating insights..."
    this.loadingMessage = "Wait until the insights are generated<br/>(refresh page if you want to interrupt thinking process)"

    this.researchReport = {
      key: "",
      title: "",
      dateOfCreation: new Date(),
      dateOfUpdate: new Date(),
      chapters: [],
      researchTargetPrompt: "",
      userId: "",
      summary: "",
      companyName: "",
      companyDescription: "",
      companyWebsite: "",
      reportContent: "",
      language: "",
      researchCategory: "",
      initialQuestions: []
    }

    this.researchReport.researchTargetPrompt = researchTargetPrompt
    this.researchReport.userId = this.userId
    this.researchReport.dateOfCreation = new Date()

    this.promptLanguage = await this.research.detectLanguage(this.researchReport.researchTargetPrompt, this.organizationKey, this.projectKey, this.userId, this.llmLimit)
    this.researchReport.language = this.promptLanguage
    const company = await this.research.identifyCompany(this.organizationKey, this.projectKey, this.researchReport.researchTargetPrompt, this.promptLanguage, this.userId, this.llmLimit, modelKey)
    this.researchReport.companyName = company.name
    this.researchReport.companyDescription = company.description
    this.researchReport.companyWebsite = company.website
    let companyPromptDescription = ""
    if (company.name != undefined && company.name != "") {
      companyPromptDescription = "Company name: " + company.name + "\n\n"
    }
    if (company.description != undefined && company.description != "") {
      companyPromptDescription = "Company description: " + company.description + "\n\n"
    }

    this.initialQuestionsAsked = 0
    const ambiguity = await this.research.detectCompanyAmbiguity(this.researchReport.researchTargetPrompt + companyPromptDescription, this.organizationKey, this.projectKey, this.userId, this.llmLimit, modelKey, this.promptLanguage)
    this.chatComments.length = 0  
    if (ambiguity.length > 0) { // amibiquity in user prompt detected
      this.dialogKey = "ambiguity"
      this.researchReport.initialQuestions = ambiguity.map((item: any) => item.question)
      this.chatComments.push({"content": this.researchReport.initialQuestions[this.initialQuestionsAsked], "isAI": true})
      this.isRagchatVisible = true
      this.isLoadingLabelVisible = false
      this.initialQuestionsAsked += 1
    } else { // there is no ambiguity in user prompt

      const researchCategory = await this.research.detectResearchCategory(this.researchReport.researchTargetPrompt, this.organizationKey, this.projectKey, this.userId, this.llmLimit)
      this.researchReport.researchCategory = researchCategory
  
  
      const initialQuestions = await this.research.detectPromptCriteria(this.researchReport.researchTargetPrompt + companyPromptDescription, this.organizationKey, this.projectKey, this.promptLanguage, this.userId, this.llmLimit, modelKey)
      this.researchReport.initialQuestions = initialQuestions.map((item: any) => item.question)
      
  
      if (initialQuestions.length > 0) { // display first question from initial questions
        this.dialogKey = "promptCriteria"
        this.chatComments.push({"content": this.researchReport.initialQuestions[this.initialQuestionsAsked], "isAI": true})
        this.isRagchatVisible = true
        this.isLoadingLabelVisible = false
        this.initialQuestionsAsked += 1
      } else { // if no initial questions are detected, then start deep research
        if (this.canvasPermissions.isFastAIUsed == true) {
          this.fastAIResearch()
        } else {
          this.deepResearch()
        }
      }
    }
  }

  async resolveAmbiguity() { // solve ambiguity in user prompt after answering the question by him
    let ambiuityQA = "\n\n\nClarification of the user prompt:\n"
    this.chatComments.forEach(item => {
      if (item.isAI == true) {
        ambiuityQA += "Question: " + item.content + "\n"
      } else {
        ambiuityQA += "User answered: " + item.content + "\n\n"
      }
    })
    const prompt = this.researchReport.researchTargetPrompt + ambiuityQA
    const company = await this.research.identifyCompany(this.organizationKey, this.projectKey, prompt, this.promptLanguage, this.userId, this.llmLimit, this.modelKey) // prepare company description again
    this.researchReport.companyName = company.name
    this.researchReport.companyDescription = company.description
    this.researchReport.companyWebsite = company.website
    let companyPromptDescription = ""
    if (company.name != undefined && company.name != "") {
      companyPromptDescription = "Company name: " + company.name + "\n\n"
    }
    if (company.description != undefined && company.description != "") {
      companyPromptDescription = "Company description: " + company.description + "\n\n"
    }
    this.initialQuestionsAsked = 0
    
    const researchCategory = await this.research.detectResearchCategory(this.researchReport.researchTargetPrompt, this.organizationKey, this.projectKey, this.userId, this.llmLimit)
    this.researchReport.researchCategory = researchCategory


    const initialQuestions = await this.research.detectPromptCriteria(this.researchReport.researchTargetPrompt + companyPromptDescription, this.organizationKey, this.projectKey, this.promptLanguage, this.userId, this.llmLimit, this.modelKey)
    this.researchReport.initialQuestions = initialQuestions.map((item: any) => item.question)

    if (initialQuestions.length > 0) { // display first question from initial questions
      this.dialogKey = "promptCriteria"
      this.chatComments.push({"content": this.researchReport.initialQuestions[this.initialQuestionsAsked], "isAI": true})
      this.isRagchatVisible = true
      this.isLoadingLabelVisible = false
      this.initialQuestionsAsked += 1
    } else { // if no initial questions are detected, then start deep research
      if (this.canvasPermissions.isFastAIUsed == true) {
        this.fastAIResearch()
      } else {
        this.deepResearch()
      }
    }
  }

  async deepResearchPublic(researchTargetPrompt: string) { // this is used to generate report by AI
    let elementContentArray: string[] = []
    elementContentArray = await this.getSelectedContent(this.minContentLengthForOST, this.maxContentLengthForOST) // 10000 is max length of content to extract, content is  divided into chunks
    if (this.llmLimit <= 0) {
      this.firestore.showSnackBar("You don't have any credits left. Please buy more credits. Contact us at: hello@prodely.com")
      return
    }
    this.isCanvasVisible = false
    this.service.changeSelectedContentKeys([])
    this.researchReportKey = ""
    this.progressLog.length = 0
    this.progressStatus = ""
    this.hideContextMenus()
    this.researchReport.researchTargetPrompt = researchTargetPrompt

    const prompt1 = "Znajdź oficjalne strony ministerstw cyfryzacji krajów członkowskich UE."
    const prompt2 = "Znajdź dokumenty poświęcone zagadnieniom: interoperacyjność, minimalne wymagania dla publicznych systemów teleinformatycznych, minimalne wymagania dla rejestrów publicznych, architektura systemu teleinformatycznego, ocena interoperacyjności, zarządzanie usługami, API publicznych systemów teleinformatycznych, kodowanie znaków, formaty plików, standardy oraz struktury udostępnianych danych."
    const prompt3 = "Jakie rozwiązania europejskie w zakresie wyżej wymienionych zagadnień można zastosować w ramach rozporządzenia ws. Krajowych Ram Interoperacyjności? Zaproponuj nowe zapisy do rozporządzenia ws. Krajowych Ram Interoperacyjności"
    this.loadingTitle = "Generating insights..."
    this.loadingMessage = "Wait until the insights are generated<br/>(refresh page if you want to interrupt thinking process)"

    this.researchReport = {
      key: "",
      title: "",
      dateOfCreation: new Date(),
      dateOfUpdate: new Date(),
      chapters: [],
      researchTargetPrompt: "",
      userId: "",
      summary: "",
      companyName: "",
      companyDescription: "",
      companyWebsite: "",
      reportContent: "",
      language: "",
      researchCategory: "",
      initialQuestions: []
    }
    researchTargetPrompt = prompt1 + "\n\n\n" + prompt2
    this.researchReport.researchTargetPrompt = researchTargetPrompt
    let initialQA = "\n\n\nAdditional information from user:\n"
    this.chatComments.forEach(item => {
      if (item.isAI == true) {
        initialQA += "Question: " + item.content + "\n"
      } else {
        initialQA += "User answered: " + item.content + "\n\n"
      }
    })

    this.researchReport.researchTargetPrompt += initialQA
 
    const maxCountries = 2
    const maxSources = 30
    this.promptLanguage = "pl"

    this.progressLog.push("Getting countries list...")
    let countries: any = await this.publicresearch.getCountries(this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-2.5-flash-lite", this.researchReport.researchTargetPrompt)
    countries = countries.slice(0,maxCountries)
    let countryContent: {country: string, domain: string, content: string, bestPractices: string}[] = []
    for (let i = 0; i < countries.length; i++) { // going through countries
      const country = countries[i].country
      this.progressLog.push("Getting sources for country: " + country + "...")
      const domain = this.publicresearch.extractTLD(countries[i].domain)
      const countryPrompt = researchTargetPrompt + "" + " Only for country: " + country + " and domain: " + domain
      const countrySources: any = await this.publicresearch.getSources(this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-2.5-flash-lite", countryPrompt, this.promptLanguage)
      this.progressLog.push("Received sources for country: " + country + ". Processing them...")
      let sourceInformation = []
      try {
        const sourcesCount = countrySources[0].sources.length
        if (sourcesCount > 0) {
          sourceInformation = countrySources[0].sources    
        }
      } catch (error) {
        console.error("error: ",error)
        const sourcesCount = countrySources.length
        if (sourcesCount > 0) {
          sourceInformation = countrySources
        }
      }

      let j = 0
      let sourceContent = ""
      let sourcePromises: Promise<any>[] = []
      while (j < sourceInformation.length && j < maxSources) {
        const source = sourceInformation[j].source
        const sourcePrompt = prompt2 + "\n\n\n Get all relevant information from the source: " + source
        sourcePromises.push(this.publicresearch.getExternalContent(this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-2.5-flash-lite", sourcePrompt, this.promptLanguage))
        await new Promise(resolve => setTimeout(resolve, 100))
        j++
      }
      const externalContents = await Promise.all(sourcePromises)
      for (let k = 0; k < externalContents.length; k++) {
        sourceContent += externalContents[k] + "\n\n"
      }
      this.progressLog.push("Received content for country: " + country)
      countryContent.push({country: country, domain: domain, content: sourceContent, bestPractices: ""})
      await new Promise(resolve => setTimeout(resolve, 100))
    }
    this.progressLog.push("Finding best practices...")
    let bestPracticePromises: Promise<any>[] = []
    for (let i = 0; i < countryContent.length; i++) {
      const countryContentItem = countryContent[i].content
      bestPracticePromises.push(this.publicresearch.findBestPractices(countryContentItem, prompt2, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-2.5-flash-lite"))
    }
    const bestPracticesPerCountry = await Promise.all(bestPracticePromises)
    this.progressLog.push("Finding gaps between best practices and analized content...")
    for (let i = 0; i < bestPracticesPerCountry.length; i++) {
      let sourcePromises: Promise<any>[] = []
      for (let j = 0; j < elementContentArray.length; j++) {
        sourcePromises.push(this.publicresearch.findGaps(elementContentArray[j], bestPracticesPerCountry[i], this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-2.5-flash-lite"))
      }
      const sourceContent = await Promise.all(sourcePromises)

      for (let k = 0; k < sourceContent.length; k++) {
        countryContent[i].bestPractices += sourceContent[k] + "\n\n\n"
      }
      this.progressLog.push("Formatting raport chapter...")
      countryContent[i].bestPractices = await this.publicresearch.consolidateGaps(countryContent[i].bestPractices, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-2.5-flash")
    }

    const gaps = countryContent.join("\n\n")
    const recommendations = await this.publicresearch.writeRecommendations(gaps, prompt2, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, "gemini-3-pro-preview") //"gemini-2.5-pro"
    this.researchReport.chapters.unshift({title: "Recommendations", description: "Legislative recommendations", content: recommendations, researchQuestions: []})
    this.progressLog.push("Final result achieved.")
    this.researchReport.title = "Public research report"
    this.researchReport.chapters = countryContent.map((item: any) => ({title: item.country, description: item.domain, content: item.bestPractices, researchQuestions: []}))
    this.researchReport.summary = "Public research report"
    this.researchReport.reportContent = "Public research report"
    this.researchReport.dateOfUpdate = new Date()
    this.researchReport.dateOfCreation = new Date()
    this.researchReport.companyName = "Public research report"
    this.researchReport.companyDescription = "Public research report"
    this.researchReport.companyWebsite = "Public research report"
    this.researchReport.language = "pl"
    this.researchReport.researchCategory = "Public research report"
    this.researchReport.initialQuestions = []
    this.researchReport.researchTargetPrompt = researchTargetPrompt
    this.uploadResearchReportPDF(this.researchReport.chapters, this.researchReport, this.researchReport.companyName, this.researchReport.title)

    this.isCanvasVisible = true
  }
  

  async deepResearch() { // this is used to generate report by AI
    let initialQA = "\n\n\nAdditional information from user:\n"
    this.chatComments.forEach(item => {
      if (item.isAI == true) {
        initialQA += "Question: " + item.content + "\n"
      } else {
        initialQA += "User answered: " + item.content + "\n\n"
      }
    })

    this.researchReport.researchTargetPrompt += initialQA
    let chapters: Chapter[] = []
    const maxAnswers = 10

    let researchPlan = await this.research.planResearch(this.researchReport.researchTargetPrompt, this.researchReport.companyName, this.researchReport.companyDescription, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.modelKey, this.maxChapters, this.researchReport.researchCategory)

    const researchQuestions = await this.research.writeReseachQuestions(researchPlan, this.researchReport.companyName, this.researchReport.companyDescription, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.modelKey, maxAnswers, false) || []
    const answers = await this.research.answerQuestions(researchPlan, researchQuestions, maxAnswers, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit) || []
    const contrarianAnswers = await this.research.writeContrarianAnswers(researchPlan, answers, this.researchReport.researchTargetPrompt, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.modelKey) || []
    //chapters = await this.research.writeShortChapters(this.researchReport.researchTargetPrompt, this.researchReport.companyName, this.researchReport.companyDescription, researchPlan, answers, contrarianAnswers, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit) || []
    //chapters = await this.research.followResearchQuestions(this.researchReport.researchTargetPrompt, chapters, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.modelKey) || []
    const foreignInspiration = await this.research.findForeignInspirationForChapters(researchPlan, chapters, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.modelKey) || []
    chapters = await this.research.writeChapters(this.researchReport.researchTargetPrompt, chapters, this.researchReport.companyName, this.researchReport.companyDescription, researchPlan, answers, contrarianAnswers, foreignInspiration, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.modelKey) || []
    chapters = await this.research.findEarlyOpportunities(chapters, foreignInspiration, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit) || []
    const summary = await this.research.summarizeResearch(chapters, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.researchReport.companyName) || []

    this.researchReport.summary = summary[0].content
    chapters.unshift({title: "Summary", description: "Summary of the report", content: this.researchReport.summary, researchQuestions: [], links: []})
    for (let i = 0; i < chapters.length; i++) {
      chapters[i].content = this.research.formatText(chapters[i].content)
      this.researchReport.chapters.push({"title": chapters[i].title || "", "content": chapters[i].content || "", "description": chapters[i].description || "", "researchQuestions": chapters[i].researchQuestions || []})
    }
    this.researchReport.title = summary[0].title
    
    this.progressStatus = "Report completed. Saving it researcher module..."
    this.progressLog.push(this.progressStatus)
    this.researchReport.dateOfUpdate = new Date()
    this.isResearchReportUploaded = false
    await this.uploadResearchReportPDF(researchPlan, this.researchReport, this.researchReport.companyName, this.researchReport.title)
    this.progressStatus = "Report uploaded to knowledge base..."
    this.progressLog.push(this.progressStatus)
  }

  async fastAIResearch() { // verstion of thinking process using fast AI for testing and demonstration purposes
    const modelKey = this.canvasPermissions.isFastAIUsed == true ? "gemini-2.5-flash-lite" : this.modelKey
    let initialQA = "\n\n\nAdditional information from user:\n"
    this.chatComments.forEach(item => {
      if (item.isAI == true) {
        initialQA += "Question: " + item.content + "\n"
      } else {
        initialQA += "User answered: " + item.content + "\n\n"
      }
    })

    this.researchReport.researchTargetPrompt += initialQA
    let chapters: Chapter[] = []
    const maxAnswers = 10

    let researchPlan = await this.research.planResearch(this.researchReport.researchTargetPrompt, this.researchReport.companyName, this.researchReport.companyDescription, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, modelKey, this.maxChapters, this.researchReport.researchCategory)
  //  const researchQuestions = await this.research.writeReseachQuestions(researchPlan, this.researchReport.companyName, this.researchReport.companyDescription, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, modelKey, maxAnswers, false) || []
   // const answers = await this.research.answerQuestions(researchPlan, researchQuestions, maxAnswers, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit) || []
   // const contrarianAnswers = await this.research.writeContrarianAnswers(researchPlan, answers, this.researchReport.researchTargetPrompt, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, modelKey) || []
  //  const foreignInspiration = await this.research.findForeignInspirationForChapters(researchPlan, chapters, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, modelKey) || []
    chapters = await this.research.writeChapters(this.researchReport.researchTargetPrompt, chapters, this.researchReport.companyName, this.researchReport.companyDescription, researchPlan, [], [], [], this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, modelKey) || []
   // chapters = await this.research.findEarlyOpportunities(chapters, foreignInspiration, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit) || []
    const summary = await this.research.summarizeResearch(chapters, this.promptLanguage, this.organizationKey, this.projectKey, this.userId, this.llmLimit, this.researchReport.companyName) || []

    this.researchReport.summary = summary[0].content
    chapters.unshift({title: "Summary", description: "Summary of the report", content: this.researchReport.summary, researchQuestions: [], links: []})
    for (let i = 0; i < chapters.length; i++) {
      chapters[i].content = this.research.formatText(chapters[i].content)
      this.researchReport.chapters.push({"title": chapters[i].title || "", "content": chapters[i].content || "", "description": chapters[i].description || "", "researchQuestions": chapters[i].researchQuestions || []})
    }
    this.researchReport.title = summary[0].title
    
    this.progressStatus = "Report completed. Saving it knowledge base..."
    this.progressLog.push(this.progressStatus)
    this.researchReport.dateOfUpdate = new Date()
    this.isResearchReportUploaded = false
    await this.uploadResearchReportPDF(researchPlan, this.researchReport, this.researchReport.companyName, this.researchReport.title)
    this.progressStatus = "Report uploaded to knowledge base..."
    this.progressLog.push(this.progressStatus)
  }

  async saveResearchReport() {
    let switchListeningInFunction = true
    if (this.isListening == false) {
      switchListeningInFunction = false
    }
    this.isListening = false
    this.researchReportKey = await this.firestore.saveResearchReport(this.organizationKey, this.projectKey, this.userId, this.researchReport) // saves in research reports collection
    await this.firestore.updateReportKeyForCanvas(this.organizationKey, this.canvasKey, this.researchReportKey) // updates canvas with report key
    this.isResearchReportUploaded = true
    if (switchListeningInFunction == true) {
      this.isListening = true
    }
    return this.researchReportKey
  }

  async getURL(urlLink: string) {
    const storage = getStorage();
    const imageRef = storageRef(storage, urlLink);
    return await getDownloadURL(imageRef)
        .then((url) => {
          return url
    });
  }

  async downloadResearchReport() {
    const urlLink = await this.firestore.getDocumentURL(this.organizationKey, this.researchReportDocumentKey)
    if (urlLink != undefined && urlLink != "") {
      this.getURL(urlLink).then(url => {
        window.open(url, "_blank")
      })
    } else {
      this.firestore.showSnackBar("Research report not found.")
    }
  }

  async uploadResearchReportPDF(researchPlan: {title: string, description: string}[], researchReport: ResearchReport, companyName: string = "", reportTitle: string = "") {
    try {
      const tempDiv = document.createElement('div');
      tempDiv.className = 'pdf-content-style'; // Use the same CSS classes for styling

      let autodoc = "";
      autodoc += "<h1>" + researchReport.title + "</h1><h4>Table of contents</h4>";

      for (let i = 0; i < researchPlan.length; i++) {
        const chapter = researchPlan[i];
        autodoc += "<h2>" + chapter.title + "</h2>";
        autodoc += "<p>" + this.research.formatText(chapter.description) + "</p>";
      }

      for (const chapter of researchReport.chapters) {
        autodoc += "<h2>" + chapter.title + "</h2>";
        autodoc += "<p>" + this.research.formatText(chapter.content) + "</p>";
      }
      autodoc += "<p class='footer'>Research report generated by Prodely (<a href='https://prodely.com'>Prodely</a>). Do not hesitate to contact us at: hello@prodely.com.</p>";
      this.researchReport.reportContent = autodoc
      const contentWidth = 555; 

              tempDiv.innerHTML = `<style>
@font-face {
  font-family: 'Roboto-Regular';
  src: url('data:application/font-ttf;base64,');
  font-weight: normal;
  font-style: normal;
}
 .pdf-content-style, .pdf-content-style * {
  width: ${contentWidth}pt;
  box-sizing: border-box;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  font-family: 'Roboto-Regular', sans-serif!important; 
  line-height: 1.4 !important; /* IMPORTANT: Explicit line height for general text */
}

.pdf-content-style .footer {
  font-size: 8pt;
  margin-top: 10pt;
  line-height: 1.2;
}

.pdf-content-style a {
  word-break: break-all !important;
}

.pdf-content-style h1 {
  font-size: 24pt;
  margin-bottom: 18pt;
  line-height: 1.2;
}
.pdf-content-style h2 {
  font-size: 18pt;
  margin-top: 24pt;
  margin-bottom: 12pt;
  line-height: 1.3;
}
  .pdf-content-style h3 {
  font-size: 14pt;
  margin-top: 20pt;
  margin-bottom: 12pt;
  line-height: 1.3;
}
.pdf-content-style p {
  font-size: 10pt;
  margin-bottom: 10pt;
  line-height: 1.6; /* Slightly larger line height for paragraphs */
}
.pdf-content-style ul, .pdf-content-style ol {
  margin-left: 25pt; /* Indent lists */
  margin-bottom: 10pt;
  padding-left: 0; /* Remove default padding that might cause issues */
}
.pdf-content-style li {
  font-size: 10pt;
  margin-bottom: 5pt; /* Space between list items */
  line-height: 1.6; /* Ensure consistent line height */
}
.pdf-content-style ul {
  list-style: none;
}
  /*
.pdf-content-style td {
  min-width: 100pt;
  font-size: 8pt;
  margin-bottom: 5pt; /* Space between list items */
  line-height: 1.2; /* Ensure consistent line height */
}*/
/*.pdf-content-style ul li:before {
  content: "• "; 
  color: black; 
  display: inline-block;
  width: 1em;
  margin-left: -1em
}</style>`+autodoc;
      

    document.body.appendChild(tempDiv); 

      const doc = new jsPDF({
        unit: 'pt',
        format: 'a4',
        orientation: "portrait"
      });

      doc.addFont('Roboto-Regular-normal.ttf', 'Roboto-Regular', 'normal'); // Register the font NEW LINE TEST IT!
      doc.setFont("Roboto-Regular"); 
      doc.setFontSize(12);


      await new Promise<void>((resolve, reject) => {
        doc.html(tempDiv, {
          callback: pdfDoc => {
            document.body.removeChild(tempDiv);
            resolve()
          },
          x: 20,
          y: 20,
          
        //  width: 555, // or omit if CSS width is set properly
          html2canvas: { 
            scrollX: 0,
            scrollY: 0,
            scale: 0.67,
            width: contentWidth-40, // Use the same width as your CSS
            // Let html2canvas determine the window width automatically
            windowWidth: contentWidth, 
          //  windowWidth: 500,
            }, // Use 1 unless you need small fonts
          margin: [20, 20, 20, 20],
          autoPaging: 'text'
        });
      })

      const pdfBlob = doc.output('blob'); // extracting file content
      this.progressStatus = "Converting research report to PDF..."
      this.progressLog.push(this.progressStatus)
      const file: File = new File([pdfBlob], companyName+" "+reportTitle+"_research_report.pdf", { type: "application/pdf" }); // converting to file
      const contentKey = "" // there is no content key for the document uploaded from computer, because document is not related to any post
      // Open dialog for the current file
      const result = await firstValueFrom(this.dialog.open(UploadpopupComponent, { // opening dialog for uploading file to the project and saving it to the database
        panelClass: "dialog-container",
        data: {
          "userId": this.userId,
          "contentKey": contentKey,
          "file": file,
          "organizationKey": this.organizationKey,
          "projectKey": this.projectKey,
          "contentType": "document",
          "doAddCover": false,
          "objectType": "document",
          "projectName": this.projectName,
          "userImageUpload": false,
          "coverImageURL": "",
          "closeAfterImageCapture": false
        }
      }).afterClosed());
      this.isLoadingLabelVisible = false
      this.loadingMessage = "Please wait, uploading research report to knowledge base..."
      await this.saveResearchReport()
      this.progressStatus = "Report saved. You can download it, now."
      this.progressLog.push(this.progressStatus)

      if (result != false && (result.documentKey != undefined)) {
        this.progressStatus = "Uploading research report to knowledge base..."
        this.progressLog.push(this.progressStatus)
        const documentKey = result.documentKey;
        this.researchReportDocumentKey = documentKey
        await this.search.readDocument(this.organizationKey, this.userId, this.projectKey, contentKey, documentKey, this.embeddingModel, result.fileType)
        this.service.changeSelectedContentKeys([documentKey])
        await this.firestore.storeSelectedContentKeys(this.organizationKey, this.projectKey, this.userId, [documentKey])
        this.progressStatus = "Report saved to knowledge base. You can now download it later."
        this.progressLog.push(this.progressStatus)
        this.isCanvasVisible = true
        this.donotShowContentList = true
        this.isDataSourcesVisible = true

        const result2 = await firstValueFrom(this.dialog.open(ConfirmingDialogComponent, {
          data: {
            "content": "Do you want to conduct deeper analysis of the report? This may take 1 to 5 minutes.",
            "onlyCloseButton": false,
            "title": "Deeper analysis",
            "documentKey": documentKey,
            "organizationKey": this.organizationKey
          }
        }).afterClosed());
        if (result2) {
          this.isCanvasVisible = false
          await this.createOntologies(documentKey)
        } else {
          this.isCanvasVisible = true
        }

        const dialogRef2 = this.dialog.open(ConfirmingDialogComponent, {
          data: {
            "content": "Do you want to generate opportunities based on the report?",
            "onlyCloseButton": false,
            "title": "Generate ideas",
            "documentKey": documentKey,
            "organizationKey": this.organizationKey
          }
        })
        dialogRef2.afterClosed().subscribe((result: any) => {
          if (result) {
            this.isCanvasVisible = false
            this.generateByAI(this.researchReport.reportContent)
            return true
          } else {
            this.isCanvasVisible = true
          }
          this.isLoadingLabelVisible = false
          this.loadingMessage = ""
          return false
        })

      }

    } catch (error) {
      console.error("Error generating or uploading PDF:", error);
      // Handle error appropriately in your Angular app (e.g., show a toast)
      throw error; // Re-throw to be caught by the component calling this service
    }
  }


async createOntologies(documentKey: string) {
  this.isLoadingLabelVisible = true
  this.loadingMessage = "Creating ontologies..."
  this.loadingTitle = "Creating ontologies..."
  this.progressStatus = "Creating ontologies..."
  this.progressLog.push(this.progressStatus)
  let errorMessage = null;
  let results = null;
  const body = {
    userId: this.userId,
    organizationKey: this.organizationKey,
    projectKey: this.projectKey,
    contentKeys: [documentKey],
    documentKeys: [documentKey],
    llmLimit: 100,
    maxRows: 200,
    maxLength: 10000,
    launchReasoning: true,
    useCase: "ost"
  }

  try {
    const response: any = await firstValueFrom(
      this.http.post("https://europe-west1-lessons-learned-fd280.cloudfunctions.net/runCreateOntologies", body)
    );

    // Check for business logic success
    if (response.status === 'success' && response.ontologies) {
      return response.ontologies;
    } else {
      // Handle cases where the server responds with 200 OK but the "status" field is "error"
      throw new Error(response.message || 'Ontology creation failed.');
    }

  } catch (error: any) {
    // Handle network errors, 404, 500, or the error thrown above
    console.error("Error creating ontologies:", error);
    const errorMessage = error.message || 'An unexpected error occurred.';
    
    // Optional: Reset progress status on failure
    this.progressStatus = "Error occurred.";
    
    return null; // Or re-throw the error depending on your UI needs
  } finally {
    // This runs whether the request succeeded OR failed
    this.isLoadingLabelVisible = false;
  }
}

  convertSimpleHtmlToPdfMake(htmlString: string) {
    const content: any[] = [];
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
  
    // For a simple <p> tag, you can directly map it
    const paragraphs = tempDiv.querySelectorAll('p');
    paragraphs.forEach(p => {
      content.push({ text: p.textContent, style: 'paragraph' });
    });
  
    // You would expand this logic for other tags like h1, h2, ul, li, a, etc.
    // For example, if you had <h1>Test</h1>, you'd add:
    // const h1s = tempDiv.querySelectorAll('h1');
    // h1s.forEach(h => {
    //   content.push({ text: h.textContent, style: 'h1' });
    // });
  
    return content;
  }

  private scrollToBottom() {
    try {
      this.progressLogWrapper.nativeElement.scrollTop =
        this.progressLogWrapper.nativeElement.scrollHeight;
    } catch (err) {}
  }

  updateStatus(event: any) {

  }

  updateColor(event: any) {

  }

  onUpdateName(event: any) {
    const card = this.treeCards.find(c => c.key == this.selectedShapeKey)
    if (card) {
      card.card.setName(event.name, card.card.commentsCount, card.card.emoticonsString)
    }
  }

  updateComplete(event: any) {

  }

  async updateDelete(event: any) {
    const selectedShapeKey = event.selectedShapeKey
    const contentKey = this.treeCards.find(c => c.key == selectedShapeKey)?.contentKey
    const isDeleted = event.isDeleted
    if (isDeleted == true) {
      await this.deleteOSTCard(selectedShapeKey)
      this.selectedShapeKey = ""
      this.hideContextMenus()
      this.isEditCardNamePopupVisible = false
      this.isPostPanelOpen = false
      this.isManualTreeComponentPopupVisible = false
      this.manualAddContent = ""
      this.manualAddTitle = ""
      if (contentKey != undefined) {
        let switchListeningInFunction = true
        if (this.isListening == false) {
          switchListeningInFunction = false
        }
        this.isListening = false
        this.firestore.removePost(contentKey, this.organizationKey, this.projectKey).then(() => {
          if (switchListeningInFunction == true) {
            this.isListening = true
          }
        })
      }
    }
  }

  updateCoverImage(event: any) {

  }

  onRTFEditorKeyUp(event: MouseEvent | KeyboardEvent) {
    this.rtfEditor.commands.exec()
  }

  onRTFEditorChange(html: object) {
  //  this.pastedLink = this.firestoreService.stripHTML(html.toString()) 
    if (this.manualAddContent == "<p></p>") {
      this.manualAddContent = ""
    }

  }

  onRTFEditorKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
    if (event.key === 'Shift') {

    }
  }

  dontListenToFocus = false

  async setFocus(force: boolean = false) { // forced focus moves all users 
    this.setFocusKey = this.firestore.generateUID()
    const s = this.stage.clone()
    s.scale({ x: 1, y: 1});
    const position = s.position();
    this.dontListenToFocus = true
    const zoom = this.stage.scaleX()
    await this.firestore.setFocus(this.organizationKey, this.canvasKey, this.setFocusKey, position, zoom, force)
    this.dontListenToFocus = false
  }

  listenToFocus() { // listens to forced focus position and moves canvas to it
    const db = this.firestore.getApps()
    const docRef = doc(db, "organizations", this.organizationKey, "setFocusPositions", this.canvasKey)
    this.unsubFocus =  onSnapshot(docRef, (snapshot) => {
      if (snapshot.exists() && this.dontListenToFocus == false) {
        const position = snapshot.get("position")
        const dateOfUpdate = snapshot.get("dateOfUpdate")
        const zoom = snapshot.get("zoom")
        const force = snapshot.get("force")
        const dateDiff = Date.now() - dateOfUpdate
        if (dateDiff > 10000) {
          return
        }
        const positionKey = snapshot.get("positionKey")
        if (positionKey != this.setFocusKey && force == true) {
          this.setFocusKey = positionKey
          this.isLoadingLabelVisible = true
          this.loadingTitle = "Moving canvas in 2 seconds..."
          this.loadingMessage = "Administrator requested to move focus to the canvas."
          setTimeout(() => {
            this.isLoadingLabelVisible = false
            this.loadingMessage = ""
            this.loadingTitle = ""
            this.moveToPosition(position.x, position.y, zoom)
          }, 2000)
        }
      }
    })
  }



  paymentPopupRef: any = null

  openPaymentPopup() {
    this.paymentPopupRef = this.dialog.open(PaymentpopupComponent, {
      panelClass: "dialog-container",
      data: {
        "userId": this.userId
      }
    })
  }

  closePaymentPopup() {
    this.paymentPopupRef.close()
  }

  onPermissionsChange() {
    this.firestore.updateCanvasPermissions(this.organizationKey, this.canvasKey, this.canvasPermissions)
  }

  async getPermissions() {
    this.canvasPermissions = await this.firestore.getCanvasPermissions(this.organizationKey, this.canvasKey)
    this.canvasPermissions.isFastAIUsed = true
    if (this.userId == "ritHfncGyKdlmuPUApEkHFfPff13") {
      this.isSuperUser = true
    } else {
      this.isSuperUser = false
    }
  }

  async selectKidsCards() {
    const selectedCard = this.treeCards.find(card => card.key == this.selectedTreeCardKey)
    if (selectedCard) {
      for (const kidCardKey of selectedCard.kidCardKeys) {
        const kidCard = this.treeCards.find(card => card.key == kidCardKey)
        if (kidCard) {
          kidCard.card.setCardChecked(true)
          this.selectedCards.push(kidCard)
        }
      }
    }
    this.layer.batchDraw()
  }

  async deselectAllCards() {
    this.selectedCards = this.treeCards.filter(card => card.card.isCardChecked);
    if (this.selectedCards.length > 0) {
    this.treeCards.forEach((card: any) => {
      if (card.card.isCardChecked == true) {
        card.card.setCardChecked(false)
      }
    })
    this.selectedCards.length = 0
    this.layer.batchDraw()
    } else {
      this.firestore.showSnackBar("No cards selected to deselect.");
    }
  }

  async toggleRagchat() {
    this.userQuery = ""
    let contentCount = 0
    this.chatComments.length = 0
    this.isRagPopupVisible = !this.isRagPopupVisible
    this.useSearchGrounding = true
    if (this.isRagPopupVisible == true) {
      this.selectedCards = this.treeCards.filter(card => card.card.isCardChecked);
      let parentCardKeys: string[] = [] 
      this.selectedCards.forEach(card => {
        const p = this.getParentCardKeys(card.key, parentCardKeys)
        for (const key of p) {
          if (parentCardKeys.includes(key) == false) {
            parentCardKeys.push(key)
          }
        }
      })
      this.chatTitle = "Content selected: "
      this.selectedCards = [...this.selectedCards, ...this.treeCards.filter(card => parentCardKeys.includes(card.key))] // add parent cards to selected cards
      this.selectedContentKeys = this.selectedCards.filter(card => card.contentKey != undefined && card.contentKey != "").map(card => card.key)
      const selectedOSTCards = this.selectedCards.filter(card => card.contentKey == undefined || card.contentKey == "")
      this.additionalContent = ""
      selectedOSTCards.forEach(card => {
        this.additionalContent += "Card type: " + card.cardType + "\n\n"
        this.additionalContent += "Card name: " + card.card.name + "\n\n"
        this.additionalContent += "Card content: " + card.content + "\n\n\n\n\n"
      })


      const selectedDocumentKeys = this.selectedContent.map(item => item.key).filter(key => key != undefined && key != "");
      if (selectedOSTCards.length > 0) {
        contentCount += selectedOSTCards.length
        this.chatTitle += selectedOSTCards.length +" cards, "
      }
      if (this.selectedContentKeys.length > 0) {
        contentCount += this.selectedContentKeys.length
        this.chatTitle += this.selectedContentKeys.length + " content items, "
      }
      if (selectedDocumentKeys.length > 0) {
        contentCount += selectedDocumentKeys.length
        this.chatTitle += selectedDocumentKeys.length + " documents "
      }
      this.chatTitle += "to chat with."
      this.responseChunks = await this.getChunks(selectedDocumentKeys)
    }
    if (this.isRagPopupVisible == true && contentCount == 0) {
      this.isRagPopupVisible = false
      this.firestore.showSnackBar("You need to select some cards or content from knowledge base to chat with.")
    }
  }

  getParentCardKeys(cardKey: string, parentCardKeys: string[]) {
    const card = this.treeCards.find(card => card.key == cardKey)
    if (card && card.parentKey != undefined && card.parentKey != "" && parentCardKeys.includes(card.parentKey) == false) {
      parentCardKeys.push(card.parentKey)
      const p = this.getParentCardKeys(card.parentKey, parentCardKeys)
      for (const key of p) {
        if (parentCardKeys.includes(key) == false) {
          parentCardKeys.push(key)
        }
      }
    }
    return parentCardKeys
  }

  async getChunks(documentKeys: string[]) {
    return await this.firestore.getChunksByDocumentKeys(this.organizationKey, documentKeys).then(result => {
      return result
    })
  }

  onRagPopupSendComment(event: any) {
  }

}